/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.AmendPendingOrderRequest = (function() {

    /**
     * Properties of an AmendPendingOrderRequest.
     * @exports IAmendPendingOrderRequest
     * @interface IAmendPendingOrderRequest
     * @property {string|null} [OrderId] AmendPendingOrderRequest OrderId
     * @property {number|null} [Price] AmendPendingOrderRequest Price
     * @property {number|null} [Quantity] AmendPendingOrderRequest Quantity
     * @property {ExpirationType|null} [Expiry] AmendPendingOrderRequest Expiry
     * @property {google.protobuf.IStringValue|null} [ExpiryDate] AmendPendingOrderRequest ExpiryDate
     */

    /**
     * Constructs a new AmendPendingOrderRequest.
     * @exports AmendPendingOrderRequest
     * @classdesc Represents an AmendPendingOrderRequest.
     * @implements IAmendPendingOrderRequest
     * @constructor
     * @param {IAmendPendingOrderRequest=} [properties] Properties to set
     */
    function AmendPendingOrderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AmendPendingOrderRequest OrderId.
     * @member {string} OrderId
     * @memberof AmendPendingOrderRequest
     * @instance
     */
    AmendPendingOrderRequest.prototype.OrderId = "";

    /**
     * AmendPendingOrderRequest Price.
     * @member {number} Price
     * @memberof AmendPendingOrderRequest
     * @instance
     */
    AmendPendingOrderRequest.prototype.Price = 0;

    /**
     * AmendPendingOrderRequest Quantity.
     * @member {number} Quantity
     * @memberof AmendPendingOrderRequest
     * @instance
     */
    AmendPendingOrderRequest.prototype.Quantity = 0;

    /**
     * AmendPendingOrderRequest Expiry.
     * @member {ExpirationType} Expiry
     * @memberof AmendPendingOrderRequest
     * @instance
     */
    AmendPendingOrderRequest.prototype.Expiry = 0;

    /**
     * AmendPendingOrderRequest ExpiryDate.
     * @member {google.protobuf.IStringValue|null|undefined} ExpiryDate
     * @memberof AmendPendingOrderRequest
     * @instance
     */
    AmendPendingOrderRequest.prototype.ExpiryDate = null;

    /**
     * Creates a new AmendPendingOrderRequest instance using the specified properties.
     * @function create
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {IAmendPendingOrderRequest=} [properties] Properties to set
     * @returns {AmendPendingOrderRequest} AmendPendingOrderRequest instance
     */
    AmendPendingOrderRequest.create = function create(properties) {
        return new AmendPendingOrderRequest(properties);
    };

    /**
     * Encodes the specified AmendPendingOrderRequest message. Does not implicitly {@link AmendPendingOrderRequest.verify|verify} messages.
     * @function encode
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {IAmendPendingOrderRequest} message AmendPendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AmendPendingOrderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OrderId != null && Object.hasOwnProperty.call(message, "OrderId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.OrderId);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Price);
        if (message.Quantity != null && Object.hasOwnProperty.call(message, "Quantity"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.Quantity);
        if (message.Expiry != null && Object.hasOwnProperty.call(message, "Expiry"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Expiry);
        if (message.ExpiryDate != null && Object.hasOwnProperty.call(message, "ExpiryDate"))
            $root.google.protobuf.StringValue.encode(message.ExpiryDate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AmendPendingOrderRequest message, length delimited. Does not implicitly {@link AmendPendingOrderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {IAmendPendingOrderRequest} message AmendPendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AmendPendingOrderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AmendPendingOrderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AmendPendingOrderRequest} AmendPendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AmendPendingOrderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AmendPendingOrderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.OrderId = reader.string();
                break;
            case 2:
                message.Price = reader.double();
                break;
            case 3:
                message.Quantity = reader.double();
                break;
            case 4:
                message.Expiry = reader.int32();
                break;
            case 5:
                message.ExpiryDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AmendPendingOrderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AmendPendingOrderRequest} AmendPendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AmendPendingOrderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AmendPendingOrderRequest message.
     * @function verify
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AmendPendingOrderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            if (!$util.isString(message.OrderId))
                return "OrderId: string expected";
        if (message.Price != null && message.hasOwnProperty("Price"))
            if (typeof message.Price !== "number")
                return "Price: number expected";
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            if (typeof message.Quantity !== "number")
                return "Quantity: number expected";
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            switch (message.Expiry) {
            default:
                return "Expiry: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExpiryDate);
            if (error)
                return "ExpiryDate." + error;
        }
        return null;
    };

    /**
     * Creates an AmendPendingOrderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AmendPendingOrderRequest} AmendPendingOrderRequest
     */
    AmendPendingOrderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AmendPendingOrderRequest)
            return object;
        var message = new $root.AmendPendingOrderRequest();
        if (object.OrderId != null)
            message.OrderId = String(object.OrderId);
        if (object.Price != null)
            message.Price = Number(object.Price);
        if (object.Quantity != null)
            message.Quantity = Number(object.Quantity);
        switch (object.Expiry) {
        case "EXPIRATIONTYPE_UNKNOWN":
        case 0:
            message.Expiry = 0;
            break;
        case "EXPIRATIONTYPE_GTC":
        case 1:
            message.Expiry = 1;
            break;
        case "EXPIRATIONTYPE_GTD":
        case 2:
            message.Expiry = 2;
            break;
        case "EXPIRATIONTYPE_GTS":
        case 3:
            message.Expiry = 3;
            break;
        case "EXPIRATIONTYPE_FOK":
        case 4:
            message.Expiry = 4;
            break;
        case "EXPIRATIONTYPE_IOC":
        case 5:
            message.Expiry = 5;
            break;
        }
        if (object.ExpiryDate != null) {
            if (typeof object.ExpiryDate !== "object")
                throw TypeError(".AmendPendingOrderRequest.ExpiryDate: object expected");
            message.ExpiryDate = $root.google.protobuf.StringValue.fromObject(object.ExpiryDate);
        }
        return message;
    };

    /**
     * Creates a plain object from an AmendPendingOrderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AmendPendingOrderRequest
     * @static
     * @param {AmendPendingOrderRequest} message AmendPendingOrderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AmendPendingOrderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.OrderId = "";
            object.Price = 0;
            object.Quantity = 0;
            object.Expiry = options.enums === String ? "EXPIRATIONTYPE_UNKNOWN" : 0;
            object.ExpiryDate = null;
        }
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            object.OrderId = message.OrderId;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = options.json && !isFinite(message.Price) ? String(message.Price) : message.Price;
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            object.Quantity = options.json && !isFinite(message.Quantity) ? String(message.Quantity) : message.Quantity;
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            object.Expiry = options.enums === String ? $root.ExpirationType[message.Expiry] : message.Expiry;
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate"))
            object.ExpiryDate = $root.google.protobuf.StringValue.toObject(message.ExpiryDate, options);
        return object;
    };

    /**
     * Converts this AmendPendingOrderRequest to JSON.
     * @function toJSON
     * @memberof AmendPendingOrderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AmendPendingOrderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AmendPendingOrderRequest;
})();

$root.AmendPendingOrderResponse = (function() {

    /**
     * Properties of an AmendPendingOrderResponse.
     * @exports IAmendPendingOrderResponse
     * @interface IAmendPendingOrderResponse
     * @property {boolean|null} [Accepted] AmendPendingOrderResponse Accepted
     * @property {string|null} [Reason] AmendPendingOrderResponse Reason
     */

    /**
     * Constructs a new AmendPendingOrderResponse.
     * @exports AmendPendingOrderResponse
     * @classdesc Represents an AmendPendingOrderResponse.
     * @implements IAmendPendingOrderResponse
     * @constructor
     * @param {IAmendPendingOrderResponse=} [properties] Properties to set
     */
    function AmendPendingOrderResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AmendPendingOrderResponse Accepted.
     * @member {boolean} Accepted
     * @memberof AmendPendingOrderResponse
     * @instance
     */
    AmendPendingOrderResponse.prototype.Accepted = false;

    /**
     * AmendPendingOrderResponse Reason.
     * @member {string} Reason
     * @memberof AmendPendingOrderResponse
     * @instance
     */
    AmendPendingOrderResponse.prototype.Reason = "";

    /**
     * Creates a new AmendPendingOrderResponse instance using the specified properties.
     * @function create
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {IAmendPendingOrderResponse=} [properties] Properties to set
     * @returns {AmendPendingOrderResponse} AmendPendingOrderResponse instance
     */
    AmendPendingOrderResponse.create = function create(properties) {
        return new AmendPendingOrderResponse(properties);
    };

    /**
     * Encodes the specified AmendPendingOrderResponse message. Does not implicitly {@link AmendPendingOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {IAmendPendingOrderResponse} message AmendPendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AmendPendingOrderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified AmendPendingOrderResponse message, length delimited. Does not implicitly {@link AmendPendingOrderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {IAmendPendingOrderResponse} message AmendPendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AmendPendingOrderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AmendPendingOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AmendPendingOrderResponse} AmendPendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AmendPendingOrderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AmendPendingOrderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AmendPendingOrderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AmendPendingOrderResponse} AmendPendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AmendPendingOrderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AmendPendingOrderResponse message.
     * @function verify
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AmendPendingOrderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates an AmendPendingOrderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AmendPendingOrderResponse} AmendPendingOrderResponse
     */
    AmendPendingOrderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AmendPendingOrderResponse)
            return object;
        var message = new $root.AmendPendingOrderResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from an AmendPendingOrderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AmendPendingOrderResponse
     * @static
     * @param {AmendPendingOrderResponse} message AmendPendingOrderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AmendPendingOrderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this AmendPendingOrderResponse to JSON.
     * @function toJSON
     * @memberof AmendPendingOrderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AmendPendingOrderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AmendPendingOrderResponse;
})();











































$root.google = (function() {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    var google = {};

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        var protobuf = {};

        protobuf.DoubleValue = (function() {

            /**
             * Properties of a DoubleValue.
             * @memberof google.protobuf
             * @interface IDoubleValue
             * @property {number|null} [value] DoubleValue value
             */

            /**
             * Constructs a new DoubleValue.
             * @memberof google.protobuf
             * @classdesc Represents a DoubleValue.
             * @implements IDoubleValue
             * @constructor
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             */
            function DoubleValue(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DoubleValue value.
             * @member {number} value
             * @memberof google.protobuf.DoubleValue
             * @instance
             */
            DoubleValue.prototype.value = 0;

            /**
             * Creates a new DoubleValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
             * @returns {google.protobuf.DoubleValue} DoubleValue instance
             */
            DoubleValue.create = function create(properties) {
                return new DoubleValue(properties);
            };

            /**
             * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 1 =*/9).double(message.value);
                return writer;
            };

            /**
             * Encodes the specified DoubleValue message, length delimited. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DoubleValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DoubleValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.DoubleValue} DoubleValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DoubleValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DoubleValue message.
             * @function verify
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DoubleValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.DoubleValue} DoubleValue
             */
            DoubleValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DoubleValue)
                    return object;
                var message = new $root.google.protobuf.DoubleValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.DoubleValue
             * @static
             * @param {google.protobuf.DoubleValue} message DoubleValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DoubleValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this DoubleValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.DoubleValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DoubleValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DoubleValue;
        })();

        protobuf.FloatValue = (function() {

            /**
             * Properties of a FloatValue.
             * @memberof google.protobuf
             * @interface IFloatValue
             * @property {number|null} [value] FloatValue value
             */

            /**
             * Constructs a new FloatValue.
             * @memberof google.protobuf
             * @classdesc Represents a FloatValue.
             * @implements IFloatValue
             * @constructor
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             */
            function FloatValue(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FloatValue value.
             * @member {number} value
             * @memberof google.protobuf.FloatValue
             * @instance
             */
            FloatValue.prototype.value = 0;

            /**
             * Creates a new FloatValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue=} [properties] Properties to set
             * @returns {google.protobuf.FloatValue} FloatValue instance
             */
            FloatValue.create = function create(properties) {
                return new FloatValue(properties);
            };

            /**
             * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
                return writer;
            };

            /**
             * Encodes the specified FloatValue message, length delimited. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FloatValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.float();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FloatValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FloatValue} FloatValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FloatValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FloatValue message.
             * @function verify
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FloatValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "number")
                        return "value: number expected";
                return null;
            };

            /**
             * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FloatValue} FloatValue
             */
            FloatValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FloatValue)
                    return object;
                var message = new $root.google.protobuf.FloatValue();
                if (object.value != null)
                    message.value = Number(object.value);
                return message;
            };

            /**
             * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FloatValue
             * @static
             * @param {google.protobuf.FloatValue} message FloatValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FloatValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                return object;
            };

            /**
             * Converts this FloatValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.FloatValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FloatValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FloatValue;
        })();

        protobuf.Int64Value = (function() {

            /**
             * Properties of an Int64Value.
             * @memberof google.protobuf
             * @interface IInt64Value
             * @property {number|Long|null} [value] Int64Value value
             */

            /**
             * Constructs a new Int64Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int64Value.
             * @implements IInt64Value
             * @constructor
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             */
            function Int64Value(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.Int64Value
             * @instance
             */
            Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Int64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.Int64Value} Int64Value instance
             */
            Int64Value.create = function create(properties) {
                return new Int64Value(properties);
            };

            /**
             * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int64Value message, length delimited. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int64Value();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int64Value} Int64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int64Value message.
             * @function verify
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int64Value} Int64Value
             */
            Int64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int64Value)
                    return object;
                var message = new $root.google.protobuf.Int64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = false;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int64Value
             * @static
             * @param {google.protobuf.Int64Value} message Int64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber() : message.value;
                return object;
            };

            /**
             * Converts this Int64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int64Value;
        })();

        protobuf.UInt64Value = (function() {

            /**
             * Properties of a UInt64Value.
             * @memberof google.protobuf
             * @interface IUInt64Value
             * @property {number|Long|null} [value] UInt64Value value
             */

            /**
             * Constructs a new UInt64Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt64Value.
             * @implements IUInt64Value
             * @constructor
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             */
            function UInt64Value(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt64Value value.
             * @member {number|Long} value
             * @memberof google.protobuf.UInt64Value
             * @instance
             */
            UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * Creates a new UInt64Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt64Value} UInt64Value instance
             */
            UInt64Value.create = function create(properties) {
                return new UInt64Value(properties);
            };

            /**
             * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt64Value message, length delimited. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt64Value();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt64Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt64Value} UInt64Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt64Value message.
             * @function verify
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt64Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                        return "value: integer|Long expected";
                return null;
            };

            /**
             * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt64Value} UInt64Value
             */
            UInt64Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt64Value)
                    return object;
                var message = new $root.google.protobuf.UInt64Value();
                if (object.value != null)
                    if ($util.Long)
                        (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                    else if (typeof object.value === "string")
                        message.value = parseInt(object.value, 10);
                    else if (typeof object.value === "number")
                        message.value = object.value;
                    else if (typeof object.value === "object")
                        message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
                return message;
            };

            /**
             * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt64Value
             * @static
             * @param {google.protobuf.UInt64Value} message UInt64Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt64Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.value = options.longs === String ? "0" : 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value === "number")
                        object.value = options.longs === String ? String(message.value) : message.value;
                    else
                        object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
                return object;
            };

            /**
             * Converts this UInt64Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt64Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt64Value;
        })();

        protobuf.Int32Value = (function() {

            /**
             * Properties of an Int32Value.
             * @memberof google.protobuf
             * @interface IInt32Value
             * @property {number|null} [value] Int32Value value
             */

            /**
             * Constructs a new Int32Value.
             * @memberof google.protobuf
             * @classdesc Represents an Int32Value.
             * @implements IInt32Value
             * @constructor
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             */
            function Int32Value(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Int32Value value.
             * @member {number} value
             * @memberof google.protobuf.Int32Value
             * @instance
             */
            Int32Value.prototype.value = 0;

            /**
             * Creates a new Int32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.Int32Value} Int32Value instance
             */
            Int32Value.create = function create(properties) {
                return new Int32Value(properties);
            };

            /**
             * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                return writer;
            };

            /**
             * Encodes the specified Int32Value message, length delimited. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int32Value();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an Int32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.Int32Value} Int32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Int32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an Int32Value message.
             * @function verify
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Int32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.Int32Value} Int32Value
             */
            Int32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.Int32Value)
                    return object;
                var message = new $root.google.protobuf.Int32Value();
                if (object.value != null)
                    message.value = object.value | 0;
                return message;
            };

            /**
             * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.Int32Value
             * @static
             * @param {google.protobuf.Int32Value} message Int32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Int32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this Int32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.Int32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Int32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int32Value;
        })();

        protobuf.UInt32Value = (function() {

            /**
             * Properties of a UInt32Value.
             * @memberof google.protobuf
             * @interface IUInt32Value
             * @property {number|null} [value] UInt32Value value
             */

            /**
             * Constructs a new UInt32Value.
             * @memberof google.protobuf
             * @classdesc Represents a UInt32Value.
             * @implements IUInt32Value
             * @constructor
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             */
            function UInt32Value(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UInt32Value value.
             * @member {number} value
             * @memberof google.protobuf.UInt32Value
             * @instance
             */
            UInt32Value.prototype.value = 0;

            /**
             * Creates a new UInt32Value instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
             * @returns {google.protobuf.UInt32Value} UInt32Value instance
             */
            UInt32Value.create = function create(properties) {
                return new UInt32Value(properties);
            };

            /**
             * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                return writer;
            };

            /**
             * Encodes the specified UInt32Value message, length delimited. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt32Value();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.uint32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a UInt32Value message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UInt32Value} UInt32Value
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UInt32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a UInt32Value message.
             * @function verify
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UInt32Value.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isInteger(message.value))
                        return "value: integer expected";
                return null;
            };

            /**
             * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UInt32Value} UInt32Value
             */
            UInt32Value.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UInt32Value)
                    return object;
                var message = new $root.google.protobuf.UInt32Value();
                if (object.value != null)
                    message.value = object.value >>> 0;
                return message;
            };

            /**
             * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UInt32Value
             * @static
             * @param {google.protobuf.UInt32Value} message UInt32Value
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UInt32Value.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = 0;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this UInt32Value to JSON.
             * @function toJSON
             * @memberof google.protobuf.UInt32Value
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UInt32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt32Value;
        })();

        protobuf.BoolValue = (function() {

            /**
             * Properties of a BoolValue.
             * @memberof google.protobuf
             * @interface IBoolValue
             * @property {boolean|null} [value] BoolValue value
             */

            /**
             * Constructs a new BoolValue.
             * @memberof google.protobuf
             * @classdesc Represents a BoolValue.
             * @implements IBoolValue
             * @constructor
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             */
            function BoolValue(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BoolValue value.
             * @member {boolean} value
             * @memberof google.protobuf.BoolValue
             * @instance
             */
            BoolValue.prototype.value = false;

            /**
             * Creates a new BoolValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue=} [properties] Properties to set
             * @returns {google.protobuf.BoolValue} BoolValue instance
             */
            BoolValue.create = function create(properties) {
                return new BoolValue(properties);
            };

            /**
             * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                return writer;
            };

            /**
             * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BoolValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BoolValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BoolValue} BoolValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BoolValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BoolValue message.
             * @function verify
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BoolValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (typeof message.value !== "boolean")
                        return "value: boolean expected";
                return null;
            };

            /**
             * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BoolValue} BoolValue
             */
            BoolValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BoolValue)
                    return object;
                var message = new $root.google.protobuf.BoolValue();
                if (object.value != null)
                    message.value = Boolean(object.value);
                return message;
            };

            /**
             * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BoolValue
             * @static
             * @param {google.protobuf.BoolValue} message BoolValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BoolValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = false;
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this BoolValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BoolValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BoolValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BoolValue;
        })();

        protobuf.StringValue = (function() {

            /**
             * Properties of a StringValue.
             * @memberof google.protobuf
             * @interface IStringValue
             * @property {string|null} [value] StringValue value
             */

            /**
             * Constructs a new StringValue.
             * @memberof google.protobuf
             * @classdesc Represents a StringValue.
             * @implements IStringValue
             * @constructor
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             */
            function StringValue(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StringValue value.
             * @member {string} value
             * @memberof google.protobuf.StringValue
             * @instance
             */
            StringValue.prototype.value = "";

            /**
             * Creates a new StringValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue=} [properties] Properties to set
             * @returns {google.protobuf.StringValue} StringValue instance
             */
            StringValue.create = function create(properties) {
                return new StringValue(properties);
            };

            /**
             * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                return writer;
            };

            /**
             * Encodes the specified StringValue message, length delimited. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StringValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.StringValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StringValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.StringValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.StringValue} StringValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StringValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StringValue message.
             * @function verify
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StringValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!$util.isString(message.value))
                        return "value: string expected";
                return null;
            };

            /**
             * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.StringValue} StringValue
             */
            StringValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.StringValue)
                    return object;
                var message = new $root.google.protobuf.StringValue();
                if (object.value != null)
                    message.value = String(object.value);
                return message;
            };

            /**
             * Creates a plain object from a StringValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.StringValue
             * @static
             * @param {google.protobuf.StringValue} message StringValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StringValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.value = "";
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = message.value;
                return object;
            };

            /**
             * Converts this StringValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.StringValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StringValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StringValue;
        })();

        protobuf.BytesValue = (function() {

            /**
             * Properties of a BytesValue.
             * @memberof google.protobuf
             * @interface IBytesValue
             * @property {Uint8Array|null} [value] BytesValue value
             */

            /**
             * Constructs a new BytesValue.
             * @memberof google.protobuf
             * @classdesc Represents a BytesValue.
             * @implements IBytesValue
             * @constructor
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             */
            function BytesValue(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * BytesValue value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.BytesValue
             * @instance
             */
            BytesValue.prototype.value = $util.newBuffer([]);

            /**
             * Creates a new BytesValue instance using the specified properties.
             * @function create
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue=} [properties] Properties to set
             * @returns {google.protobuf.BytesValue} BytesValue instance
             */
            BytesValue.create = function create(properties) {
                return new BytesValue(properties);
            };

            /**
             * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                    writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                return writer;
            };

            /**
             * Encodes the specified BytesValue message, length delimited. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BytesValue();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.value = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a BytesValue message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.BytesValue} BytesValue
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            BytesValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a BytesValue message.
             * @function verify
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            BytesValue.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.value != null && message.hasOwnProperty("value"))
                    if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                        return "value: buffer expected";
                return null;
            };

            /**
             * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.BytesValue} BytesValue
             */
            BytesValue.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.BytesValue)
                    return object;
                var message = new $root.google.protobuf.BytesValue();
                if (object.value != null)
                    if (typeof object.value === "string")
                        $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                    else if (object.value.length)
                        message.value = object.value;
                return message;
            };

            /**
             * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.BytesValue
             * @static
             * @param {google.protobuf.BytesValue} message BytesValue
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            BytesValue.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if (options.bytes === String)
                        object.value = "";
                    else {
                        object.value = [];
                        if (options.bytes !== Array)
                            object.value = $util.newBuffer(object.value);
                    }
                if (message.value != null && message.hasOwnProperty("value"))
                    object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                return object;
            };

            /**
             * Converts this BytesValue to JSON.
             * @function toJSON
             * @memberof google.protobuf.BytesValue
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            BytesValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BytesValue;
        })();

        return protobuf;
    })();

    return google;
})();

$root.AuthenticationRequest = (function() {

    /**
     * Properties of an AuthenticationRequest.
     * @exports IAuthenticationRequest
     * @interface IAuthenticationRequest
     * @property {string|null} [Token] AuthenticationRequest Token
     */

    /**
     * Constructs a new AuthenticationRequest.
     * @exports AuthenticationRequest
     * @classdesc Represents an AuthenticationRequest.
     * @implements IAuthenticationRequest
     * @constructor
     * @param {IAuthenticationRequest=} [properties] Properties to set
     */
    function AuthenticationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AuthenticationRequest Token.
     * @member {string} Token
     * @memberof AuthenticationRequest
     * @instance
     */
    AuthenticationRequest.prototype.Token = "";

    /**
     * Creates a new AuthenticationRequest instance using the specified properties.
     * @function create
     * @memberof AuthenticationRequest
     * @static
     * @param {IAuthenticationRequest=} [properties] Properties to set
     * @returns {AuthenticationRequest} AuthenticationRequest instance
     */
    AuthenticationRequest.create = function create(properties) {
        return new AuthenticationRequest(properties);
    };

    /**
     * Encodes the specified AuthenticationRequest message. Does not implicitly {@link AuthenticationRequest.verify|verify} messages.
     * @function encode
     * @memberof AuthenticationRequest
     * @static
     * @param {IAuthenticationRequest} message AuthenticationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthenticationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Token);
        return writer;
    };

    /**
     * Encodes the specified AuthenticationRequest message, length delimited. Does not implicitly {@link AuthenticationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AuthenticationRequest
     * @static
     * @param {IAuthenticationRequest} message AuthenticationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthenticationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AuthenticationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AuthenticationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AuthenticationRequest} AuthenticationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthenticationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AuthenticationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Token = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AuthenticationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AuthenticationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AuthenticationRequest} AuthenticationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthenticationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AuthenticationRequest message.
     * @function verify
     * @memberof AuthenticationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AuthenticationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Token != null && message.hasOwnProperty("Token"))
            if (!$util.isString(message.Token))
                return "Token: string expected";
        return null;
    };

    /**
     * Creates an AuthenticationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AuthenticationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AuthenticationRequest} AuthenticationRequest
     */
    AuthenticationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AuthenticationRequest)
            return object;
        var message = new $root.AuthenticationRequest();
        if (object.Token != null)
            message.Token = String(object.Token);
        return message;
    };

    /**
     * Creates a plain object from an AuthenticationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AuthenticationRequest
     * @static
     * @param {AuthenticationRequest} message AuthenticationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AuthenticationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Token = "";
        if (message.Token != null && message.hasOwnProperty("Token"))
            object.Token = message.Token;
        return object;
    };

    /**
     * Converts this AuthenticationRequest to JSON.
     * @function toJSON
     * @memberof AuthenticationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AuthenticationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthenticationRequest;
})();

$root.AuthenticationResponse = (function() {

    /**
     * Properties of an AuthenticationResponse.
     * @exports IAuthenticationResponse
     * @interface IAuthenticationResponse
     */

    /**
     * Constructs a new AuthenticationResponse.
     * @exports AuthenticationResponse
     * @classdesc Represents an AuthenticationResponse.
     * @implements IAuthenticationResponse
     * @constructor
     * @param {IAuthenticationResponse=} [properties] Properties to set
     */
    function AuthenticationResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new AuthenticationResponse instance using the specified properties.
     * @function create
     * @memberof AuthenticationResponse
     * @static
     * @param {IAuthenticationResponse=} [properties] Properties to set
     * @returns {AuthenticationResponse} AuthenticationResponse instance
     */
    AuthenticationResponse.create = function create(properties) {
        return new AuthenticationResponse(properties);
    };

    /**
     * Encodes the specified AuthenticationResponse message. Does not implicitly {@link AuthenticationResponse.verify|verify} messages.
     * @function encode
     * @memberof AuthenticationResponse
     * @static
     * @param {IAuthenticationResponse} message AuthenticationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthenticationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified AuthenticationResponse message, length delimited. Does not implicitly {@link AuthenticationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AuthenticationResponse
     * @static
     * @param {IAuthenticationResponse} message AuthenticationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AuthenticationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AuthenticationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AuthenticationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AuthenticationResponse} AuthenticationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthenticationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AuthenticationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AuthenticationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AuthenticationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AuthenticationResponse} AuthenticationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AuthenticationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AuthenticationResponse message.
     * @function verify
     * @memberof AuthenticationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AuthenticationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates an AuthenticationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AuthenticationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AuthenticationResponse} AuthenticationResponse
     */
    AuthenticationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AuthenticationResponse)
            return object;
        return new $root.AuthenticationResponse();
    };

    /**
     * Creates a plain object from an AuthenticationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AuthenticationResponse
     * @static
     * @param {AuthenticationResponse} message AuthenticationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AuthenticationResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this AuthenticationResponse to JSON.
     * @function toJSON
     * @memberof AuthenticationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AuthenticationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AuthenticationResponse;
})();

$root.CancelAllOrdersRequest = (function() {

    /**
     * Properties of a CancelAllOrdersRequest.
     * @exports ICancelAllOrdersRequest
     * @interface ICancelAllOrdersRequest
     * @property {number|null} [ClientId] CancelAllOrdersRequest ClientId
     */

    /**
     * Constructs a new CancelAllOrdersRequest.
     * @exports CancelAllOrdersRequest
     * @classdesc Represents a CancelAllOrdersRequest.
     * @implements ICancelAllOrdersRequest
     * @constructor
     * @param {ICancelAllOrdersRequest=} [properties] Properties to set
     */
    function CancelAllOrdersRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CancelAllOrdersRequest ClientId.
     * @member {number} ClientId
     * @memberof CancelAllOrdersRequest
     * @instance
     */
    CancelAllOrdersRequest.prototype.ClientId = 0;

    /**
     * Creates a new CancelAllOrdersRequest instance using the specified properties.
     * @function create
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {ICancelAllOrdersRequest=} [properties] Properties to set
     * @returns {CancelAllOrdersRequest} CancelAllOrdersRequest instance
     */
    CancelAllOrdersRequest.create = function create(properties) {
        return new CancelAllOrdersRequest(properties);
    };

    /**
     * Encodes the specified CancelAllOrdersRequest message. Does not implicitly {@link CancelAllOrdersRequest.verify|verify} messages.
     * @function encode
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {ICancelAllOrdersRequest} message CancelAllOrdersRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelAllOrdersRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClientId);
        return writer;
    };

    /**
     * Encodes the specified CancelAllOrdersRequest message, length delimited. Does not implicitly {@link CancelAllOrdersRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {ICancelAllOrdersRequest} message CancelAllOrdersRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelAllOrdersRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelAllOrdersRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelAllOrdersRequest} CancelAllOrdersRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelAllOrdersRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelAllOrdersRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClientId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelAllOrdersRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelAllOrdersRequest} CancelAllOrdersRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelAllOrdersRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelAllOrdersRequest message.
     * @function verify
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelAllOrdersRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        return null;
    };

    /**
     * Creates a CancelAllOrdersRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelAllOrdersRequest} CancelAllOrdersRequest
     */
    CancelAllOrdersRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelAllOrdersRequest)
            return object;
        var message = new $root.CancelAllOrdersRequest();
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        return message;
    };

    /**
     * Creates a plain object from a CancelAllOrdersRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelAllOrdersRequest
     * @static
     * @param {CancelAllOrdersRequest} message CancelAllOrdersRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelAllOrdersRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.ClientId = 0;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        return object;
    };

    /**
     * Converts this CancelAllOrdersRequest to JSON.
     * @function toJSON
     * @memberof CancelAllOrdersRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelAllOrdersRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelAllOrdersRequest;
})();

$root.CancelAllOrdersResponse = (function() {

    /**
     * Properties of a CancelAllOrdersResponse.
     * @exports ICancelAllOrdersResponse
     * @interface ICancelAllOrdersResponse
     */

    /**
     * Constructs a new CancelAllOrdersResponse.
     * @exports CancelAllOrdersResponse
     * @classdesc Represents a CancelAllOrdersResponse.
     * @implements ICancelAllOrdersResponse
     * @constructor
     * @param {ICancelAllOrdersResponse=} [properties] Properties to set
     */
    function CancelAllOrdersResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new CancelAllOrdersResponse instance using the specified properties.
     * @function create
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {ICancelAllOrdersResponse=} [properties] Properties to set
     * @returns {CancelAllOrdersResponse} CancelAllOrdersResponse instance
     */
    CancelAllOrdersResponse.create = function create(properties) {
        return new CancelAllOrdersResponse(properties);
    };

    /**
     * Encodes the specified CancelAllOrdersResponse message. Does not implicitly {@link CancelAllOrdersResponse.verify|verify} messages.
     * @function encode
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {ICancelAllOrdersResponse} message CancelAllOrdersResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelAllOrdersResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified CancelAllOrdersResponse message, length delimited. Does not implicitly {@link CancelAllOrdersResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {ICancelAllOrdersResponse} message CancelAllOrdersResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelAllOrdersResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelAllOrdersResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelAllOrdersResponse} CancelAllOrdersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelAllOrdersResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelAllOrdersResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelAllOrdersResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelAllOrdersResponse} CancelAllOrdersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelAllOrdersResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelAllOrdersResponse message.
     * @function verify
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelAllOrdersResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a CancelAllOrdersResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelAllOrdersResponse} CancelAllOrdersResponse
     */
    CancelAllOrdersResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelAllOrdersResponse)
            return object;
        return new $root.CancelAllOrdersResponse();
    };

    /**
     * Creates a plain object from a CancelAllOrdersResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelAllOrdersResponse
     * @static
     * @param {CancelAllOrdersResponse} message CancelAllOrdersResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelAllOrdersResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this CancelAllOrdersResponse to JSON.
     * @function toJSON
     * @memberof CancelAllOrdersResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelAllOrdersResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelAllOrdersResponse;
})();

$root.CancelPendingOrderRequest = (function() {

    /**
     * Properties of a CancelPendingOrderRequest.
     * @exports ICancelPendingOrderRequest
     * @interface ICancelPendingOrderRequest
     * @property {string|null} [OrderId] CancelPendingOrderRequest OrderId
     */

    /**
     * Constructs a new CancelPendingOrderRequest.
     * @exports CancelPendingOrderRequest
     * @classdesc Represents a CancelPendingOrderRequest.
     * @implements ICancelPendingOrderRequest
     * @constructor
     * @param {ICancelPendingOrderRequest=} [properties] Properties to set
     */
    function CancelPendingOrderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CancelPendingOrderRequest OrderId.
     * @member {string} OrderId
     * @memberof CancelPendingOrderRequest
     * @instance
     */
    CancelPendingOrderRequest.prototype.OrderId = "";

    /**
     * Creates a new CancelPendingOrderRequest instance using the specified properties.
     * @function create
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {ICancelPendingOrderRequest=} [properties] Properties to set
     * @returns {CancelPendingOrderRequest} CancelPendingOrderRequest instance
     */
    CancelPendingOrderRequest.create = function create(properties) {
        return new CancelPendingOrderRequest(properties);
    };

    /**
     * Encodes the specified CancelPendingOrderRequest message. Does not implicitly {@link CancelPendingOrderRequest.verify|verify} messages.
     * @function encode
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {ICancelPendingOrderRequest} message CancelPendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelPendingOrderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OrderId != null && Object.hasOwnProperty.call(message, "OrderId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.OrderId);
        return writer;
    };

    /**
     * Encodes the specified CancelPendingOrderRequest message, length delimited. Does not implicitly {@link CancelPendingOrderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {ICancelPendingOrderRequest} message CancelPendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelPendingOrderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelPendingOrderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelPendingOrderRequest} CancelPendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelPendingOrderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelPendingOrderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.OrderId = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelPendingOrderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelPendingOrderRequest} CancelPendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelPendingOrderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelPendingOrderRequest message.
     * @function verify
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelPendingOrderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            if (!$util.isString(message.OrderId))
                return "OrderId: string expected";
        return null;
    };

    /**
     * Creates a CancelPendingOrderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelPendingOrderRequest} CancelPendingOrderRequest
     */
    CancelPendingOrderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelPendingOrderRequest)
            return object;
        var message = new $root.CancelPendingOrderRequest();
        if (object.OrderId != null)
            message.OrderId = String(object.OrderId);
        return message;
    };

    /**
     * Creates a plain object from a CancelPendingOrderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelPendingOrderRequest
     * @static
     * @param {CancelPendingOrderRequest} message CancelPendingOrderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelPendingOrderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.OrderId = "";
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            object.OrderId = message.OrderId;
        return object;
    };

    /**
     * Converts this CancelPendingOrderRequest to JSON.
     * @function toJSON
     * @memberof CancelPendingOrderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelPendingOrderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelPendingOrderRequest;
})();

$root.CancelPendingOrderResponse = (function() {

    /**
     * Properties of a CancelPendingOrderResponse.
     * @exports ICancelPendingOrderResponse
     * @interface ICancelPendingOrderResponse
     */

    /**
     * Constructs a new CancelPendingOrderResponse.
     * @exports CancelPendingOrderResponse
     * @classdesc Represents a CancelPendingOrderResponse.
     * @implements ICancelPendingOrderResponse
     * @constructor
     * @param {ICancelPendingOrderResponse=} [properties] Properties to set
     */
    function CancelPendingOrderResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new CancelPendingOrderResponse instance using the specified properties.
     * @function create
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {ICancelPendingOrderResponse=} [properties] Properties to set
     * @returns {CancelPendingOrderResponse} CancelPendingOrderResponse instance
     */
    CancelPendingOrderResponse.create = function create(properties) {
        return new CancelPendingOrderResponse(properties);
    };

    /**
     * Encodes the specified CancelPendingOrderResponse message. Does not implicitly {@link CancelPendingOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {ICancelPendingOrderResponse} message CancelPendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelPendingOrderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified CancelPendingOrderResponse message, length delimited. Does not implicitly {@link CancelPendingOrderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {ICancelPendingOrderResponse} message CancelPendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CancelPendingOrderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CancelPendingOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CancelPendingOrderResponse} CancelPendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelPendingOrderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CancelPendingOrderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CancelPendingOrderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CancelPendingOrderResponse} CancelPendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CancelPendingOrderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CancelPendingOrderResponse message.
     * @function verify
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CancelPendingOrderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a CancelPendingOrderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CancelPendingOrderResponse} CancelPendingOrderResponse
     */
    CancelPendingOrderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CancelPendingOrderResponse)
            return object;
        return new $root.CancelPendingOrderResponse();
    };

    /**
     * Creates a plain object from a CancelPendingOrderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CancelPendingOrderResponse
     * @static
     * @param {CancelPendingOrderResponse} message CancelPendingOrderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CancelPendingOrderResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this CancelPendingOrderResponse to JSON.
     * @function toJSON
     * @memberof CancelPendingOrderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CancelPendingOrderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CancelPendingOrderResponse;
})();

$root.ConfigurationRequest = (function() {

    /**
     * Properties of a ConfigurationRequest.
     * @exports IConfigurationRequest
     * @interface IConfigurationRequest
     */

    /**
     * Constructs a new ConfigurationRequest.
     * @exports ConfigurationRequest
     * @classdesc Represents a ConfigurationRequest.
     * @implements IConfigurationRequest
     * @constructor
     * @param {IConfigurationRequest=} [properties] Properties to set
     */
    function ConfigurationRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ConfigurationRequest instance using the specified properties.
     * @function create
     * @memberof ConfigurationRequest
     * @static
     * @param {IConfigurationRequest=} [properties] Properties to set
     * @returns {ConfigurationRequest} ConfigurationRequest instance
     */
    ConfigurationRequest.create = function create(properties) {
        return new ConfigurationRequest(properties);
    };

    /**
     * Encodes the specified ConfigurationRequest message. Does not implicitly {@link ConfigurationRequest.verify|verify} messages.
     * @function encode
     * @memberof ConfigurationRequest
     * @static
     * @param {IConfigurationRequest} message ConfigurationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConfigurationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ConfigurationRequest message, length delimited. Does not implicitly {@link ConfigurationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ConfigurationRequest
     * @static
     * @param {IConfigurationRequest} message ConfigurationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConfigurationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ConfigurationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ConfigurationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ConfigurationRequest} ConfigurationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConfigurationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfigurationRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ConfigurationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ConfigurationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ConfigurationRequest} ConfigurationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConfigurationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ConfigurationRequest message.
     * @function verify
     * @memberof ConfigurationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ConfigurationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ConfigurationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ConfigurationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ConfigurationRequest} ConfigurationRequest
     */
    ConfigurationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfigurationRequest)
            return object;
        return new $root.ConfigurationRequest();
    };

    /**
     * Creates a plain object from a ConfigurationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ConfigurationRequest
     * @static
     * @param {ConfigurationRequest} message ConfigurationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ConfigurationRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ConfigurationRequest to JSON.
     * @function toJSON
     * @memberof ConfigurationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ConfigurationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfigurationRequest;
})();

$root.ConfigurationResponse = (function() {

    /**
     * Properties of a ConfigurationResponse.
     * @exports IConfigurationResponse
     * @interface IConfigurationResponse
     * @property {Array.<string>|null} [Tenors] ConfigurationResponse Tenors
     * @property {ForwardDisplayMode|null} [ForwardDisplayMode] ConfigurationResponse ForwardDisplayMode
     * @property {Array.<PadType>|null} [AvailiableProducts] ConfigurationResponse AvailiableProducts
     * @property {boolean|null} [CurrencyInversionForESP] ConfigurationResponse CurrencyInversionForESP
     * @property {boolean|null} [CurrencyInversionForRFS] ConfigurationResponse CurrencyInversionForRFS
     * @property {boolean|null} [DecimalAmounts] ConfigurationResponse DecimalAmounts
     * @property {boolean|null} [ContactUs] ConfigurationResponse ContactUs
     * @property {boolean|null} [RoundSwaps] ConfigurationResponse RoundSwaps
     * @property {boolean|null} [ExtendedFirmName] ConfigurationResponse ExtendedFirmName
     * @property {number|null} [MaxDefaultPads] ConfigurationResponse MaxDefaultPads
     * @property {number|null} [TradingClickThrottle] ConfigurationResponse TradingClickThrottle
     * @property {string|null} [DefaultCurrencyPair] ConfigurationResponse DefaultCurrencyPair
     */

    /**
     * Constructs a new ConfigurationResponse.
     * @exports ConfigurationResponse
     * @classdesc Represents a ConfigurationResponse.
     * @implements IConfigurationResponse
     * @constructor
     * @param {IConfigurationResponse=} [properties] Properties to set
     */
    function ConfigurationResponse(properties) {
        this.Tenors = [];
        this.AvailiableProducts = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ConfigurationResponse Tenors.
     * @member {Array.<string>} Tenors
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.Tenors = $util.emptyArray;

    /**
     * ConfigurationResponse ForwardDisplayMode.
     * @member {ForwardDisplayMode} ForwardDisplayMode
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.ForwardDisplayMode = 0;

    /**
     * ConfigurationResponse AvailiableProducts.
     * @member {Array.<PadType>} AvailiableProducts
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.AvailiableProducts = $util.emptyArray;

    /**
     * ConfigurationResponse CurrencyInversionForESP.
     * @member {boolean} CurrencyInversionForESP
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.CurrencyInversionForESP = false;

    /**
     * ConfigurationResponse CurrencyInversionForRFS.
     * @member {boolean} CurrencyInversionForRFS
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.CurrencyInversionForRFS = false;

    /**
     * ConfigurationResponse DecimalAmounts.
     * @member {boolean} DecimalAmounts
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.DecimalAmounts = false;

    /**
     * ConfigurationResponse ContactUs.
     * @member {boolean} ContactUs
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.ContactUs = false;

    /**
     * ConfigurationResponse RoundSwaps.
     * @member {boolean} RoundSwaps
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.RoundSwaps = false;

    /**
     * ConfigurationResponse ExtendedFirmName.
     * @member {boolean} ExtendedFirmName
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.ExtendedFirmName = false;

    /**
     * ConfigurationResponse MaxDefaultPads.
     * @member {number} MaxDefaultPads
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.MaxDefaultPads = 0;

    /**
     * ConfigurationResponse TradingClickThrottle.
     * @member {number} TradingClickThrottle
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.TradingClickThrottle = 0;

    /**
     * ConfigurationResponse DefaultCurrencyPair.
     * @member {string} DefaultCurrencyPair
     * @memberof ConfigurationResponse
     * @instance
     */
    ConfigurationResponse.prototype.DefaultCurrencyPair = "";

    /**
     * Creates a new ConfigurationResponse instance using the specified properties.
     * @function create
     * @memberof ConfigurationResponse
     * @static
     * @param {IConfigurationResponse=} [properties] Properties to set
     * @returns {ConfigurationResponse} ConfigurationResponse instance
     */
    ConfigurationResponse.create = function create(properties) {
        return new ConfigurationResponse(properties);
    };

    /**
     * Encodes the specified ConfigurationResponse message. Does not implicitly {@link ConfigurationResponse.verify|verify} messages.
     * @function encode
     * @memberof ConfigurationResponse
     * @static
     * @param {IConfigurationResponse} message ConfigurationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConfigurationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Tenors != null && message.Tenors.length)
            for (var i = 0; i < message.Tenors.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Tenors[i]);
        if (message.ForwardDisplayMode != null && Object.hasOwnProperty.call(message, "ForwardDisplayMode"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ForwardDisplayMode);
        if (message.AvailiableProducts != null && message.AvailiableProducts.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (var i = 0; i < message.AvailiableProducts.length; ++i)
                writer.int32(message.AvailiableProducts[i]);
            writer.ldelim();
        }
        if (message.CurrencyInversionForESP != null && Object.hasOwnProperty.call(message, "CurrencyInversionForESP"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.CurrencyInversionForESP);
        if (message.CurrencyInversionForRFS != null && Object.hasOwnProperty.call(message, "CurrencyInversionForRFS"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.CurrencyInversionForRFS);
        if (message.DecimalAmounts != null && Object.hasOwnProperty.call(message, "DecimalAmounts"))
            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.DecimalAmounts);
        if (message.ContactUs != null && Object.hasOwnProperty.call(message, "ContactUs"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.ContactUs);
        if (message.RoundSwaps != null && Object.hasOwnProperty.call(message, "RoundSwaps"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.RoundSwaps);
        if (message.ExtendedFirmName != null && Object.hasOwnProperty.call(message, "ExtendedFirmName"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.ExtendedFirmName);
        if (message.MaxDefaultPads != null && Object.hasOwnProperty.call(message, "MaxDefaultPads"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.MaxDefaultPads);
        if (message.TradingClickThrottle != null && Object.hasOwnProperty.call(message, "TradingClickThrottle"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.TradingClickThrottle);
        if (message.DefaultCurrencyPair != null && Object.hasOwnProperty.call(message, "DefaultCurrencyPair"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.DefaultCurrencyPair);
        return writer;
    };

    /**
     * Encodes the specified ConfigurationResponse message, length delimited. Does not implicitly {@link ConfigurationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ConfigurationResponse
     * @static
     * @param {IConfigurationResponse} message ConfigurationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConfigurationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ConfigurationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ConfigurationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ConfigurationResponse} ConfigurationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConfigurationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConfigurationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Tenors && message.Tenors.length))
                    message.Tenors = [];
                message.Tenors.push(reader.string());
                break;
            case 2:
                message.ForwardDisplayMode = reader.int32();
                break;
            case 3:
                if (!(message.AvailiableProducts && message.AvailiableProducts.length))
                    message.AvailiableProducts = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.AvailiableProducts.push(reader.int32());
                } else
                    message.AvailiableProducts.push(reader.int32());
                break;
            case 4:
                message.CurrencyInversionForESP = reader.bool();
                break;
            case 5:
                message.CurrencyInversionForRFS = reader.bool();
                break;
            case 6:
                message.DecimalAmounts = reader.bool();
                break;
            case 7:
                message.ContactUs = reader.bool();
                break;
            case 8:
                message.RoundSwaps = reader.bool();
                break;
            case 9:
                message.ExtendedFirmName = reader.bool();
                break;
            case 10:
                message.MaxDefaultPads = reader.int32();
                break;
            case 11:
                message.TradingClickThrottle = reader.int32();
                break;
            case 12:
                message.DefaultCurrencyPair = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ConfigurationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ConfigurationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ConfigurationResponse} ConfigurationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConfigurationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ConfigurationResponse message.
     * @function verify
     * @memberof ConfigurationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ConfigurationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Tenors != null && message.hasOwnProperty("Tenors")) {
            if (!Array.isArray(message.Tenors))
                return "Tenors: array expected";
            for (var i = 0; i < message.Tenors.length; ++i)
                if (!$util.isString(message.Tenors[i]))
                    return "Tenors: string[] expected";
        }
        if (message.ForwardDisplayMode != null && message.hasOwnProperty("ForwardDisplayMode"))
            switch (message.ForwardDisplayMode) {
            default:
                return "ForwardDisplayMode: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.AvailiableProducts != null && message.hasOwnProperty("AvailiableProducts")) {
            if (!Array.isArray(message.AvailiableProducts))
                return "AvailiableProducts: array expected";
            for (var i = 0; i < message.AvailiableProducts.length; ++i)
                switch (message.AvailiableProducts[i]) {
                default:
                    return "AvailiableProducts: enum value[] expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
        }
        if (message.CurrencyInversionForESP != null && message.hasOwnProperty("CurrencyInversionForESP"))
            if (typeof message.CurrencyInversionForESP !== "boolean")
                return "CurrencyInversionForESP: boolean expected";
        if (message.CurrencyInversionForRFS != null && message.hasOwnProperty("CurrencyInversionForRFS"))
            if (typeof message.CurrencyInversionForRFS !== "boolean")
                return "CurrencyInversionForRFS: boolean expected";
        if (message.DecimalAmounts != null && message.hasOwnProperty("DecimalAmounts"))
            if (typeof message.DecimalAmounts !== "boolean")
                return "DecimalAmounts: boolean expected";
        if (message.ContactUs != null && message.hasOwnProperty("ContactUs"))
            if (typeof message.ContactUs !== "boolean")
                return "ContactUs: boolean expected";
        if (message.RoundSwaps != null && message.hasOwnProperty("RoundSwaps"))
            if (typeof message.RoundSwaps !== "boolean")
                return "RoundSwaps: boolean expected";
        if (message.ExtendedFirmName != null && message.hasOwnProperty("ExtendedFirmName"))
            if (typeof message.ExtendedFirmName !== "boolean")
                return "ExtendedFirmName: boolean expected";
        if (message.MaxDefaultPads != null && message.hasOwnProperty("MaxDefaultPads"))
            if (!$util.isInteger(message.MaxDefaultPads))
                return "MaxDefaultPads: integer expected";
        if (message.TradingClickThrottle != null && message.hasOwnProperty("TradingClickThrottle"))
            if (!$util.isInteger(message.TradingClickThrottle))
                return "TradingClickThrottle: integer expected";
        if (message.DefaultCurrencyPair != null && message.hasOwnProperty("DefaultCurrencyPair"))
            if (!$util.isString(message.DefaultCurrencyPair))
                return "DefaultCurrencyPair: string expected";
        return null;
    };

    /**
     * Creates a ConfigurationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ConfigurationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ConfigurationResponse} ConfigurationResponse
     */
    ConfigurationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.ConfigurationResponse)
            return object;
        var message = new $root.ConfigurationResponse();
        if (object.Tenors) {
            if (!Array.isArray(object.Tenors))
                throw TypeError(".ConfigurationResponse.Tenors: array expected");
            message.Tenors = [];
            for (var i = 0; i < object.Tenors.length; ++i)
                message.Tenors[i] = String(object.Tenors[i]);
        }
        switch (object.ForwardDisplayMode) {
        case "FORWARDDISPLAYMODE_POINTS":
        case 0:
            message.ForwardDisplayMode = 0;
            break;
        case "FORWARDDISPLAYMODE_SPOTPRICE":
        case 1:
            message.ForwardDisplayMode = 1;
            break;
        case "FORWARDDISPLAYMODE_SIMPLIFIED":
        case 2:
            message.ForwardDisplayMode = 2;
            break;
        }
        if (object.AvailiableProducts) {
            if (!Array.isArray(object.AvailiableProducts))
                throw TypeError(".ConfigurationResponse.AvailiableProducts: array expected");
            message.AvailiableProducts = [];
            for (var i = 0; i < object.AvailiableProducts.length; ++i)
                switch (object.AvailiableProducts[i]) {
                default:
                case "PADTYPE_SPOT":
                case 0:
                    message.AvailiableProducts[i] = 0;
                    break;
                case "PADTYPE_FORWARD":
                case 1:
                    message.AvailiableProducts[i] = 1;
                    break;
                case "PADTYPE_SWAP":
                case 2:
                    message.AvailiableProducts[i] = 2;
                    break;
                case "PADTYPE_PENDING":
                case 3:
                    message.AvailiableProducts[i] = 3;
                    break;
                }
        }
        if (object.CurrencyInversionForESP != null)
            message.CurrencyInversionForESP = Boolean(object.CurrencyInversionForESP);
        if (object.CurrencyInversionForRFS != null)
            message.CurrencyInversionForRFS = Boolean(object.CurrencyInversionForRFS);
        if (object.DecimalAmounts != null)
            message.DecimalAmounts = Boolean(object.DecimalAmounts);
        if (object.ContactUs != null)
            message.ContactUs = Boolean(object.ContactUs);
        if (object.RoundSwaps != null)
            message.RoundSwaps = Boolean(object.RoundSwaps);
        if (object.ExtendedFirmName != null)
            message.ExtendedFirmName = Boolean(object.ExtendedFirmName);
        if (object.MaxDefaultPads != null)
            message.MaxDefaultPads = object.MaxDefaultPads | 0;
        if (object.TradingClickThrottle != null)
            message.TradingClickThrottle = object.TradingClickThrottle | 0;
        if (object.DefaultCurrencyPair != null)
            message.DefaultCurrencyPair = String(object.DefaultCurrencyPair);
        return message;
    };

    /**
     * Creates a plain object from a ConfigurationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ConfigurationResponse
     * @static
     * @param {ConfigurationResponse} message ConfigurationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ConfigurationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Tenors = [];
            object.AvailiableProducts = [];
        }
        if (options.defaults) {
            object.ForwardDisplayMode = options.enums === String ? "FORWARDDISPLAYMODE_POINTS" : 0;
            object.CurrencyInversionForESP = false;
            object.CurrencyInversionForRFS = false;
            object.DecimalAmounts = false;
            object.ContactUs = false;
            object.RoundSwaps = false;
            object.ExtendedFirmName = false;
            object.MaxDefaultPads = 0;
            object.TradingClickThrottle = 0;
            object.DefaultCurrencyPair = "";
        }
        if (message.Tenors && message.Tenors.length) {
            object.Tenors = [];
            for (var j = 0; j < message.Tenors.length; ++j)
                object.Tenors[j] = message.Tenors[j];
        }
        if (message.ForwardDisplayMode != null && message.hasOwnProperty("ForwardDisplayMode"))
            object.ForwardDisplayMode = options.enums === String ? $root.ForwardDisplayMode[message.ForwardDisplayMode] : message.ForwardDisplayMode;
        if (message.AvailiableProducts && message.AvailiableProducts.length) {
            object.AvailiableProducts = [];
            for (var j = 0; j < message.AvailiableProducts.length; ++j)
                object.AvailiableProducts[j] = options.enums === String ? $root.PadType[message.AvailiableProducts[j]] : message.AvailiableProducts[j];
        }
        if (message.CurrencyInversionForESP != null && message.hasOwnProperty("CurrencyInversionForESP"))
            object.CurrencyInversionForESP = message.CurrencyInversionForESP;
        if (message.CurrencyInversionForRFS != null && message.hasOwnProperty("CurrencyInversionForRFS"))
            object.CurrencyInversionForRFS = message.CurrencyInversionForRFS;
        if (message.DecimalAmounts != null && message.hasOwnProperty("DecimalAmounts"))
            object.DecimalAmounts = message.DecimalAmounts;
        if (message.ContactUs != null && message.hasOwnProperty("ContactUs"))
            object.ContactUs = message.ContactUs;
        if (message.RoundSwaps != null && message.hasOwnProperty("RoundSwaps"))
            object.RoundSwaps = message.RoundSwaps;
        if (message.ExtendedFirmName != null && message.hasOwnProperty("ExtendedFirmName"))
            object.ExtendedFirmName = message.ExtendedFirmName;
        if (message.MaxDefaultPads != null && message.hasOwnProperty("MaxDefaultPads"))
            object.MaxDefaultPads = message.MaxDefaultPads;
        if (message.TradingClickThrottle != null && message.hasOwnProperty("TradingClickThrottle"))
            object.TradingClickThrottle = message.TradingClickThrottle;
        if (message.DefaultCurrencyPair != null && message.hasOwnProperty("DefaultCurrencyPair"))
            object.DefaultCurrencyPair = message.DefaultCurrencyPair;
        return object;
    };

    /**
     * Converts this ConfigurationResponse to JSON.
     * @function toJSON
     * @memberof ConfigurationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ConfigurationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ConfigurationResponse;
})();

$root.DisclaimerRequest = (function() {

    /**
     * Properties of a DisclaimerRequest.
     * @exports IDisclaimerRequest
     * @interface IDisclaimerRequest
     */

    /**
     * Constructs a new DisclaimerRequest.
     * @exports DisclaimerRequest
     * @classdesc Represents a DisclaimerRequest.
     * @implements IDisclaimerRequest
     * @constructor
     * @param {IDisclaimerRequest=} [properties] Properties to set
     */
    function DisclaimerRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new DisclaimerRequest instance using the specified properties.
     * @function create
     * @memberof DisclaimerRequest
     * @static
     * @param {IDisclaimerRequest=} [properties] Properties to set
     * @returns {DisclaimerRequest} DisclaimerRequest instance
     */
    DisclaimerRequest.create = function create(properties) {
        return new DisclaimerRequest(properties);
    };

    /**
     * Encodes the specified DisclaimerRequest message. Does not implicitly {@link DisclaimerRequest.verify|verify} messages.
     * @function encode
     * @memberof DisclaimerRequest
     * @static
     * @param {IDisclaimerRequest} message DisclaimerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified DisclaimerRequest message, length delimited. Does not implicitly {@link DisclaimerRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DisclaimerRequest
     * @static
     * @param {IDisclaimerRequest} message DisclaimerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DisclaimerRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DisclaimerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DisclaimerRequest} DisclaimerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DisclaimerRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DisclaimerRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DisclaimerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DisclaimerRequest} DisclaimerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DisclaimerRequest message.
     * @function verify
     * @memberof DisclaimerRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DisclaimerRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a DisclaimerRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DisclaimerRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DisclaimerRequest} DisclaimerRequest
     */
    DisclaimerRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DisclaimerRequest)
            return object;
        return new $root.DisclaimerRequest();
    };

    /**
     * Creates a plain object from a DisclaimerRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DisclaimerRequest
     * @static
     * @param {DisclaimerRequest} message DisclaimerRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DisclaimerRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this DisclaimerRequest to JSON.
     * @function toJSON
     * @memberof DisclaimerRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DisclaimerRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DisclaimerRequest;
})();

$root.DisclaimerResponse = (function() {

    /**
     * Properties of a DisclaimerResponse.
     * @exports IDisclaimerResponse
     * @interface IDisclaimerResponse
     * @property {boolean|null} [IsApproved] DisclaimerResponse IsApproved
     * @property {Array.<string>|null} [Clauses] DisclaimerResponse Clauses
     */

    /**
     * Constructs a new DisclaimerResponse.
     * @exports DisclaimerResponse
     * @classdesc Represents a DisclaimerResponse.
     * @implements IDisclaimerResponse
     * @constructor
     * @param {IDisclaimerResponse=} [properties] Properties to set
     */
    function DisclaimerResponse(properties) {
        this.Clauses = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DisclaimerResponse IsApproved.
     * @member {boolean} IsApproved
     * @memberof DisclaimerResponse
     * @instance
     */
    DisclaimerResponse.prototype.IsApproved = false;

    /**
     * DisclaimerResponse Clauses.
     * @member {Array.<string>} Clauses
     * @memberof DisclaimerResponse
     * @instance
     */
    DisclaimerResponse.prototype.Clauses = $util.emptyArray;

    /**
     * Creates a new DisclaimerResponse instance using the specified properties.
     * @function create
     * @memberof DisclaimerResponse
     * @static
     * @param {IDisclaimerResponse=} [properties] Properties to set
     * @returns {DisclaimerResponse} DisclaimerResponse instance
     */
    DisclaimerResponse.create = function create(properties) {
        return new DisclaimerResponse(properties);
    };

    /**
     * Encodes the specified DisclaimerResponse message. Does not implicitly {@link DisclaimerResponse.verify|verify} messages.
     * @function encode
     * @memberof DisclaimerResponse
     * @static
     * @param {IDisclaimerResponse} message DisclaimerResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.IsApproved != null && Object.hasOwnProperty.call(message, "IsApproved"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.IsApproved);
        if (message.Clauses != null && message.Clauses.length)
            for (var i = 0; i < message.Clauses.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Clauses[i]);
        return writer;
    };

    /**
     * Encodes the specified DisclaimerResponse message, length delimited. Does not implicitly {@link DisclaimerResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DisclaimerResponse
     * @static
     * @param {IDisclaimerResponse} message DisclaimerResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DisclaimerResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DisclaimerResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DisclaimerResponse} DisclaimerResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DisclaimerResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.IsApproved = reader.bool();
                break;
            case 2:
                if (!(message.Clauses && message.Clauses.length))
                    message.Clauses = [];
                message.Clauses.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DisclaimerResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DisclaimerResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DisclaimerResponse} DisclaimerResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DisclaimerResponse message.
     * @function verify
     * @memberof DisclaimerResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DisclaimerResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.IsApproved != null && message.hasOwnProperty("IsApproved"))
            if (typeof message.IsApproved !== "boolean")
                return "IsApproved: boolean expected";
        if (message.Clauses != null && message.hasOwnProperty("Clauses")) {
            if (!Array.isArray(message.Clauses))
                return "Clauses: array expected";
            for (var i = 0; i < message.Clauses.length; ++i)
                if (!$util.isString(message.Clauses[i]))
                    return "Clauses: string[] expected";
        }
        return null;
    };

    /**
     * Creates a DisclaimerResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DisclaimerResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DisclaimerResponse} DisclaimerResponse
     */
    DisclaimerResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DisclaimerResponse)
            return object;
        var message = new $root.DisclaimerResponse();
        if (object.IsApproved != null)
            message.IsApproved = Boolean(object.IsApproved);
        if (object.Clauses) {
            if (!Array.isArray(object.Clauses))
                throw TypeError(".DisclaimerResponse.Clauses: array expected");
            message.Clauses = [];
            for (var i = 0; i < object.Clauses.length; ++i)
                message.Clauses[i] = String(object.Clauses[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a DisclaimerResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DisclaimerResponse
     * @static
     * @param {DisclaimerResponse} message DisclaimerResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DisclaimerResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Clauses = [];
        if (options.defaults)
            object.IsApproved = false;
        if (message.IsApproved != null && message.hasOwnProperty("IsApproved"))
            object.IsApproved = message.IsApproved;
        if (message.Clauses && message.Clauses.length) {
            object.Clauses = [];
            for (var j = 0; j < message.Clauses.length; ++j)
                object.Clauses[j] = message.Clauses[j];
        }
        return object;
    };

    /**
     * Converts this DisclaimerResponse to JSON.
     * @function toJSON
     * @memberof DisclaimerResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DisclaimerResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DisclaimerResponse;
})();

$root.DisclaimerApprovalSaveRequest = (function() {

    /**
     * Properties of a DisclaimerApprovalSaveRequest.
     * @exports IDisclaimerApprovalSaveRequest
     * @interface IDisclaimerApprovalSaveRequest
     */

    /**
     * Constructs a new DisclaimerApprovalSaveRequest.
     * @exports DisclaimerApprovalSaveRequest
     * @classdesc Represents a DisclaimerApprovalSaveRequest.
     * @implements IDisclaimerApprovalSaveRequest
     * @constructor
     * @param {IDisclaimerApprovalSaveRequest=} [properties] Properties to set
     */
    function DisclaimerApprovalSaveRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new DisclaimerApprovalSaveRequest instance using the specified properties.
     * @function create
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {IDisclaimerApprovalSaveRequest=} [properties] Properties to set
     * @returns {DisclaimerApprovalSaveRequest} DisclaimerApprovalSaveRequest instance
     */
    DisclaimerApprovalSaveRequest.create = function create(properties) {
        return new DisclaimerApprovalSaveRequest(properties);
    };

    /**
     * Encodes the specified DisclaimerApprovalSaveRequest message. Does not implicitly {@link DisclaimerApprovalSaveRequest.verify|verify} messages.
     * @function encode
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {IDisclaimerApprovalSaveRequest} message DisclaimerApprovalSaveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerApprovalSaveRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified DisclaimerApprovalSaveRequest message, length delimited. Does not implicitly {@link DisclaimerApprovalSaveRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {IDisclaimerApprovalSaveRequest} message DisclaimerApprovalSaveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerApprovalSaveRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DisclaimerApprovalSaveRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DisclaimerApprovalSaveRequest} DisclaimerApprovalSaveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerApprovalSaveRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DisclaimerApprovalSaveRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DisclaimerApprovalSaveRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DisclaimerApprovalSaveRequest} DisclaimerApprovalSaveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerApprovalSaveRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DisclaimerApprovalSaveRequest message.
     * @function verify
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DisclaimerApprovalSaveRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a DisclaimerApprovalSaveRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DisclaimerApprovalSaveRequest} DisclaimerApprovalSaveRequest
     */
    DisclaimerApprovalSaveRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DisclaimerApprovalSaveRequest)
            return object;
        return new $root.DisclaimerApprovalSaveRequest();
    };

    /**
     * Creates a plain object from a DisclaimerApprovalSaveRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DisclaimerApprovalSaveRequest
     * @static
     * @param {DisclaimerApprovalSaveRequest} message DisclaimerApprovalSaveRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DisclaimerApprovalSaveRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this DisclaimerApprovalSaveRequest to JSON.
     * @function toJSON
     * @memberof DisclaimerApprovalSaveRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DisclaimerApprovalSaveRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DisclaimerApprovalSaveRequest;
})();

$root.DisclaimerApprovalSaveResponse = (function() {

    /**
     * Properties of a DisclaimerApprovalSaveResponse.
     * @exports IDisclaimerApprovalSaveResponse
     * @interface IDisclaimerApprovalSaveResponse
     * @property {boolean|null} [Accepted] DisclaimerApprovalSaveResponse Accepted
     * @property {string|null} [Reason] DisclaimerApprovalSaveResponse Reason
     */

    /**
     * Constructs a new DisclaimerApprovalSaveResponse.
     * @exports DisclaimerApprovalSaveResponse
     * @classdesc Represents a DisclaimerApprovalSaveResponse.
     * @implements IDisclaimerApprovalSaveResponse
     * @constructor
     * @param {IDisclaimerApprovalSaveResponse=} [properties] Properties to set
     */
    function DisclaimerApprovalSaveResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DisclaimerApprovalSaveResponse Accepted.
     * @member {boolean} Accepted
     * @memberof DisclaimerApprovalSaveResponse
     * @instance
     */
    DisclaimerApprovalSaveResponse.prototype.Accepted = false;

    /**
     * DisclaimerApprovalSaveResponse Reason.
     * @member {string} Reason
     * @memberof DisclaimerApprovalSaveResponse
     * @instance
     */
    DisclaimerApprovalSaveResponse.prototype.Reason = "";

    /**
     * Creates a new DisclaimerApprovalSaveResponse instance using the specified properties.
     * @function create
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {IDisclaimerApprovalSaveResponse=} [properties] Properties to set
     * @returns {DisclaimerApprovalSaveResponse} DisclaimerApprovalSaveResponse instance
     */
    DisclaimerApprovalSaveResponse.create = function create(properties) {
        return new DisclaimerApprovalSaveResponse(properties);
    };

    /**
     * Encodes the specified DisclaimerApprovalSaveResponse message. Does not implicitly {@link DisclaimerApprovalSaveResponse.verify|verify} messages.
     * @function encode
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {IDisclaimerApprovalSaveResponse} message DisclaimerApprovalSaveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerApprovalSaveResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified DisclaimerApprovalSaveResponse message, length delimited. Does not implicitly {@link DisclaimerApprovalSaveResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {IDisclaimerApprovalSaveResponse} message DisclaimerApprovalSaveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DisclaimerApprovalSaveResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DisclaimerApprovalSaveResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DisclaimerApprovalSaveResponse} DisclaimerApprovalSaveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerApprovalSaveResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.DisclaimerApprovalSaveResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DisclaimerApprovalSaveResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DisclaimerApprovalSaveResponse} DisclaimerApprovalSaveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DisclaimerApprovalSaveResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DisclaimerApprovalSaveResponse message.
     * @function verify
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DisclaimerApprovalSaveResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a DisclaimerApprovalSaveResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DisclaimerApprovalSaveResponse} DisclaimerApprovalSaveResponse
     */
    DisclaimerApprovalSaveResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DisclaimerApprovalSaveResponse)
            return object;
        var message = new $root.DisclaimerApprovalSaveResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a DisclaimerApprovalSaveResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DisclaimerApprovalSaveResponse
     * @static
     * @param {DisclaimerApprovalSaveResponse} message DisclaimerApprovalSaveResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DisclaimerApprovalSaveResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this DisclaimerApprovalSaveResponse to JSON.
     * @function toJSON
     * @memberof DisclaimerApprovalSaveResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DisclaimerApprovalSaveResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return DisclaimerApprovalSaveResponse;
})();

$root.ResponseError = (function() {

    /**
     * Properties of a ResponseError.
     * @exports IResponseError
     * @interface IResponseError
     * @property {number|null} [errorCode] ResponseError errorCode
     * @property {google.protobuf.IStringValue|null} [errorMessage] ResponseError errorMessage
     * @property {SeverityCode|null} [severityCode] ResponseError severityCode
     * @property {boolean|null} [isAutoCloseMessage] ResponseError isAutoCloseMessage
     */

    /**
     * Constructs a new ResponseError.
     * @exports ResponseError
     * @classdesc Represents a ResponseError.
     * @implements IResponseError
     * @constructor
     * @param {IResponseError=} [properties] Properties to set
     */
    function ResponseError(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ResponseError errorCode.
     * @member {number} errorCode
     * @memberof ResponseError
     * @instance
     */
    ResponseError.prototype.errorCode = 0;

    /**
     * ResponseError errorMessage.
     * @member {google.protobuf.IStringValue|null|undefined} errorMessage
     * @memberof ResponseError
     * @instance
     */
    ResponseError.prototype.errorMessage = null;

    /**
     * ResponseError severityCode.
     * @member {SeverityCode} severityCode
     * @memberof ResponseError
     * @instance
     */
    ResponseError.prototype.severityCode = 0;

    /**
     * ResponseError isAutoCloseMessage.
     * @member {boolean} isAutoCloseMessage
     * @memberof ResponseError
     * @instance
     */
    ResponseError.prototype.isAutoCloseMessage = false;

    /**
     * Creates a new ResponseError instance using the specified properties.
     * @function create
     * @memberof ResponseError
     * @static
     * @param {IResponseError=} [properties] Properties to set
     * @returns {ResponseError} ResponseError instance
     */
    ResponseError.create = function create(properties) {
        return new ResponseError(properties);
    };

    /**
     * Encodes the specified ResponseError message. Does not implicitly {@link ResponseError.verify|verify} messages.
     * @function encode
     * @memberof ResponseError
     * @static
     * @param {IResponseError} message ResponseError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResponseError.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.errorCode != null && Object.hasOwnProperty.call(message, "errorCode"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errorCode);
        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
            $root.google.protobuf.StringValue.encode(message.errorMessage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.severityCode != null && Object.hasOwnProperty.call(message, "severityCode"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.severityCode);
        if (message.isAutoCloseMessage != null && Object.hasOwnProperty.call(message, "isAutoCloseMessage"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isAutoCloseMessage);
        return writer;
    };

    /**
     * Encodes the specified ResponseError message, length delimited. Does not implicitly {@link ResponseError.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ResponseError
     * @static
     * @param {IResponseError} message ResponseError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ResponseError.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ResponseError message from the specified reader or buffer.
     * @function decode
     * @memberof ResponseError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ResponseError} ResponseError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResponseError.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ResponseError();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.errorCode = reader.int32();
                break;
            case 2:
                message.errorMessage = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 3:
                message.severityCode = reader.int32();
                break;
            case 4:
                message.isAutoCloseMessage = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ResponseError message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ResponseError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ResponseError} ResponseError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ResponseError.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ResponseError message.
     * @function verify
     * @memberof ResponseError
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ResponseError.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.errorCode != null && message.hasOwnProperty("errorCode"))
            if (!$util.isInteger(message.errorCode))
                return "errorCode: integer expected";
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage")) {
            var error = $root.google.protobuf.StringValue.verify(message.errorMessage);
            if (error)
                return "errorMessage." + error;
        }
        if (message.severityCode != null && message.hasOwnProperty("severityCode"))
            switch (message.severityCode) {
            default:
                return "severityCode: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.isAutoCloseMessage != null && message.hasOwnProperty("isAutoCloseMessage"))
            if (typeof message.isAutoCloseMessage !== "boolean")
                return "isAutoCloseMessage: boolean expected";
        return null;
    };

    /**
     * Creates a ResponseError message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ResponseError
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ResponseError} ResponseError
     */
    ResponseError.fromObject = function fromObject(object) {
        if (object instanceof $root.ResponseError)
            return object;
        var message = new $root.ResponseError();
        if (object.errorCode != null)
            message.errorCode = object.errorCode | 0;
        if (object.errorMessage != null) {
            if (typeof object.errorMessage !== "object")
                throw TypeError(".ResponseError.errorMessage: object expected");
            message.errorMessage = $root.google.protobuf.StringValue.fromObject(object.errorMessage);
        }
        switch (object.severityCode) {
        case "SEVERITYCODE_ERROR":
        case 0:
            message.severityCode = 0;
            break;
        case "SEVERITYCODE_WARNING":
        case 1:
            message.severityCode = 1;
            break;
        case "SEVERITYCODE_INFO":
        case 2:
            message.severityCode = 2;
            break;
        }
        if (object.isAutoCloseMessage != null)
            message.isAutoCloseMessage = Boolean(object.isAutoCloseMessage);
        return message;
    };

    /**
     * Creates a plain object from a ResponseError message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ResponseError
     * @static
     * @param {ResponseError} message ResponseError
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ResponseError.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.errorCode = 0;
            object.errorMessage = null;
            object.severityCode = options.enums === String ? "SEVERITYCODE_ERROR" : 0;
            object.isAutoCloseMessage = false;
        }
        if (message.errorCode != null && message.hasOwnProperty("errorCode"))
            object.errorCode = message.errorCode;
        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
            object.errorMessage = $root.google.protobuf.StringValue.toObject(message.errorMessage, options);
        if (message.severityCode != null && message.hasOwnProperty("severityCode"))
            object.severityCode = options.enums === String ? $root.SeverityCode[message.severityCode] : message.severityCode;
        if (message.isAutoCloseMessage != null && message.hasOwnProperty("isAutoCloseMessage"))
            object.isAutoCloseMessage = message.isAutoCloseMessage;
        return object;
    };

    /**
     * Converts this ResponseError to JSON.
     * @function toJSON
     * @memberof ResponseError
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ResponseError.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ResponseError;
})();

$root.EnvelopeRequest = (function() {

    /**
     * Properties of an EnvelopeRequest.
     * @exports IEnvelopeRequest
     * @interface IEnvelopeRequest
     * @property {number|null} [requestId] EnvelopeRequest requestId
     * @property {RequestType|null} [requestType] EnvelopeRequest requestType
     * @property {number|null} [nestedMsgType] EnvelopeRequest nestedMsgType
     * @property {google.protobuf.IBytesValue|null} [nestedMessage] EnvelopeRequest nestedMessage
     * @property {string|null} [traceParent] EnvelopeRequest traceParent
     */

    /**
     * Constructs a new EnvelopeRequest.
     * @exports EnvelopeRequest
     * @classdesc Represents an EnvelopeRequest.
     * @implements IEnvelopeRequest
     * @constructor
     * @param {IEnvelopeRequest=} [properties] Properties to set
     */
    function EnvelopeRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EnvelopeRequest requestId.
     * @member {number} requestId
     * @memberof EnvelopeRequest
     * @instance
     */
    EnvelopeRequest.prototype.requestId = 0;

    /**
     * EnvelopeRequest requestType.
     * @member {RequestType} requestType
     * @memberof EnvelopeRequest
     * @instance
     */
    EnvelopeRequest.prototype.requestType = 0;

    /**
     * EnvelopeRequest nestedMsgType.
     * @member {number} nestedMsgType
     * @memberof EnvelopeRequest
     * @instance
     */
    EnvelopeRequest.prototype.nestedMsgType = 0;

    /**
     * EnvelopeRequest nestedMessage.
     * @member {google.protobuf.IBytesValue|null|undefined} nestedMessage
     * @memberof EnvelopeRequest
     * @instance
     */
    EnvelopeRequest.prototype.nestedMessage = null;

    /**
     * EnvelopeRequest traceParent.
     * @member {string} traceParent
     * @memberof EnvelopeRequest
     * @instance
     */
    EnvelopeRequest.prototype.traceParent = "";

    /**
     * Creates a new EnvelopeRequest instance using the specified properties.
     * @function create
     * @memberof EnvelopeRequest
     * @static
     * @param {IEnvelopeRequest=} [properties] Properties to set
     * @returns {EnvelopeRequest} EnvelopeRequest instance
     */
    EnvelopeRequest.create = function create(properties) {
        return new EnvelopeRequest(properties);
    };

    /**
     * Encodes the specified EnvelopeRequest message. Does not implicitly {@link EnvelopeRequest.verify|verify} messages.
     * @function encode
     * @memberof EnvelopeRequest
     * @static
     * @param {IEnvelopeRequest} message EnvelopeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EnvelopeRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.requestId);
        if (message.requestType != null && Object.hasOwnProperty.call(message, "requestType"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.requestType);
        if (message.nestedMsgType != null && Object.hasOwnProperty.call(message, "nestedMsgType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.nestedMsgType);
        if (message.nestedMessage != null && Object.hasOwnProperty.call(message, "nestedMessage"))
            $root.google.protobuf.BytesValue.encode(message.nestedMessage, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.traceParent != null && Object.hasOwnProperty.call(message, "traceParent"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.traceParent);
        return writer;
    };

    /**
     * Encodes the specified EnvelopeRequest message, length delimited. Does not implicitly {@link EnvelopeRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EnvelopeRequest
     * @static
     * @param {IEnvelopeRequest} message EnvelopeRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EnvelopeRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EnvelopeRequest message from the specified reader or buffer.
     * @function decode
     * @memberof EnvelopeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EnvelopeRequest} EnvelopeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EnvelopeRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EnvelopeRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.requestId = reader.int32();
                break;
            case 2:
                message.requestType = reader.int32();
                break;
            case 3:
                message.nestedMsgType = reader.int32();
                break;
            case 4:
                message.nestedMessage = $root.google.protobuf.BytesValue.decode(reader, reader.uint32());
                break;
            case 5:
                message.traceParent = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EnvelopeRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EnvelopeRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EnvelopeRequest} EnvelopeRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EnvelopeRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EnvelopeRequest message.
     * @function verify
     * @memberof EnvelopeRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EnvelopeRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        if (message.requestType != null && message.hasOwnProperty("requestType"))
            switch (message.requestType) {
            default:
                return "requestType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.nestedMsgType != null && message.hasOwnProperty("nestedMsgType"))
            if (!$util.isInteger(message.nestedMsgType))
                return "nestedMsgType: integer expected";
        if (message.nestedMessage != null && message.hasOwnProperty("nestedMessage")) {
            var error = $root.google.protobuf.BytesValue.verify(message.nestedMessage);
            if (error)
                return "nestedMessage." + error;
        }
        if (message.traceParent != null && message.hasOwnProperty("traceParent"))
            if (!$util.isString(message.traceParent))
                return "traceParent: string expected";
        return null;
    };

    /**
     * Creates an EnvelopeRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EnvelopeRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EnvelopeRequest} EnvelopeRequest
     */
    EnvelopeRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.EnvelopeRequest)
            return object;
        var message = new $root.EnvelopeRequest();
        if (object.requestId != null)
            message.requestId = object.requestId | 0;
        switch (object.requestType) {
        case "REQUESTTYPE_UNKNOWN":
        case 0:
            message.requestType = 0;
            break;
        case "REQUESTTYPE_SUBSCRIBE":
        case 1:
            message.requestType = 1;
            break;
        case "REQUESTTYPE_UNSUBSCRIBE":
        case 2:
            message.requestType = 2;
            break;
        case "REQUESTTYPE_REQUEST":
        case 3:
            message.requestType = 3;
            break;
        case "REQUESTTYPE_SEND":
        case 4:
            message.requestType = 4;
            break;
        }
        if (object.nestedMsgType != null)
            message.nestedMsgType = object.nestedMsgType | 0;
        if (object.nestedMessage != null) {
            if (typeof object.nestedMessage !== "object")
                throw TypeError(".EnvelopeRequest.nestedMessage: object expected");
            message.nestedMessage = $root.google.protobuf.BytesValue.fromObject(object.nestedMessage);
        }
        if (object.traceParent != null)
            message.traceParent = String(object.traceParent);
        return message;
    };

    /**
     * Creates a plain object from an EnvelopeRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EnvelopeRequest
     * @static
     * @param {EnvelopeRequest} message EnvelopeRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EnvelopeRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.requestId = 0;
            object.requestType = options.enums === String ? "REQUESTTYPE_UNKNOWN" : 0;
            object.nestedMsgType = 0;
            object.nestedMessage = null;
            object.traceParent = "";
        }
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.requestType != null && message.hasOwnProperty("requestType"))
            object.requestType = options.enums === String ? $root.RequestType[message.requestType] : message.requestType;
        if (message.nestedMsgType != null && message.hasOwnProperty("nestedMsgType"))
            object.nestedMsgType = message.nestedMsgType;
        if (message.nestedMessage != null && message.hasOwnProperty("nestedMessage"))
            object.nestedMessage = $root.google.protobuf.BytesValue.toObject(message.nestedMessage, options);
        if (message.traceParent != null && message.hasOwnProperty("traceParent"))
            object.traceParent = message.traceParent;
        return object;
    };

    /**
     * Converts this EnvelopeRequest to JSON.
     * @function toJSON
     * @memberof EnvelopeRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EnvelopeRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EnvelopeRequest;
})();

$root.EnvelopeResponse = (function() {

    /**
     * Properties of an EnvelopeResponse.
     * @exports IEnvelopeResponse
     * @interface IEnvelopeResponse
     * @property {number|null} [requestId] EnvelopeResponse requestId
     * @property {number|null} [responseId] EnvelopeResponse responseId
     * @property {IResponseError|null} [error] EnvelopeResponse error
     * @property {google.protobuf.IBytesValue|null} [nestedMessage] EnvelopeResponse nestedMessage
     * @property {boolean|null} [terminal] EnvelopeResponse terminal
     * @property {string|null} [traceParent] EnvelopeResponse traceParent
     */

    /**
     * Constructs a new EnvelopeResponse.
     * @exports EnvelopeResponse
     * @classdesc Represents an EnvelopeResponse.
     * @implements IEnvelopeResponse
     * @constructor
     * @param {IEnvelopeResponse=} [properties] Properties to set
     */
    function EnvelopeResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EnvelopeResponse requestId.
     * @member {number} requestId
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.requestId = 0;

    /**
     * EnvelopeResponse responseId.
     * @member {number} responseId
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.responseId = 0;

    /**
     * EnvelopeResponse error.
     * @member {IResponseError|null|undefined} error
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.error = null;

    /**
     * EnvelopeResponse nestedMessage.
     * @member {google.protobuf.IBytesValue|null|undefined} nestedMessage
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.nestedMessage = null;

    /**
     * EnvelopeResponse terminal.
     * @member {boolean} terminal
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.terminal = false;

    /**
     * EnvelopeResponse traceParent.
     * @member {string} traceParent
     * @memberof EnvelopeResponse
     * @instance
     */
    EnvelopeResponse.prototype.traceParent = "";

    /**
     * Creates a new EnvelopeResponse instance using the specified properties.
     * @function create
     * @memberof EnvelopeResponse
     * @static
     * @param {IEnvelopeResponse=} [properties] Properties to set
     * @returns {EnvelopeResponse} EnvelopeResponse instance
     */
    EnvelopeResponse.create = function create(properties) {
        return new EnvelopeResponse(properties);
    };

    /**
     * Encodes the specified EnvelopeResponse message. Does not implicitly {@link EnvelopeResponse.verify|verify} messages.
     * @function encode
     * @memberof EnvelopeResponse
     * @static
     * @param {IEnvelopeResponse} message EnvelopeResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EnvelopeResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.requestId);
        if (message.responseId != null && Object.hasOwnProperty.call(message, "responseId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.responseId);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            $root.ResponseError.encode(message.error, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.nestedMessage != null && Object.hasOwnProperty.call(message, "nestedMessage"))
            $root.google.protobuf.BytesValue.encode(message.nestedMessage, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.terminal != null && Object.hasOwnProperty.call(message, "terminal"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.terminal);
        if (message.traceParent != null && Object.hasOwnProperty.call(message, "traceParent"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.traceParent);
        return writer;
    };

    /**
     * Encodes the specified EnvelopeResponse message, length delimited. Does not implicitly {@link EnvelopeResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EnvelopeResponse
     * @static
     * @param {IEnvelopeResponse} message EnvelopeResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EnvelopeResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EnvelopeResponse message from the specified reader or buffer.
     * @function decode
     * @memberof EnvelopeResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EnvelopeResponse} EnvelopeResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EnvelopeResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EnvelopeResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.requestId = reader.int32();
                break;
            case 2:
                message.responseId = reader.int32();
                break;
            case 3:
                message.error = $root.ResponseError.decode(reader, reader.uint32());
                break;
            case 4:
                message.nestedMessage = $root.google.protobuf.BytesValue.decode(reader, reader.uint32());
                break;
            case 5:
                message.terminal = reader.bool();
                break;
            case 6:
                message.traceParent = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EnvelopeResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EnvelopeResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EnvelopeResponse} EnvelopeResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EnvelopeResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EnvelopeResponse message.
     * @function verify
     * @memberof EnvelopeResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EnvelopeResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        if (message.responseId != null && message.hasOwnProperty("responseId"))
            if (!$util.isInteger(message.responseId))
                return "responseId: integer expected";
        if (message.error != null && message.hasOwnProperty("error")) {
            var error = $root.ResponseError.verify(message.error);
            if (error)
                return "error." + error;
        }
        if (message.nestedMessage != null && message.hasOwnProperty("nestedMessage")) {
            var error = $root.google.protobuf.BytesValue.verify(message.nestedMessage);
            if (error)
                return "nestedMessage." + error;
        }
        if (message.terminal != null && message.hasOwnProperty("terminal"))
            if (typeof message.terminal !== "boolean")
                return "terminal: boolean expected";
        if (message.traceParent != null && message.hasOwnProperty("traceParent"))
            if (!$util.isString(message.traceParent))
                return "traceParent: string expected";
        return null;
    };

    /**
     * Creates an EnvelopeResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EnvelopeResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EnvelopeResponse} EnvelopeResponse
     */
    EnvelopeResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.EnvelopeResponse)
            return object;
        var message = new $root.EnvelopeResponse();
        if (object.requestId != null)
            message.requestId = object.requestId | 0;
        if (object.responseId != null)
            message.responseId = object.responseId | 0;
        if (object.error != null) {
            if (typeof object.error !== "object")
                throw TypeError(".EnvelopeResponse.error: object expected");
            message.error = $root.ResponseError.fromObject(object.error);
        }
        if (object.nestedMessage != null) {
            if (typeof object.nestedMessage !== "object")
                throw TypeError(".EnvelopeResponse.nestedMessage: object expected");
            message.nestedMessage = $root.google.protobuf.BytesValue.fromObject(object.nestedMessage);
        }
        if (object.terminal != null)
            message.terminal = Boolean(object.terminal);
        if (object.traceParent != null)
            message.traceParent = String(object.traceParent);
        return message;
    };

    /**
     * Creates a plain object from an EnvelopeResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EnvelopeResponse
     * @static
     * @param {EnvelopeResponse} message EnvelopeResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EnvelopeResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.requestId = 0;
            object.responseId = 0;
            object.error = null;
            object.nestedMessage = null;
            object.terminal = false;
            object.traceParent = "";
        }
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.responseId != null && message.hasOwnProperty("responseId"))
            object.responseId = message.responseId;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = $root.ResponseError.toObject(message.error, options);
        if (message.nestedMessage != null && message.hasOwnProperty("nestedMessage"))
            object.nestedMessage = $root.google.protobuf.BytesValue.toObject(message.nestedMessage, options);
        if (message.terminal != null && message.hasOwnProperty("terminal"))
            object.terminal = message.terminal;
        if (message.traceParent != null && message.hasOwnProperty("traceParent"))
            object.traceParent = message.traceParent;
        return object;
    };

    /**
     * Converts this EnvelopeResponse to JSON.
     * @function toJSON
     * @memberof EnvelopeResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EnvelopeResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EnvelopeResponse;
})();

$root.FeedbackRequest = (function() {

    /**
     * Properties of a FeedbackRequest.
     * @exports IFeedbackRequest
     * @interface IFeedbackRequest
     * @property {string|null} [Message] FeedbackRequest Message
     * @property {google.protobuf.IStringValue|null} [ImageData] FeedbackRequest ImageData
     */

    /**
     * Constructs a new FeedbackRequest.
     * @exports FeedbackRequest
     * @classdesc Represents a FeedbackRequest.
     * @implements IFeedbackRequest
     * @constructor
     * @param {IFeedbackRequest=} [properties] Properties to set
     */
    function FeedbackRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FeedbackRequest Message.
     * @member {string} Message
     * @memberof FeedbackRequest
     * @instance
     */
    FeedbackRequest.prototype.Message = "";

    /**
     * FeedbackRequest ImageData.
     * @member {google.protobuf.IStringValue|null|undefined} ImageData
     * @memberof FeedbackRequest
     * @instance
     */
    FeedbackRequest.prototype.ImageData = null;

    /**
     * Creates a new FeedbackRequest instance using the specified properties.
     * @function create
     * @memberof FeedbackRequest
     * @static
     * @param {IFeedbackRequest=} [properties] Properties to set
     * @returns {FeedbackRequest} FeedbackRequest instance
     */
    FeedbackRequest.create = function create(properties) {
        return new FeedbackRequest(properties);
    };

    /**
     * Encodes the specified FeedbackRequest message. Does not implicitly {@link FeedbackRequest.verify|verify} messages.
     * @function encode
     * @memberof FeedbackRequest
     * @static
     * @param {IFeedbackRequest} message FeedbackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FeedbackRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Message);
        if (message.ImageData != null && Object.hasOwnProperty.call(message, "ImageData"))
            $root.google.protobuf.StringValue.encode(message.ImageData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FeedbackRequest message, length delimited. Does not implicitly {@link FeedbackRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FeedbackRequest
     * @static
     * @param {IFeedbackRequest} message FeedbackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FeedbackRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FeedbackRequest message from the specified reader or buffer.
     * @function decode
     * @memberof FeedbackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FeedbackRequest} FeedbackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FeedbackRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FeedbackRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Message = reader.string();
                break;
            case 2:
                message.ImageData = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FeedbackRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FeedbackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FeedbackRequest} FeedbackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FeedbackRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FeedbackRequest message.
     * @function verify
     * @memberof FeedbackRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FeedbackRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Message != null && message.hasOwnProperty("Message"))
            if (!$util.isString(message.Message))
                return "Message: string expected";
        if (message.ImageData != null && message.hasOwnProperty("ImageData")) {
            var error = $root.google.protobuf.StringValue.verify(message.ImageData);
            if (error)
                return "ImageData." + error;
        }
        return null;
    };

    /**
     * Creates a FeedbackRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FeedbackRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FeedbackRequest} FeedbackRequest
     */
    FeedbackRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.FeedbackRequest)
            return object;
        var message = new $root.FeedbackRequest();
        if (object.Message != null)
            message.Message = String(object.Message);
        if (object.ImageData != null) {
            if (typeof object.ImageData !== "object")
                throw TypeError(".FeedbackRequest.ImageData: object expected");
            message.ImageData = $root.google.protobuf.StringValue.fromObject(object.ImageData);
        }
        return message;
    };

    /**
     * Creates a plain object from a FeedbackRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FeedbackRequest
     * @static
     * @param {FeedbackRequest} message FeedbackRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FeedbackRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Message = "";
            object.ImageData = null;
        }
        if (message.Message != null && message.hasOwnProperty("Message"))
            object.Message = message.Message;
        if (message.ImageData != null && message.hasOwnProperty("ImageData"))
            object.ImageData = $root.google.protobuf.StringValue.toObject(message.ImageData, options);
        return object;
    };

    /**
     * Converts this FeedbackRequest to JSON.
     * @function toJSON
     * @memberof FeedbackRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FeedbackRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FeedbackRequest;
})();

$root.FeedbackResponse = (function() {

    /**
     * Properties of a FeedbackResponse.
     * @exports IFeedbackResponse
     * @interface IFeedbackResponse
     * @property {boolean|null} [Accepted] FeedbackResponse Accepted
     * @property {string|null} [Reason] FeedbackResponse Reason
     */

    /**
     * Constructs a new FeedbackResponse.
     * @exports FeedbackResponse
     * @classdesc Represents a FeedbackResponse.
     * @implements IFeedbackResponse
     * @constructor
     * @param {IFeedbackResponse=} [properties] Properties to set
     */
    function FeedbackResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FeedbackResponse Accepted.
     * @member {boolean} Accepted
     * @memberof FeedbackResponse
     * @instance
     */
    FeedbackResponse.prototype.Accepted = false;

    /**
     * FeedbackResponse Reason.
     * @member {string} Reason
     * @memberof FeedbackResponse
     * @instance
     */
    FeedbackResponse.prototype.Reason = "";

    /**
     * Creates a new FeedbackResponse instance using the specified properties.
     * @function create
     * @memberof FeedbackResponse
     * @static
     * @param {IFeedbackResponse=} [properties] Properties to set
     * @returns {FeedbackResponse} FeedbackResponse instance
     */
    FeedbackResponse.create = function create(properties) {
        return new FeedbackResponse(properties);
    };

    /**
     * Encodes the specified FeedbackResponse message. Does not implicitly {@link FeedbackResponse.verify|verify} messages.
     * @function encode
     * @memberof FeedbackResponse
     * @static
     * @param {IFeedbackResponse} message FeedbackResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FeedbackResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified FeedbackResponse message, length delimited. Does not implicitly {@link FeedbackResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FeedbackResponse
     * @static
     * @param {IFeedbackResponse} message FeedbackResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FeedbackResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FeedbackResponse message from the specified reader or buffer.
     * @function decode
     * @memberof FeedbackResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FeedbackResponse} FeedbackResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FeedbackResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FeedbackResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FeedbackResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FeedbackResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FeedbackResponse} FeedbackResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FeedbackResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FeedbackResponse message.
     * @function verify
     * @memberof FeedbackResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FeedbackResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a FeedbackResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FeedbackResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FeedbackResponse} FeedbackResponse
     */
    FeedbackResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.FeedbackResponse)
            return object;
        var message = new $root.FeedbackResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a FeedbackResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FeedbackResponse
     * @static
     * @param {FeedbackResponse} message FeedbackResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FeedbackResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this FeedbackResponse to JSON.
     * @function toJSON
     * @memberof FeedbackResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FeedbackResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FeedbackResponse;
})();

$root.Holiday = (function() {

    /**
     * Properties of a Holiday.
     * @exports IHoliday
     * @interface IHoliday
     * @property {string|null} [Date] Holiday Date
     * @property {string|null} [Reason] Holiday Reason
     */

    /**
     * Constructs a new Holiday.
     * @exports Holiday
     * @classdesc Represents a Holiday.
     * @implements IHoliday
     * @constructor
     * @param {IHoliday=} [properties] Properties to set
     */
    function Holiday(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Holiday Date.
     * @member {string} Date
     * @memberof Holiday
     * @instance
     */
    Holiday.prototype.Date = "";

    /**
     * Holiday Reason.
     * @member {string} Reason
     * @memberof Holiday
     * @instance
     */
    Holiday.prototype.Reason = "";

    /**
     * Creates a new Holiday instance using the specified properties.
     * @function create
     * @memberof Holiday
     * @static
     * @param {IHoliday=} [properties] Properties to set
     * @returns {Holiday} Holiday instance
     */
    Holiday.create = function create(properties) {
        return new Holiday(properties);
    };

    /**
     * Encodes the specified Holiday message. Does not implicitly {@link Holiday.verify|verify} messages.
     * @function encode
     * @memberof Holiday
     * @static
     * @param {IHoliday} message Holiday message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Holiday.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Date);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified Holiday message, length delimited. Does not implicitly {@link Holiday.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Holiday
     * @static
     * @param {IHoliday} message Holiday message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Holiday.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Holiday message from the specified reader or buffer.
     * @function decode
     * @memberof Holiday
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Holiday} Holiday
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Holiday.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Holiday();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Date = reader.string();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Holiday message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Holiday
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Holiday} Holiday
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Holiday.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Holiday message.
     * @function verify
     * @memberof Holiday
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Holiday.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Date != null && message.hasOwnProperty("Date"))
            if (!$util.isString(message.Date))
                return "Date: string expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a Holiday message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Holiday
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Holiday} Holiday
     */
    Holiday.fromObject = function fromObject(object) {
        if (object instanceof $root.Holiday)
            return object;
        var message = new $root.Holiday();
        if (object.Date != null)
            message.Date = String(object.Date);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a Holiday message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Holiday
     * @static
     * @param {Holiday} message Holiday
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Holiday.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Date = "";
            object.Reason = "";
        }
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = message.Date;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this Holiday to JSON.
     * @function toJSON
     * @memberof Holiday
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Holiday.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Holiday;
})();

$root.FirmInstrumentInfo = (function() {

    /**
     * Properties of a FirmInstrumentInfo.
     * @exports IFirmInstrumentInfo
     * @interface IFirmInstrumentInfo
     * @property {string|null} [Symbol] FirmInstrumentInfo Symbol
     * @property {number|null} [RoundLot] FirmInstrumentInfo RoundLot
     * @property {number|null} [MinTradeVolume] FirmInstrumentInfo MinTradeVolume
     * @property {InstrumentType|null} [InstrumentType] FirmInstrumentInfo InstrumentType
     * @property {Array.<string>|null} [OBSOLETE_Tenors] FirmInstrumentInfo OBSOLETE_Tenors
     * @property {number|null} [SettlementPeriod] FirmInstrumentInfo SettlementPeriod
     * @property {Array.<IHoliday>|null} [Holidays] FirmInstrumentInfo Holidays
     * @property {boolean|null} [QuotesTrendOnly] FirmInstrumentInfo QuotesTrendOnly
     */

    /**
     * Constructs a new FirmInstrumentInfo.
     * @exports FirmInstrumentInfo
     * @classdesc Represents a FirmInstrumentInfo.
     * @implements IFirmInstrumentInfo
     * @constructor
     * @param {IFirmInstrumentInfo=} [properties] Properties to set
     */
    function FirmInstrumentInfo(properties) {
        this.OBSOLETE_Tenors = [];
        this.Holidays = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FirmInstrumentInfo Symbol.
     * @member {string} Symbol
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.Symbol = "";

    /**
     * FirmInstrumentInfo RoundLot.
     * @member {number} RoundLot
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.RoundLot = 0;

    /**
     * FirmInstrumentInfo MinTradeVolume.
     * @member {number} MinTradeVolume
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.MinTradeVolume = 0;

    /**
     * FirmInstrumentInfo InstrumentType.
     * @member {InstrumentType} InstrumentType
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.InstrumentType = 0;

    /**
     * FirmInstrumentInfo OBSOLETE_Tenors.
     * @member {Array.<string>} OBSOLETE_Tenors
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.OBSOLETE_Tenors = $util.emptyArray;

    /**
     * FirmInstrumentInfo SettlementPeriod.
     * @member {number} SettlementPeriod
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.SettlementPeriod = 0;

    /**
     * FirmInstrumentInfo Holidays.
     * @member {Array.<IHoliday>} Holidays
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.Holidays = $util.emptyArray;

    /**
     * FirmInstrumentInfo QuotesTrendOnly.
     * @member {boolean} QuotesTrendOnly
     * @memberof FirmInstrumentInfo
     * @instance
     */
    FirmInstrumentInfo.prototype.QuotesTrendOnly = false;

    /**
     * Creates a new FirmInstrumentInfo instance using the specified properties.
     * @function create
     * @memberof FirmInstrumentInfo
     * @static
     * @param {IFirmInstrumentInfo=} [properties] Properties to set
     * @returns {FirmInstrumentInfo} FirmInstrumentInfo instance
     */
    FirmInstrumentInfo.create = function create(properties) {
        return new FirmInstrumentInfo(properties);
    };

    /**
     * Encodes the specified FirmInstrumentInfo message. Does not implicitly {@link FirmInstrumentInfo.verify|verify} messages.
     * @function encode
     * @memberof FirmInstrumentInfo
     * @static
     * @param {IFirmInstrumentInfo} message FirmInstrumentInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmInstrumentInfo.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Symbol != null && Object.hasOwnProperty.call(message, "Symbol"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Symbol);
        if (message.RoundLot != null && Object.hasOwnProperty.call(message, "RoundLot"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.RoundLot);
        if (message.MinTradeVolume != null && Object.hasOwnProperty.call(message, "MinTradeVolume"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.MinTradeVolume);
        if (message.InstrumentType != null && Object.hasOwnProperty.call(message, "InstrumentType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.InstrumentType);
        if (message.OBSOLETE_Tenors != null && message.OBSOLETE_Tenors.length)
            for (var i = 0; i < message.OBSOLETE_Tenors.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.OBSOLETE_Tenors[i]);
        if (message.SettlementPeriod != null && Object.hasOwnProperty.call(message, "SettlementPeriod"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.SettlementPeriod);
        if (message.Holidays != null && message.Holidays.length)
            for (var i = 0; i < message.Holidays.length; ++i)
                $root.Holiday.encode(message.Holidays[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.QuotesTrendOnly != null && Object.hasOwnProperty.call(message, "QuotesTrendOnly"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.QuotesTrendOnly);
        return writer;
    };

    /**
     * Encodes the specified FirmInstrumentInfo message, length delimited. Does not implicitly {@link FirmInstrumentInfo.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FirmInstrumentInfo
     * @static
     * @param {IFirmInstrumentInfo} message FirmInstrumentInfo message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmInstrumentInfo.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FirmInstrumentInfo message from the specified reader or buffer.
     * @function decode
     * @memberof FirmInstrumentInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FirmInstrumentInfo} FirmInstrumentInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmInstrumentInfo.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmInstrumentInfo();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Symbol = reader.string();
                break;
            case 2:
                message.RoundLot = reader.int32();
                break;
            case 3:
                message.MinTradeVolume = reader.int32();
                break;
            case 4:
                message.InstrumentType = reader.int32();
                break;
            case 5:
                if (!(message.OBSOLETE_Tenors && message.OBSOLETE_Tenors.length))
                    message.OBSOLETE_Tenors = [];
                message.OBSOLETE_Tenors.push(reader.string());
                break;
            case 6:
                message.SettlementPeriod = reader.int32();
                break;
            case 7:
                if (!(message.Holidays && message.Holidays.length))
                    message.Holidays = [];
                message.Holidays.push($root.Holiday.decode(reader, reader.uint32()));
                break;
            case 8:
                message.QuotesTrendOnly = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FirmInstrumentInfo message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FirmInstrumentInfo
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FirmInstrumentInfo} FirmInstrumentInfo
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmInstrumentInfo.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FirmInstrumentInfo message.
     * @function verify
     * @memberof FirmInstrumentInfo
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FirmInstrumentInfo.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            if (!$util.isString(message.Symbol))
                return "Symbol: string expected";
        if (message.RoundLot != null && message.hasOwnProperty("RoundLot"))
            if (!$util.isInteger(message.RoundLot))
                return "RoundLot: integer expected";
        if (message.MinTradeVolume != null && message.hasOwnProperty("MinTradeVolume"))
            if (!$util.isInteger(message.MinTradeVolume))
                return "MinTradeVolume: integer expected";
        if (message.InstrumentType != null && message.hasOwnProperty("InstrumentType"))
            switch (message.InstrumentType) {
            default:
                return "InstrumentType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.OBSOLETE_Tenors != null && message.hasOwnProperty("OBSOLETE_Tenors")) {
            if (!Array.isArray(message.OBSOLETE_Tenors))
                return "OBSOLETE_Tenors: array expected";
            for (var i = 0; i < message.OBSOLETE_Tenors.length; ++i)
                if (!$util.isString(message.OBSOLETE_Tenors[i]))
                    return "OBSOLETE_Tenors: string[] expected";
        }
        if (message.SettlementPeriod != null && message.hasOwnProperty("SettlementPeriod"))
            if (!$util.isInteger(message.SettlementPeriod))
                return "SettlementPeriod: integer expected";
        if (message.Holidays != null && message.hasOwnProperty("Holidays")) {
            if (!Array.isArray(message.Holidays))
                return "Holidays: array expected";
            for (var i = 0; i < message.Holidays.length; ++i) {
                var error = $root.Holiday.verify(message.Holidays[i]);
                if (error)
                    return "Holidays." + error;
            }
        }
        if (message.QuotesTrendOnly != null && message.hasOwnProperty("QuotesTrendOnly"))
            if (typeof message.QuotesTrendOnly !== "boolean")
                return "QuotesTrendOnly: boolean expected";
        return null;
    };

    /**
     * Creates a FirmInstrumentInfo message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FirmInstrumentInfo
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FirmInstrumentInfo} FirmInstrumentInfo
     */
    FirmInstrumentInfo.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmInstrumentInfo)
            return object;
        var message = new $root.FirmInstrumentInfo();
        if (object.Symbol != null)
            message.Symbol = String(object.Symbol);
        if (object.RoundLot != null)
            message.RoundLot = object.RoundLot | 0;
        if (object.MinTradeVolume != null)
            message.MinTradeVolume = object.MinTradeVolume | 0;
        switch (object.InstrumentType) {
        case "INSTRUMENTTYPE_SPOT":
        case 0:
            message.InstrumentType = 0;
            break;
        case "INSTRUMENTTYPE_FORWARD":
        case 1:
            message.InstrumentType = 1;
            break;
        }
        if (object.OBSOLETE_Tenors) {
            if (!Array.isArray(object.OBSOLETE_Tenors))
                throw TypeError(".FirmInstrumentInfo.OBSOLETE_Tenors: array expected");
            message.OBSOLETE_Tenors = [];
            for (var i = 0; i < object.OBSOLETE_Tenors.length; ++i)
                message.OBSOLETE_Tenors[i] = String(object.OBSOLETE_Tenors[i]);
        }
        if (object.SettlementPeriod != null)
            message.SettlementPeriod = object.SettlementPeriod | 0;
        if (object.Holidays) {
            if (!Array.isArray(object.Holidays))
                throw TypeError(".FirmInstrumentInfo.Holidays: array expected");
            message.Holidays = [];
            for (var i = 0; i < object.Holidays.length; ++i) {
                if (typeof object.Holidays[i] !== "object")
                    throw TypeError(".FirmInstrumentInfo.Holidays: object expected");
                message.Holidays[i] = $root.Holiday.fromObject(object.Holidays[i]);
            }
        }
        if (object.QuotesTrendOnly != null)
            message.QuotesTrendOnly = Boolean(object.QuotesTrendOnly);
        return message;
    };

    /**
     * Creates a plain object from a FirmInstrumentInfo message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FirmInstrumentInfo
     * @static
     * @param {FirmInstrumentInfo} message FirmInstrumentInfo
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FirmInstrumentInfo.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.OBSOLETE_Tenors = [];
            object.Holidays = [];
        }
        if (options.defaults) {
            object.Symbol = "";
            object.RoundLot = 0;
            object.MinTradeVolume = 0;
            object.InstrumentType = options.enums === String ? "INSTRUMENTTYPE_SPOT" : 0;
            object.SettlementPeriod = 0;
            object.QuotesTrendOnly = false;
        }
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            object.Symbol = message.Symbol;
        if (message.RoundLot != null && message.hasOwnProperty("RoundLot"))
            object.RoundLot = message.RoundLot;
        if (message.MinTradeVolume != null && message.hasOwnProperty("MinTradeVolume"))
            object.MinTradeVolume = message.MinTradeVolume;
        if (message.InstrumentType != null && message.hasOwnProperty("InstrumentType"))
            object.InstrumentType = options.enums === String ? $root.InstrumentType[message.InstrumentType] : message.InstrumentType;
        if (message.OBSOLETE_Tenors && message.OBSOLETE_Tenors.length) {
            object.OBSOLETE_Tenors = [];
            for (var j = 0; j < message.OBSOLETE_Tenors.length; ++j)
                object.OBSOLETE_Tenors[j] = message.OBSOLETE_Tenors[j];
        }
        if (message.SettlementPeriod != null && message.hasOwnProperty("SettlementPeriod"))
            object.SettlementPeriod = message.SettlementPeriod;
        if (message.Holidays && message.Holidays.length) {
            object.Holidays = [];
            for (var j = 0; j < message.Holidays.length; ++j)
                object.Holidays[j] = $root.Holiday.toObject(message.Holidays[j], options);
        }
        if (message.QuotesTrendOnly != null && message.hasOwnProperty("QuotesTrendOnly"))
            object.QuotesTrendOnly = message.QuotesTrendOnly;
        return object;
    };

    /**
     * Converts this FirmInstrumentInfo to JSON.
     * @function toJSON
     * @memberof FirmInstrumentInfo
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FirmInstrumentInfo.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmInstrumentInfo;
})();

$root.Firm = (function() {

    /**
     * Properties of a Firm.
     * @exports IFirm
     * @interface IFirm
     * @property {number|null} [Id] Firm Id
     * @property {string|null} [Name] Firm Name
     * @property {google.protobuf.IStringValue|null} [ExternalRef] Firm ExternalRef
     * @property {boolean|null} [InHouse] Firm InHouse
     * @property {Array.<IFirmInstrumentInfo>|null} [Instruments] Firm Instruments
     */

    /**
     * Constructs a new Firm.
     * @exports Firm
     * @classdesc Represents a Firm.
     * @implements IFirm
     * @constructor
     * @param {IFirm=} [properties] Properties to set
     */
    function Firm(properties) {
        this.Instruments = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Firm Id.
     * @member {number} Id
     * @memberof Firm
     * @instance
     */
    Firm.prototype.Id = 0;

    /**
     * Firm Name.
     * @member {string} Name
     * @memberof Firm
     * @instance
     */
    Firm.prototype.Name = "";

    /**
     * Firm ExternalRef.
     * @member {google.protobuf.IStringValue|null|undefined} ExternalRef
     * @memberof Firm
     * @instance
     */
    Firm.prototype.ExternalRef = null;

    /**
     * Firm InHouse.
     * @member {boolean} InHouse
     * @memberof Firm
     * @instance
     */
    Firm.prototype.InHouse = false;

    /**
     * Firm Instruments.
     * @member {Array.<IFirmInstrumentInfo>} Instruments
     * @memberof Firm
     * @instance
     */
    Firm.prototype.Instruments = $util.emptyArray;

    /**
     * Creates a new Firm instance using the specified properties.
     * @function create
     * @memberof Firm
     * @static
     * @param {IFirm=} [properties] Properties to set
     * @returns {Firm} Firm instance
     */
    Firm.create = function create(properties) {
        return new Firm(properties);
    };

    /**
     * Encodes the specified Firm message. Does not implicitly {@link Firm.verify|verify} messages.
     * @function encode
     * @memberof Firm
     * @static
     * @param {IFirm} message Firm message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Firm.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.ExternalRef != null && Object.hasOwnProperty.call(message, "ExternalRef"))
            $root.google.protobuf.StringValue.encode(message.ExternalRef, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.InHouse != null && Object.hasOwnProperty.call(message, "InHouse"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.InHouse);
        if (message.Instruments != null && message.Instruments.length)
            for (var i = 0; i < message.Instruments.length; ++i)
                $root.FirmInstrumentInfo.encode(message.Instruments[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Firm message, length delimited. Does not implicitly {@link Firm.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Firm
     * @static
     * @param {IFirm} message Firm message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Firm.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Firm message from the specified reader or buffer.
     * @function decode
     * @memberof Firm
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Firm} Firm
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Firm.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Firm();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.ExternalRef = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 4:
                message.InHouse = reader.bool();
                break;
            case 5:
                if (!(message.Instruments && message.Instruments.length))
                    message.Instruments = [];
                message.Instruments.push($root.FirmInstrumentInfo.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Firm message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Firm
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Firm} Firm
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Firm.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Firm message.
     * @function verify
     * @memberof Firm
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Firm.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.ExternalRef != null && message.hasOwnProperty("ExternalRef")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExternalRef);
            if (error)
                return "ExternalRef." + error;
        }
        if (message.InHouse != null && message.hasOwnProperty("InHouse"))
            if (typeof message.InHouse !== "boolean")
                return "InHouse: boolean expected";
        if (message.Instruments != null && message.hasOwnProperty("Instruments")) {
            if (!Array.isArray(message.Instruments))
                return "Instruments: array expected";
            for (var i = 0; i < message.Instruments.length; ++i) {
                var error = $root.FirmInstrumentInfo.verify(message.Instruments[i]);
                if (error)
                    return "Instruments." + error;
            }
        }
        return null;
    };

    /**
     * Creates a Firm message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Firm
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Firm} Firm
     */
    Firm.fromObject = function fromObject(object) {
        if (object instanceof $root.Firm)
            return object;
        var message = new $root.Firm();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.ExternalRef != null) {
            if (typeof object.ExternalRef !== "object")
                throw TypeError(".Firm.ExternalRef: object expected");
            message.ExternalRef = $root.google.protobuf.StringValue.fromObject(object.ExternalRef);
        }
        if (object.InHouse != null)
            message.InHouse = Boolean(object.InHouse);
        if (object.Instruments) {
            if (!Array.isArray(object.Instruments))
                throw TypeError(".Firm.Instruments: array expected");
            message.Instruments = [];
            for (var i = 0; i < object.Instruments.length; ++i) {
                if (typeof object.Instruments[i] !== "object")
                    throw TypeError(".Firm.Instruments: object expected");
                message.Instruments[i] = $root.FirmInstrumentInfo.fromObject(object.Instruments[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a Firm message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Firm
     * @static
     * @param {Firm} message Firm
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Firm.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Instruments = [];
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
            object.ExternalRef = null;
            object.InHouse = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.ExternalRef != null && message.hasOwnProperty("ExternalRef"))
            object.ExternalRef = $root.google.protobuf.StringValue.toObject(message.ExternalRef, options);
        if (message.InHouse != null && message.hasOwnProperty("InHouse"))
            object.InHouse = message.InHouse;
        if (message.Instruments && message.Instruments.length) {
            object.Instruments = [];
            for (var j = 0; j < message.Instruments.length; ++j)
                object.Instruments[j] = $root.FirmInstrumentInfo.toObject(message.Instruments[j], options);
        }
        return object;
    };

    /**
     * Converts this Firm to JSON.
     * @function toJSON
     * @memberof Firm
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Firm.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Firm;
})();

$root.FirmsInstrumentsRequest = (function() {

    /**
     * Properties of a FirmsInstrumentsRequest.
     * @exports IFirmsInstrumentsRequest
     * @interface IFirmsInstrumentsRequest
     */

    /**
     * Constructs a new FirmsInstrumentsRequest.
     * @exports FirmsInstrumentsRequest
     * @classdesc Represents a FirmsInstrumentsRequest.
     * @implements IFirmsInstrumentsRequest
     * @constructor
     * @param {IFirmsInstrumentsRequest=} [properties] Properties to set
     */
    function FirmsInstrumentsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new FirmsInstrumentsRequest instance using the specified properties.
     * @function create
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {IFirmsInstrumentsRequest=} [properties] Properties to set
     * @returns {FirmsInstrumentsRequest} FirmsInstrumentsRequest instance
     */
    FirmsInstrumentsRequest.create = function create(properties) {
        return new FirmsInstrumentsRequest(properties);
    };

    /**
     * Encodes the specified FirmsInstrumentsRequest message. Does not implicitly {@link FirmsInstrumentsRequest.verify|verify} messages.
     * @function encode
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {IFirmsInstrumentsRequest} message FirmsInstrumentsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmsInstrumentsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified FirmsInstrumentsRequest message, length delimited. Does not implicitly {@link FirmsInstrumentsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {IFirmsInstrumentsRequest} message FirmsInstrumentsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmsInstrumentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FirmsInstrumentsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FirmsInstrumentsRequest} FirmsInstrumentsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmsInstrumentsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmsInstrumentsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FirmsInstrumentsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FirmsInstrumentsRequest} FirmsInstrumentsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmsInstrumentsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FirmsInstrumentsRequest message.
     * @function verify
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FirmsInstrumentsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a FirmsInstrumentsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FirmsInstrumentsRequest} FirmsInstrumentsRequest
     */
    FirmsInstrumentsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmsInstrumentsRequest)
            return object;
        return new $root.FirmsInstrumentsRequest();
    };

    /**
     * Creates a plain object from a FirmsInstrumentsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FirmsInstrumentsRequest
     * @static
     * @param {FirmsInstrumentsRequest} message FirmsInstrumentsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FirmsInstrumentsRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this FirmsInstrumentsRequest to JSON.
     * @function toJSON
     * @memberof FirmsInstrumentsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FirmsInstrumentsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmsInstrumentsRequest;
})();

$root.FirmsInstrumentsResponse = (function() {

    /**
     * Properties of a FirmsInstrumentsResponse.
     * @exports IFirmsInstrumentsResponse
     * @interface IFirmsInstrumentsResponse
     * @property {Array.<IFirm>|null} [Firms] FirmsInstrumentsResponse Firms
     * @property {number|null} [SelectedFirmId] FirmsInstrumentsResponse SelectedFirmId
     */

    /**
     * Constructs a new FirmsInstrumentsResponse.
     * @exports FirmsInstrumentsResponse
     * @classdesc Represents a FirmsInstrumentsResponse.
     * @implements IFirmsInstrumentsResponse
     * @constructor
     * @param {IFirmsInstrumentsResponse=} [properties] Properties to set
     */
    function FirmsInstrumentsResponse(properties) {
        this.Firms = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FirmsInstrumentsResponse Firms.
     * @member {Array.<IFirm>} Firms
     * @memberof FirmsInstrumentsResponse
     * @instance
     */
    FirmsInstrumentsResponse.prototype.Firms = $util.emptyArray;

    /**
     * FirmsInstrumentsResponse SelectedFirmId.
     * @member {number} SelectedFirmId
     * @memberof FirmsInstrumentsResponse
     * @instance
     */
    FirmsInstrumentsResponse.prototype.SelectedFirmId = 0;

    /**
     * Creates a new FirmsInstrumentsResponse instance using the specified properties.
     * @function create
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {IFirmsInstrumentsResponse=} [properties] Properties to set
     * @returns {FirmsInstrumentsResponse} FirmsInstrumentsResponse instance
     */
    FirmsInstrumentsResponse.create = function create(properties) {
        return new FirmsInstrumentsResponse(properties);
    };

    /**
     * Encodes the specified FirmsInstrumentsResponse message. Does not implicitly {@link FirmsInstrumentsResponse.verify|verify} messages.
     * @function encode
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {IFirmsInstrumentsResponse} message FirmsInstrumentsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmsInstrumentsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Firms != null && message.Firms.length)
            for (var i = 0; i < message.Firms.length; ++i)
                $root.Firm.encode(message.Firms[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.SelectedFirmId != null && Object.hasOwnProperty.call(message, "SelectedFirmId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.SelectedFirmId);
        return writer;
    };

    /**
     * Encodes the specified FirmsInstrumentsResponse message, length delimited. Does not implicitly {@link FirmsInstrumentsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {IFirmsInstrumentsResponse} message FirmsInstrumentsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirmsInstrumentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FirmsInstrumentsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FirmsInstrumentsResponse} FirmsInstrumentsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmsInstrumentsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirmsInstrumentsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Firms && message.Firms.length))
                    message.Firms = [];
                message.Firms.push($root.Firm.decode(reader, reader.uint32()));
                break;
            case 2:
                message.SelectedFirmId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FirmsInstrumentsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FirmsInstrumentsResponse} FirmsInstrumentsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirmsInstrumentsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FirmsInstrumentsResponse message.
     * @function verify
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FirmsInstrumentsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Firms != null && message.hasOwnProperty("Firms")) {
            if (!Array.isArray(message.Firms))
                return "Firms: array expected";
            for (var i = 0; i < message.Firms.length; ++i) {
                var error = $root.Firm.verify(message.Firms[i]);
                if (error)
                    return "Firms." + error;
            }
        }
        if (message.SelectedFirmId != null && message.hasOwnProperty("SelectedFirmId"))
            if (!$util.isInteger(message.SelectedFirmId))
                return "SelectedFirmId: integer expected";
        return null;
    };

    /**
     * Creates a FirmsInstrumentsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FirmsInstrumentsResponse} FirmsInstrumentsResponse
     */
    FirmsInstrumentsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.FirmsInstrumentsResponse)
            return object;
        var message = new $root.FirmsInstrumentsResponse();
        if (object.Firms) {
            if (!Array.isArray(object.Firms))
                throw TypeError(".FirmsInstrumentsResponse.Firms: array expected");
            message.Firms = [];
            for (var i = 0; i < object.Firms.length; ++i) {
                if (typeof object.Firms[i] !== "object")
                    throw TypeError(".FirmsInstrumentsResponse.Firms: object expected");
                message.Firms[i] = $root.Firm.fromObject(object.Firms[i]);
            }
        }
        if (object.SelectedFirmId != null)
            message.SelectedFirmId = object.SelectedFirmId | 0;
        return message;
    };

    /**
     * Creates a plain object from a FirmsInstrumentsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FirmsInstrumentsResponse
     * @static
     * @param {FirmsInstrumentsResponse} message FirmsInstrumentsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FirmsInstrumentsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Firms = [];
        if (options.defaults)
            object.SelectedFirmId = 0;
        if (message.Firms && message.Firms.length) {
            object.Firms = [];
            for (var j = 0; j < message.Firms.length; ++j)
                object.Firms[j] = $root.Firm.toObject(message.Firms[j], options);
        }
        if (message.SelectedFirmId != null && message.hasOwnProperty("SelectedFirmId"))
            object.SelectedFirmId = message.SelectedFirmId;
        return object;
    };

    /**
     * Converts this FirmsInstrumentsResponse to JSON.
     * @function toJSON
     * @memberof FirmsInstrumentsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FirmsInstrumentsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirmsInstrumentsResponse;
})();

$root.ForwardQuoteRequest = (function() {

    /**
     * Properties of a ForwardQuoteRequest.
     * @exports IForwardQuoteRequest
     * @interface IForwardQuoteRequest
     * @property {ForwardProduct|null} [Type] ForwardQuoteRequest Type
     * @property {number|null} [ClientId] ForwardQuoteRequest ClientId
     * @property {number|null} [Quantity] ForwardQuoteRequest Quantity
     * @property {string|null} [Instrument] ForwardQuoteRequest Instrument
     * @property {string|null} [BaseCurrency] ForwardQuoteRequest BaseCurrency
     * @property {string|null} [Tenor] ForwardQuoteRequest Tenor
     * @property {number|null} [FarQuantity] ForwardQuoteRequest FarQuantity
     * @property {string|null} [FarTenor] ForwardQuoteRequest FarTenor
     */

    /**
     * Constructs a new ForwardQuoteRequest.
     * @exports ForwardQuoteRequest
     * @classdesc Represents a ForwardQuoteRequest.
     * @implements IForwardQuoteRequest
     * @constructor
     * @param {IForwardQuoteRequest=} [properties] Properties to set
     */
    function ForwardQuoteRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForwardQuoteRequest Type.
     * @member {ForwardProduct} Type
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.Type = 0;

    /**
     * ForwardQuoteRequest ClientId.
     * @member {number} ClientId
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.ClientId = 0;

    /**
     * ForwardQuoteRequest Quantity.
     * @member {number} Quantity
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.Quantity = 0;

    /**
     * ForwardQuoteRequest Instrument.
     * @member {string} Instrument
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.Instrument = "";

    /**
     * ForwardQuoteRequest BaseCurrency.
     * @member {string} BaseCurrency
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.BaseCurrency = "";

    /**
     * ForwardQuoteRequest Tenor.
     * @member {string} Tenor
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.Tenor = "";

    /**
     * ForwardQuoteRequest FarQuantity.
     * @member {number} FarQuantity
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.FarQuantity = 0;

    /**
     * ForwardQuoteRequest FarTenor.
     * @member {string} FarTenor
     * @memberof ForwardQuoteRequest
     * @instance
     */
    ForwardQuoteRequest.prototype.FarTenor = "";

    /**
     * Creates a new ForwardQuoteRequest instance using the specified properties.
     * @function create
     * @memberof ForwardQuoteRequest
     * @static
     * @param {IForwardQuoteRequest=} [properties] Properties to set
     * @returns {ForwardQuoteRequest} ForwardQuoteRequest instance
     */
    ForwardQuoteRequest.create = function create(properties) {
        return new ForwardQuoteRequest(properties);
    };

    /**
     * Encodes the specified ForwardQuoteRequest message. Does not implicitly {@link ForwardQuoteRequest.verify|verify} messages.
     * @function encode
     * @memberof ForwardQuoteRequest
     * @static
     * @param {IForwardQuoteRequest} message ForwardQuoteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ClientId);
        if (message.Quantity != null && Object.hasOwnProperty.call(message, "Quantity"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.Quantity);
        if (message.Instrument != null && Object.hasOwnProperty.call(message, "Instrument"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Instrument);
        if (message.BaseCurrency != null && Object.hasOwnProperty.call(message, "BaseCurrency"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BaseCurrency);
        if (message.Tenor != null && Object.hasOwnProperty.call(message, "Tenor"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Tenor);
        if (message.FarQuantity != null && Object.hasOwnProperty.call(message, "FarQuantity"))
            writer.uint32(/* id 7, wireType 1 =*/57).double(message.FarQuantity);
        if (message.FarTenor != null && Object.hasOwnProperty.call(message, "FarTenor"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.FarTenor);
        return writer;
    };

    /**
     * Encodes the specified ForwardQuoteRequest message, length delimited. Does not implicitly {@link ForwardQuoteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForwardQuoteRequest
     * @static
     * @param {IForwardQuoteRequest} message ForwardQuoteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForwardQuoteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardQuoteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardQuoteRequest} ForwardQuoteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForwardQuoteRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Type = reader.int32();
                break;
            case 2:
                message.ClientId = reader.int32();
                break;
            case 3:
                message.Quantity = reader.double();
                break;
            case 4:
                message.Instrument = reader.string();
                break;
            case 5:
                message.BaseCurrency = reader.string();
                break;
            case 6:
                message.Tenor = reader.string();
                break;
            case 7:
                message.FarQuantity = reader.double();
                break;
            case 8:
                message.FarTenor = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForwardQuoteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForwardQuoteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForwardQuoteRequest} ForwardQuoteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForwardQuoteRequest message.
     * @function verify
     * @memberof ForwardQuoteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForwardQuoteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            if (typeof message.Quantity !== "number")
                return "Quantity: number expected";
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            if (!$util.isString(message.Instrument))
                return "Instrument: string expected";
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            if (!$util.isString(message.BaseCurrency))
                return "BaseCurrency: string expected";
        if (message.Tenor != null && message.hasOwnProperty("Tenor"))
            if (!$util.isString(message.Tenor))
                return "Tenor: string expected";
        if (message.FarQuantity != null && message.hasOwnProperty("FarQuantity"))
            if (typeof message.FarQuantity !== "number")
                return "FarQuantity: number expected";
        if (message.FarTenor != null && message.hasOwnProperty("FarTenor"))
            if (!$util.isString(message.FarTenor))
                return "FarTenor: string expected";
        return null;
    };

    /**
     * Creates a ForwardQuoteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardQuoteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardQuoteRequest} ForwardQuoteRequest
     */
    ForwardQuoteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.ForwardQuoteRequest)
            return object;
        var message = new $root.ForwardQuoteRequest();
        switch (object.Type) {
        case "FORWARDPRODUCT_FORWARD":
        case 0:
            message.Type = 0;
            break;
        case "FORWARDPRODUCT_SWAP":
        case 1:
            message.Type = 1;
            break;
        }
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        if (object.Quantity != null)
            message.Quantity = Number(object.Quantity);
        if (object.Instrument != null)
            message.Instrument = String(object.Instrument);
        if (object.BaseCurrency != null)
            message.BaseCurrency = String(object.BaseCurrency);
        if (object.Tenor != null)
            message.Tenor = String(object.Tenor);
        if (object.FarQuantity != null)
            message.FarQuantity = Number(object.FarQuantity);
        if (object.FarTenor != null)
            message.FarTenor = String(object.FarTenor);
        return message;
    };

    /**
     * Creates a plain object from a ForwardQuoteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardQuoteRequest
     * @static
     * @param {ForwardQuoteRequest} message ForwardQuoteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardQuoteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Type = options.enums === String ? "FORWARDPRODUCT_FORWARD" : 0;
            object.ClientId = 0;
            object.Quantity = 0;
            object.Instrument = "";
            object.BaseCurrency = "";
            object.Tenor = "";
            object.FarQuantity = 0;
            object.FarTenor = "";
        }
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.ForwardProduct[message.Type] : message.Type;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            object.Quantity = options.json && !isFinite(message.Quantity) ? String(message.Quantity) : message.Quantity;
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            object.Instrument = message.Instrument;
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            object.BaseCurrency = message.BaseCurrency;
        if (message.Tenor != null && message.hasOwnProperty("Tenor"))
            object.Tenor = message.Tenor;
        if (message.FarQuantity != null && message.hasOwnProperty("FarQuantity"))
            object.FarQuantity = options.json && !isFinite(message.FarQuantity) ? String(message.FarQuantity) : message.FarQuantity;
        if (message.FarTenor != null && message.hasOwnProperty("FarTenor"))
            object.FarTenor = message.FarTenor;
        return object;
    };

    /**
     * Converts this ForwardQuoteRequest to JSON.
     * @function toJSON
     * @memberof ForwardQuoteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardQuoteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ForwardQuoteRequest;
})();

$root.ForwardQuoteSide = (function() {

    /**
     * Properties of a ForwardQuoteSide.
     * @exports IForwardQuoteSide
     * @interface IForwardQuoteSide
     * @property {IPrice|null} [SpotRate] ForwardQuoteSide SpotRate
     * @property {IPrice|null} [NearRate] ForwardQuoteSide NearRate
     * @property {IPoint|null} [NearPoints] ForwardQuoteSide NearPoints
     * @property {IPrice|null} [FarRate] ForwardQuoteSide FarRate
     * @property {IPoint|null} [FarPoints] ForwardQuoteSide FarPoints
     * @property {IPoint|null} [SwapRate] ForwardQuoteSide SwapRate
     */

    /**
     * Constructs a new ForwardQuoteSide.
     * @exports ForwardQuoteSide
     * @classdesc Represents a ForwardQuoteSide.
     * @implements IForwardQuoteSide
     * @constructor
     * @param {IForwardQuoteSide=} [properties] Properties to set
     */
    function ForwardQuoteSide(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForwardQuoteSide SpotRate.
     * @member {IPrice|null|undefined} SpotRate
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.SpotRate = null;

    /**
     * ForwardQuoteSide NearRate.
     * @member {IPrice|null|undefined} NearRate
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.NearRate = null;

    /**
     * ForwardQuoteSide NearPoints.
     * @member {IPoint|null|undefined} NearPoints
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.NearPoints = null;

    /**
     * ForwardQuoteSide FarRate.
     * @member {IPrice|null|undefined} FarRate
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.FarRate = null;

    /**
     * ForwardQuoteSide FarPoints.
     * @member {IPoint|null|undefined} FarPoints
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.FarPoints = null;

    /**
     * ForwardQuoteSide SwapRate.
     * @member {IPoint|null|undefined} SwapRate
     * @memberof ForwardQuoteSide
     * @instance
     */
    ForwardQuoteSide.prototype.SwapRate = null;

    /**
     * Creates a new ForwardQuoteSide instance using the specified properties.
     * @function create
     * @memberof ForwardQuoteSide
     * @static
     * @param {IForwardQuoteSide=} [properties] Properties to set
     * @returns {ForwardQuoteSide} ForwardQuoteSide instance
     */
    ForwardQuoteSide.create = function create(properties) {
        return new ForwardQuoteSide(properties);
    };

    /**
     * Encodes the specified ForwardQuoteSide message. Does not implicitly {@link ForwardQuoteSide.verify|verify} messages.
     * @function encode
     * @memberof ForwardQuoteSide
     * @static
     * @param {IForwardQuoteSide} message ForwardQuoteSide message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteSide.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SpotRate != null && Object.hasOwnProperty.call(message, "SpotRate"))
            $root.Price.encode(message.SpotRate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.NearRate != null && Object.hasOwnProperty.call(message, "NearRate"))
            $root.Price.encode(message.NearRate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.NearPoints != null && Object.hasOwnProperty.call(message, "NearPoints"))
            $root.Point.encode(message.NearPoints, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.FarRate != null && Object.hasOwnProperty.call(message, "FarRate"))
            $root.Price.encode(message.FarRate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.FarPoints != null && Object.hasOwnProperty.call(message, "FarPoints"))
            $root.Point.encode(message.FarPoints, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.SwapRate != null && Object.hasOwnProperty.call(message, "SwapRate"))
            $root.Point.encode(message.SwapRate, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ForwardQuoteSide message, length delimited. Does not implicitly {@link ForwardQuoteSide.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForwardQuoteSide
     * @static
     * @param {IForwardQuoteSide} message ForwardQuoteSide message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteSide.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForwardQuoteSide message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardQuoteSide
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardQuoteSide} ForwardQuoteSide
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteSide.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForwardQuoteSide();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.SpotRate = $root.Price.decode(reader, reader.uint32());
                break;
            case 2:
                message.NearRate = $root.Price.decode(reader, reader.uint32());
                break;
            case 3:
                message.NearPoints = $root.Point.decode(reader, reader.uint32());
                break;
            case 4:
                message.FarRate = $root.Price.decode(reader, reader.uint32());
                break;
            case 5:
                message.FarPoints = $root.Point.decode(reader, reader.uint32());
                break;
            case 6:
                message.SwapRate = $root.Point.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForwardQuoteSide message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForwardQuoteSide
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForwardQuoteSide} ForwardQuoteSide
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteSide.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForwardQuoteSide message.
     * @function verify
     * @memberof ForwardQuoteSide
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForwardQuoteSide.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SpotRate != null && message.hasOwnProperty("SpotRate")) {
            var error = $root.Price.verify(message.SpotRate);
            if (error)
                return "SpotRate." + error;
        }
        if (message.NearRate != null && message.hasOwnProperty("NearRate")) {
            var error = $root.Price.verify(message.NearRate);
            if (error)
                return "NearRate." + error;
        }
        if (message.NearPoints != null && message.hasOwnProperty("NearPoints")) {
            var error = $root.Point.verify(message.NearPoints);
            if (error)
                return "NearPoints." + error;
        }
        if (message.FarRate != null && message.hasOwnProperty("FarRate")) {
            var error = $root.Price.verify(message.FarRate);
            if (error)
                return "FarRate." + error;
        }
        if (message.FarPoints != null && message.hasOwnProperty("FarPoints")) {
            var error = $root.Point.verify(message.FarPoints);
            if (error)
                return "FarPoints." + error;
        }
        if (message.SwapRate != null && message.hasOwnProperty("SwapRate")) {
            var error = $root.Point.verify(message.SwapRate);
            if (error)
                return "SwapRate." + error;
        }
        return null;
    };

    /**
     * Creates a ForwardQuoteSide message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardQuoteSide
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardQuoteSide} ForwardQuoteSide
     */
    ForwardQuoteSide.fromObject = function fromObject(object) {
        if (object instanceof $root.ForwardQuoteSide)
            return object;
        var message = new $root.ForwardQuoteSide();
        if (object.SpotRate != null) {
            if (typeof object.SpotRate !== "object")
                throw TypeError(".ForwardQuoteSide.SpotRate: object expected");
            message.SpotRate = $root.Price.fromObject(object.SpotRate);
        }
        if (object.NearRate != null) {
            if (typeof object.NearRate !== "object")
                throw TypeError(".ForwardQuoteSide.NearRate: object expected");
            message.NearRate = $root.Price.fromObject(object.NearRate);
        }
        if (object.NearPoints != null) {
            if (typeof object.NearPoints !== "object")
                throw TypeError(".ForwardQuoteSide.NearPoints: object expected");
            message.NearPoints = $root.Point.fromObject(object.NearPoints);
        }
        if (object.FarRate != null) {
            if (typeof object.FarRate !== "object")
                throw TypeError(".ForwardQuoteSide.FarRate: object expected");
            message.FarRate = $root.Price.fromObject(object.FarRate);
        }
        if (object.FarPoints != null) {
            if (typeof object.FarPoints !== "object")
                throw TypeError(".ForwardQuoteSide.FarPoints: object expected");
            message.FarPoints = $root.Point.fromObject(object.FarPoints);
        }
        if (object.SwapRate != null) {
            if (typeof object.SwapRate !== "object")
                throw TypeError(".ForwardQuoteSide.SwapRate: object expected");
            message.SwapRate = $root.Point.fromObject(object.SwapRate);
        }
        return message;
    };

    /**
     * Creates a plain object from a ForwardQuoteSide message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardQuoteSide
     * @static
     * @param {ForwardQuoteSide} message ForwardQuoteSide
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardQuoteSide.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.SpotRate = null;
            object.NearRate = null;
            object.NearPoints = null;
            object.FarRate = null;
            object.FarPoints = null;
            object.SwapRate = null;
        }
        if (message.SpotRate != null && message.hasOwnProperty("SpotRate"))
            object.SpotRate = $root.Price.toObject(message.SpotRate, options);
        if (message.NearRate != null && message.hasOwnProperty("NearRate"))
            object.NearRate = $root.Price.toObject(message.NearRate, options);
        if (message.NearPoints != null && message.hasOwnProperty("NearPoints"))
            object.NearPoints = $root.Point.toObject(message.NearPoints, options);
        if (message.FarRate != null && message.hasOwnProperty("FarRate"))
            object.FarRate = $root.Price.toObject(message.FarRate, options);
        if (message.FarPoints != null && message.hasOwnProperty("FarPoints"))
            object.FarPoints = $root.Point.toObject(message.FarPoints, options);
        if (message.SwapRate != null && message.hasOwnProperty("SwapRate"))
            object.SwapRate = $root.Point.toObject(message.SwapRate, options);
        return object;
    };

    /**
     * Converts this ForwardQuoteSide to JSON.
     * @function toJSON
     * @memberof ForwardQuoteSide
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardQuoteSide.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ForwardQuoteSide;
})();

$root.ForwardQuoteDelta = (function() {

    /**
     * Properties of a ForwardQuoteDelta.
     * @exports IForwardQuoteDelta
     * @interface IForwardQuoteDelta
     * @property {IPoint|null} [SpotRateDelta] ForwardQuoteDelta SpotRateDelta
     * @property {IPoint|null} [ForwardRateDelta] ForwardQuoteDelta ForwardRateDelta
     * @property {IPoint|null} [SwapRateDelta] ForwardQuoteDelta SwapRateDelta
     * @property {IPrice|null} [SwapMidRate] ForwardQuoteDelta SwapMidRate
     */

    /**
     * Constructs a new ForwardQuoteDelta.
     * @exports ForwardQuoteDelta
     * @classdesc Represents a ForwardQuoteDelta.
     * @implements IForwardQuoteDelta
     * @constructor
     * @param {IForwardQuoteDelta=} [properties] Properties to set
     */
    function ForwardQuoteDelta(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForwardQuoteDelta SpotRateDelta.
     * @member {IPoint|null|undefined} SpotRateDelta
     * @memberof ForwardQuoteDelta
     * @instance
     */
    ForwardQuoteDelta.prototype.SpotRateDelta = null;

    /**
     * ForwardQuoteDelta ForwardRateDelta.
     * @member {IPoint|null|undefined} ForwardRateDelta
     * @memberof ForwardQuoteDelta
     * @instance
     */
    ForwardQuoteDelta.prototype.ForwardRateDelta = null;

    /**
     * ForwardQuoteDelta SwapRateDelta.
     * @member {IPoint|null|undefined} SwapRateDelta
     * @memberof ForwardQuoteDelta
     * @instance
     */
    ForwardQuoteDelta.prototype.SwapRateDelta = null;

    /**
     * ForwardQuoteDelta SwapMidRate.
     * @member {IPrice|null|undefined} SwapMidRate
     * @memberof ForwardQuoteDelta
     * @instance
     */
    ForwardQuoteDelta.prototype.SwapMidRate = null;

    /**
     * Creates a new ForwardQuoteDelta instance using the specified properties.
     * @function create
     * @memberof ForwardQuoteDelta
     * @static
     * @param {IForwardQuoteDelta=} [properties] Properties to set
     * @returns {ForwardQuoteDelta} ForwardQuoteDelta instance
     */
    ForwardQuoteDelta.create = function create(properties) {
        return new ForwardQuoteDelta(properties);
    };

    /**
     * Encodes the specified ForwardQuoteDelta message. Does not implicitly {@link ForwardQuoteDelta.verify|verify} messages.
     * @function encode
     * @memberof ForwardQuoteDelta
     * @static
     * @param {IForwardQuoteDelta} message ForwardQuoteDelta message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteDelta.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SpotRateDelta != null && Object.hasOwnProperty.call(message, "SpotRateDelta"))
            $root.Point.encode(message.SpotRateDelta, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.ForwardRateDelta != null && Object.hasOwnProperty.call(message, "ForwardRateDelta"))
            $root.Point.encode(message.ForwardRateDelta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.SwapRateDelta != null && Object.hasOwnProperty.call(message, "SwapRateDelta"))
            $root.Point.encode(message.SwapRateDelta, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.SwapMidRate != null && Object.hasOwnProperty.call(message, "SwapMidRate"))
            $root.Price.encode(message.SwapMidRate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ForwardQuoteDelta message, length delimited. Does not implicitly {@link ForwardQuoteDelta.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForwardQuoteDelta
     * @static
     * @param {IForwardQuoteDelta} message ForwardQuoteDelta message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteDelta.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForwardQuoteDelta message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardQuoteDelta
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardQuoteDelta} ForwardQuoteDelta
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteDelta.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForwardQuoteDelta();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.SpotRateDelta = $root.Point.decode(reader, reader.uint32());
                break;
            case 2:
                message.ForwardRateDelta = $root.Point.decode(reader, reader.uint32());
                break;
            case 3:
                message.SwapRateDelta = $root.Point.decode(reader, reader.uint32());
                break;
            case 4:
                message.SwapMidRate = $root.Price.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForwardQuoteDelta message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForwardQuoteDelta
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForwardQuoteDelta} ForwardQuoteDelta
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteDelta.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForwardQuoteDelta message.
     * @function verify
     * @memberof ForwardQuoteDelta
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForwardQuoteDelta.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SpotRateDelta != null && message.hasOwnProperty("SpotRateDelta")) {
            var error = $root.Point.verify(message.SpotRateDelta);
            if (error)
                return "SpotRateDelta." + error;
        }
        if (message.ForwardRateDelta != null && message.hasOwnProperty("ForwardRateDelta")) {
            var error = $root.Point.verify(message.ForwardRateDelta);
            if (error)
                return "ForwardRateDelta." + error;
        }
        if (message.SwapRateDelta != null && message.hasOwnProperty("SwapRateDelta")) {
            var error = $root.Point.verify(message.SwapRateDelta);
            if (error)
                return "SwapRateDelta." + error;
        }
        if (message.SwapMidRate != null && message.hasOwnProperty("SwapMidRate")) {
            var error = $root.Price.verify(message.SwapMidRate);
            if (error)
                return "SwapMidRate." + error;
        }
        return null;
    };

    /**
     * Creates a ForwardQuoteDelta message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardQuoteDelta
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardQuoteDelta} ForwardQuoteDelta
     */
    ForwardQuoteDelta.fromObject = function fromObject(object) {
        if (object instanceof $root.ForwardQuoteDelta)
            return object;
        var message = new $root.ForwardQuoteDelta();
        if (object.SpotRateDelta != null) {
            if (typeof object.SpotRateDelta !== "object")
                throw TypeError(".ForwardQuoteDelta.SpotRateDelta: object expected");
            message.SpotRateDelta = $root.Point.fromObject(object.SpotRateDelta);
        }
        if (object.ForwardRateDelta != null) {
            if (typeof object.ForwardRateDelta !== "object")
                throw TypeError(".ForwardQuoteDelta.ForwardRateDelta: object expected");
            message.ForwardRateDelta = $root.Point.fromObject(object.ForwardRateDelta);
        }
        if (object.SwapRateDelta != null) {
            if (typeof object.SwapRateDelta !== "object")
                throw TypeError(".ForwardQuoteDelta.SwapRateDelta: object expected");
            message.SwapRateDelta = $root.Point.fromObject(object.SwapRateDelta);
        }
        if (object.SwapMidRate != null) {
            if (typeof object.SwapMidRate !== "object")
                throw TypeError(".ForwardQuoteDelta.SwapMidRate: object expected");
            message.SwapMidRate = $root.Price.fromObject(object.SwapMidRate);
        }
        return message;
    };

    /**
     * Creates a plain object from a ForwardQuoteDelta message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardQuoteDelta
     * @static
     * @param {ForwardQuoteDelta} message ForwardQuoteDelta
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardQuoteDelta.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.SpotRateDelta = null;
            object.ForwardRateDelta = null;
            object.SwapRateDelta = null;
            object.SwapMidRate = null;
        }
        if (message.SpotRateDelta != null && message.hasOwnProperty("SpotRateDelta"))
            object.SpotRateDelta = $root.Point.toObject(message.SpotRateDelta, options);
        if (message.ForwardRateDelta != null && message.hasOwnProperty("ForwardRateDelta"))
            object.ForwardRateDelta = $root.Point.toObject(message.ForwardRateDelta, options);
        if (message.SwapRateDelta != null && message.hasOwnProperty("SwapRateDelta"))
            object.SwapRateDelta = $root.Point.toObject(message.SwapRateDelta, options);
        if (message.SwapMidRate != null && message.hasOwnProperty("SwapMidRate"))
            object.SwapMidRate = $root.Price.toObject(message.SwapMidRate, options);
        return object;
    };

    /**
     * Converts this ForwardQuoteDelta to JSON.
     * @function toJSON
     * @memberof ForwardQuoteDelta
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardQuoteDelta.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ForwardQuoteDelta;
})();

$root.ForwardQuoteResponse = (function() {

    /**
     * Properties of a ForwardQuoteResponse.
     * @exports IForwardQuoteResponse
     * @interface IForwardQuoteResponse
     * @property {string|null} [QuoteID] ForwardQuoteResponse QuoteID
     * @property {IForwardQuoteSide|null} [Ask] ForwardQuoteResponse Ask
     * @property {IForwardQuoteSide|null} [Bid] ForwardQuoteResponse Bid
     * @property {IForwardQuoteDelta|null} [Spread] ForwardQuoteResponse Spread
     */

    /**
     * Constructs a new ForwardQuoteResponse.
     * @exports ForwardQuoteResponse
     * @classdesc Represents a ForwardQuoteResponse.
     * @implements IForwardQuoteResponse
     * @constructor
     * @param {IForwardQuoteResponse=} [properties] Properties to set
     */
    function ForwardQuoteResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ForwardQuoteResponse QuoteID.
     * @member {string} QuoteID
     * @memberof ForwardQuoteResponse
     * @instance
     */
    ForwardQuoteResponse.prototype.QuoteID = "";

    /**
     * ForwardQuoteResponse Ask.
     * @member {IForwardQuoteSide|null|undefined} Ask
     * @memberof ForwardQuoteResponse
     * @instance
     */
    ForwardQuoteResponse.prototype.Ask = null;

    /**
     * ForwardQuoteResponse Bid.
     * @member {IForwardQuoteSide|null|undefined} Bid
     * @memberof ForwardQuoteResponse
     * @instance
     */
    ForwardQuoteResponse.prototype.Bid = null;

    /**
     * ForwardQuoteResponse Spread.
     * @member {IForwardQuoteDelta|null|undefined} Spread
     * @memberof ForwardQuoteResponse
     * @instance
     */
    ForwardQuoteResponse.prototype.Spread = null;

    /**
     * Creates a new ForwardQuoteResponse instance using the specified properties.
     * @function create
     * @memberof ForwardQuoteResponse
     * @static
     * @param {IForwardQuoteResponse=} [properties] Properties to set
     * @returns {ForwardQuoteResponse} ForwardQuoteResponse instance
     */
    ForwardQuoteResponse.create = function create(properties) {
        return new ForwardQuoteResponse(properties);
    };

    /**
     * Encodes the specified ForwardQuoteResponse message. Does not implicitly {@link ForwardQuoteResponse.verify|verify} messages.
     * @function encode
     * @memberof ForwardQuoteResponse
     * @static
     * @param {IForwardQuoteResponse} message ForwardQuoteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.QuoteID != null && Object.hasOwnProperty.call(message, "QuoteID"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.QuoteID);
        if (message.Ask != null && Object.hasOwnProperty.call(message, "Ask"))
            $root.ForwardQuoteSide.encode(message.Ask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Bid != null && Object.hasOwnProperty.call(message, "Bid"))
            $root.ForwardQuoteSide.encode(message.Bid, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Spread != null && Object.hasOwnProperty.call(message, "Spread"))
            $root.ForwardQuoteDelta.encode(message.Spread, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ForwardQuoteResponse message, length delimited. Does not implicitly {@link ForwardQuoteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ForwardQuoteResponse
     * @static
     * @param {IForwardQuoteResponse} message ForwardQuoteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ForwardQuoteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ForwardQuoteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ForwardQuoteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ForwardQuoteResponse} ForwardQuoteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ForwardQuoteResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.QuoteID = reader.string();
                break;
            case 2:
                message.Ask = $root.ForwardQuoteSide.decode(reader, reader.uint32());
                break;
            case 3:
                message.Bid = $root.ForwardQuoteSide.decode(reader, reader.uint32());
                break;
            case 4:
                message.Spread = $root.ForwardQuoteDelta.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ForwardQuoteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ForwardQuoteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ForwardQuoteResponse} ForwardQuoteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ForwardQuoteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ForwardQuoteResponse message.
     * @function verify
     * @memberof ForwardQuoteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ForwardQuoteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.QuoteID != null && message.hasOwnProperty("QuoteID"))
            if (!$util.isString(message.QuoteID))
                return "QuoteID: string expected";
        if (message.Ask != null && message.hasOwnProperty("Ask")) {
            var error = $root.ForwardQuoteSide.verify(message.Ask);
            if (error)
                return "Ask." + error;
        }
        if (message.Bid != null && message.hasOwnProperty("Bid")) {
            var error = $root.ForwardQuoteSide.verify(message.Bid);
            if (error)
                return "Bid." + error;
        }
        if (message.Spread != null && message.hasOwnProperty("Spread")) {
            var error = $root.ForwardQuoteDelta.verify(message.Spread);
            if (error)
                return "Spread." + error;
        }
        return null;
    };

    /**
     * Creates a ForwardQuoteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ForwardQuoteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ForwardQuoteResponse} ForwardQuoteResponse
     */
    ForwardQuoteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.ForwardQuoteResponse)
            return object;
        var message = new $root.ForwardQuoteResponse();
        if (object.QuoteID != null)
            message.QuoteID = String(object.QuoteID);
        if (object.Ask != null) {
            if (typeof object.Ask !== "object")
                throw TypeError(".ForwardQuoteResponse.Ask: object expected");
            message.Ask = $root.ForwardQuoteSide.fromObject(object.Ask);
        }
        if (object.Bid != null) {
            if (typeof object.Bid !== "object")
                throw TypeError(".ForwardQuoteResponse.Bid: object expected");
            message.Bid = $root.ForwardQuoteSide.fromObject(object.Bid);
        }
        if (object.Spread != null) {
            if (typeof object.Spread !== "object")
                throw TypeError(".ForwardQuoteResponse.Spread: object expected");
            message.Spread = $root.ForwardQuoteDelta.fromObject(object.Spread);
        }
        return message;
    };

    /**
     * Creates a plain object from a ForwardQuoteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ForwardQuoteResponse
     * @static
     * @param {ForwardQuoteResponse} message ForwardQuoteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ForwardQuoteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.QuoteID = "";
            object.Ask = null;
            object.Bid = null;
            object.Spread = null;
        }
        if (message.QuoteID != null && message.hasOwnProperty("QuoteID"))
            object.QuoteID = message.QuoteID;
        if (message.Ask != null && message.hasOwnProperty("Ask"))
            object.Ask = $root.ForwardQuoteSide.toObject(message.Ask, options);
        if (message.Bid != null && message.hasOwnProperty("Bid"))
            object.Bid = $root.ForwardQuoteSide.toObject(message.Bid, options);
        if (message.Spread != null && message.hasOwnProperty("Spread"))
            object.Spread = $root.ForwardQuoteDelta.toObject(message.Spread, options);
        return object;
    };

    /**
     * Converts this ForwardQuoteResponse to JSON.
     * @function toJSON
     * @memberof ForwardQuoteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ForwardQuoteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ForwardQuoteResponse;
})();

$root.Price = (function() {

    /**
     * Properties of a Price.
     * @exports IPrice
     * @interface IPrice
     * @property {number|null} [Value] Price Value
     * @property {number|null} [FractionSize] Price FractionSize
     * @property {number|null} [ExtraDigits] Price ExtraDigits
     */

    /**
     * Constructs a new Price.
     * @exports Price
     * @classdesc Represents a Price.
     * @implements IPrice
     * @constructor
     * @param {IPrice=} [properties] Properties to set
     */
    function Price(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Price Value.
     * @member {number} Value
     * @memberof Price
     * @instance
     */
    Price.prototype.Value = 0;

    /**
     * Price FractionSize.
     * @member {number} FractionSize
     * @memberof Price
     * @instance
     */
    Price.prototype.FractionSize = 0;

    /**
     * Price ExtraDigits.
     * @member {number} ExtraDigits
     * @memberof Price
     * @instance
     */
    Price.prototype.ExtraDigits = 0;

    /**
     * Creates a new Price instance using the specified properties.
     * @function create
     * @memberof Price
     * @static
     * @param {IPrice=} [properties] Properties to set
     * @returns {Price} Price instance
     */
    Price.create = function create(properties) {
        return new Price(properties);
    };

    /**
     * Encodes the specified Price message. Does not implicitly {@link Price.verify|verify} messages.
     * @function encode
     * @memberof Price
     * @static
     * @param {IPrice} message Price message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Price.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.Value);
        if (message.FractionSize != null && Object.hasOwnProperty.call(message, "FractionSize"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.FractionSize);
        if (message.ExtraDigits != null && Object.hasOwnProperty.call(message, "ExtraDigits"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ExtraDigits);
        return writer;
    };

    /**
     * Encodes the specified Price message, length delimited. Does not implicitly {@link Price.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Price
     * @static
     * @param {IPrice} message Price message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Price.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Price message from the specified reader or buffer.
     * @function decode
     * @memberof Price
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Price} Price
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Price.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Price();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.double();
                break;
            case 2:
                message.FractionSize = reader.int32();
                break;
            case 3:
                message.ExtraDigits = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Price message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Price
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Price} Price
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Price.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Price message.
     * @function verify
     * @memberof Price
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Price.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value !== "number")
                return "Value: number expected";
        if (message.FractionSize != null && message.hasOwnProperty("FractionSize"))
            if (!$util.isInteger(message.FractionSize))
                return "FractionSize: integer expected";
        if (message.ExtraDigits != null && message.hasOwnProperty("ExtraDigits"))
            if (!$util.isInteger(message.ExtraDigits))
                return "ExtraDigits: integer expected";
        return null;
    };

    /**
     * Creates a Price message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Price
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Price} Price
     */
    Price.fromObject = function fromObject(object) {
        if (object instanceof $root.Price)
            return object;
        var message = new $root.Price();
        if (object.Value != null)
            message.Value = Number(object.Value);
        if (object.FractionSize != null)
            message.FractionSize = object.FractionSize | 0;
        if (object.ExtraDigits != null)
            message.ExtraDigits = object.ExtraDigits | 0;
        return message;
    };

    /**
     * Creates a plain object from a Price message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Price
     * @static
     * @param {Price} message Price
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Price.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Value = 0;
            object.FractionSize = 0;
            object.ExtraDigits = 0;
        }
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.json && !isFinite(message.Value) ? String(message.Value) : message.Value;
        if (message.FractionSize != null && message.hasOwnProperty("FractionSize"))
            object.FractionSize = message.FractionSize;
        if (message.ExtraDigits != null && message.hasOwnProperty("ExtraDigits"))
            object.ExtraDigits = message.ExtraDigits;
        return object;
    };

    /**
     * Converts this Price to JSON.
     * @function toJSON
     * @memberof Price
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Price.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Price;
})();

$root.Point = (function() {

    /**
     * Properties of a Point.
     * @exports IPoint
     * @interface IPoint
     * @property {number|null} [Value] Point Value
     * @property {number|null} [ExtraDigits] Point ExtraDigits
     */

    /**
     * Constructs a new Point.
     * @exports Point
     * @classdesc Represents a Point.
     * @implements IPoint
     * @constructor
     * @param {IPoint=} [properties] Properties to set
     */
    function Point(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Point Value.
     * @member {number} Value
     * @memberof Point
     * @instance
     */
    Point.prototype.Value = 0;

    /**
     * Point ExtraDigits.
     * @member {number} ExtraDigits
     * @memberof Point
     * @instance
     */
    Point.prototype.ExtraDigits = 0;

    /**
     * Creates a new Point instance using the specified properties.
     * @function create
     * @memberof Point
     * @static
     * @param {IPoint=} [properties] Properties to set
     * @returns {Point} Point instance
     */
    Point.create = function create(properties) {
        return new Point(properties);
    };

    /**
     * Encodes the specified Point message. Does not implicitly {@link Point.verify|verify} messages.
     * @function encode
     * @memberof Point
     * @static
     * @param {IPoint} message Point message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Point.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.Value);
        if (message.ExtraDigits != null && Object.hasOwnProperty.call(message, "ExtraDigits"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ExtraDigits);
        return writer;
    };

    /**
     * Encodes the specified Point message, length delimited. Does not implicitly {@link Point.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Point
     * @static
     * @param {IPoint} message Point message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Point.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Point message from the specified reader or buffer.
     * @function decode
     * @memberof Point
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Point} Point
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Point.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Point();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.double();
                break;
            case 2:
                message.ExtraDigits = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Point message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Point
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Point} Point
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Point.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Point message.
     * @function verify
     * @memberof Point
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Point.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value !== "number")
                return "Value: number expected";
        if (message.ExtraDigits != null && message.hasOwnProperty("ExtraDigits"))
            if (!$util.isInteger(message.ExtraDigits))
                return "ExtraDigits: integer expected";
        return null;
    };

    /**
     * Creates a Point message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Point
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Point} Point
     */
    Point.fromObject = function fromObject(object) {
        if (object instanceof $root.Point)
            return object;
        var message = new $root.Point();
        if (object.Value != null)
            message.Value = Number(object.Value);
        if (object.ExtraDigits != null)
            message.ExtraDigits = object.ExtraDigits | 0;
        return message;
    };

    /**
     * Creates a plain object from a Point message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Point
     * @static
     * @param {Point} message Point
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Point.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Value = 0;
            object.ExtraDigits = 0;
        }
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.json && !isFinite(message.Value) ? String(message.Value) : message.Value;
        if (message.ExtraDigits != null && message.hasOwnProperty("ExtraDigits"))
            object.ExtraDigits = message.ExtraDigits;
        return object;
    };

    /**
     * Converts this Point to JSON.
     * @function toJSON
     * @memberof Point
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Point.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Point;
})();

$root.HistoricalNotificationsRequest = (function() {

    /**
     * Properties of a HistoricalNotificationsRequest.
     * @exports IHistoricalNotificationsRequest
     * @interface IHistoricalNotificationsRequest
     */

    /**
     * Constructs a new HistoricalNotificationsRequest.
     * @exports HistoricalNotificationsRequest
     * @classdesc Represents a HistoricalNotificationsRequest.
     * @implements IHistoricalNotificationsRequest
     * @constructor
     * @param {IHistoricalNotificationsRequest=} [properties] Properties to set
     */
    function HistoricalNotificationsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new HistoricalNotificationsRequest instance using the specified properties.
     * @function create
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {IHistoricalNotificationsRequest=} [properties] Properties to set
     * @returns {HistoricalNotificationsRequest} HistoricalNotificationsRequest instance
     */
    HistoricalNotificationsRequest.create = function create(properties) {
        return new HistoricalNotificationsRequest(properties);
    };

    /**
     * Encodes the specified HistoricalNotificationsRequest message. Does not implicitly {@link HistoricalNotificationsRequest.verify|verify} messages.
     * @function encode
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {IHistoricalNotificationsRequest} message HistoricalNotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HistoricalNotificationsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified HistoricalNotificationsRequest message, length delimited. Does not implicitly {@link HistoricalNotificationsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {IHistoricalNotificationsRequest} message HistoricalNotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HistoricalNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HistoricalNotificationsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HistoricalNotificationsRequest} HistoricalNotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HistoricalNotificationsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HistoricalNotificationsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HistoricalNotificationsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HistoricalNotificationsRequest} HistoricalNotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HistoricalNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HistoricalNotificationsRequest message.
     * @function verify
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HistoricalNotificationsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a HistoricalNotificationsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HistoricalNotificationsRequest} HistoricalNotificationsRequest
     */
    HistoricalNotificationsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.HistoricalNotificationsRequest)
            return object;
        return new $root.HistoricalNotificationsRequest();
    };

    /**
     * Creates a plain object from a HistoricalNotificationsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HistoricalNotificationsRequest
     * @static
     * @param {HistoricalNotificationsRequest} message HistoricalNotificationsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HistoricalNotificationsRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this HistoricalNotificationsRequest to JSON.
     * @function toJSON
     * @memberof HistoricalNotificationsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HistoricalNotificationsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HistoricalNotificationsRequest;
})();

$root.HistoricalNotificationsResponse = (function() {

    /**
     * Properties of a HistoricalNotificationsResponse.
     * @exports IHistoricalNotificationsResponse
     * @interface IHistoricalNotificationsResponse
     * @property {Array.<INotificationBarebone>|null} [Notifications] HistoricalNotificationsResponse Notifications
     */

    /**
     * Constructs a new HistoricalNotificationsResponse.
     * @exports HistoricalNotificationsResponse
     * @classdesc Represents a HistoricalNotificationsResponse.
     * @implements IHistoricalNotificationsResponse
     * @constructor
     * @param {IHistoricalNotificationsResponse=} [properties] Properties to set
     */
    function HistoricalNotificationsResponse(properties) {
        this.Notifications = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * HistoricalNotificationsResponse Notifications.
     * @member {Array.<INotificationBarebone>} Notifications
     * @memberof HistoricalNotificationsResponse
     * @instance
     */
    HistoricalNotificationsResponse.prototype.Notifications = $util.emptyArray;

    /**
     * Creates a new HistoricalNotificationsResponse instance using the specified properties.
     * @function create
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {IHistoricalNotificationsResponse=} [properties] Properties to set
     * @returns {HistoricalNotificationsResponse} HistoricalNotificationsResponse instance
     */
    HistoricalNotificationsResponse.create = function create(properties) {
        return new HistoricalNotificationsResponse(properties);
    };

    /**
     * Encodes the specified HistoricalNotificationsResponse message. Does not implicitly {@link HistoricalNotificationsResponse.verify|verify} messages.
     * @function encode
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {IHistoricalNotificationsResponse} message HistoricalNotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HistoricalNotificationsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Notifications != null && message.Notifications.length)
            for (var i = 0; i < message.Notifications.length; ++i)
                $root.NotificationBarebone.encode(message.Notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified HistoricalNotificationsResponse message, length delimited. Does not implicitly {@link HistoricalNotificationsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {IHistoricalNotificationsResponse} message HistoricalNotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HistoricalNotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HistoricalNotificationsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HistoricalNotificationsResponse} HistoricalNotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HistoricalNotificationsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HistoricalNotificationsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Notifications && message.Notifications.length))
                    message.Notifications = [];
                message.Notifications.push($root.NotificationBarebone.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HistoricalNotificationsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HistoricalNotificationsResponse} HistoricalNotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HistoricalNotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HistoricalNotificationsResponse message.
     * @function verify
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HistoricalNotificationsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Notifications != null && message.hasOwnProperty("Notifications")) {
            if (!Array.isArray(message.Notifications))
                return "Notifications: array expected";
            for (var i = 0; i < message.Notifications.length; ++i) {
                var error = $root.NotificationBarebone.verify(message.Notifications[i]);
                if (error)
                    return "Notifications." + error;
            }
        }
        return null;
    };

    /**
     * Creates a HistoricalNotificationsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HistoricalNotificationsResponse} HistoricalNotificationsResponse
     */
    HistoricalNotificationsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.HistoricalNotificationsResponse)
            return object;
        var message = new $root.HistoricalNotificationsResponse();
        if (object.Notifications) {
            if (!Array.isArray(object.Notifications))
                throw TypeError(".HistoricalNotificationsResponse.Notifications: array expected");
            message.Notifications = [];
            for (var i = 0; i < object.Notifications.length; ++i) {
                if (typeof object.Notifications[i] !== "object")
                    throw TypeError(".HistoricalNotificationsResponse.Notifications: object expected");
                message.Notifications[i] = $root.NotificationBarebone.fromObject(object.Notifications[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a HistoricalNotificationsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HistoricalNotificationsResponse
     * @static
     * @param {HistoricalNotificationsResponse} message HistoricalNotificationsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HistoricalNotificationsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Notifications = [];
        if (message.Notifications && message.Notifications.length) {
            object.Notifications = [];
            for (var j = 0; j < message.Notifications.length; ++j)
                object.Notifications[j] = $root.NotificationBarebone.toObject(message.Notifications[j], options);
        }
        return object;
    };

    /**
     * Converts this HistoricalNotificationsResponse to JSON.
     * @function toJSON
     * @memberof HistoricalNotificationsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HistoricalNotificationsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HistoricalNotificationsResponse;
})();

$root.NotificationBarebone = (function() {

    /**
     * Properties of a NotificationBarebone.
     * @exports INotificationBarebone
     * @interface INotificationBarebone
     * @property {string|null} [Id] NotificationBarebone Id
     * @property {NotificationItemType|null} [Topic] NotificationBarebone Topic
     */

    /**
     * Constructs a new NotificationBarebone.
     * @exports NotificationBarebone
     * @classdesc Represents a NotificationBarebone.
     * @implements INotificationBarebone
     * @constructor
     * @param {INotificationBarebone=} [properties] Properties to set
     */
    function NotificationBarebone(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NotificationBarebone Id.
     * @member {string} Id
     * @memberof NotificationBarebone
     * @instance
     */
    NotificationBarebone.prototype.Id = "";

    /**
     * NotificationBarebone Topic.
     * @member {NotificationItemType} Topic
     * @memberof NotificationBarebone
     * @instance
     */
    NotificationBarebone.prototype.Topic = 0;

    /**
     * Creates a new NotificationBarebone instance using the specified properties.
     * @function create
     * @memberof NotificationBarebone
     * @static
     * @param {INotificationBarebone=} [properties] Properties to set
     * @returns {NotificationBarebone} NotificationBarebone instance
     */
    NotificationBarebone.create = function create(properties) {
        return new NotificationBarebone(properties);
    };

    /**
     * Encodes the specified NotificationBarebone message. Does not implicitly {@link NotificationBarebone.verify|verify} messages.
     * @function encode
     * @memberof NotificationBarebone
     * @static
     * @param {INotificationBarebone} message NotificationBarebone message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationBarebone.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.Topic != null && Object.hasOwnProperty.call(message, "Topic"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Topic);
        return writer;
    };

    /**
     * Encodes the specified NotificationBarebone message, length delimited. Does not implicitly {@link NotificationBarebone.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NotificationBarebone
     * @static
     * @param {INotificationBarebone} message NotificationBarebone message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationBarebone.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NotificationBarebone message from the specified reader or buffer.
     * @function decode
     * @memberof NotificationBarebone
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NotificationBarebone} NotificationBarebone
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationBarebone.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NotificationBarebone();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.Topic = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NotificationBarebone message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NotificationBarebone
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NotificationBarebone} NotificationBarebone
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationBarebone.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NotificationBarebone message.
     * @function verify
     * @memberof NotificationBarebone
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NotificationBarebone.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.Topic != null && message.hasOwnProperty("Topic"))
            switch (message.Topic) {
            default:
                return "Topic: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        return null;
    };

    /**
     * Creates a NotificationBarebone message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NotificationBarebone
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NotificationBarebone} NotificationBarebone
     */
    NotificationBarebone.fromObject = function fromObject(object) {
        if (object instanceof $root.NotificationBarebone)
            return object;
        var message = new $root.NotificationBarebone();
        if (object.Id != null)
            message.Id = String(object.Id);
        switch (object.Topic) {
        case "NOTIFICATIONITEMTYPE_SENT":
        case 0:
            message.Topic = 0;
            break;
        case "NOTIFICATIONITEMTYPE_FILLED":
        case 1:
            message.Topic = 1;
            break;
        case "NOTIFICATIONITEMTYPE_REJECTED":
        case 2:
            message.Topic = 2;
            break;
        case "NOTIFICATIONITEMTYPE_SUSPENDED":
        case 3:
            message.Topic = 3;
            break;
        case "NOTIFICATIONITEMTYPE_TRADINGDISABLED":
        case 4:
            message.Topic = 4;
            break;
        case "NOTIFICATIONITEMTYPE_CANCELLED":
        case 5:
            message.Topic = 5;
            break;
        case "NOTIFICATIONITEMTYPE_EXPIRED":
        case 6:
            message.Topic = 6;
            break;
        case "NOTIFICATIONITEMTYPE_ORDERCHANGED":
        case 7:
            message.Topic = 7;
            break;
        case "NOTIFICATIONITEMTYPE_BACKTOACTIVE":
        case 8:
            message.Topic = 8;
            break;
        case "NOTIFICATIONITEMTYPE_UNKNOWN":
        case 9:
            message.Topic = 9;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a NotificationBarebone message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NotificationBarebone
     * @static
     * @param {NotificationBarebone} message NotificationBarebone
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NotificationBarebone.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = "";
            object.Topic = options.enums === String ? "NOTIFICATIONITEMTYPE_SENT" : 0;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Topic != null && message.hasOwnProperty("Topic"))
            object.Topic = options.enums === String ? $root.NotificationItemType[message.Topic] : message.Topic;
        return object;
    };

    /**
     * Converts this NotificationBarebone to JSON.
     * @function toJSON
     * @memberof NotificationBarebone
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NotificationBarebone.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NotificationBarebone;
})();

$root.Notification = (function() {

    /**
     * Properties of a Notification.
     * @exports INotification
     * @interface INotification
     * @property {string|null} [Id] Notification Id
     * @property {NotificationItemType|null} [Topic] Notification Topic
     * @property {string|null} [CustomHeader] Notification CustomHeader
     * @property {IFormattedText|null} [Message] Notification Message
     * @property {string|null} [Date] Notification Date
     * @property {google.protobuf.IStringValue|null} [RelatedOrderId] Notification RelatedOrderId
     * @property {google.protobuf.IInt32Value|null} [ClientId] Notification ClientId
     */

    /**
     * Constructs a new Notification.
     * @exports Notification
     * @classdesc Represents a Notification.
     * @implements INotification
     * @constructor
     * @param {INotification=} [properties] Properties to set
     */
    function Notification(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Notification Id.
     * @member {string} Id
     * @memberof Notification
     * @instance
     */
    Notification.prototype.Id = "";

    /**
     * Notification Topic.
     * @member {NotificationItemType} Topic
     * @memberof Notification
     * @instance
     */
    Notification.prototype.Topic = 0;

    /**
     * Notification CustomHeader.
     * @member {string} CustomHeader
     * @memberof Notification
     * @instance
     */
    Notification.prototype.CustomHeader = "";

    /**
     * Notification Message.
     * @member {IFormattedText|null|undefined} Message
     * @memberof Notification
     * @instance
     */
    Notification.prototype.Message = null;

    /**
     * Notification Date.
     * @member {string} Date
     * @memberof Notification
     * @instance
     */
    Notification.prototype.Date = "";

    /**
     * Notification RelatedOrderId.
     * @member {google.protobuf.IStringValue|null|undefined} RelatedOrderId
     * @memberof Notification
     * @instance
     */
    Notification.prototype.RelatedOrderId = null;

    /**
     * Notification ClientId.
     * @member {google.protobuf.IInt32Value|null|undefined} ClientId
     * @memberof Notification
     * @instance
     */
    Notification.prototype.ClientId = null;

    /**
     * Creates a new Notification instance using the specified properties.
     * @function create
     * @memberof Notification
     * @static
     * @param {INotification=} [properties] Properties to set
     * @returns {Notification} Notification instance
     */
    Notification.create = function create(properties) {
        return new Notification(properties);
    };

    /**
     * Encodes the specified Notification message. Does not implicitly {@link Notification.verify|verify} messages.
     * @function encode
     * @memberof Notification
     * @static
     * @param {INotification} message Notification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Notification.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.Topic != null && Object.hasOwnProperty.call(message, "Topic"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Topic);
        if (message.CustomHeader != null && Object.hasOwnProperty.call(message, "CustomHeader"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.CustomHeader);
        if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
            $root.FormattedText.encode(message.Message, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Date);
        if (message.RelatedOrderId != null && Object.hasOwnProperty.call(message, "RelatedOrderId"))
            $root.google.protobuf.StringValue.encode(message.RelatedOrderId, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            $root.google.protobuf.Int32Value.encode(message.ClientId, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Notification message, length delimited. Does not implicitly {@link Notification.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Notification
     * @static
     * @param {INotification} message Notification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Notification.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Notification message from the specified reader or buffer.
     * @function decode
     * @memberof Notification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Notification} Notification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Notification.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Notification();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.Topic = reader.int32();
                break;
            case 3:
                message.CustomHeader = reader.string();
                break;
            case 4:
                message.Message = $root.FormattedText.decode(reader, reader.uint32());
                break;
            case 5:
                message.Date = reader.string();
                break;
            case 6:
                message.RelatedOrderId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 7:
                message.ClientId = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Notification message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Notification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Notification} Notification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Notification.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Notification message.
     * @function verify
     * @memberof Notification
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Notification.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.Topic != null && message.hasOwnProperty("Topic"))
            switch (message.Topic) {
            default:
                return "Topic: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.CustomHeader != null && message.hasOwnProperty("CustomHeader"))
            if (!$util.isString(message.CustomHeader))
                return "CustomHeader: string expected";
        if (message.Message != null && message.hasOwnProperty("Message")) {
            var error = $root.FormattedText.verify(message.Message);
            if (error)
                return "Message." + error;
        }
        if (message.Date != null && message.hasOwnProperty("Date"))
            if (!$util.isString(message.Date))
                return "Date: string expected";
        if (message.RelatedOrderId != null && message.hasOwnProperty("RelatedOrderId")) {
            var error = $root.google.protobuf.StringValue.verify(message.RelatedOrderId);
            if (error)
                return "RelatedOrderId." + error;
        }
        if (message.ClientId != null && message.hasOwnProperty("ClientId")) {
            var error = $root.google.protobuf.Int32Value.verify(message.ClientId);
            if (error)
                return "ClientId." + error;
        }
        return null;
    };

    /**
     * Creates a Notification message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Notification
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Notification} Notification
     */
    Notification.fromObject = function fromObject(object) {
        if (object instanceof $root.Notification)
            return object;
        var message = new $root.Notification();
        if (object.Id != null)
            message.Id = String(object.Id);
        switch (object.Topic) {
        case "NOTIFICATIONITEMTYPE_SENT":
        case 0:
            message.Topic = 0;
            break;
        case "NOTIFICATIONITEMTYPE_FILLED":
        case 1:
            message.Topic = 1;
            break;
        case "NOTIFICATIONITEMTYPE_REJECTED":
        case 2:
            message.Topic = 2;
            break;
        case "NOTIFICATIONITEMTYPE_SUSPENDED":
        case 3:
            message.Topic = 3;
            break;
        case "NOTIFICATIONITEMTYPE_TRADINGDISABLED":
        case 4:
            message.Topic = 4;
            break;
        case "NOTIFICATIONITEMTYPE_CANCELLED":
        case 5:
            message.Topic = 5;
            break;
        case "NOTIFICATIONITEMTYPE_EXPIRED":
        case 6:
            message.Topic = 6;
            break;
        case "NOTIFICATIONITEMTYPE_ORDERCHANGED":
        case 7:
            message.Topic = 7;
            break;
        case "NOTIFICATIONITEMTYPE_BACKTOACTIVE":
        case 8:
            message.Topic = 8;
            break;
        case "NOTIFICATIONITEMTYPE_UNKNOWN":
        case 9:
            message.Topic = 9;
            break;
        }
        if (object.CustomHeader != null)
            message.CustomHeader = String(object.CustomHeader);
        if (object.Message != null) {
            if (typeof object.Message !== "object")
                throw TypeError(".Notification.Message: object expected");
            message.Message = $root.FormattedText.fromObject(object.Message);
        }
        if (object.Date != null)
            message.Date = String(object.Date);
        if (object.RelatedOrderId != null) {
            if (typeof object.RelatedOrderId !== "object")
                throw TypeError(".Notification.RelatedOrderId: object expected");
            message.RelatedOrderId = $root.google.protobuf.StringValue.fromObject(object.RelatedOrderId);
        }
        if (object.ClientId != null) {
            if (typeof object.ClientId !== "object")
                throw TypeError(".Notification.ClientId: object expected");
            message.ClientId = $root.google.protobuf.Int32Value.fromObject(object.ClientId);
        }
        return message;
    };

    /**
     * Creates a plain object from a Notification message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Notification
     * @static
     * @param {Notification} message Notification
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Notification.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = "";
            object.Topic = options.enums === String ? "NOTIFICATIONITEMTYPE_SENT" : 0;
            object.CustomHeader = "";
            object.Message = null;
            object.Date = "";
            object.RelatedOrderId = null;
            object.ClientId = null;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Topic != null && message.hasOwnProperty("Topic"))
            object.Topic = options.enums === String ? $root.NotificationItemType[message.Topic] : message.Topic;
        if (message.CustomHeader != null && message.hasOwnProperty("CustomHeader"))
            object.CustomHeader = message.CustomHeader;
        if (message.Message != null && message.hasOwnProperty("Message"))
            object.Message = $root.FormattedText.toObject(message.Message, options);
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = message.Date;
        if (message.RelatedOrderId != null && message.hasOwnProperty("RelatedOrderId"))
            object.RelatedOrderId = $root.google.protobuf.StringValue.toObject(message.RelatedOrderId, options);
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = $root.google.protobuf.Int32Value.toObject(message.ClientId, options);
        return object;
    };

    /**
     * Converts this Notification to JSON.
     * @function toJSON
     * @memberof Notification
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Notification.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Notification;
})();

$root.SoundNotification = (function() {

    /**
     * Properties of a SoundNotification.
     * @exports ISoundNotification
     * @interface ISoundNotification
     * @property {string|null} [Id] SoundNotification Id
     */

    /**
     * Constructs a new SoundNotification.
     * @exports SoundNotification
     * @classdesc Represents a SoundNotification.
     * @implements ISoundNotification
     * @constructor
     * @param {ISoundNotification=} [properties] Properties to set
     */
    function SoundNotification(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SoundNotification Id.
     * @member {string} Id
     * @memberof SoundNotification
     * @instance
     */
    SoundNotification.prototype.Id = "";

    /**
     * Creates a new SoundNotification instance using the specified properties.
     * @function create
     * @memberof SoundNotification
     * @static
     * @param {ISoundNotification=} [properties] Properties to set
     * @returns {SoundNotification} SoundNotification instance
     */
    SoundNotification.create = function create(properties) {
        return new SoundNotification(properties);
    };

    /**
     * Encodes the specified SoundNotification message. Does not implicitly {@link SoundNotification.verify|verify} messages.
     * @function encode
     * @memberof SoundNotification
     * @static
     * @param {ISoundNotification} message SoundNotification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotification.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        return writer;
    };

    /**
     * Encodes the specified SoundNotification message, length delimited. Does not implicitly {@link SoundNotification.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SoundNotification
     * @static
     * @param {ISoundNotification} message SoundNotification message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotification.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SoundNotification message from the specified reader or buffer.
     * @function decode
     * @memberof SoundNotification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SoundNotification} SoundNotification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotification.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SoundNotification();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SoundNotification message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SoundNotification
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SoundNotification} SoundNotification
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotification.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SoundNotification message.
     * @function verify
     * @memberof SoundNotification
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SoundNotification.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        return null;
    };

    /**
     * Creates a SoundNotification message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SoundNotification
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SoundNotification} SoundNotification
     */
    SoundNotification.fromObject = function fromObject(object) {
        if (object instanceof $root.SoundNotification)
            return object;
        var message = new $root.SoundNotification();
        if (object.Id != null)
            message.Id = String(object.Id);
        return message;
    };

    /**
     * Creates a plain object from a SoundNotification message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SoundNotification
     * @static
     * @param {SoundNotification} message SoundNotification
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SoundNotification.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Id = "";
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        return object;
    };

    /**
     * Converts this SoundNotification to JSON.
     * @function toJSON
     * @memberof SoundNotification
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SoundNotification.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SoundNotification;
})();

$root.LimitsRequest = (function() {

    /**
     * Properties of a LimitsRequest.
     * @exports ILimitsRequest
     * @interface ILimitsRequest
     * @property {number|null} [ClientId] LimitsRequest ClientId
     */

    /**
     * Constructs a new LimitsRequest.
     * @exports LimitsRequest
     * @classdesc Represents a LimitsRequest.
     * @implements ILimitsRequest
     * @constructor
     * @param {ILimitsRequest=} [properties] Properties to set
     */
    function LimitsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LimitsRequest ClientId.
     * @member {number} ClientId
     * @memberof LimitsRequest
     * @instance
     */
    LimitsRequest.prototype.ClientId = 0;

    /**
     * Creates a new LimitsRequest instance using the specified properties.
     * @function create
     * @memberof LimitsRequest
     * @static
     * @param {ILimitsRequest=} [properties] Properties to set
     * @returns {LimitsRequest} LimitsRequest instance
     */
    LimitsRequest.create = function create(properties) {
        return new LimitsRequest(properties);
    };

    /**
     * Encodes the specified LimitsRequest message. Does not implicitly {@link LimitsRequest.verify|verify} messages.
     * @function encode
     * @memberof LimitsRequest
     * @static
     * @param {ILimitsRequest} message LimitsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LimitsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClientId);
        return writer;
    };

    /**
     * Encodes the specified LimitsRequest message, length delimited. Does not implicitly {@link LimitsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LimitsRequest
     * @static
     * @param {ILimitsRequest} message LimitsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LimitsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LimitsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof LimitsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LimitsRequest} LimitsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LimitsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LimitsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClientId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LimitsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LimitsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LimitsRequest} LimitsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LimitsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LimitsRequest message.
     * @function verify
     * @memberof LimitsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LimitsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        return null;
    };

    /**
     * Creates a LimitsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LimitsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LimitsRequest} LimitsRequest
     */
    LimitsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.LimitsRequest)
            return object;
        var message = new $root.LimitsRequest();
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        return message;
    };

    /**
     * Creates a plain object from a LimitsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LimitsRequest
     * @static
     * @param {LimitsRequest} message LimitsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LimitsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.ClientId = 0;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        return object;
    };

    /**
     * Converts this LimitsRequest to JSON.
     * @function toJSON
     * @memberof LimitsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LimitsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LimitsRequest;
})();

$root.Limit = (function() {

    /**
     * Properties of a Limit.
     * @exports ILimit
     * @interface ILimit
     * @property {string|null} [Alias] Limit Alias
     * @property {number|null} [Limit] Limit Limit
     * @property {number|null} [Consumed] Limit Consumed
     * @property {string|null} [Currency] Limit Currency
     * @property {string|null} [Updated] Limit Updated
     */

    /**
     * Constructs a new Limit.
     * @exports Limit
     * @classdesc Represents a Limit.
     * @implements ILimit
     * @constructor
     * @param {ILimit=} [properties] Properties to set
     */
    function Limit(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Limit Alias.
     * @member {string} Alias
     * @memberof Limit
     * @instance
     */
    Limit.prototype.Alias = "";

    /**
     * Limit Limit.
     * @member {number} Limit
     * @memberof Limit
     * @instance
     */
    Limit.prototype.Limit = 0;

    /**
     * Limit Consumed.
     * @member {number} Consumed
     * @memberof Limit
     * @instance
     */
    Limit.prototype.Consumed = 0;

    /**
     * Limit Currency.
     * @member {string} Currency
     * @memberof Limit
     * @instance
     */
    Limit.prototype.Currency = "";

    /**
     * Limit Updated.
     * @member {string} Updated
     * @memberof Limit
     * @instance
     */
    Limit.prototype.Updated = "";

    /**
     * Creates a new Limit instance using the specified properties.
     * @function create
     * @memberof Limit
     * @static
     * @param {ILimit=} [properties] Properties to set
     * @returns {Limit} Limit instance
     */
    Limit.create = function create(properties) {
        return new Limit(properties);
    };

    /**
     * Encodes the specified Limit message. Does not implicitly {@link Limit.verify|verify} messages.
     * @function encode
     * @memberof Limit
     * @static
     * @param {ILimit} message Limit message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Limit.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Alias != null && Object.hasOwnProperty.call(message, "Alias"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Alias);
        if (message.Limit != null && Object.hasOwnProperty.call(message, "Limit"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Limit);
        if (message.Consumed != null && Object.hasOwnProperty.call(message, "Consumed"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.Consumed);
        if (message.Currency != null && Object.hasOwnProperty.call(message, "Currency"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Currency);
        if (message.Updated != null && Object.hasOwnProperty.call(message, "Updated"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Updated);
        return writer;
    };

    /**
     * Encodes the specified Limit message, length delimited. Does not implicitly {@link Limit.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Limit
     * @static
     * @param {ILimit} message Limit message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Limit.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Limit message from the specified reader or buffer.
     * @function decode
     * @memberof Limit
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Limit} Limit
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Limit.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Limit();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Alias = reader.string();
                break;
            case 2:
                message.Limit = reader.double();
                break;
            case 3:
                message.Consumed = reader.double();
                break;
            case 4:
                message.Currency = reader.string();
                break;
            case 5:
                message.Updated = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Limit message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Limit
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Limit} Limit
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Limit.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Limit message.
     * @function verify
     * @memberof Limit
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Limit.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Alias != null && message.hasOwnProperty("Alias"))
            if (!$util.isString(message.Alias))
                return "Alias: string expected";
        if (message.Limit != null && message.hasOwnProperty("Limit"))
            if (typeof message.Limit !== "number")
                return "Limit: number expected";
        if (message.Consumed != null && message.hasOwnProperty("Consumed"))
            if (typeof message.Consumed !== "number")
                return "Consumed: number expected";
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            if (!$util.isString(message.Currency))
                return "Currency: string expected";
        if (message.Updated != null && message.hasOwnProperty("Updated"))
            if (!$util.isString(message.Updated))
                return "Updated: string expected";
        return null;
    };

    /**
     * Creates a Limit message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Limit
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Limit} Limit
     */
    Limit.fromObject = function fromObject(object) {
        if (object instanceof $root.Limit)
            return object;
        var message = new $root.Limit();
        if (object.Alias != null)
            message.Alias = String(object.Alias);
        if (object.Limit != null)
            message.Limit = Number(object.Limit);
        if (object.Consumed != null)
            message.Consumed = Number(object.Consumed);
        if (object.Currency != null)
            message.Currency = String(object.Currency);
        if (object.Updated != null)
            message.Updated = String(object.Updated);
        return message;
    };

    /**
     * Creates a plain object from a Limit message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Limit
     * @static
     * @param {Limit} message Limit
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Limit.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Alias = "";
            object.Limit = 0;
            object.Consumed = 0;
            object.Currency = "";
            object.Updated = "";
        }
        if (message.Alias != null && message.hasOwnProperty("Alias"))
            object.Alias = message.Alias;
        if (message.Limit != null && message.hasOwnProperty("Limit"))
            object.Limit = options.json && !isFinite(message.Limit) ? String(message.Limit) : message.Limit;
        if (message.Consumed != null && message.hasOwnProperty("Consumed"))
            object.Consumed = options.json && !isFinite(message.Consumed) ? String(message.Consumed) : message.Consumed;
        if (message.Currency != null && message.hasOwnProperty("Currency"))
            object.Currency = message.Currency;
        if (message.Updated != null && message.hasOwnProperty("Updated"))
            object.Updated = message.Updated;
        return object;
    };

    /**
     * Converts this Limit to JSON.
     * @function toJSON
     * @memberof Limit
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Limit.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Limit;
})();

$root.LimitsResponse = (function() {

    /**
     * Properties of a LimitsResponse.
     * @exports ILimitsResponse
     * @interface ILimitsResponse
     * @property {Array.<ILimit>|null} [Limits] LimitsResponse Limits
     */

    /**
     * Constructs a new LimitsResponse.
     * @exports LimitsResponse
     * @classdesc Represents a LimitsResponse.
     * @implements ILimitsResponse
     * @constructor
     * @param {ILimitsResponse=} [properties] Properties to set
     */
    function LimitsResponse(properties) {
        this.Limits = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LimitsResponse Limits.
     * @member {Array.<ILimit>} Limits
     * @memberof LimitsResponse
     * @instance
     */
    LimitsResponse.prototype.Limits = $util.emptyArray;

    /**
     * Creates a new LimitsResponse instance using the specified properties.
     * @function create
     * @memberof LimitsResponse
     * @static
     * @param {ILimitsResponse=} [properties] Properties to set
     * @returns {LimitsResponse} LimitsResponse instance
     */
    LimitsResponse.create = function create(properties) {
        return new LimitsResponse(properties);
    };

    /**
     * Encodes the specified LimitsResponse message. Does not implicitly {@link LimitsResponse.verify|verify} messages.
     * @function encode
     * @memberof LimitsResponse
     * @static
     * @param {ILimitsResponse} message LimitsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LimitsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Limits != null && message.Limits.length)
            for (var i = 0; i < message.Limits.length; ++i)
                $root.Limit.encode(message.Limits[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LimitsResponse message, length delimited. Does not implicitly {@link LimitsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LimitsResponse
     * @static
     * @param {ILimitsResponse} message LimitsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LimitsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LimitsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof LimitsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LimitsResponse} LimitsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LimitsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LimitsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Limits && message.Limits.length))
                    message.Limits = [];
                message.Limits.push($root.Limit.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LimitsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LimitsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LimitsResponse} LimitsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LimitsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LimitsResponse message.
     * @function verify
     * @memberof LimitsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LimitsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Limits != null && message.hasOwnProperty("Limits")) {
            if (!Array.isArray(message.Limits))
                return "Limits: array expected";
            for (var i = 0; i < message.Limits.length; ++i) {
                var error = $root.Limit.verify(message.Limits[i]);
                if (error)
                    return "Limits." + error;
            }
        }
        return null;
    };

    /**
     * Creates a LimitsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LimitsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LimitsResponse} LimitsResponse
     */
    LimitsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.LimitsResponse)
            return object;
        var message = new $root.LimitsResponse();
        if (object.Limits) {
            if (!Array.isArray(object.Limits))
                throw TypeError(".LimitsResponse.Limits: array expected");
            message.Limits = [];
            for (var i = 0; i < object.Limits.length; ++i) {
                if (typeof object.Limits[i] !== "object")
                    throw TypeError(".LimitsResponse.Limits: object expected");
                message.Limits[i] = $root.Limit.fromObject(object.Limits[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a LimitsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LimitsResponse
     * @static
     * @param {LimitsResponse} message LimitsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LimitsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Limits = [];
        if (message.Limits && message.Limits.length) {
            object.Limits = [];
            for (var j = 0; j < message.Limits.length; ++j)
                object.Limits[j] = $root.Limit.toObject(message.Limits[j], options);
        }
        return object;
    };

    /**
     * Converts this LimitsResponse to JSON.
     * @function toJSON
     * @memberof LimitsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LimitsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LimitsResponse;
})();

$root.LogItem = (function() {

    /**
     * Properties of a LogItem.
     * @exports ILogItem
     * @interface ILogItem
     * @property {string|null} [Timestamp] LogItem Timestamp
     * @property {Object.<string,string>|null} [Attributes] LogItem Attributes
     * @property {Object.<string,string>|null} [Resource] LogItem Resource
     * @property {string|null} [TraceId] LogItem TraceId
     * @property {string|null} [SpanId] LogItem SpanId
     * @property {string|null} [SeverityText] LogItem SeverityText
     * @property {number|null} [SeverityNumber] LogItem SeverityNumber
     * @property {string|null} [Body] LogItem Body
     */

    /**
     * Constructs a new LogItem.
     * @exports LogItem
     * @classdesc Represents a LogItem.
     * @implements ILogItem
     * @constructor
     * @param {ILogItem=} [properties] Properties to set
     */
    function LogItem(properties) {
        this.Attributes = {};
        this.Resource = {};
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LogItem Timestamp.
     * @member {string} Timestamp
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.Timestamp = "";

    /**
     * LogItem Attributes.
     * @member {Object.<string,string>} Attributes
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.Attributes = $util.emptyObject;

    /**
     * LogItem Resource.
     * @member {Object.<string,string>} Resource
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.Resource = $util.emptyObject;

    /**
     * LogItem TraceId.
     * @member {string} TraceId
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.TraceId = "";

    /**
     * LogItem SpanId.
     * @member {string} SpanId
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.SpanId = "";

    /**
     * LogItem SeverityText.
     * @member {string} SeverityText
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.SeverityText = "";

    /**
     * LogItem SeverityNumber.
     * @member {number} SeverityNumber
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.SeverityNumber = 0;

    /**
     * LogItem Body.
     * @member {string} Body
     * @memberof LogItem
     * @instance
     */
    LogItem.prototype.Body = "";

    /**
     * Creates a new LogItem instance using the specified properties.
     * @function create
     * @memberof LogItem
     * @static
     * @param {ILogItem=} [properties] Properties to set
     * @returns {LogItem} LogItem instance
     */
    LogItem.create = function create(properties) {
        return new LogItem(properties);
    };

    /**
     * Encodes the specified LogItem message. Does not implicitly {@link LogItem.verify|verify} messages.
     * @function encode
     * @memberof LogItem
     * @static
     * @param {ILogItem} message LogItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Timestamp != null && Object.hasOwnProperty.call(message, "Timestamp"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Timestamp);
        if (message.Attributes != null && Object.hasOwnProperty.call(message, "Attributes"))
            for (var keys = Object.keys(message.Attributes), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Attributes[keys[i]]).ldelim();
        if (message.Resource != null && Object.hasOwnProperty.call(message, "Resource"))
            for (var keys = Object.keys(message.Resource), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Resource[keys[i]]).ldelim();
        if (message.TraceId != null && Object.hasOwnProperty.call(message, "TraceId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TraceId);
        if (message.SpanId != null && Object.hasOwnProperty.call(message, "SpanId"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.SpanId);
        if (message.SeverityText != null && Object.hasOwnProperty.call(message, "SeverityText"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.SeverityText);
        if (message.SeverityNumber != null && Object.hasOwnProperty.call(message, "SeverityNumber"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.SeverityNumber);
        if (message.Body != null && Object.hasOwnProperty.call(message, "Body"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.Body);
        return writer;
    };

    /**
     * Encodes the specified LogItem message, length delimited. Does not implicitly {@link LogItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LogItem
     * @static
     * @param {ILogItem} message LogItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LogItem message from the specified reader or buffer.
     * @function decode
     * @memberof LogItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LogItem} LogItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LogItem(), key, value;
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Timestamp = reader.string();
                break;
            case 2:
                if (message.Attributes === $util.emptyObject)
                    message.Attributes = {};
                var end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                    var tag2 = reader.uint32();
                    switch (tag2 >>> 3) {
                    case 1:
                        key = reader.string();
                        break;
                    case 2:
                        value = reader.string();
                        break;
                    default:
                        reader.skipType(tag2 & 7);
                        break;
                    }
                }
                message.Attributes[key] = value;
                break;
            case 3:
                if (message.Resource === $util.emptyObject)
                    message.Resource = {};
                var end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                    var tag2 = reader.uint32();
                    switch (tag2 >>> 3) {
                    case 1:
                        key = reader.string();
                        break;
                    case 2:
                        value = reader.string();
                        break;
                    default:
                        reader.skipType(tag2 & 7);
                        break;
                    }
                }
                message.Resource[key] = value;
                break;
            case 4:
                message.TraceId = reader.string();
                break;
            case 5:
                message.SpanId = reader.string();
                break;
            case 6:
                message.SeverityText = reader.string();
                break;
            case 7:
                message.SeverityNumber = reader.int32();
                break;
            case 8:
                message.Body = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LogItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LogItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LogItem} LogItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LogItem message.
     * @function verify
     * @memberof LogItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LogItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (!$util.isString(message.Timestamp))
                return "Timestamp: string expected";
        if (message.Attributes != null && message.hasOwnProperty("Attributes")) {
            if (!$util.isObject(message.Attributes))
                return "Attributes: object expected";
            var key = Object.keys(message.Attributes);
            for (var i = 0; i < key.length; ++i)
                if (!$util.isString(message.Attributes[key[i]]))
                    return "Attributes: string{k:string} expected";
        }
        if (message.Resource != null && message.hasOwnProperty("Resource")) {
            if (!$util.isObject(message.Resource))
                return "Resource: object expected";
            var key = Object.keys(message.Resource);
            for (var i = 0; i < key.length; ++i)
                if (!$util.isString(message.Resource[key[i]]))
                    return "Resource: string{k:string} expected";
        }
        if (message.TraceId != null && message.hasOwnProperty("TraceId"))
            if (!$util.isString(message.TraceId))
                return "TraceId: string expected";
        if (message.SpanId != null && message.hasOwnProperty("SpanId"))
            if (!$util.isString(message.SpanId))
                return "SpanId: string expected";
        if (message.SeverityText != null && message.hasOwnProperty("SeverityText"))
            if (!$util.isString(message.SeverityText))
                return "SeverityText: string expected";
        if (message.SeverityNumber != null && message.hasOwnProperty("SeverityNumber"))
            if (!$util.isInteger(message.SeverityNumber))
                return "SeverityNumber: integer expected";
        if (message.Body != null && message.hasOwnProperty("Body"))
            if (!$util.isString(message.Body))
                return "Body: string expected";
        return null;
    };

    /**
     * Creates a LogItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LogItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LogItem} LogItem
     */
    LogItem.fromObject = function fromObject(object) {
        if (object instanceof $root.LogItem)
            return object;
        var message = new $root.LogItem();
        if (object.Timestamp != null)
            message.Timestamp = String(object.Timestamp);
        if (object.Attributes) {
            if (typeof object.Attributes !== "object")
                throw TypeError(".LogItem.Attributes: object expected");
            message.Attributes = {};
            for (var keys = Object.keys(object.Attributes), i = 0; i < keys.length; ++i)
                message.Attributes[keys[i]] = String(object.Attributes[keys[i]]);
        }
        if (object.Resource) {
            if (typeof object.Resource !== "object")
                throw TypeError(".LogItem.Resource: object expected");
            message.Resource = {};
            for (var keys = Object.keys(object.Resource), i = 0; i < keys.length; ++i)
                message.Resource[keys[i]] = String(object.Resource[keys[i]]);
        }
        if (object.TraceId != null)
            message.TraceId = String(object.TraceId);
        if (object.SpanId != null)
            message.SpanId = String(object.SpanId);
        if (object.SeverityText != null)
            message.SeverityText = String(object.SeverityText);
        if (object.SeverityNumber != null)
            message.SeverityNumber = object.SeverityNumber | 0;
        if (object.Body != null)
            message.Body = String(object.Body);
        return message;
    };

    /**
     * Creates a plain object from a LogItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LogItem
     * @static
     * @param {LogItem} message LogItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LogItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.objects || options.defaults) {
            object.Attributes = {};
            object.Resource = {};
        }
        if (options.defaults) {
            object.Timestamp = "";
            object.TraceId = "";
            object.SpanId = "";
            object.SeverityText = "";
            object.SeverityNumber = 0;
            object.Body = "";
        }
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            object.Timestamp = message.Timestamp;
        var keys2;
        if (message.Attributes && (keys2 = Object.keys(message.Attributes)).length) {
            object.Attributes = {};
            for (var j = 0; j < keys2.length; ++j)
                object.Attributes[keys2[j]] = message.Attributes[keys2[j]];
        }
        if (message.Resource && (keys2 = Object.keys(message.Resource)).length) {
            object.Resource = {};
            for (var j = 0; j < keys2.length; ++j)
                object.Resource[keys2[j]] = message.Resource[keys2[j]];
        }
        if (message.TraceId != null && message.hasOwnProperty("TraceId"))
            object.TraceId = message.TraceId;
        if (message.SpanId != null && message.hasOwnProperty("SpanId"))
            object.SpanId = message.SpanId;
        if (message.SeverityText != null && message.hasOwnProperty("SeverityText"))
            object.SeverityText = message.SeverityText;
        if (message.SeverityNumber != null && message.hasOwnProperty("SeverityNumber"))
            object.SeverityNumber = message.SeverityNumber;
        if (message.Body != null && message.hasOwnProperty("Body"))
            object.Body = message.Body;
        return object;
    };

    /**
     * Converts this LogItem to JSON.
     * @function toJSON
     * @memberof LogItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LogItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LogItem;
})();

$root.LogRequest = (function() {

    /**
     * Properties of a LogRequest.
     * @exports ILogRequest
     * @interface ILogRequest
     * @property {Array.<ILogItem>|null} [Items] LogRequest Items
     */

    /**
     * Constructs a new LogRequest.
     * @exports LogRequest
     * @classdesc Represents a LogRequest.
     * @implements ILogRequest
     * @constructor
     * @param {ILogRequest=} [properties] Properties to set
     */
    function LogRequest(properties) {
        this.Items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LogRequest Items.
     * @member {Array.<ILogItem>} Items
     * @memberof LogRequest
     * @instance
     */
    LogRequest.prototype.Items = $util.emptyArray;

    /**
     * Creates a new LogRequest instance using the specified properties.
     * @function create
     * @memberof LogRequest
     * @static
     * @param {ILogRequest=} [properties] Properties to set
     * @returns {LogRequest} LogRequest instance
     */
    LogRequest.create = function create(properties) {
        return new LogRequest(properties);
    };

    /**
     * Encodes the specified LogRequest message. Does not implicitly {@link LogRequest.verify|verify} messages.
     * @function encode
     * @memberof LogRequest
     * @static
     * @param {ILogRequest} message LogRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && message.Items.length)
            for (var i = 0; i < message.Items.length; ++i)
                $root.LogItem.encode(message.Items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified LogRequest message, length delimited. Does not implicitly {@link LogRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LogRequest
     * @static
     * @param {ILogRequest} message LogRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LogRequest message from the specified reader or buffer.
     * @function decode
     * @memberof LogRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LogRequest} LogRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LogRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Items && message.Items.length))
                    message.Items = [];
                message.Items.push($root.LogItem.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LogRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LogRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LogRequest} LogRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LogRequest message.
     * @function verify
     * @memberof LogRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LogRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!Array.isArray(message.Items))
                return "Items: array expected";
            for (var i = 0; i < message.Items.length; ++i) {
                var error = $root.LogItem.verify(message.Items[i]);
                if (error)
                    return "Items." + error;
            }
        }
        return null;
    };

    /**
     * Creates a LogRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LogRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LogRequest} LogRequest
     */
    LogRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.LogRequest)
            return object;
        var message = new $root.LogRequest();
        if (object.Items) {
            if (!Array.isArray(object.Items))
                throw TypeError(".LogRequest.Items: array expected");
            message.Items = [];
            for (var i = 0; i < object.Items.length; ++i) {
                if (typeof object.Items[i] !== "object")
                    throw TypeError(".LogRequest.Items: object expected");
                message.Items[i] = $root.LogItem.fromObject(object.Items[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a LogRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LogRequest
     * @static
     * @param {LogRequest} message LogRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LogRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Items = [];
        if (message.Items && message.Items.length) {
            object.Items = [];
            for (var j = 0; j < message.Items.length; ++j)
                object.Items[j] = $root.LogItem.toObject(message.Items[j], options);
        }
        return object;
    };

    /**
     * Converts this LogRequest to JSON.
     * @function toJSON
     * @memberof LogRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LogRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LogRequest;
})();

$root.LogResponse = (function() {

    /**
     * Properties of a LogResponse.
     * @exports ILogResponse
     * @interface ILogResponse
     */

    /**
     * Constructs a new LogResponse.
     * @exports LogResponse
     * @classdesc Represents a LogResponse.
     * @implements ILogResponse
     * @constructor
     * @param {ILogResponse=} [properties] Properties to set
     */
    function LogResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new LogResponse instance using the specified properties.
     * @function create
     * @memberof LogResponse
     * @static
     * @param {ILogResponse=} [properties] Properties to set
     * @returns {LogResponse} LogResponse instance
     */
    LogResponse.create = function create(properties) {
        return new LogResponse(properties);
    };

    /**
     * Encodes the specified LogResponse message. Does not implicitly {@link LogResponse.verify|verify} messages.
     * @function encode
     * @memberof LogResponse
     * @static
     * @param {ILogResponse} message LogResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified LogResponse message, length delimited. Does not implicitly {@link LogResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LogResponse
     * @static
     * @param {ILogResponse} message LogResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LogResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LogResponse message from the specified reader or buffer.
     * @function decode
     * @memberof LogResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LogResponse} LogResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LogResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LogResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LogResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LogResponse} LogResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LogResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LogResponse message.
     * @function verify
     * @memberof LogResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LogResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a LogResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LogResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LogResponse} LogResponse
     */
    LogResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.LogResponse)
            return object;
        return new $root.LogResponse();
    };

    /**
     * Creates a plain object from a LogResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LogResponse
     * @static
     * @param {LogResponse} message LogResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LogResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this LogResponse to JSON.
     * @function toJSON
     * @memberof LogResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LogResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return LogResponse;
})();

$root.CounterUpdateEvent = (function() {

    /**
     * Properties of a CounterUpdateEvent.
     * @exports ICounterUpdateEvent
     * @interface ICounterUpdateEvent
     * @property {CounterType|null} [Counter] CounterUpdateEvent Counter
     * @property {number|null} [Value] CounterUpdateEvent Value
     * @property {Array.<string>|null} [Labels] CounterUpdateEvent Labels
     * @property {CounterAction|null} [Action] CounterUpdateEvent Action
     */

    /**
     * Constructs a new CounterUpdateEvent.
     * @exports CounterUpdateEvent
     * @classdesc Represents a CounterUpdateEvent.
     * @implements ICounterUpdateEvent
     * @constructor
     * @param {ICounterUpdateEvent=} [properties] Properties to set
     */
    function CounterUpdateEvent(properties) {
        this.Labels = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CounterUpdateEvent Counter.
     * @member {CounterType} Counter
     * @memberof CounterUpdateEvent
     * @instance
     */
    CounterUpdateEvent.prototype.Counter = 0;

    /**
     * CounterUpdateEvent Value.
     * @member {number} Value
     * @memberof CounterUpdateEvent
     * @instance
     */
    CounterUpdateEvent.prototype.Value = 0;

    /**
     * CounterUpdateEvent Labels.
     * @member {Array.<string>} Labels
     * @memberof CounterUpdateEvent
     * @instance
     */
    CounterUpdateEvent.prototype.Labels = $util.emptyArray;

    /**
     * CounterUpdateEvent Action.
     * @member {CounterAction} Action
     * @memberof CounterUpdateEvent
     * @instance
     */
    CounterUpdateEvent.prototype.Action = 0;

    /**
     * Creates a new CounterUpdateEvent instance using the specified properties.
     * @function create
     * @memberof CounterUpdateEvent
     * @static
     * @param {ICounterUpdateEvent=} [properties] Properties to set
     * @returns {CounterUpdateEvent} CounterUpdateEvent instance
     */
    CounterUpdateEvent.create = function create(properties) {
        return new CounterUpdateEvent(properties);
    };

    /**
     * Encodes the specified CounterUpdateEvent message. Does not implicitly {@link CounterUpdateEvent.verify|verify} messages.
     * @function encode
     * @memberof CounterUpdateEvent
     * @static
     * @param {ICounterUpdateEvent} message CounterUpdateEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterUpdateEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Counter != null && Object.hasOwnProperty.call(message, "Counter"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Counter);
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Value);
        if (message.Labels != null && message.Labels.length)
            for (var i = 0; i < message.Labels.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Labels[i]);
        if (message.Action != null && Object.hasOwnProperty.call(message, "Action"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Action);
        return writer;
    };

    /**
     * Encodes the specified CounterUpdateEvent message, length delimited. Does not implicitly {@link CounterUpdateEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CounterUpdateEvent
     * @static
     * @param {ICounterUpdateEvent} message CounterUpdateEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterUpdateEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CounterUpdateEvent message from the specified reader or buffer.
     * @function decode
     * @memberof CounterUpdateEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CounterUpdateEvent} CounterUpdateEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterUpdateEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CounterUpdateEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Counter = reader.int32();
                break;
            case 2:
                message.Value = reader.double();
                break;
            case 3:
                if (!(message.Labels && message.Labels.length))
                    message.Labels = [];
                message.Labels.push(reader.string());
                break;
            case 4:
                message.Action = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CounterUpdateEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CounterUpdateEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CounterUpdateEvent} CounterUpdateEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterUpdateEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CounterUpdateEvent message.
     * @function verify
     * @memberof CounterUpdateEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CounterUpdateEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Counter != null && message.hasOwnProperty("Counter"))
            switch (message.Counter) {
            default:
                return "Counter: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value !== "number")
                return "Value: number expected";
        if (message.Labels != null && message.hasOwnProperty("Labels")) {
            if (!Array.isArray(message.Labels))
                return "Labels: array expected";
            for (var i = 0; i < message.Labels.length; ++i)
                if (!$util.isString(message.Labels[i]))
                    return "Labels: string[] expected";
        }
        if (message.Action != null && message.hasOwnProperty("Action"))
            switch (message.Action) {
            default:
                return "Action: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    /**
     * Creates a CounterUpdateEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CounterUpdateEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CounterUpdateEvent} CounterUpdateEvent
     */
    CounterUpdateEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.CounterUpdateEvent)
            return object;
        var message = new $root.CounterUpdateEvent();
        switch (object.Counter) {
        case "COUNTERTYPE_UNKNOWN_TYPE":
        case 0:
            message.Counter = 0;
            break;
        case "COUNTERTYPE_CLIENT_WS_INPUT_LATENCY":
        case 1:
            message.Counter = 1;
            break;
        case "COUNTERTYPE_CLIENT_ELEMENT_CLICK_COUNT":
        case 2:
            message.Counter = 2;
            break;
        case "COUNTERTYPE_CLIENT_OPENED_PADS_COUNT":
        case 3:
            message.Counter = 3;
            break;
        }
        if (object.Value != null)
            message.Value = Number(object.Value);
        if (object.Labels) {
            if (!Array.isArray(object.Labels))
                throw TypeError(".CounterUpdateEvent.Labels: array expected");
            message.Labels = [];
            for (var i = 0; i < object.Labels.length; ++i)
                message.Labels[i] = String(object.Labels[i]);
        }
        switch (object.Action) {
        case "COUNTERACTION_UNKNOWN_ACION":
        case 0:
            message.Action = 0;
            break;
        case "COUNTERACTION_INCREMENT":
        case 1:
            message.Action = 1;
            break;
        case "COUNTERACTION_DECREMENT":
        case 2:
            message.Action = 2;
            break;
        case "COUNTERACTION_OBSERVE":
        case 3:
            message.Action = 3;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a CounterUpdateEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CounterUpdateEvent
     * @static
     * @param {CounterUpdateEvent} message CounterUpdateEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CounterUpdateEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Labels = [];
        if (options.defaults) {
            object.Counter = options.enums === String ? "COUNTERTYPE_UNKNOWN_TYPE" : 0;
            object.Value = 0;
            object.Action = options.enums === String ? "COUNTERACTION_UNKNOWN_ACION" : 0;
        }
        if (message.Counter != null && message.hasOwnProperty("Counter"))
            object.Counter = options.enums === String ? $root.CounterType[message.Counter] : message.Counter;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.json && !isFinite(message.Value) ? String(message.Value) : message.Value;
        if (message.Labels && message.Labels.length) {
            object.Labels = [];
            for (var j = 0; j < message.Labels.length; ++j)
                object.Labels[j] = message.Labels[j];
        }
        if (message.Action != null && message.hasOwnProperty("Action"))
            object.Action = options.enums === String ? $root.CounterAction[message.Action] : message.Action;
        return object;
    };

    /**
     * Converts this CounterUpdateEvent to JSON.
     * @function toJSON
     * @memberof CounterUpdateEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CounterUpdateEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CounterUpdateEvent;
})();

$root.MetricRequest = (function() {

    /**
     * Properties of a MetricRequest.
     * @exports IMetricRequest
     * @interface IMetricRequest
     * @property {Array.<ICounterUpdateEvent>|null} [Events] MetricRequest Events
     */

    /**
     * Constructs a new MetricRequest.
     * @exports MetricRequest
     * @classdesc Represents a MetricRequest.
     * @implements IMetricRequest
     * @constructor
     * @param {IMetricRequest=} [properties] Properties to set
     */
    function MetricRequest(properties) {
        this.Events = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MetricRequest Events.
     * @member {Array.<ICounterUpdateEvent>} Events
     * @memberof MetricRequest
     * @instance
     */
    MetricRequest.prototype.Events = $util.emptyArray;

    /**
     * Creates a new MetricRequest instance using the specified properties.
     * @function create
     * @memberof MetricRequest
     * @static
     * @param {IMetricRequest=} [properties] Properties to set
     * @returns {MetricRequest} MetricRequest instance
     */
    MetricRequest.create = function create(properties) {
        return new MetricRequest(properties);
    };

    /**
     * Encodes the specified MetricRequest message. Does not implicitly {@link MetricRequest.verify|verify} messages.
     * @function encode
     * @memberof MetricRequest
     * @static
     * @param {IMetricRequest} message MetricRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetricRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Events != null && message.Events.length)
            for (var i = 0; i < message.Events.length; ++i)
                $root.CounterUpdateEvent.encode(message.Events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MetricRequest message, length delimited. Does not implicitly {@link MetricRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MetricRequest
     * @static
     * @param {IMetricRequest} message MetricRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetricRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MetricRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MetricRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetricRequest} MetricRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetricRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MetricRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Events && message.Events.length))
                    message.Events = [];
                message.Events.push($root.CounterUpdateEvent.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MetricRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MetricRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MetricRequest} MetricRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetricRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MetricRequest message.
     * @function verify
     * @memberof MetricRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MetricRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Events != null && message.hasOwnProperty("Events")) {
            if (!Array.isArray(message.Events))
                return "Events: array expected";
            for (var i = 0; i < message.Events.length; ++i) {
                var error = $root.CounterUpdateEvent.verify(message.Events[i]);
                if (error)
                    return "Events." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MetricRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetricRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetricRequest} MetricRequest
     */
    MetricRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MetricRequest)
            return object;
        var message = new $root.MetricRequest();
        if (object.Events) {
            if (!Array.isArray(object.Events))
                throw TypeError(".MetricRequest.Events: array expected");
            message.Events = [];
            for (var i = 0; i < object.Events.length; ++i) {
                if (typeof object.Events[i] !== "object")
                    throw TypeError(".MetricRequest.Events: object expected");
                message.Events[i] = $root.CounterUpdateEvent.fromObject(object.Events[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MetricRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetricRequest
     * @static
     * @param {MetricRequest} message MetricRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetricRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Events = [];
        if (message.Events && message.Events.length) {
            object.Events = [];
            for (var j = 0; j < message.Events.length; ++j)
                object.Events[j] = $root.CounterUpdateEvent.toObject(message.Events[j], options);
        }
        return object;
    };

    /**
     * Converts this MetricRequest to JSON.
     * @function toJSON
     * @memberof MetricRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetricRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MetricRequest;
})();

$root.MetricResponse = (function() {

    /**
     * Properties of a MetricResponse.
     * @exports IMetricResponse
     * @interface IMetricResponse
     */

    /**
     * Constructs a new MetricResponse.
     * @exports MetricResponse
     * @classdesc Represents a MetricResponse.
     * @implements IMetricResponse
     * @constructor
     * @param {IMetricResponse=} [properties] Properties to set
     */
    function MetricResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new MetricResponse instance using the specified properties.
     * @function create
     * @memberof MetricResponse
     * @static
     * @param {IMetricResponse=} [properties] Properties to set
     * @returns {MetricResponse} MetricResponse instance
     */
    MetricResponse.create = function create(properties) {
        return new MetricResponse(properties);
    };

    /**
     * Encodes the specified MetricResponse message. Does not implicitly {@link MetricResponse.verify|verify} messages.
     * @function encode
     * @memberof MetricResponse
     * @static
     * @param {IMetricResponse} message MetricResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetricResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified MetricResponse message, length delimited. Does not implicitly {@link MetricResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MetricResponse
     * @static
     * @param {IMetricResponse} message MetricResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetricResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MetricResponse message from the specified reader or buffer.
     * @function decode
     * @memberof MetricResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetricResponse} MetricResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetricResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MetricResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MetricResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MetricResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MetricResponse} MetricResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetricResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MetricResponse message.
     * @function verify
     * @memberof MetricResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MetricResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a MetricResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetricResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetricResponse} MetricResponse
     */
    MetricResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.MetricResponse)
            return object;
        return new $root.MetricResponse();
    };

    /**
     * Creates a plain object from a MetricResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetricResponse
     * @static
     * @param {MetricResponse} message MetricResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetricResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this MetricResponse to JSON.
     * @function toJSON
     * @memberof MetricResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetricResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MetricResponse;
})();





$root.NotificationResolveRequest = (function() {

    /**
     * Properties of a NotificationResolveRequest.
     * @exports INotificationResolveRequest
     * @interface INotificationResolveRequest
     * @property {Array.<string>|null} [id] NotificationResolveRequest id
     */

    /**
     * Constructs a new NotificationResolveRequest.
     * @exports NotificationResolveRequest
     * @classdesc Represents a NotificationResolveRequest.
     * @implements INotificationResolveRequest
     * @constructor
     * @param {INotificationResolveRequest=} [properties] Properties to set
     */
    function NotificationResolveRequest(properties) {
        this.id = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NotificationResolveRequest id.
     * @member {Array.<string>} id
     * @memberof NotificationResolveRequest
     * @instance
     */
    NotificationResolveRequest.prototype.id = $util.emptyArray;

    /**
     * Creates a new NotificationResolveRequest instance using the specified properties.
     * @function create
     * @memberof NotificationResolveRequest
     * @static
     * @param {INotificationResolveRequest=} [properties] Properties to set
     * @returns {NotificationResolveRequest} NotificationResolveRequest instance
     */
    NotificationResolveRequest.create = function create(properties) {
        return new NotificationResolveRequest(properties);
    };

    /**
     * Encodes the specified NotificationResolveRequest message. Does not implicitly {@link NotificationResolveRequest.verify|verify} messages.
     * @function encode
     * @memberof NotificationResolveRequest
     * @static
     * @param {INotificationResolveRequest} message NotificationResolveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationResolveRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && message.id.length)
            for (var i = 0; i < message.id.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id[i]);
        return writer;
    };

    /**
     * Encodes the specified NotificationResolveRequest message, length delimited. Does not implicitly {@link NotificationResolveRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NotificationResolveRequest
     * @static
     * @param {INotificationResolveRequest} message NotificationResolveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationResolveRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NotificationResolveRequest message from the specified reader or buffer.
     * @function decode
     * @memberof NotificationResolveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NotificationResolveRequest} NotificationResolveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationResolveRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NotificationResolveRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.id && message.id.length))
                    message.id = [];
                message.id.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NotificationResolveRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NotificationResolveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NotificationResolveRequest} NotificationResolveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationResolveRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NotificationResolveRequest message.
     * @function verify
     * @memberof NotificationResolveRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NotificationResolveRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id")) {
            if (!Array.isArray(message.id))
                return "id: array expected";
            for (var i = 0; i < message.id.length; ++i)
                if (!$util.isString(message.id[i]))
                    return "id: string[] expected";
        }
        return null;
    };

    /**
     * Creates a NotificationResolveRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NotificationResolveRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NotificationResolveRequest} NotificationResolveRequest
     */
    NotificationResolveRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NotificationResolveRequest)
            return object;
        var message = new $root.NotificationResolveRequest();
        if (object.id) {
            if (!Array.isArray(object.id))
                throw TypeError(".NotificationResolveRequest.id: array expected");
            message.id = [];
            for (var i = 0; i < object.id.length; ++i)
                message.id[i] = String(object.id[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a NotificationResolveRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NotificationResolveRequest
     * @static
     * @param {NotificationResolveRequest} message NotificationResolveRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NotificationResolveRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.id = [];
        if (message.id && message.id.length) {
            object.id = [];
            for (var j = 0; j < message.id.length; ++j)
                object.id[j] = message.id[j];
        }
        return object;
    };

    /**
     * Converts this NotificationResolveRequest to JSON.
     * @function toJSON
     * @memberof NotificationResolveRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NotificationResolveRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NotificationResolveRequest;
})();

$root.NotificationResolveResponse = (function() {

    /**
     * Properties of a NotificationResolveResponse.
     * @exports INotificationResolveResponse
     * @interface INotificationResolveResponse
     * @property {Array.<INotification>|null} [Notifications] NotificationResolveResponse Notifications
     */

    /**
     * Constructs a new NotificationResolveResponse.
     * @exports NotificationResolveResponse
     * @classdesc Represents a NotificationResolveResponse.
     * @implements INotificationResolveResponse
     * @constructor
     * @param {INotificationResolveResponse=} [properties] Properties to set
     */
    function NotificationResolveResponse(properties) {
        this.Notifications = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NotificationResolveResponse Notifications.
     * @member {Array.<INotification>} Notifications
     * @memberof NotificationResolveResponse
     * @instance
     */
    NotificationResolveResponse.prototype.Notifications = $util.emptyArray;

    /**
     * Creates a new NotificationResolveResponse instance using the specified properties.
     * @function create
     * @memberof NotificationResolveResponse
     * @static
     * @param {INotificationResolveResponse=} [properties] Properties to set
     * @returns {NotificationResolveResponse} NotificationResolveResponse instance
     */
    NotificationResolveResponse.create = function create(properties) {
        return new NotificationResolveResponse(properties);
    };

    /**
     * Encodes the specified NotificationResolveResponse message. Does not implicitly {@link NotificationResolveResponse.verify|verify} messages.
     * @function encode
     * @memberof NotificationResolveResponse
     * @static
     * @param {INotificationResolveResponse} message NotificationResolveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationResolveResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Notifications != null && message.Notifications.length)
            for (var i = 0; i < message.Notifications.length; ++i)
                $root.Notification.encode(message.Notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified NotificationResolveResponse message, length delimited. Does not implicitly {@link NotificationResolveResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NotificationResolveResponse
     * @static
     * @param {INotificationResolveResponse} message NotificationResolveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationResolveResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NotificationResolveResponse message from the specified reader or buffer.
     * @function decode
     * @memberof NotificationResolveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NotificationResolveResponse} NotificationResolveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationResolveResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NotificationResolveResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Notifications && message.Notifications.length))
                    message.Notifications = [];
                message.Notifications.push($root.Notification.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NotificationResolveResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NotificationResolveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NotificationResolveResponse} NotificationResolveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationResolveResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NotificationResolveResponse message.
     * @function verify
     * @memberof NotificationResolveResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NotificationResolveResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Notifications != null && message.hasOwnProperty("Notifications")) {
            if (!Array.isArray(message.Notifications))
                return "Notifications: array expected";
            for (var i = 0; i < message.Notifications.length; ++i) {
                var error = $root.Notification.verify(message.Notifications[i]);
                if (error)
                    return "Notifications." + error;
            }
        }
        return null;
    };

    /**
     * Creates a NotificationResolveResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NotificationResolveResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NotificationResolveResponse} NotificationResolveResponse
     */
    NotificationResolveResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.NotificationResolveResponse)
            return object;
        var message = new $root.NotificationResolveResponse();
        if (object.Notifications) {
            if (!Array.isArray(object.Notifications))
                throw TypeError(".NotificationResolveResponse.Notifications: array expected");
            message.Notifications = [];
            for (var i = 0; i < object.Notifications.length; ++i) {
                if (typeof object.Notifications[i] !== "object")
                    throw TypeError(".NotificationResolveResponse.Notifications: object expected");
                message.Notifications[i] = $root.Notification.fromObject(object.Notifications[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a NotificationResolveResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NotificationResolveResponse
     * @static
     * @param {NotificationResolveResponse} message NotificationResolveResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NotificationResolveResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Notifications = [];
        if (message.Notifications && message.Notifications.length) {
            object.Notifications = [];
            for (var j = 0; j < message.Notifications.length; ++j)
                object.Notifications[j] = $root.Notification.toObject(message.Notifications[j], options);
        }
        return object;
    };

    /**
     * Converts this NotificationResolveResponse to JSON.
     * @function toJSON
     * @memberof NotificationResolveResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NotificationResolveResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NotificationResolveResponse;
})();

$root.NotificationsRequest = (function() {

    /**
     * Properties of a NotificationsRequest.
     * @exports INotificationsRequest
     * @interface INotificationsRequest
     */

    /**
     * Constructs a new NotificationsRequest.
     * @exports NotificationsRequest
     * @classdesc Represents a NotificationsRequest.
     * @implements INotificationsRequest
     * @constructor
     * @param {INotificationsRequest=} [properties] Properties to set
     */
    function NotificationsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new NotificationsRequest instance using the specified properties.
     * @function create
     * @memberof NotificationsRequest
     * @static
     * @param {INotificationsRequest=} [properties] Properties to set
     * @returns {NotificationsRequest} NotificationsRequest instance
     */
    NotificationsRequest.create = function create(properties) {
        return new NotificationsRequest(properties);
    };

    /**
     * Encodes the specified NotificationsRequest message. Does not implicitly {@link NotificationsRequest.verify|verify} messages.
     * @function encode
     * @memberof NotificationsRequest
     * @static
     * @param {INotificationsRequest} message NotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified NotificationsRequest message, length delimited. Does not implicitly {@link NotificationsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NotificationsRequest
     * @static
     * @param {INotificationsRequest} message NotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NotificationsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof NotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NotificationsRequest} NotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NotificationsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NotificationsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NotificationsRequest} NotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NotificationsRequest message.
     * @function verify
     * @memberof NotificationsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NotificationsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a NotificationsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NotificationsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NotificationsRequest} NotificationsRequest
     */
    NotificationsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.NotificationsRequest)
            return object;
        return new $root.NotificationsRequest();
    };

    /**
     * Creates a plain object from a NotificationsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NotificationsRequest
     * @static
     * @param {NotificationsRequest} message NotificationsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NotificationsRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this NotificationsRequest to JSON.
     * @function toJSON
     * @memberof NotificationsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NotificationsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NotificationsRequest;
})();

$root.NotificationsResponse = (function() {

    /**
     * Properties of a NotificationsResponse.
     * @exports INotificationsResponse
     * @interface INotificationsResponse
     * @property {Array.<INotification>|null} [Notifications] NotificationsResponse Notifications
     */

    /**
     * Constructs a new NotificationsResponse.
     * @exports NotificationsResponse
     * @classdesc Represents a NotificationsResponse.
     * @implements INotificationsResponse
     * @constructor
     * @param {INotificationsResponse=} [properties] Properties to set
     */
    function NotificationsResponse(properties) {
        this.Notifications = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NotificationsResponse Notifications.
     * @member {Array.<INotification>} Notifications
     * @memberof NotificationsResponse
     * @instance
     */
    NotificationsResponse.prototype.Notifications = $util.emptyArray;

    /**
     * Creates a new NotificationsResponse instance using the specified properties.
     * @function create
     * @memberof NotificationsResponse
     * @static
     * @param {INotificationsResponse=} [properties] Properties to set
     * @returns {NotificationsResponse} NotificationsResponse instance
     */
    NotificationsResponse.create = function create(properties) {
        return new NotificationsResponse(properties);
    };

    /**
     * Encodes the specified NotificationsResponse message. Does not implicitly {@link NotificationsResponse.verify|verify} messages.
     * @function encode
     * @memberof NotificationsResponse
     * @static
     * @param {INotificationsResponse} message NotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Notifications != null && message.Notifications.length)
            for (var i = 0; i < message.Notifications.length; ++i)
                $root.Notification.encode(message.Notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified NotificationsResponse message, length delimited. Does not implicitly {@link NotificationsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NotificationsResponse
     * @static
     * @param {INotificationsResponse} message NotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NotificationsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof NotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NotificationsResponse} NotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NotificationsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Notifications && message.Notifications.length))
                    message.Notifications = [];
                message.Notifications.push($root.Notification.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NotificationsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NotificationsResponse} NotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NotificationsResponse message.
     * @function verify
     * @memberof NotificationsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NotificationsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Notifications != null && message.hasOwnProperty("Notifications")) {
            if (!Array.isArray(message.Notifications))
                return "Notifications: array expected";
            for (var i = 0; i < message.Notifications.length; ++i) {
                var error = $root.Notification.verify(message.Notifications[i]);
                if (error)
                    return "Notifications." + error;
            }
        }
        return null;
    };

    /**
     * Creates a NotificationsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NotificationsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NotificationsResponse} NotificationsResponse
     */
    NotificationsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.NotificationsResponse)
            return object;
        var message = new $root.NotificationsResponse();
        if (object.Notifications) {
            if (!Array.isArray(object.Notifications))
                throw TypeError(".NotificationsResponse.Notifications: array expected");
            message.Notifications = [];
            for (var i = 0; i < object.Notifications.length; ++i) {
                if (typeof object.Notifications[i] !== "object")
                    throw TypeError(".NotificationsResponse.Notifications: object expected");
                message.Notifications[i] = $root.Notification.fromObject(object.Notifications[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a NotificationsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NotificationsResponse
     * @static
     * @param {NotificationsResponse} message NotificationsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NotificationsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Notifications = [];
        if (message.Notifications && message.Notifications.length) {
            object.Notifications = [];
            for (var j = 0; j < message.Notifications.length; ++j)
                object.Notifications[j] = $root.Notification.toObject(message.Notifications[j], options);
        }
        return object;
    };

    /**
     * Converts this NotificationsResponse to JSON.
     * @function toJSON
     * @memberof NotificationsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NotificationsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NotificationsResponse;
})();

$root.OrdersRequest = (function() {

    /**
     * Properties of an OrdersRequest.
     * @exports IOrdersRequest
     * @interface IOrdersRequest
     * @property {number|null} [ClientId] OrdersRequest ClientId
     * @property {number|null} [ChunkSize] OrdersRequest ChunkSize
     */

    /**
     * Constructs a new OrdersRequest.
     * @exports OrdersRequest
     * @classdesc Represents an OrdersRequest.
     * @implements IOrdersRequest
     * @constructor
     * @param {IOrdersRequest=} [properties] Properties to set
     */
    function OrdersRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrdersRequest ClientId.
     * @member {number} ClientId
     * @memberof OrdersRequest
     * @instance
     */
    OrdersRequest.prototype.ClientId = 0;

    /**
     * OrdersRequest ChunkSize.
     * @member {number} ChunkSize
     * @memberof OrdersRequest
     * @instance
     */
    OrdersRequest.prototype.ChunkSize = 0;

    /**
     * Creates a new OrdersRequest instance using the specified properties.
     * @function create
     * @memberof OrdersRequest
     * @static
     * @param {IOrdersRequest=} [properties] Properties to set
     * @returns {OrdersRequest} OrdersRequest instance
     */
    OrdersRequest.create = function create(properties) {
        return new OrdersRequest(properties);
    };

    /**
     * Encodes the specified OrdersRequest message. Does not implicitly {@link OrdersRequest.verify|verify} messages.
     * @function encode
     * @memberof OrdersRequest
     * @static
     * @param {IOrdersRequest} message OrdersRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrdersRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClientId);
        if (message.ChunkSize != null && Object.hasOwnProperty.call(message, "ChunkSize"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ChunkSize);
        return writer;
    };

    /**
     * Encodes the specified OrdersRequest message, length delimited. Does not implicitly {@link OrdersRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrdersRequest
     * @static
     * @param {IOrdersRequest} message OrdersRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrdersRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrdersRequest message from the specified reader or buffer.
     * @function decode
     * @memberof OrdersRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrdersRequest} OrdersRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrdersRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrdersRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClientId = reader.int32();
                break;
            case 2:
                message.ChunkSize = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrdersRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrdersRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrdersRequest} OrdersRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrdersRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrdersRequest message.
     * @function verify
     * @memberof OrdersRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrdersRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.ChunkSize != null && message.hasOwnProperty("ChunkSize"))
            if (!$util.isInteger(message.ChunkSize))
                return "ChunkSize: integer expected";
        return null;
    };

    /**
     * Creates an OrdersRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrdersRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrdersRequest} OrdersRequest
     */
    OrdersRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.OrdersRequest)
            return object;
        var message = new $root.OrdersRequest();
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        if (object.ChunkSize != null)
            message.ChunkSize = object.ChunkSize | 0;
        return message;
    };

    /**
     * Creates a plain object from an OrdersRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrdersRequest
     * @static
     * @param {OrdersRequest} message OrdersRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrdersRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ClientId = 0;
            object.ChunkSize = 0;
        }
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.ChunkSize != null && message.hasOwnProperty("ChunkSize"))
            object.ChunkSize = message.ChunkSize;
        return object;
    };

    /**
     * Converts this OrdersRequest to JSON.
     * @function toJSON
     * @memberof OrdersRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrdersRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrdersRequest;
})();

$root.OrdersResponse = (function() {

    /**
     * Properties of an OrdersResponse.
     * @exports IOrdersResponse
     * @interface IOrdersResponse
     * @property {Array.<IOrder>|null} [NewOrders] OrdersResponse NewOrders
     * @property {Array.<IOrderUpdate>|null} [UpdatedOrders] OrdersResponse UpdatedOrders
     * @property {Array.<string>|null} [DeletedOrdersIds] OrdersResponse DeletedOrdersIds
     * @property {number|null} [TotalAmount] OrdersResponse TotalAmount
     */

    /**
     * Constructs a new OrdersResponse.
     * @exports OrdersResponse
     * @classdesc Represents an OrdersResponse.
     * @implements IOrdersResponse
     * @constructor
     * @param {IOrdersResponse=} [properties] Properties to set
     */
    function OrdersResponse(properties) {
        this.NewOrders = [];
        this.UpdatedOrders = [];
        this.DeletedOrdersIds = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrdersResponse NewOrders.
     * @member {Array.<IOrder>} NewOrders
     * @memberof OrdersResponse
     * @instance
     */
    OrdersResponse.prototype.NewOrders = $util.emptyArray;

    /**
     * OrdersResponse UpdatedOrders.
     * @member {Array.<IOrderUpdate>} UpdatedOrders
     * @memberof OrdersResponse
     * @instance
     */
    OrdersResponse.prototype.UpdatedOrders = $util.emptyArray;

    /**
     * OrdersResponse DeletedOrdersIds.
     * @member {Array.<string>} DeletedOrdersIds
     * @memberof OrdersResponse
     * @instance
     */
    OrdersResponse.prototype.DeletedOrdersIds = $util.emptyArray;

    /**
     * OrdersResponse TotalAmount.
     * @member {number} TotalAmount
     * @memberof OrdersResponse
     * @instance
     */
    OrdersResponse.prototype.TotalAmount = 0;

    /**
     * Creates a new OrdersResponse instance using the specified properties.
     * @function create
     * @memberof OrdersResponse
     * @static
     * @param {IOrdersResponse=} [properties] Properties to set
     * @returns {OrdersResponse} OrdersResponse instance
     */
    OrdersResponse.create = function create(properties) {
        return new OrdersResponse(properties);
    };

    /**
     * Encodes the specified OrdersResponse message. Does not implicitly {@link OrdersResponse.verify|verify} messages.
     * @function encode
     * @memberof OrdersResponse
     * @static
     * @param {IOrdersResponse} message OrdersResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrdersResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.NewOrders != null && message.NewOrders.length)
            for (var i = 0; i < message.NewOrders.length; ++i)
                $root.Order.encode(message.NewOrders[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.UpdatedOrders != null && message.UpdatedOrders.length)
            for (var i = 0; i < message.UpdatedOrders.length; ++i)
                $root.OrderUpdate.encode(message.UpdatedOrders[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.DeletedOrdersIds != null && message.DeletedOrdersIds.length)
            for (var i = 0; i < message.DeletedOrdersIds.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.DeletedOrdersIds[i]);
        if (message.TotalAmount != null && Object.hasOwnProperty.call(message, "TotalAmount"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.TotalAmount);
        return writer;
    };

    /**
     * Encodes the specified OrdersResponse message, length delimited. Does not implicitly {@link OrdersResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrdersResponse
     * @static
     * @param {IOrdersResponse} message OrdersResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrdersResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrdersResponse message from the specified reader or buffer.
     * @function decode
     * @memberof OrdersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrdersResponse} OrdersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrdersResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrdersResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.NewOrders && message.NewOrders.length))
                    message.NewOrders = [];
                message.NewOrders.push($root.Order.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.UpdatedOrders && message.UpdatedOrders.length))
                    message.UpdatedOrders = [];
                message.UpdatedOrders.push($root.OrderUpdate.decode(reader, reader.uint32()));
                break;
            case 3:
                if (!(message.DeletedOrdersIds && message.DeletedOrdersIds.length))
                    message.DeletedOrdersIds = [];
                message.DeletedOrdersIds.push(reader.string());
                break;
            case 4:
                message.TotalAmount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrdersResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrdersResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrdersResponse} OrdersResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrdersResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrdersResponse message.
     * @function verify
     * @memberof OrdersResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrdersResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.NewOrders != null && message.hasOwnProperty("NewOrders")) {
            if (!Array.isArray(message.NewOrders))
                return "NewOrders: array expected";
            for (var i = 0; i < message.NewOrders.length; ++i) {
                var error = $root.Order.verify(message.NewOrders[i]);
                if (error)
                    return "NewOrders." + error;
            }
        }
        if (message.UpdatedOrders != null && message.hasOwnProperty("UpdatedOrders")) {
            if (!Array.isArray(message.UpdatedOrders))
                return "UpdatedOrders: array expected";
            for (var i = 0; i < message.UpdatedOrders.length; ++i) {
                var error = $root.OrderUpdate.verify(message.UpdatedOrders[i]);
                if (error)
                    return "UpdatedOrders." + error;
            }
        }
        if (message.DeletedOrdersIds != null && message.hasOwnProperty("DeletedOrdersIds")) {
            if (!Array.isArray(message.DeletedOrdersIds))
                return "DeletedOrdersIds: array expected";
            for (var i = 0; i < message.DeletedOrdersIds.length; ++i)
                if (!$util.isString(message.DeletedOrdersIds[i]))
                    return "DeletedOrdersIds: string[] expected";
        }
        if (message.TotalAmount != null && message.hasOwnProperty("TotalAmount"))
            if (!$util.isInteger(message.TotalAmount))
                return "TotalAmount: integer expected";
        return null;
    };

    /**
     * Creates an OrdersResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrdersResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrdersResponse} OrdersResponse
     */
    OrdersResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.OrdersResponse)
            return object;
        var message = new $root.OrdersResponse();
        if (object.NewOrders) {
            if (!Array.isArray(object.NewOrders))
                throw TypeError(".OrdersResponse.NewOrders: array expected");
            message.NewOrders = [];
            for (var i = 0; i < object.NewOrders.length; ++i) {
                if (typeof object.NewOrders[i] !== "object")
                    throw TypeError(".OrdersResponse.NewOrders: object expected");
                message.NewOrders[i] = $root.Order.fromObject(object.NewOrders[i]);
            }
        }
        if (object.UpdatedOrders) {
            if (!Array.isArray(object.UpdatedOrders))
                throw TypeError(".OrdersResponse.UpdatedOrders: array expected");
            message.UpdatedOrders = [];
            for (var i = 0; i < object.UpdatedOrders.length; ++i) {
                if (typeof object.UpdatedOrders[i] !== "object")
                    throw TypeError(".OrdersResponse.UpdatedOrders: object expected");
                message.UpdatedOrders[i] = $root.OrderUpdate.fromObject(object.UpdatedOrders[i]);
            }
        }
        if (object.DeletedOrdersIds) {
            if (!Array.isArray(object.DeletedOrdersIds))
                throw TypeError(".OrdersResponse.DeletedOrdersIds: array expected");
            message.DeletedOrdersIds = [];
            for (var i = 0; i < object.DeletedOrdersIds.length; ++i)
                message.DeletedOrdersIds[i] = String(object.DeletedOrdersIds[i]);
        }
        if (object.TotalAmount != null)
            message.TotalAmount = object.TotalAmount | 0;
        return message;
    };

    /**
     * Creates a plain object from an OrdersResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrdersResponse
     * @static
     * @param {OrdersResponse} message OrdersResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrdersResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.NewOrders = [];
            object.UpdatedOrders = [];
            object.DeletedOrdersIds = [];
        }
        if (options.defaults)
            object.TotalAmount = 0;
        if (message.NewOrders && message.NewOrders.length) {
            object.NewOrders = [];
            for (var j = 0; j < message.NewOrders.length; ++j)
                object.NewOrders[j] = $root.Order.toObject(message.NewOrders[j], options);
        }
        if (message.UpdatedOrders && message.UpdatedOrders.length) {
            object.UpdatedOrders = [];
            for (var j = 0; j < message.UpdatedOrders.length; ++j)
                object.UpdatedOrders[j] = $root.OrderUpdate.toObject(message.UpdatedOrders[j], options);
        }
        if (message.DeletedOrdersIds && message.DeletedOrdersIds.length) {
            object.DeletedOrdersIds = [];
            for (var j = 0; j < message.DeletedOrdersIds.length; ++j)
                object.DeletedOrdersIds[j] = message.DeletedOrdersIds[j];
        }
        if (message.TotalAmount != null && message.hasOwnProperty("TotalAmount"))
            object.TotalAmount = message.TotalAmount;
        return object;
    };

    /**
     * Converts this OrdersResponse to JSON.
     * @function toJSON
     * @memberof OrdersResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrdersResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrdersResponse;
})();

$root.Order = (function() {

    /**
     * Properties of an Order.
     * @exports IOrder
     * @interface IOrder
     * @property {OrderInstrument|null} [OrderInstrument] Order OrderInstrument
     * @property {string|null} [OrderId] Order OrderId
     * @property {OrderState|null} [State] Order State
     * @property {number|null} [FillPercent] Order FillPercent
     * @property {OrderType|null} [Type] Order Type
     * @property {string|null} [Symbol] Order Symbol
     * @property {TradeSide|null} [Side] Order Side
     * @property {string|null} [CreatedBy] Order CreatedBy
     * @property {string|null} [ExtRefUserId] Order ExtRefUserId
     * @property {number|null} [ClientId] Order ClientId
     * @property {string|null} [ExtRefClientId] Order ExtRefClientId
     * @property {number|null} [RequestedAmount] Order RequestedAmount
     * @property {number|null} [LeftAmount] Order LeftAmount
     * @property {number|null} [FilledAmount] Order FilledAmount
     * @property {string|null} [BaseCurrency] Order BaseCurrency
     * @property {number|null} [RequestedPrice] Order RequestedPrice
     * @property {number|null} [FilledPrice] Order FilledPrice
     * @property {string|null} [CreatedDate] Order CreatedDate
     * @property {string|null} [UpdateDate] Order UpdateDate
     * @property {number|null} [NearPoints] Order NearPoints
     * @property {google.protobuf.IStringValue|null} [NearValueDate] Order NearValueDate
     * @property {number|null} [NearAmount] Order NearAmount
     * @property {number|null} [NearPrice] Order NearPrice
     * @property {google.protobuf.IDoubleValue|null} [FarPoints] Order FarPoints
     * @property {google.protobuf.IStringValue|null} [FarValueDate] Order FarValueDate
     * @property {google.protobuf.IDoubleValue|null} [FarAmount] Order FarAmount
     * @property {google.protobuf.IDoubleValue|null} [FarPrice] Order FarPrice
     * @property {ExpirationType|null} [Expiry] Order Expiry
     * @property {google.protobuf.IStringValue|null} [ExpiryDate] Order ExpiryDate
     * @property {google.protobuf.IDoubleValue|null} [MarketDistance] Order MarketDistance
     * @property {google.protobuf.IDoubleValue|null} [MarketPoints] Order MarketPoints
     * @property {MarketApproximation|null} [MarketCloseness] Order MarketCloseness
     * @property {google.protobuf.IStringValue|null} [ExecutionDate] Order ExecutionDate
     * @property {string|null} [ClientName] Order ClientName
     * @property {string|null} [TraderName] Order TraderName
     * @property {number|null} [CounterFilledAmount] Order CounterFilledAmount
     * @property {string|null} [CounterCurrency] Order CounterCurrency
     * @property {google.protobuf.IDoubleValue|null} [FarCounterFilledAmount] Order FarCounterFilledAmount
     * @property {google.protobuf.IDoubleValue|null} [SpotRate] Order SpotRate
     * @property {google.protobuf.IStringValue|null} [PendingStrategyId] Order PendingStrategyId
     * @property {PriceType|null} [PendingLegType] Order PendingLegType
     * @property {PendingStrategy|null} [PendingStrategy] Order PendingStrategy
     * @property {google.protobuf.IStringValue|null} [KondorDealTypeID] Order KondorDealTypeID
     */

    /**
     * Constructs a new Order.
     * @exports Order
     * @classdesc Represents an Order.
     * @implements IOrder
     * @constructor
     * @param {IOrder=} [properties] Properties to set
     */
    function Order(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Order OrderInstrument.
     * @member {OrderInstrument} OrderInstrument
     * @memberof Order
     * @instance
     */
    Order.prototype.OrderInstrument = 0;

    /**
     * Order OrderId.
     * @member {string} OrderId
     * @memberof Order
     * @instance
     */
    Order.prototype.OrderId = "";

    /**
     * Order State.
     * @member {OrderState} State
     * @memberof Order
     * @instance
     */
    Order.prototype.State = 0;

    /**
     * Order FillPercent.
     * @member {number} FillPercent
     * @memberof Order
     * @instance
     */
    Order.prototype.FillPercent = 0;

    /**
     * Order Type.
     * @member {OrderType} Type
     * @memberof Order
     * @instance
     */
    Order.prototype.Type = 0;

    /**
     * Order Symbol.
     * @member {string} Symbol
     * @memberof Order
     * @instance
     */
    Order.prototype.Symbol = "";

    /**
     * Order Side.
     * @member {TradeSide} Side
     * @memberof Order
     * @instance
     */
    Order.prototype.Side = 0;

    /**
     * Order CreatedBy.
     * @member {string} CreatedBy
     * @memberof Order
     * @instance
     */
    Order.prototype.CreatedBy = "";

    /**
     * Order ExtRefUserId.
     * @member {string} ExtRefUserId
     * @memberof Order
     * @instance
     */
    Order.prototype.ExtRefUserId = "";

    /**
     * Order ClientId.
     * @member {number} ClientId
     * @memberof Order
     * @instance
     */
    Order.prototype.ClientId = 0;

    /**
     * Order ExtRefClientId.
     * @member {string} ExtRefClientId
     * @memberof Order
     * @instance
     */
    Order.prototype.ExtRefClientId = "";

    /**
     * Order RequestedAmount.
     * @member {number} RequestedAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.RequestedAmount = 0;

    /**
     * Order LeftAmount.
     * @member {number} LeftAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.LeftAmount = 0;

    /**
     * Order FilledAmount.
     * @member {number} FilledAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.FilledAmount = 0;

    /**
     * Order BaseCurrency.
     * @member {string} BaseCurrency
     * @memberof Order
     * @instance
     */
    Order.prototype.BaseCurrency = "";

    /**
     * Order RequestedPrice.
     * @member {number} RequestedPrice
     * @memberof Order
     * @instance
     */
    Order.prototype.RequestedPrice = 0;

    /**
     * Order FilledPrice.
     * @member {number} FilledPrice
     * @memberof Order
     * @instance
     */
    Order.prototype.FilledPrice = 0;

    /**
     * Order CreatedDate.
     * @member {string} CreatedDate
     * @memberof Order
     * @instance
     */
    Order.prototype.CreatedDate = "";

    /**
     * Order UpdateDate.
     * @member {string} UpdateDate
     * @memberof Order
     * @instance
     */
    Order.prototype.UpdateDate = "";

    /**
     * Order NearPoints.
     * @member {number} NearPoints
     * @memberof Order
     * @instance
     */
    Order.prototype.NearPoints = 0;

    /**
     * Order NearValueDate.
     * @member {google.protobuf.IStringValue|null|undefined} NearValueDate
     * @memberof Order
     * @instance
     */
    Order.prototype.NearValueDate = null;

    /**
     * Order NearAmount.
     * @member {number} NearAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.NearAmount = 0;

    /**
     * Order NearPrice.
     * @member {number} NearPrice
     * @memberof Order
     * @instance
     */
    Order.prototype.NearPrice = 0;

    /**
     * Order FarPoints.
     * @member {google.protobuf.IDoubleValue|null|undefined} FarPoints
     * @memberof Order
     * @instance
     */
    Order.prototype.FarPoints = null;

    /**
     * Order FarValueDate.
     * @member {google.protobuf.IStringValue|null|undefined} FarValueDate
     * @memberof Order
     * @instance
     */
    Order.prototype.FarValueDate = null;

    /**
     * Order FarAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} FarAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.FarAmount = null;

    /**
     * Order FarPrice.
     * @member {google.protobuf.IDoubleValue|null|undefined} FarPrice
     * @memberof Order
     * @instance
     */
    Order.prototype.FarPrice = null;

    /**
     * Order Expiry.
     * @member {ExpirationType} Expiry
     * @memberof Order
     * @instance
     */
    Order.prototype.Expiry = 0;

    /**
     * Order ExpiryDate.
     * @member {google.protobuf.IStringValue|null|undefined} ExpiryDate
     * @memberof Order
     * @instance
     */
    Order.prototype.ExpiryDate = null;

    /**
     * Order MarketDistance.
     * @member {google.protobuf.IDoubleValue|null|undefined} MarketDistance
     * @memberof Order
     * @instance
     */
    Order.prototype.MarketDistance = null;

    /**
     * Order MarketPoints.
     * @member {google.protobuf.IDoubleValue|null|undefined} MarketPoints
     * @memberof Order
     * @instance
     */
    Order.prototype.MarketPoints = null;

    /**
     * Order MarketCloseness.
     * @member {MarketApproximation} MarketCloseness
     * @memberof Order
     * @instance
     */
    Order.prototype.MarketCloseness = 0;

    /**
     * Order ExecutionDate.
     * @member {google.protobuf.IStringValue|null|undefined} ExecutionDate
     * @memberof Order
     * @instance
     */
    Order.prototype.ExecutionDate = null;

    /**
     * Order ClientName.
     * @member {string} ClientName
     * @memberof Order
     * @instance
     */
    Order.prototype.ClientName = "";

    /**
     * Order TraderName.
     * @member {string} TraderName
     * @memberof Order
     * @instance
     */
    Order.prototype.TraderName = "";

    /**
     * Order CounterFilledAmount.
     * @member {number} CounterFilledAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.CounterFilledAmount = 0;

    /**
     * Order CounterCurrency.
     * @member {string} CounterCurrency
     * @memberof Order
     * @instance
     */
    Order.prototype.CounterCurrency = "";

    /**
     * Order FarCounterFilledAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} FarCounterFilledAmount
     * @memberof Order
     * @instance
     */
    Order.prototype.FarCounterFilledAmount = null;

    /**
     * Order SpotRate.
     * @member {google.protobuf.IDoubleValue|null|undefined} SpotRate
     * @memberof Order
     * @instance
     */
    Order.prototype.SpotRate = null;

    /**
     * Order PendingStrategyId.
     * @member {google.protobuf.IStringValue|null|undefined} PendingStrategyId
     * @memberof Order
     * @instance
     */
    Order.prototype.PendingStrategyId = null;

    /**
     * Order PendingLegType.
     * @member {PriceType} PendingLegType
     * @memberof Order
     * @instance
     */
    Order.prototype.PendingLegType = 0;

    /**
     * Order PendingStrategy.
     * @member {PendingStrategy} PendingStrategy
     * @memberof Order
     * @instance
     */
    Order.prototype.PendingStrategy = 0;

    /**
     * Order KondorDealTypeID.
     * @member {google.protobuf.IStringValue|null|undefined} KondorDealTypeID
     * @memberof Order
     * @instance
     */
    Order.prototype.KondorDealTypeID = null;

    /**
     * Creates a new Order instance using the specified properties.
     * @function create
     * @memberof Order
     * @static
     * @param {IOrder=} [properties] Properties to set
     * @returns {Order} Order instance
     */
    Order.create = function create(properties) {
        return new Order(properties);
    };

    /**
     * Encodes the specified Order message. Does not implicitly {@link Order.verify|verify} messages.
     * @function encode
     * @memberof Order
     * @static
     * @param {IOrder} message Order message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Order.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OrderInstrument != null && Object.hasOwnProperty.call(message, "OrderInstrument"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.OrderInstrument);
        if (message.OrderId != null && Object.hasOwnProperty.call(message, "OrderId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.OrderId);
        if (message.State != null && Object.hasOwnProperty.call(message, "State"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.State);
        if (message.FillPercent != null && Object.hasOwnProperty.call(message, "FillPercent"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.FillPercent);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Type);
        if (message.Symbol != null && Object.hasOwnProperty.call(message, "Symbol"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.Symbol);
        if (message.Side != null && Object.hasOwnProperty.call(message, "Side"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.Side);
        if (message.CreatedBy != null && Object.hasOwnProperty.call(message, "CreatedBy"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.CreatedBy);
        if (message.ExtRefUserId != null && Object.hasOwnProperty.call(message, "ExtRefUserId"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.ExtRefUserId);
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.ClientId);
        if (message.ExtRefClientId != null && Object.hasOwnProperty.call(message, "ExtRefClientId"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.ExtRefClientId);
        if (message.RequestedAmount != null && Object.hasOwnProperty.call(message, "RequestedAmount"))
            writer.uint32(/* id 12, wireType 1 =*/97).double(message.RequestedAmount);
        if (message.LeftAmount != null && Object.hasOwnProperty.call(message, "LeftAmount"))
            writer.uint32(/* id 13, wireType 1 =*/105).double(message.LeftAmount);
        if (message.FilledAmount != null && Object.hasOwnProperty.call(message, "FilledAmount"))
            writer.uint32(/* id 14, wireType 1 =*/113).double(message.FilledAmount);
        if (message.BaseCurrency != null && Object.hasOwnProperty.call(message, "BaseCurrency"))
            writer.uint32(/* id 15, wireType 2 =*/122).string(message.BaseCurrency);
        if (message.RequestedPrice != null && Object.hasOwnProperty.call(message, "RequestedPrice"))
            writer.uint32(/* id 16, wireType 1 =*/129).double(message.RequestedPrice);
        if (message.FilledPrice != null && Object.hasOwnProperty.call(message, "FilledPrice"))
            writer.uint32(/* id 17, wireType 1 =*/137).double(message.FilledPrice);
        if (message.CreatedDate != null && Object.hasOwnProperty.call(message, "CreatedDate"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.CreatedDate);
        if (message.UpdateDate != null && Object.hasOwnProperty.call(message, "UpdateDate"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.UpdateDate);
        if (message.NearPoints != null && Object.hasOwnProperty.call(message, "NearPoints"))
            writer.uint32(/* id 20, wireType 1 =*/161).double(message.NearPoints);
        if (message.NearValueDate != null && Object.hasOwnProperty.call(message, "NearValueDate"))
            $root.google.protobuf.StringValue.encode(message.NearValueDate, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
        if (message.NearAmount != null && Object.hasOwnProperty.call(message, "NearAmount"))
            writer.uint32(/* id 22, wireType 1 =*/177).double(message.NearAmount);
        if (message.NearPrice != null && Object.hasOwnProperty.call(message, "NearPrice"))
            writer.uint32(/* id 23, wireType 1 =*/185).double(message.NearPrice);
        if (message.FarPoints != null && Object.hasOwnProperty.call(message, "FarPoints"))
            $root.google.protobuf.DoubleValue.encode(message.FarPoints, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
        if (message.FarValueDate != null && Object.hasOwnProperty.call(message, "FarValueDate"))
            $root.google.protobuf.StringValue.encode(message.FarValueDate, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
        if (message.FarAmount != null && Object.hasOwnProperty.call(message, "FarAmount"))
            $root.google.protobuf.DoubleValue.encode(message.FarAmount, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
        if (message.FarPrice != null && Object.hasOwnProperty.call(message, "FarPrice"))
            $root.google.protobuf.DoubleValue.encode(message.FarPrice, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
        if (message.Expiry != null && Object.hasOwnProperty.call(message, "Expiry"))
            writer.uint32(/* id 28, wireType 0 =*/224).int32(message.Expiry);
        if (message.ExpiryDate != null && Object.hasOwnProperty.call(message, "ExpiryDate"))
            $root.google.protobuf.StringValue.encode(message.ExpiryDate, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
        if (message.MarketDistance != null && Object.hasOwnProperty.call(message, "MarketDistance"))
            $root.google.protobuf.DoubleValue.encode(message.MarketDistance, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
        if (message.MarketPoints != null && Object.hasOwnProperty.call(message, "MarketPoints"))
            $root.google.protobuf.DoubleValue.encode(message.MarketPoints, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
        if (message.MarketCloseness != null && Object.hasOwnProperty.call(message, "MarketCloseness"))
            writer.uint32(/* id 32, wireType 0 =*/256).int32(message.MarketCloseness);
        if (message.ExecutionDate != null && Object.hasOwnProperty.call(message, "ExecutionDate"))
            $root.google.protobuf.StringValue.encode(message.ExecutionDate, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
        if (message.ClientName != null && Object.hasOwnProperty.call(message, "ClientName"))
            writer.uint32(/* id 34, wireType 2 =*/274).string(message.ClientName);
        if (message.TraderName != null && Object.hasOwnProperty.call(message, "TraderName"))
            writer.uint32(/* id 35, wireType 2 =*/282).string(message.TraderName);
        if (message.CounterFilledAmount != null && Object.hasOwnProperty.call(message, "CounterFilledAmount"))
            writer.uint32(/* id 36, wireType 1 =*/289).double(message.CounterFilledAmount);
        if (message.CounterCurrency != null && Object.hasOwnProperty.call(message, "CounterCurrency"))
            writer.uint32(/* id 37, wireType 2 =*/298).string(message.CounterCurrency);
        if (message.FarCounterFilledAmount != null && Object.hasOwnProperty.call(message, "FarCounterFilledAmount"))
            $root.google.protobuf.DoubleValue.encode(message.FarCounterFilledAmount, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
        if (message.SpotRate != null && Object.hasOwnProperty.call(message, "SpotRate"))
            $root.google.protobuf.DoubleValue.encode(message.SpotRate, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
        if (message.PendingStrategyId != null && Object.hasOwnProperty.call(message, "PendingStrategyId"))
            $root.google.protobuf.StringValue.encode(message.PendingStrategyId, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
        if (message.PendingLegType != null && Object.hasOwnProperty.call(message, "PendingLegType"))
            writer.uint32(/* id 41, wireType 0 =*/328).int32(message.PendingLegType);
        if (message.PendingStrategy != null && Object.hasOwnProperty.call(message, "PendingStrategy"))
            writer.uint32(/* id 42, wireType 0 =*/336).int32(message.PendingStrategy);
        if (message.KondorDealTypeID != null && Object.hasOwnProperty.call(message, "KondorDealTypeID"))
            $root.google.protobuf.StringValue.encode(message.KondorDealTypeID, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified Order message, length delimited. Does not implicitly {@link Order.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Order
     * @static
     * @param {IOrder} message Order message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Order.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Order message from the specified reader or buffer.
     * @function decode
     * @memberof Order
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Order} Order
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Order.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Order();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.OrderInstrument = reader.int32();
                break;
            case 2:
                message.OrderId = reader.string();
                break;
            case 3:
                message.State = reader.int32();
                break;
            case 4:
                message.FillPercent = reader.double();
                break;
            case 5:
                message.Type = reader.int32();
                break;
            case 6:
                message.Symbol = reader.string();
                break;
            case 7:
                message.Side = reader.int32();
                break;
            case 8:
                message.CreatedBy = reader.string();
                break;
            case 9:
                message.ExtRefUserId = reader.string();
                break;
            case 10:
                message.ClientId = reader.int32();
                break;
            case 11:
                message.ExtRefClientId = reader.string();
                break;
            case 12:
                message.RequestedAmount = reader.double();
                break;
            case 13:
                message.LeftAmount = reader.double();
                break;
            case 14:
                message.FilledAmount = reader.double();
                break;
            case 15:
                message.BaseCurrency = reader.string();
                break;
            case 16:
                message.RequestedPrice = reader.double();
                break;
            case 17:
                message.FilledPrice = reader.double();
                break;
            case 18:
                message.CreatedDate = reader.string();
                break;
            case 19:
                message.UpdateDate = reader.string();
                break;
            case 20:
                message.NearPoints = reader.double();
                break;
            case 21:
                message.NearValueDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 22:
                message.NearAmount = reader.double();
                break;
            case 23:
                message.NearPrice = reader.double();
                break;
            case 24:
                message.FarPoints = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 25:
                message.FarValueDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 26:
                message.FarAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 27:
                message.FarPrice = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 28:
                message.Expiry = reader.int32();
                break;
            case 29:
                message.ExpiryDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 30:
                message.MarketDistance = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 31:
                message.MarketPoints = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 32:
                message.MarketCloseness = reader.int32();
                break;
            case 33:
                message.ExecutionDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 34:
                message.ClientName = reader.string();
                break;
            case 35:
                message.TraderName = reader.string();
                break;
            case 36:
                message.CounterFilledAmount = reader.double();
                break;
            case 37:
                message.CounterCurrency = reader.string();
                break;
            case 38:
                message.FarCounterFilledAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 39:
                message.SpotRate = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 40:
                message.PendingStrategyId = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 41:
                message.PendingLegType = reader.int32();
                break;
            case 42:
                message.PendingStrategy = reader.int32();
                break;
            case 43:
                message.KondorDealTypeID = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Order message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Order
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Order} Order
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Order.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Order message.
     * @function verify
     * @memberof Order
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Order.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OrderInstrument != null && message.hasOwnProperty("OrderInstrument"))
            switch (message.OrderInstrument) {
            default:
                return "OrderInstrument: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            if (!$util.isString(message.OrderId))
                return "OrderId: string expected";
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.FillPercent != null && message.hasOwnProperty("FillPercent"))
            if (typeof message.FillPercent !== "number")
                return "FillPercent: number expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            if (!$util.isString(message.Symbol))
                return "Symbol: string expected";
        if (message.Side != null && message.hasOwnProperty("Side"))
            switch (message.Side) {
            default:
                return "Side: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.CreatedBy != null && message.hasOwnProperty("CreatedBy"))
            if (!$util.isString(message.CreatedBy))
                return "CreatedBy: string expected";
        if (message.ExtRefUserId != null && message.hasOwnProperty("ExtRefUserId"))
            if (!$util.isString(message.ExtRefUserId))
                return "ExtRefUserId: string expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.ExtRefClientId != null && message.hasOwnProperty("ExtRefClientId"))
            if (!$util.isString(message.ExtRefClientId))
                return "ExtRefClientId: string expected";
        if (message.RequestedAmount != null && message.hasOwnProperty("RequestedAmount"))
            if (typeof message.RequestedAmount !== "number")
                return "RequestedAmount: number expected";
        if (message.LeftAmount != null && message.hasOwnProperty("LeftAmount"))
            if (typeof message.LeftAmount !== "number")
                return "LeftAmount: number expected";
        if (message.FilledAmount != null && message.hasOwnProperty("FilledAmount"))
            if (typeof message.FilledAmount !== "number")
                return "FilledAmount: number expected";
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            if (!$util.isString(message.BaseCurrency))
                return "BaseCurrency: string expected";
        if (message.RequestedPrice != null && message.hasOwnProperty("RequestedPrice"))
            if (typeof message.RequestedPrice !== "number")
                return "RequestedPrice: number expected";
        if (message.FilledPrice != null && message.hasOwnProperty("FilledPrice"))
            if (typeof message.FilledPrice !== "number")
                return "FilledPrice: number expected";
        if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate"))
            if (!$util.isString(message.CreatedDate))
                return "CreatedDate: string expected";
        if (message.UpdateDate != null && message.hasOwnProperty("UpdateDate"))
            if (!$util.isString(message.UpdateDate))
                return "UpdateDate: string expected";
        if (message.NearPoints != null && message.hasOwnProperty("NearPoints"))
            if (typeof message.NearPoints !== "number")
                return "NearPoints: number expected";
        if (message.NearValueDate != null && message.hasOwnProperty("NearValueDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.NearValueDate);
            if (error)
                return "NearValueDate." + error;
        }
        if (message.NearAmount != null && message.hasOwnProperty("NearAmount"))
            if (typeof message.NearAmount !== "number")
                return "NearAmount: number expected";
        if (message.NearPrice != null && message.hasOwnProperty("NearPrice"))
            if (typeof message.NearPrice !== "number")
                return "NearPrice: number expected";
        if (message.FarPoints != null && message.hasOwnProperty("FarPoints")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FarPoints);
            if (error)
                return "FarPoints." + error;
        }
        if (message.FarValueDate != null && message.hasOwnProperty("FarValueDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.FarValueDate);
            if (error)
                return "FarValueDate." + error;
        }
        if (message.FarAmount != null && message.hasOwnProperty("FarAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FarAmount);
            if (error)
                return "FarAmount." + error;
        }
        if (message.FarPrice != null && message.hasOwnProperty("FarPrice")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FarPrice);
            if (error)
                return "FarPrice." + error;
        }
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            switch (message.Expiry) {
            default:
                return "Expiry: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExpiryDate);
            if (error)
                return "ExpiryDate." + error;
        }
        if (message.MarketDistance != null && message.hasOwnProperty("MarketDistance")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.MarketDistance);
            if (error)
                return "MarketDistance." + error;
        }
        if (message.MarketPoints != null && message.hasOwnProperty("MarketPoints")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.MarketPoints);
            if (error)
                return "MarketPoints." + error;
        }
        if (message.MarketCloseness != null && message.hasOwnProperty("MarketCloseness"))
            switch (message.MarketCloseness) {
            default:
                return "MarketCloseness: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.ExecutionDate != null && message.hasOwnProperty("ExecutionDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExecutionDate);
            if (error)
                return "ExecutionDate." + error;
        }
        if (message.ClientName != null && message.hasOwnProperty("ClientName"))
            if (!$util.isString(message.ClientName))
                return "ClientName: string expected";
        if (message.TraderName != null && message.hasOwnProperty("TraderName"))
            if (!$util.isString(message.TraderName))
                return "TraderName: string expected";
        if (message.CounterFilledAmount != null && message.hasOwnProperty("CounterFilledAmount"))
            if (typeof message.CounterFilledAmount !== "number")
                return "CounterFilledAmount: number expected";
        if (message.CounterCurrency != null && message.hasOwnProperty("CounterCurrency"))
            if (!$util.isString(message.CounterCurrency))
                return "CounterCurrency: string expected";
        if (message.FarCounterFilledAmount != null && message.hasOwnProperty("FarCounterFilledAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FarCounterFilledAmount);
            if (error)
                return "FarCounterFilledAmount." + error;
        }
        if (message.SpotRate != null && message.hasOwnProperty("SpotRate")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.SpotRate);
            if (error)
                return "SpotRate." + error;
        }
        if (message.PendingStrategyId != null && message.hasOwnProperty("PendingStrategyId")) {
            var error = $root.google.protobuf.StringValue.verify(message.PendingStrategyId);
            if (error)
                return "PendingStrategyId." + error;
        }
        if (message.PendingLegType != null && message.hasOwnProperty("PendingLegType"))
            switch (message.PendingLegType) {
            default:
                return "PendingLegType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.PendingStrategy != null && message.hasOwnProperty("PendingStrategy"))
            switch (message.PendingStrategy) {
            default:
                return "PendingStrategy: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.KondorDealTypeID != null && message.hasOwnProperty("KondorDealTypeID")) {
            var error = $root.google.protobuf.StringValue.verify(message.KondorDealTypeID);
            if (error)
                return "KondorDealTypeID." + error;
        }
        return null;
    };

    /**
     * Creates an Order message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Order
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Order} Order
     */
    Order.fromObject = function fromObject(object) {
        if (object instanceof $root.Order)
            return object;
        var message = new $root.Order();
        switch (object.OrderInstrument) {
        case "ORDERINSTRUMENT_SPOT":
        case 0:
            message.OrderInstrument = 0;
            break;
        case "ORDERINSTRUMENT_FORWARD":
        case 1:
            message.OrderInstrument = 1;
            break;
        case "ORDERINSTRUMENT_SWAP":
        case 2:
            message.OrderInstrument = 2;
            break;
        }
        if (object.OrderId != null)
            message.OrderId = String(object.OrderId);
        switch (object.State) {
        case "ORDERSTATE_UNKNOWN":
        case 0:
            message.State = 0;
            break;
        case "ORDERSTATE_EXECUTING":
        case 1:
            message.State = 1;
            break;
        case "ORDERSTATE_ACTIVE":
        case 2:
            message.State = 2;
            break;
        case "ORDERSTATE_FILLED":
        case 3:
            message.State = 3;
            break;
        case "ORDERSTATE_PARTIALLY_CANCELLED":
        case 4:
            message.State = 4;
            break;
        case "ORDERSTATE_CANCELLED":
        case 5:
            message.State = 5;
            break;
        case "ORDERSTATE_REJECTED":
        case 6:
            message.State = 6;
            break;
        case "ORDERSTATE_INACTIVE":
        case 7:
            message.State = 7;
            break;
        case "ORDERSTATE_PARTIALLY_FILLED":
        case 8:
            message.State = 8;
            break;
        case "ORDERSTATE_SUSPENDED":
        case 9:
            message.State = 9;
            break;
        }
        if (object.FillPercent != null)
            message.FillPercent = Number(object.FillPercent);
        switch (object.Type) {
        case "ORDERTYPE_MARKET":
        case 0:
            message.Type = 0;
            break;
        case "ORDERTYPE_FULL":
        case 1:
            message.Type = 1;
            break;
        case "ORDERTYPE_IOC":
        case 2:
            message.Type = 2;
            break;
        case "ORDERTYPE_LIMIT":
        case 3:
            message.Type = 3;
            break;
        case "ORDERTYPE_STOP":
        case 4:
            message.Type = 4;
            break;
        case "ORDERTYPE_IF_DONE":
        case 5:
            message.Type = 5;
            break;
        case "ORDERTYPE_OCO":
        case 6:
            message.Type = 6;
            break;
        }
        if (object.Symbol != null)
            message.Symbol = String(object.Symbol);
        switch (object.Side) {
        case "TRADESIDE_SELL":
        case 0:
            message.Side = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.Side = 1;
            break;
        }
        if (object.CreatedBy != null)
            message.CreatedBy = String(object.CreatedBy);
        if (object.ExtRefUserId != null)
            message.ExtRefUserId = String(object.ExtRefUserId);
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        if (object.ExtRefClientId != null)
            message.ExtRefClientId = String(object.ExtRefClientId);
        if (object.RequestedAmount != null)
            message.RequestedAmount = Number(object.RequestedAmount);
        if (object.LeftAmount != null)
            message.LeftAmount = Number(object.LeftAmount);
        if (object.FilledAmount != null)
            message.FilledAmount = Number(object.FilledAmount);
        if (object.BaseCurrency != null)
            message.BaseCurrency = String(object.BaseCurrency);
        if (object.RequestedPrice != null)
            message.RequestedPrice = Number(object.RequestedPrice);
        if (object.FilledPrice != null)
            message.FilledPrice = Number(object.FilledPrice);
        if (object.CreatedDate != null)
            message.CreatedDate = String(object.CreatedDate);
        if (object.UpdateDate != null)
            message.UpdateDate = String(object.UpdateDate);
        if (object.NearPoints != null)
            message.NearPoints = Number(object.NearPoints);
        if (object.NearValueDate != null) {
            if (typeof object.NearValueDate !== "object")
                throw TypeError(".Order.NearValueDate: object expected");
            message.NearValueDate = $root.google.protobuf.StringValue.fromObject(object.NearValueDate);
        }
        if (object.NearAmount != null)
            message.NearAmount = Number(object.NearAmount);
        if (object.NearPrice != null)
            message.NearPrice = Number(object.NearPrice);
        if (object.FarPoints != null) {
            if (typeof object.FarPoints !== "object")
                throw TypeError(".Order.FarPoints: object expected");
            message.FarPoints = $root.google.protobuf.DoubleValue.fromObject(object.FarPoints);
        }
        if (object.FarValueDate != null) {
            if (typeof object.FarValueDate !== "object")
                throw TypeError(".Order.FarValueDate: object expected");
            message.FarValueDate = $root.google.protobuf.StringValue.fromObject(object.FarValueDate);
        }
        if (object.FarAmount != null) {
            if (typeof object.FarAmount !== "object")
                throw TypeError(".Order.FarAmount: object expected");
            message.FarAmount = $root.google.protobuf.DoubleValue.fromObject(object.FarAmount);
        }
        if (object.FarPrice != null) {
            if (typeof object.FarPrice !== "object")
                throw TypeError(".Order.FarPrice: object expected");
            message.FarPrice = $root.google.protobuf.DoubleValue.fromObject(object.FarPrice);
        }
        switch (object.Expiry) {
        case "EXPIRATIONTYPE_UNKNOWN":
        case 0:
            message.Expiry = 0;
            break;
        case "EXPIRATIONTYPE_GTC":
        case 1:
            message.Expiry = 1;
            break;
        case "EXPIRATIONTYPE_GTD":
        case 2:
            message.Expiry = 2;
            break;
        case "EXPIRATIONTYPE_GTS":
        case 3:
            message.Expiry = 3;
            break;
        case "EXPIRATIONTYPE_FOK":
        case 4:
            message.Expiry = 4;
            break;
        case "EXPIRATIONTYPE_IOC":
        case 5:
            message.Expiry = 5;
            break;
        }
        if (object.ExpiryDate != null) {
            if (typeof object.ExpiryDate !== "object")
                throw TypeError(".Order.ExpiryDate: object expected");
            message.ExpiryDate = $root.google.protobuf.StringValue.fromObject(object.ExpiryDate);
        }
        if (object.MarketDistance != null) {
            if (typeof object.MarketDistance !== "object")
                throw TypeError(".Order.MarketDistance: object expected");
            message.MarketDistance = $root.google.protobuf.DoubleValue.fromObject(object.MarketDistance);
        }
        if (object.MarketPoints != null) {
            if (typeof object.MarketPoints !== "object")
                throw TypeError(".Order.MarketPoints: object expected");
            message.MarketPoints = $root.google.protobuf.DoubleValue.fromObject(object.MarketPoints);
        }
        switch (object.MarketCloseness) {
        case "MARKETAPPROXIMATION_CLOSE":
        case 0:
            message.MarketCloseness = 0;
            break;
        case "MARKETAPPROXIMATION_NEAR":
        case 1:
            message.MarketCloseness = 1;
            break;
        case "MARKETAPPROXIMATION_FAR":
        case 2:
            message.MarketCloseness = 2;
            break;
        case "MARKETAPPROXIMATION_VERY_FAR":
        case 3:
            message.MarketCloseness = 3;
            break;
        }
        if (object.ExecutionDate != null) {
            if (typeof object.ExecutionDate !== "object")
                throw TypeError(".Order.ExecutionDate: object expected");
            message.ExecutionDate = $root.google.protobuf.StringValue.fromObject(object.ExecutionDate);
        }
        if (object.ClientName != null)
            message.ClientName = String(object.ClientName);
        if (object.TraderName != null)
            message.TraderName = String(object.TraderName);
        if (object.CounterFilledAmount != null)
            message.CounterFilledAmount = Number(object.CounterFilledAmount);
        if (object.CounterCurrency != null)
            message.CounterCurrency = String(object.CounterCurrency);
        if (object.FarCounterFilledAmount != null) {
            if (typeof object.FarCounterFilledAmount !== "object")
                throw TypeError(".Order.FarCounterFilledAmount: object expected");
            message.FarCounterFilledAmount = $root.google.protobuf.DoubleValue.fromObject(object.FarCounterFilledAmount);
        }
        if (object.SpotRate != null) {
            if (typeof object.SpotRate !== "object")
                throw TypeError(".Order.SpotRate: object expected");
            message.SpotRate = $root.google.protobuf.DoubleValue.fromObject(object.SpotRate);
        }
        if (object.PendingStrategyId != null) {
            if (typeof object.PendingStrategyId !== "object")
                throw TypeError(".Order.PendingStrategyId: object expected");
            message.PendingStrategyId = $root.google.protobuf.StringValue.fromObject(object.PendingStrategyId);
        }
        switch (object.PendingLegType) {
        case "PRICETYPE_LIMIT":
        case 0:
            message.PendingLegType = 0;
            break;
        case "PRICETYPE_STOP":
        case 1:
            message.PendingLegType = 1;
            break;
        }
        switch (object.PendingStrategy) {
        case "PENDINGSTRATEGY_SINGLE_ORDER":
        case 0:
            message.PendingStrategy = 0;
            break;
        case "PENDINGSTRATEGY_OCO":
        case 1:
            message.PendingStrategy = 1;
            break;
        case "PENDINGSTRATEGY_IF_DONE":
        case 2:
            message.PendingStrategy = 2;
            break;
        }
        if (object.KondorDealTypeID != null) {
            if (typeof object.KondorDealTypeID !== "object")
                throw TypeError(".Order.KondorDealTypeID: object expected");
            message.KondorDealTypeID = $root.google.protobuf.StringValue.fromObject(object.KondorDealTypeID);
        }
        return message;
    };

    /**
     * Creates a plain object from an Order message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Order
     * @static
     * @param {Order} message Order
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Order.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.OrderInstrument = options.enums === String ? "ORDERINSTRUMENT_SPOT" : 0;
            object.OrderId = "";
            object.State = options.enums === String ? "ORDERSTATE_UNKNOWN" : 0;
            object.FillPercent = 0;
            object.Type = options.enums === String ? "ORDERTYPE_MARKET" : 0;
            object.Symbol = "";
            object.Side = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.CreatedBy = "";
            object.ExtRefUserId = "";
            object.ClientId = 0;
            object.ExtRefClientId = "";
            object.RequestedAmount = 0;
            object.LeftAmount = 0;
            object.FilledAmount = 0;
            object.BaseCurrency = "";
            object.RequestedPrice = 0;
            object.FilledPrice = 0;
            object.CreatedDate = "";
            object.UpdateDate = "";
            object.NearPoints = 0;
            object.NearValueDate = null;
            object.NearAmount = 0;
            object.NearPrice = 0;
            object.FarPoints = null;
            object.FarValueDate = null;
            object.FarAmount = null;
            object.FarPrice = null;
            object.Expiry = options.enums === String ? "EXPIRATIONTYPE_UNKNOWN" : 0;
            object.ExpiryDate = null;
            object.MarketDistance = null;
            object.MarketPoints = null;
            object.MarketCloseness = options.enums === String ? "MARKETAPPROXIMATION_CLOSE" : 0;
            object.ExecutionDate = null;
            object.ClientName = "";
            object.TraderName = "";
            object.CounterFilledAmount = 0;
            object.CounterCurrency = "";
            object.FarCounterFilledAmount = null;
            object.SpotRate = null;
            object.PendingStrategyId = null;
            object.PendingLegType = options.enums === String ? "PRICETYPE_LIMIT" : 0;
            object.PendingStrategy = options.enums === String ? "PENDINGSTRATEGY_SINGLE_ORDER" : 0;
            object.KondorDealTypeID = null;
        }
        if (message.OrderInstrument != null && message.hasOwnProperty("OrderInstrument"))
            object.OrderInstrument = options.enums === String ? $root.OrderInstrument[message.OrderInstrument] : message.OrderInstrument;
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            object.OrderId = message.OrderId;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.OrderState[message.State] : message.State;
        if (message.FillPercent != null && message.hasOwnProperty("FillPercent"))
            object.FillPercent = options.json && !isFinite(message.FillPercent) ? String(message.FillPercent) : message.FillPercent;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.OrderType[message.Type] : message.Type;
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            object.Symbol = message.Symbol;
        if (message.Side != null && message.hasOwnProperty("Side"))
            object.Side = options.enums === String ? $root.TradeSide[message.Side] : message.Side;
        if (message.CreatedBy != null && message.hasOwnProperty("CreatedBy"))
            object.CreatedBy = message.CreatedBy;
        if (message.ExtRefUserId != null && message.hasOwnProperty("ExtRefUserId"))
            object.ExtRefUserId = message.ExtRefUserId;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.ExtRefClientId != null && message.hasOwnProperty("ExtRefClientId"))
            object.ExtRefClientId = message.ExtRefClientId;
        if (message.RequestedAmount != null && message.hasOwnProperty("RequestedAmount"))
            object.RequestedAmount = options.json && !isFinite(message.RequestedAmount) ? String(message.RequestedAmount) : message.RequestedAmount;
        if (message.LeftAmount != null && message.hasOwnProperty("LeftAmount"))
            object.LeftAmount = options.json && !isFinite(message.LeftAmount) ? String(message.LeftAmount) : message.LeftAmount;
        if (message.FilledAmount != null && message.hasOwnProperty("FilledAmount"))
            object.FilledAmount = options.json && !isFinite(message.FilledAmount) ? String(message.FilledAmount) : message.FilledAmount;
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            object.BaseCurrency = message.BaseCurrency;
        if (message.RequestedPrice != null && message.hasOwnProperty("RequestedPrice"))
            object.RequestedPrice = options.json && !isFinite(message.RequestedPrice) ? String(message.RequestedPrice) : message.RequestedPrice;
        if (message.FilledPrice != null && message.hasOwnProperty("FilledPrice"))
            object.FilledPrice = options.json && !isFinite(message.FilledPrice) ? String(message.FilledPrice) : message.FilledPrice;
        if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate"))
            object.CreatedDate = message.CreatedDate;
        if (message.UpdateDate != null && message.hasOwnProperty("UpdateDate"))
            object.UpdateDate = message.UpdateDate;
        if (message.NearPoints != null && message.hasOwnProperty("NearPoints"))
            object.NearPoints = options.json && !isFinite(message.NearPoints) ? String(message.NearPoints) : message.NearPoints;
        if (message.NearValueDate != null && message.hasOwnProperty("NearValueDate"))
            object.NearValueDate = $root.google.protobuf.StringValue.toObject(message.NearValueDate, options);
        if (message.NearAmount != null && message.hasOwnProperty("NearAmount"))
            object.NearAmount = options.json && !isFinite(message.NearAmount) ? String(message.NearAmount) : message.NearAmount;
        if (message.NearPrice != null && message.hasOwnProperty("NearPrice"))
            object.NearPrice = options.json && !isFinite(message.NearPrice) ? String(message.NearPrice) : message.NearPrice;
        if (message.FarPoints != null && message.hasOwnProperty("FarPoints"))
            object.FarPoints = $root.google.protobuf.DoubleValue.toObject(message.FarPoints, options);
        if (message.FarValueDate != null && message.hasOwnProperty("FarValueDate"))
            object.FarValueDate = $root.google.protobuf.StringValue.toObject(message.FarValueDate, options);
        if (message.FarAmount != null && message.hasOwnProperty("FarAmount"))
            object.FarAmount = $root.google.protobuf.DoubleValue.toObject(message.FarAmount, options);
        if (message.FarPrice != null && message.hasOwnProperty("FarPrice"))
            object.FarPrice = $root.google.protobuf.DoubleValue.toObject(message.FarPrice, options);
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            object.Expiry = options.enums === String ? $root.ExpirationType[message.Expiry] : message.Expiry;
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate"))
            object.ExpiryDate = $root.google.protobuf.StringValue.toObject(message.ExpiryDate, options);
        if (message.MarketDistance != null && message.hasOwnProperty("MarketDistance"))
            object.MarketDistance = $root.google.protobuf.DoubleValue.toObject(message.MarketDistance, options);
        if (message.MarketPoints != null && message.hasOwnProperty("MarketPoints"))
            object.MarketPoints = $root.google.protobuf.DoubleValue.toObject(message.MarketPoints, options);
        if (message.MarketCloseness != null && message.hasOwnProperty("MarketCloseness"))
            object.MarketCloseness = options.enums === String ? $root.MarketApproximation[message.MarketCloseness] : message.MarketCloseness;
        if (message.ExecutionDate != null && message.hasOwnProperty("ExecutionDate"))
            object.ExecutionDate = $root.google.protobuf.StringValue.toObject(message.ExecutionDate, options);
        if (message.ClientName != null && message.hasOwnProperty("ClientName"))
            object.ClientName = message.ClientName;
        if (message.TraderName != null && message.hasOwnProperty("TraderName"))
            object.TraderName = message.TraderName;
        if (message.CounterFilledAmount != null && message.hasOwnProperty("CounterFilledAmount"))
            object.CounterFilledAmount = options.json && !isFinite(message.CounterFilledAmount) ? String(message.CounterFilledAmount) : message.CounterFilledAmount;
        if (message.CounterCurrency != null && message.hasOwnProperty("CounterCurrency"))
            object.CounterCurrency = message.CounterCurrency;
        if (message.FarCounterFilledAmount != null && message.hasOwnProperty("FarCounterFilledAmount"))
            object.FarCounterFilledAmount = $root.google.protobuf.DoubleValue.toObject(message.FarCounterFilledAmount, options);
        if (message.SpotRate != null && message.hasOwnProperty("SpotRate"))
            object.SpotRate = $root.google.protobuf.DoubleValue.toObject(message.SpotRate, options);
        if (message.PendingStrategyId != null && message.hasOwnProperty("PendingStrategyId"))
            object.PendingStrategyId = $root.google.protobuf.StringValue.toObject(message.PendingStrategyId, options);
        if (message.PendingLegType != null && message.hasOwnProperty("PendingLegType"))
            object.PendingLegType = options.enums === String ? $root.PriceType[message.PendingLegType] : message.PendingLegType;
        if (message.PendingStrategy != null && message.hasOwnProperty("PendingStrategy"))
            object.PendingStrategy = options.enums === String ? $root.PendingStrategy[message.PendingStrategy] : message.PendingStrategy;
        if (message.KondorDealTypeID != null && message.hasOwnProperty("KondorDealTypeID"))
            object.KondorDealTypeID = $root.google.protobuf.StringValue.toObject(message.KondorDealTypeID, options);
        return object;
    };

    /**
     * Converts this Order to JSON.
     * @function toJSON
     * @memberof Order
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Order.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Order;
})();

$root.OrderStateValue = (function() {

    /**
     * Properties of an OrderStateValue.
     * @exports IOrderStateValue
     * @interface IOrderStateValue
     * @property {OrderState|null} [Value] OrderStateValue Value
     */

    /**
     * Constructs a new OrderStateValue.
     * @exports OrderStateValue
     * @classdesc Represents an OrderStateValue.
     * @implements IOrderStateValue
     * @constructor
     * @param {IOrderStateValue=} [properties] Properties to set
     */
    function OrderStateValue(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderStateValue Value.
     * @member {OrderState} Value
     * @memberof OrderStateValue
     * @instance
     */
    OrderStateValue.prototype.Value = 0;

    /**
     * Creates a new OrderStateValue instance using the specified properties.
     * @function create
     * @memberof OrderStateValue
     * @static
     * @param {IOrderStateValue=} [properties] Properties to set
     * @returns {OrderStateValue} OrderStateValue instance
     */
    OrderStateValue.create = function create(properties) {
        return new OrderStateValue(properties);
    };

    /**
     * Encodes the specified OrderStateValue message. Does not implicitly {@link OrderStateValue.verify|verify} messages.
     * @function encode
     * @memberof OrderStateValue
     * @static
     * @param {IOrderStateValue} message OrderStateValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderStateValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Value);
        return writer;
    };

    /**
     * Encodes the specified OrderStateValue message, length delimited. Does not implicitly {@link OrderStateValue.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderStateValue
     * @static
     * @param {IOrderStateValue} message OrderStateValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderStateValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderStateValue message from the specified reader or buffer.
     * @function decode
     * @memberof OrderStateValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderStateValue} OrderStateValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderStateValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderStateValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderStateValue message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderStateValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderStateValue} OrderStateValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderStateValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderStateValue message.
     * @function verify
     * @memberof OrderStateValue
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderStateValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            switch (message.Value) {
            default:
                return "Value: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        return null;
    };

    /**
     * Creates an OrderStateValue message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderStateValue
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderStateValue} OrderStateValue
     */
    OrderStateValue.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderStateValue)
            return object;
        var message = new $root.OrderStateValue();
        switch (object.Value) {
        case "ORDERSTATE_UNKNOWN":
        case 0:
            message.Value = 0;
            break;
        case "ORDERSTATE_EXECUTING":
        case 1:
            message.Value = 1;
            break;
        case "ORDERSTATE_ACTIVE":
        case 2:
            message.Value = 2;
            break;
        case "ORDERSTATE_FILLED":
        case 3:
            message.Value = 3;
            break;
        case "ORDERSTATE_PARTIALLY_CANCELLED":
        case 4:
            message.Value = 4;
            break;
        case "ORDERSTATE_CANCELLED":
        case 5:
            message.Value = 5;
            break;
        case "ORDERSTATE_REJECTED":
        case 6:
            message.Value = 6;
            break;
        case "ORDERSTATE_INACTIVE":
        case 7:
            message.Value = 7;
            break;
        case "ORDERSTATE_PARTIALLY_FILLED":
        case 8:
            message.Value = 8;
            break;
        case "ORDERSTATE_SUSPENDED":
        case 9:
            message.Value = 9;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an OrderStateValue message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderStateValue
     * @static
     * @param {OrderStateValue} message OrderStateValue
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderStateValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Value = options.enums === String ? "ORDERSTATE_UNKNOWN" : 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.enums === String ? $root.OrderState[message.Value] : message.Value;
        return object;
    };

    /**
     * Converts this OrderStateValue to JSON.
     * @function toJSON
     * @memberof OrderStateValue
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderStateValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrderStateValue;
})();

$root.MarketApproximationValue = (function() {

    /**
     * Properties of a MarketApproximationValue.
     * @exports IMarketApproximationValue
     * @interface IMarketApproximationValue
     * @property {MarketApproximation|null} [Value] MarketApproximationValue Value
     */

    /**
     * Constructs a new MarketApproximationValue.
     * @exports MarketApproximationValue
     * @classdesc Represents a MarketApproximationValue.
     * @implements IMarketApproximationValue
     * @constructor
     * @param {IMarketApproximationValue=} [properties] Properties to set
     */
    function MarketApproximationValue(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarketApproximationValue Value.
     * @member {MarketApproximation} Value
     * @memberof MarketApproximationValue
     * @instance
     */
    MarketApproximationValue.prototype.Value = 0;

    /**
     * Creates a new MarketApproximationValue instance using the specified properties.
     * @function create
     * @memberof MarketApproximationValue
     * @static
     * @param {IMarketApproximationValue=} [properties] Properties to set
     * @returns {MarketApproximationValue} MarketApproximationValue instance
     */
    MarketApproximationValue.create = function create(properties) {
        return new MarketApproximationValue(properties);
    };

    /**
     * Encodes the specified MarketApproximationValue message. Does not implicitly {@link MarketApproximationValue.verify|verify} messages.
     * @function encode
     * @memberof MarketApproximationValue
     * @static
     * @param {IMarketApproximationValue} message MarketApproximationValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketApproximationValue.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Value);
        return writer;
    };

    /**
     * Encodes the specified MarketApproximationValue message, length delimited. Does not implicitly {@link MarketApproximationValue.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarketApproximationValue
     * @static
     * @param {IMarketApproximationValue} message MarketApproximationValue message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarketApproximationValue.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarketApproximationValue message from the specified reader or buffer.
     * @function decode
     * @memberof MarketApproximationValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarketApproximationValue} MarketApproximationValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketApproximationValue.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarketApproximationValue();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarketApproximationValue message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarketApproximationValue
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarketApproximationValue} MarketApproximationValue
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarketApproximationValue.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarketApproximationValue message.
     * @function verify
     * @memberof MarketApproximationValue
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarketApproximationValue.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            switch (message.Value) {
            default:
                return "Value: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    /**
     * Creates a MarketApproximationValue message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarketApproximationValue
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarketApproximationValue} MarketApproximationValue
     */
    MarketApproximationValue.fromObject = function fromObject(object) {
        if (object instanceof $root.MarketApproximationValue)
            return object;
        var message = new $root.MarketApproximationValue();
        switch (object.Value) {
        case "MARKETAPPROXIMATION_CLOSE":
        case 0:
            message.Value = 0;
            break;
        case "MARKETAPPROXIMATION_NEAR":
        case 1:
            message.Value = 1;
            break;
        case "MARKETAPPROXIMATION_FAR":
        case 2:
            message.Value = 2;
            break;
        case "MARKETAPPROXIMATION_VERY_FAR":
        case 3:
            message.Value = 3;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a MarketApproximationValue message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarketApproximationValue
     * @static
     * @param {MarketApproximationValue} message MarketApproximationValue
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarketApproximationValue.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Value = options.enums === String ? "MARKETAPPROXIMATION_CLOSE" : 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.enums === String ? $root.MarketApproximation[message.Value] : message.Value;
        return object;
    };

    /**
     * Converts this MarketApproximationValue to JSON.
     * @function toJSON
     * @memberof MarketApproximationValue
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarketApproximationValue.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MarketApproximationValue;
})();

$root.OrderUpdate = (function() {

    /**
     * Properties of an OrderUpdate.
     * @exports IOrderUpdate
     * @interface IOrderUpdate
     * @property {string|null} [OrderId] OrderUpdate OrderId
     * @property {IOrderStateValue|null} [State] OrderUpdate State
     * @property {google.protobuf.IDoubleValue|null} [FillPercent] OrderUpdate FillPercent
     * @property {google.protobuf.IDoubleValue|null} [RequestedAmount] OrderUpdate RequestedAmount
     * @property {google.protobuf.IDoubleValue|null} [LeftAmount] OrderUpdate LeftAmount
     * @property {google.protobuf.IDoubleValue|null} [FilledAmount] OrderUpdate FilledAmount
     * @property {google.protobuf.IDoubleValue|null} [RequestedPrice] OrderUpdate RequestedPrice
     * @property {google.protobuf.IDoubleValue|null} [FilledPrice] OrderUpdate FilledPrice
     * @property {google.protobuf.IStringValue|null} [UpdateDate] OrderUpdate UpdateDate
     * @property {google.protobuf.IDoubleValue|null} [MarketDistance] OrderUpdate MarketDistance
     * @property {google.protobuf.IDoubleValue|null} [MarketPoints] OrderUpdate MarketPoints
     * @property {IMarketApproximationValue|null} [MarketCloseness] OrderUpdate MarketCloseness
     * @property {google.protobuf.IStringValue|null} [ExecutionDate] OrderUpdate ExecutionDate
     * @property {google.protobuf.IDoubleValue|null} [CounterFilledAmount] OrderUpdate CounterFilledAmount
     * @property {google.protobuf.IStringValue|null} [CounterCurrency] OrderUpdate CounterCurrency
     * @property {google.protobuf.IStringValue|null} [ValueDate] OrderUpdate ValueDate
     * @property {google.protobuf.IStringValue|null} [KondorDealTypeID] OrderUpdate KondorDealTypeID
     */

    /**
     * Constructs a new OrderUpdate.
     * @exports OrderUpdate
     * @classdesc Represents an OrderUpdate.
     * @implements IOrderUpdate
     * @constructor
     * @param {IOrderUpdate=} [properties] Properties to set
     */
    function OrderUpdate(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OrderUpdate OrderId.
     * @member {string} OrderId
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.OrderId = "";

    /**
     * OrderUpdate State.
     * @member {IOrderStateValue|null|undefined} State
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.State = null;

    /**
     * OrderUpdate FillPercent.
     * @member {google.protobuf.IDoubleValue|null|undefined} FillPercent
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.FillPercent = null;

    /**
     * OrderUpdate RequestedAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} RequestedAmount
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.RequestedAmount = null;

    /**
     * OrderUpdate LeftAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} LeftAmount
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.LeftAmount = null;

    /**
     * OrderUpdate FilledAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} FilledAmount
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.FilledAmount = null;

    /**
     * OrderUpdate RequestedPrice.
     * @member {google.protobuf.IDoubleValue|null|undefined} RequestedPrice
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.RequestedPrice = null;

    /**
     * OrderUpdate FilledPrice.
     * @member {google.protobuf.IDoubleValue|null|undefined} FilledPrice
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.FilledPrice = null;

    /**
     * OrderUpdate UpdateDate.
     * @member {google.protobuf.IStringValue|null|undefined} UpdateDate
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.UpdateDate = null;

    /**
     * OrderUpdate MarketDistance.
     * @member {google.protobuf.IDoubleValue|null|undefined} MarketDistance
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.MarketDistance = null;

    /**
     * OrderUpdate MarketPoints.
     * @member {google.protobuf.IDoubleValue|null|undefined} MarketPoints
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.MarketPoints = null;

    /**
     * OrderUpdate MarketCloseness.
     * @member {IMarketApproximationValue|null|undefined} MarketCloseness
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.MarketCloseness = null;

    /**
     * OrderUpdate ExecutionDate.
     * @member {google.protobuf.IStringValue|null|undefined} ExecutionDate
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.ExecutionDate = null;

    /**
     * OrderUpdate CounterFilledAmount.
     * @member {google.protobuf.IDoubleValue|null|undefined} CounterFilledAmount
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.CounterFilledAmount = null;

    /**
     * OrderUpdate CounterCurrency.
     * @member {google.protobuf.IStringValue|null|undefined} CounterCurrency
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.CounterCurrency = null;

    /**
     * OrderUpdate ValueDate.
     * @member {google.protobuf.IStringValue|null|undefined} ValueDate
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.ValueDate = null;

    /**
     * OrderUpdate KondorDealTypeID.
     * @member {google.protobuf.IStringValue|null|undefined} KondorDealTypeID
     * @memberof OrderUpdate
     * @instance
     */
    OrderUpdate.prototype.KondorDealTypeID = null;

    /**
     * Creates a new OrderUpdate instance using the specified properties.
     * @function create
     * @memberof OrderUpdate
     * @static
     * @param {IOrderUpdate=} [properties] Properties to set
     * @returns {OrderUpdate} OrderUpdate instance
     */
    OrderUpdate.create = function create(properties) {
        return new OrderUpdate(properties);
    };

    /**
     * Encodes the specified OrderUpdate message. Does not implicitly {@link OrderUpdate.verify|verify} messages.
     * @function encode
     * @memberof OrderUpdate
     * @static
     * @param {IOrderUpdate} message OrderUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderUpdate.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.OrderId != null && Object.hasOwnProperty.call(message, "OrderId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.OrderId);
        if (message.State != null && Object.hasOwnProperty.call(message, "State"))
            $root.OrderStateValue.encode(message.State, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.FillPercent != null && Object.hasOwnProperty.call(message, "FillPercent"))
            $root.google.protobuf.DoubleValue.encode(message.FillPercent, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.RequestedAmount != null && Object.hasOwnProperty.call(message, "RequestedAmount"))
            $root.google.protobuf.DoubleValue.encode(message.RequestedAmount, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.LeftAmount != null && Object.hasOwnProperty.call(message, "LeftAmount"))
            $root.google.protobuf.DoubleValue.encode(message.LeftAmount, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.FilledAmount != null && Object.hasOwnProperty.call(message, "FilledAmount"))
            $root.google.protobuf.DoubleValue.encode(message.FilledAmount, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.RequestedPrice != null && Object.hasOwnProperty.call(message, "RequestedPrice"))
            $root.google.protobuf.DoubleValue.encode(message.RequestedPrice, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.FilledPrice != null && Object.hasOwnProperty.call(message, "FilledPrice"))
            $root.google.protobuf.DoubleValue.encode(message.FilledPrice, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.UpdateDate != null && Object.hasOwnProperty.call(message, "UpdateDate"))
            $root.google.protobuf.StringValue.encode(message.UpdateDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.MarketDistance != null && Object.hasOwnProperty.call(message, "MarketDistance"))
            $root.google.protobuf.DoubleValue.encode(message.MarketDistance, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.MarketPoints != null && Object.hasOwnProperty.call(message, "MarketPoints"))
            $root.google.protobuf.DoubleValue.encode(message.MarketPoints, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.MarketCloseness != null && Object.hasOwnProperty.call(message, "MarketCloseness"))
            $root.MarketApproximationValue.encode(message.MarketCloseness, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.ExecutionDate != null && Object.hasOwnProperty.call(message, "ExecutionDate"))
            $root.google.protobuf.StringValue.encode(message.ExecutionDate, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.CounterFilledAmount != null && Object.hasOwnProperty.call(message, "CounterFilledAmount"))
            $root.google.protobuf.DoubleValue.encode(message.CounterFilledAmount, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.CounterCurrency != null && Object.hasOwnProperty.call(message, "CounterCurrency"))
            $root.google.protobuf.StringValue.encode(message.CounterCurrency, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
        if (message.ValueDate != null && Object.hasOwnProperty.call(message, "ValueDate"))
            $root.google.protobuf.StringValue.encode(message.ValueDate, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
        if (message.KondorDealTypeID != null && Object.hasOwnProperty.call(message, "KondorDealTypeID"))
            $root.google.protobuf.StringValue.encode(message.KondorDealTypeID, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified OrderUpdate message, length delimited. Does not implicitly {@link OrderUpdate.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OrderUpdate
     * @static
     * @param {IOrderUpdate} message OrderUpdate message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OrderUpdate.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OrderUpdate message from the specified reader or buffer.
     * @function decode
     * @memberof OrderUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OrderUpdate} OrderUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderUpdate.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OrderUpdate();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.OrderId = reader.string();
                break;
            case 2:
                message.State = $root.OrderStateValue.decode(reader, reader.uint32());
                break;
            case 3:
                message.FillPercent = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 4:
                message.RequestedAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 5:
                message.LeftAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 6:
                message.FilledAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 7:
                message.RequestedPrice = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 8:
                message.FilledPrice = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 9:
                message.UpdateDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 10:
                message.MarketDistance = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 11:
                message.MarketPoints = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 12:
                message.MarketCloseness = $root.MarketApproximationValue.decode(reader, reader.uint32());
                break;
            case 13:
                message.ExecutionDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 14:
                message.CounterFilledAmount = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 15:
                message.CounterCurrency = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 16:
                message.ValueDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 17:
                message.KondorDealTypeID = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OrderUpdate message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OrderUpdate
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OrderUpdate} OrderUpdate
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OrderUpdate.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OrderUpdate message.
     * @function verify
     * @memberof OrderUpdate
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OrderUpdate.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            if (!$util.isString(message.OrderId))
                return "OrderId: string expected";
        if (message.State != null && message.hasOwnProperty("State")) {
            var error = $root.OrderStateValue.verify(message.State);
            if (error)
                return "State." + error;
        }
        if (message.FillPercent != null && message.hasOwnProperty("FillPercent")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FillPercent);
            if (error)
                return "FillPercent." + error;
        }
        if (message.RequestedAmount != null && message.hasOwnProperty("RequestedAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.RequestedAmount);
            if (error)
                return "RequestedAmount." + error;
        }
        if (message.LeftAmount != null && message.hasOwnProperty("LeftAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.LeftAmount);
            if (error)
                return "LeftAmount." + error;
        }
        if (message.FilledAmount != null && message.hasOwnProperty("FilledAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FilledAmount);
            if (error)
                return "FilledAmount." + error;
        }
        if (message.RequestedPrice != null && message.hasOwnProperty("RequestedPrice")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.RequestedPrice);
            if (error)
                return "RequestedPrice." + error;
        }
        if (message.FilledPrice != null && message.hasOwnProperty("FilledPrice")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FilledPrice);
            if (error)
                return "FilledPrice." + error;
        }
        if (message.UpdateDate != null && message.hasOwnProperty("UpdateDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.UpdateDate);
            if (error)
                return "UpdateDate." + error;
        }
        if (message.MarketDistance != null && message.hasOwnProperty("MarketDistance")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.MarketDistance);
            if (error)
                return "MarketDistance." + error;
        }
        if (message.MarketPoints != null && message.hasOwnProperty("MarketPoints")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.MarketPoints);
            if (error)
                return "MarketPoints." + error;
        }
        if (message.MarketCloseness != null && message.hasOwnProperty("MarketCloseness")) {
            var error = $root.MarketApproximationValue.verify(message.MarketCloseness);
            if (error)
                return "MarketCloseness." + error;
        }
        if (message.ExecutionDate != null && message.hasOwnProperty("ExecutionDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExecutionDate);
            if (error)
                return "ExecutionDate." + error;
        }
        if (message.CounterFilledAmount != null && message.hasOwnProperty("CounterFilledAmount")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.CounterFilledAmount);
            if (error)
                return "CounterFilledAmount." + error;
        }
        if (message.CounterCurrency != null && message.hasOwnProperty("CounterCurrency")) {
            var error = $root.google.protobuf.StringValue.verify(message.CounterCurrency);
            if (error)
                return "CounterCurrency." + error;
        }
        if (message.ValueDate != null && message.hasOwnProperty("ValueDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ValueDate);
            if (error)
                return "ValueDate." + error;
        }
        if (message.KondorDealTypeID != null && message.hasOwnProperty("KondorDealTypeID")) {
            var error = $root.google.protobuf.StringValue.verify(message.KondorDealTypeID);
            if (error)
                return "KondorDealTypeID." + error;
        }
        return null;
    };

    /**
     * Creates an OrderUpdate message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OrderUpdate
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OrderUpdate} OrderUpdate
     */
    OrderUpdate.fromObject = function fromObject(object) {
        if (object instanceof $root.OrderUpdate)
            return object;
        var message = new $root.OrderUpdate();
        if (object.OrderId != null)
            message.OrderId = String(object.OrderId);
        if (object.State != null) {
            if (typeof object.State !== "object")
                throw TypeError(".OrderUpdate.State: object expected");
            message.State = $root.OrderStateValue.fromObject(object.State);
        }
        if (object.FillPercent != null) {
            if (typeof object.FillPercent !== "object")
                throw TypeError(".OrderUpdate.FillPercent: object expected");
            message.FillPercent = $root.google.protobuf.DoubleValue.fromObject(object.FillPercent);
        }
        if (object.RequestedAmount != null) {
            if (typeof object.RequestedAmount !== "object")
                throw TypeError(".OrderUpdate.RequestedAmount: object expected");
            message.RequestedAmount = $root.google.protobuf.DoubleValue.fromObject(object.RequestedAmount);
        }
        if (object.LeftAmount != null) {
            if (typeof object.LeftAmount !== "object")
                throw TypeError(".OrderUpdate.LeftAmount: object expected");
            message.LeftAmount = $root.google.protobuf.DoubleValue.fromObject(object.LeftAmount);
        }
        if (object.FilledAmount != null) {
            if (typeof object.FilledAmount !== "object")
                throw TypeError(".OrderUpdate.FilledAmount: object expected");
            message.FilledAmount = $root.google.protobuf.DoubleValue.fromObject(object.FilledAmount);
        }
        if (object.RequestedPrice != null) {
            if (typeof object.RequestedPrice !== "object")
                throw TypeError(".OrderUpdate.RequestedPrice: object expected");
            message.RequestedPrice = $root.google.protobuf.DoubleValue.fromObject(object.RequestedPrice);
        }
        if (object.FilledPrice != null) {
            if (typeof object.FilledPrice !== "object")
                throw TypeError(".OrderUpdate.FilledPrice: object expected");
            message.FilledPrice = $root.google.protobuf.DoubleValue.fromObject(object.FilledPrice);
        }
        if (object.UpdateDate != null) {
            if (typeof object.UpdateDate !== "object")
                throw TypeError(".OrderUpdate.UpdateDate: object expected");
            message.UpdateDate = $root.google.protobuf.StringValue.fromObject(object.UpdateDate);
        }
        if (object.MarketDistance != null) {
            if (typeof object.MarketDistance !== "object")
                throw TypeError(".OrderUpdate.MarketDistance: object expected");
            message.MarketDistance = $root.google.protobuf.DoubleValue.fromObject(object.MarketDistance);
        }
        if (object.MarketPoints != null) {
            if (typeof object.MarketPoints !== "object")
                throw TypeError(".OrderUpdate.MarketPoints: object expected");
            message.MarketPoints = $root.google.protobuf.DoubleValue.fromObject(object.MarketPoints);
        }
        if (object.MarketCloseness != null) {
            if (typeof object.MarketCloseness !== "object")
                throw TypeError(".OrderUpdate.MarketCloseness: object expected");
            message.MarketCloseness = $root.MarketApproximationValue.fromObject(object.MarketCloseness);
        }
        if (object.ExecutionDate != null) {
            if (typeof object.ExecutionDate !== "object")
                throw TypeError(".OrderUpdate.ExecutionDate: object expected");
            message.ExecutionDate = $root.google.protobuf.StringValue.fromObject(object.ExecutionDate);
        }
        if (object.CounterFilledAmount != null) {
            if (typeof object.CounterFilledAmount !== "object")
                throw TypeError(".OrderUpdate.CounterFilledAmount: object expected");
            message.CounterFilledAmount = $root.google.protobuf.DoubleValue.fromObject(object.CounterFilledAmount);
        }
        if (object.CounterCurrency != null) {
            if (typeof object.CounterCurrency !== "object")
                throw TypeError(".OrderUpdate.CounterCurrency: object expected");
            message.CounterCurrency = $root.google.protobuf.StringValue.fromObject(object.CounterCurrency);
        }
        if (object.ValueDate != null) {
            if (typeof object.ValueDate !== "object")
                throw TypeError(".OrderUpdate.ValueDate: object expected");
            message.ValueDate = $root.google.protobuf.StringValue.fromObject(object.ValueDate);
        }
        if (object.KondorDealTypeID != null) {
            if (typeof object.KondorDealTypeID !== "object")
                throw TypeError(".OrderUpdate.KondorDealTypeID: object expected");
            message.KondorDealTypeID = $root.google.protobuf.StringValue.fromObject(object.KondorDealTypeID);
        }
        return message;
    };

    /**
     * Creates a plain object from an OrderUpdate message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OrderUpdate
     * @static
     * @param {OrderUpdate} message OrderUpdate
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OrderUpdate.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.OrderId = "";
            object.State = null;
            object.FillPercent = null;
            object.RequestedAmount = null;
            object.LeftAmount = null;
            object.FilledAmount = null;
            object.RequestedPrice = null;
            object.FilledPrice = null;
            object.UpdateDate = null;
            object.MarketDistance = null;
            object.MarketPoints = null;
            object.MarketCloseness = null;
            object.ExecutionDate = null;
            object.CounterFilledAmount = null;
            object.CounterCurrency = null;
            object.ValueDate = null;
            object.KondorDealTypeID = null;
        }
        if (message.OrderId != null && message.hasOwnProperty("OrderId"))
            object.OrderId = message.OrderId;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = $root.OrderStateValue.toObject(message.State, options);
        if (message.FillPercent != null && message.hasOwnProperty("FillPercent"))
            object.FillPercent = $root.google.protobuf.DoubleValue.toObject(message.FillPercent, options);
        if (message.RequestedAmount != null && message.hasOwnProperty("RequestedAmount"))
            object.RequestedAmount = $root.google.protobuf.DoubleValue.toObject(message.RequestedAmount, options);
        if (message.LeftAmount != null && message.hasOwnProperty("LeftAmount"))
            object.LeftAmount = $root.google.protobuf.DoubleValue.toObject(message.LeftAmount, options);
        if (message.FilledAmount != null && message.hasOwnProperty("FilledAmount"))
            object.FilledAmount = $root.google.protobuf.DoubleValue.toObject(message.FilledAmount, options);
        if (message.RequestedPrice != null && message.hasOwnProperty("RequestedPrice"))
            object.RequestedPrice = $root.google.protobuf.DoubleValue.toObject(message.RequestedPrice, options);
        if (message.FilledPrice != null && message.hasOwnProperty("FilledPrice"))
            object.FilledPrice = $root.google.protobuf.DoubleValue.toObject(message.FilledPrice, options);
        if (message.UpdateDate != null && message.hasOwnProperty("UpdateDate"))
            object.UpdateDate = $root.google.protobuf.StringValue.toObject(message.UpdateDate, options);
        if (message.MarketDistance != null && message.hasOwnProperty("MarketDistance"))
            object.MarketDistance = $root.google.protobuf.DoubleValue.toObject(message.MarketDistance, options);
        if (message.MarketPoints != null && message.hasOwnProperty("MarketPoints"))
            object.MarketPoints = $root.google.protobuf.DoubleValue.toObject(message.MarketPoints, options);
        if (message.MarketCloseness != null && message.hasOwnProperty("MarketCloseness"))
            object.MarketCloseness = $root.MarketApproximationValue.toObject(message.MarketCloseness, options);
        if (message.ExecutionDate != null && message.hasOwnProperty("ExecutionDate"))
            object.ExecutionDate = $root.google.protobuf.StringValue.toObject(message.ExecutionDate, options);
        if (message.CounterFilledAmount != null && message.hasOwnProperty("CounterFilledAmount"))
            object.CounterFilledAmount = $root.google.protobuf.DoubleValue.toObject(message.CounterFilledAmount, options);
        if (message.CounterCurrency != null && message.hasOwnProperty("CounterCurrency"))
            object.CounterCurrency = $root.google.protobuf.StringValue.toObject(message.CounterCurrency, options);
        if (message.ValueDate != null && message.hasOwnProperty("ValueDate"))
            object.ValueDate = $root.google.protobuf.StringValue.toObject(message.ValueDate, options);
        if (message.KondorDealTypeID != null && message.hasOwnProperty("KondorDealTypeID"))
            object.KondorDealTypeID = $root.google.protobuf.StringValue.toObject(message.KondorDealTypeID, options);
        return object;
    };

    /**
     * Converts this OrderUpdate to JSON.
     * @function toJSON
     * @memberof OrderUpdate
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OrderUpdate.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OrderUpdate;
})();

$root.PlaceForwardOrderRequest = (function() {

    /**
     * Properties of a PlaceForwardOrderRequest.
     * @exports IPlaceForwardOrderRequest
     * @interface IPlaceForwardOrderRequest
     * @property {TradeSide|null} [Side] PlaceForwardOrderRequest Side
     * @property {number|null} [SubscriptionId] PlaceForwardOrderRequest SubscriptionId
     * @property {number|null} [NearPrice] PlaceForwardOrderRequest NearPrice
     * @property {google.protobuf.IDoubleValue|null} [FarPrice] PlaceForwardOrderRequest FarPrice
     */

    /**
     * Constructs a new PlaceForwardOrderRequest.
     * @exports PlaceForwardOrderRequest
     * @classdesc Represents a PlaceForwardOrderRequest.
     * @implements IPlaceForwardOrderRequest
     * @constructor
     * @param {IPlaceForwardOrderRequest=} [properties] Properties to set
     */
    function PlaceForwardOrderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlaceForwardOrderRequest Side.
     * @member {TradeSide} Side
     * @memberof PlaceForwardOrderRequest
     * @instance
     */
    PlaceForwardOrderRequest.prototype.Side = 0;

    /**
     * PlaceForwardOrderRequest SubscriptionId.
     * @member {number} SubscriptionId
     * @memberof PlaceForwardOrderRequest
     * @instance
     */
    PlaceForwardOrderRequest.prototype.SubscriptionId = 0;

    /**
     * PlaceForwardOrderRequest NearPrice.
     * @member {number} NearPrice
     * @memberof PlaceForwardOrderRequest
     * @instance
     */
    PlaceForwardOrderRequest.prototype.NearPrice = 0;

    /**
     * PlaceForwardOrderRequest FarPrice.
     * @member {google.protobuf.IDoubleValue|null|undefined} FarPrice
     * @memberof PlaceForwardOrderRequest
     * @instance
     */
    PlaceForwardOrderRequest.prototype.FarPrice = null;

    /**
     * Creates a new PlaceForwardOrderRequest instance using the specified properties.
     * @function create
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {IPlaceForwardOrderRequest=} [properties] Properties to set
     * @returns {PlaceForwardOrderRequest} PlaceForwardOrderRequest instance
     */
    PlaceForwardOrderRequest.create = function create(properties) {
        return new PlaceForwardOrderRequest(properties);
    };

    /**
     * Encodes the specified PlaceForwardOrderRequest message. Does not implicitly {@link PlaceForwardOrderRequest.verify|verify} messages.
     * @function encode
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {IPlaceForwardOrderRequest} message PlaceForwardOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceForwardOrderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Side != null && Object.hasOwnProperty.call(message, "Side"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Side);
        if (message.SubscriptionId != null && Object.hasOwnProperty.call(message, "SubscriptionId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.SubscriptionId);
        if (message.NearPrice != null && Object.hasOwnProperty.call(message, "NearPrice"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.NearPrice);
        if (message.FarPrice != null && Object.hasOwnProperty.call(message, "FarPrice"))
            $root.google.protobuf.DoubleValue.encode(message.FarPrice, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PlaceForwardOrderRequest message, length delimited. Does not implicitly {@link PlaceForwardOrderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {IPlaceForwardOrderRequest} message PlaceForwardOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceForwardOrderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlaceForwardOrderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlaceForwardOrderRequest} PlaceForwardOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceForwardOrderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlaceForwardOrderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Side = reader.int32();
                break;
            case 2:
                message.SubscriptionId = reader.int32();
                break;
            case 3:
                message.NearPrice = reader.double();
                break;
            case 4:
                message.FarPrice = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlaceForwardOrderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlaceForwardOrderRequest} PlaceForwardOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceForwardOrderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlaceForwardOrderRequest message.
     * @function verify
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlaceForwardOrderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Side != null && message.hasOwnProperty("Side"))
            switch (message.Side) {
            default:
                return "Side: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.SubscriptionId != null && message.hasOwnProperty("SubscriptionId"))
            if (!$util.isInteger(message.SubscriptionId))
                return "SubscriptionId: integer expected";
        if (message.NearPrice != null && message.hasOwnProperty("NearPrice"))
            if (typeof message.NearPrice !== "number")
                return "NearPrice: number expected";
        if (message.FarPrice != null && message.hasOwnProperty("FarPrice")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.FarPrice);
            if (error)
                return "FarPrice." + error;
        }
        return null;
    };

    /**
     * Creates a PlaceForwardOrderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlaceForwardOrderRequest} PlaceForwardOrderRequest
     */
    PlaceForwardOrderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PlaceForwardOrderRequest)
            return object;
        var message = new $root.PlaceForwardOrderRequest();
        switch (object.Side) {
        case "TRADESIDE_SELL":
        case 0:
            message.Side = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.Side = 1;
            break;
        }
        if (object.SubscriptionId != null)
            message.SubscriptionId = object.SubscriptionId | 0;
        if (object.NearPrice != null)
            message.NearPrice = Number(object.NearPrice);
        if (object.FarPrice != null) {
            if (typeof object.FarPrice !== "object")
                throw TypeError(".PlaceForwardOrderRequest.FarPrice: object expected");
            message.FarPrice = $root.google.protobuf.DoubleValue.fromObject(object.FarPrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PlaceForwardOrderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlaceForwardOrderRequest
     * @static
     * @param {PlaceForwardOrderRequest} message PlaceForwardOrderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlaceForwardOrderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Side = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.SubscriptionId = 0;
            object.NearPrice = 0;
            object.FarPrice = null;
        }
        if (message.Side != null && message.hasOwnProperty("Side"))
            object.Side = options.enums === String ? $root.TradeSide[message.Side] : message.Side;
        if (message.SubscriptionId != null && message.hasOwnProperty("SubscriptionId"))
            object.SubscriptionId = message.SubscriptionId;
        if (message.NearPrice != null && message.hasOwnProperty("NearPrice"))
            object.NearPrice = options.json && !isFinite(message.NearPrice) ? String(message.NearPrice) : message.NearPrice;
        if (message.FarPrice != null && message.hasOwnProperty("FarPrice"))
            object.FarPrice = $root.google.protobuf.DoubleValue.toObject(message.FarPrice, options);
        return object;
    };

    /**
     * Converts this PlaceForwardOrderRequest to JSON.
     * @function toJSON
     * @memberof PlaceForwardOrderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlaceForwardOrderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlaceForwardOrderRequest;
})();

$root.PlaceForwardOrderResponse = (function() {

    /**
     * Properties of a PlaceForwardOrderResponse.
     * @exports IPlaceForwardOrderResponse
     * @interface IPlaceForwardOrderResponse
     * @property {boolean|null} [Accepted] PlaceForwardOrderResponse Accepted
     * @property {string|null} [Reason] PlaceForwardOrderResponse Reason
     */

    /**
     * Constructs a new PlaceForwardOrderResponse.
     * @exports PlaceForwardOrderResponse
     * @classdesc Represents a PlaceForwardOrderResponse.
     * @implements IPlaceForwardOrderResponse
     * @constructor
     * @param {IPlaceForwardOrderResponse=} [properties] Properties to set
     */
    function PlaceForwardOrderResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlaceForwardOrderResponse Accepted.
     * @member {boolean} Accepted
     * @memberof PlaceForwardOrderResponse
     * @instance
     */
    PlaceForwardOrderResponse.prototype.Accepted = false;

    /**
     * PlaceForwardOrderResponse Reason.
     * @member {string} Reason
     * @memberof PlaceForwardOrderResponse
     * @instance
     */
    PlaceForwardOrderResponse.prototype.Reason = "";

    /**
     * Creates a new PlaceForwardOrderResponse instance using the specified properties.
     * @function create
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {IPlaceForwardOrderResponse=} [properties] Properties to set
     * @returns {PlaceForwardOrderResponse} PlaceForwardOrderResponse instance
     */
    PlaceForwardOrderResponse.create = function create(properties) {
        return new PlaceForwardOrderResponse(properties);
    };

    /**
     * Encodes the specified PlaceForwardOrderResponse message. Does not implicitly {@link PlaceForwardOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {IPlaceForwardOrderResponse} message PlaceForwardOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceForwardOrderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified PlaceForwardOrderResponse message, length delimited. Does not implicitly {@link PlaceForwardOrderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {IPlaceForwardOrderResponse} message PlaceForwardOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceForwardOrderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlaceForwardOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlaceForwardOrderResponse} PlaceForwardOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceForwardOrderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlaceForwardOrderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlaceForwardOrderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlaceForwardOrderResponse} PlaceForwardOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceForwardOrderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlaceForwardOrderResponse message.
     * @function verify
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlaceForwardOrderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a PlaceForwardOrderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlaceForwardOrderResponse} PlaceForwardOrderResponse
     */
    PlaceForwardOrderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.PlaceForwardOrderResponse)
            return object;
        var message = new $root.PlaceForwardOrderResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a PlaceForwardOrderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlaceForwardOrderResponse
     * @static
     * @param {PlaceForwardOrderResponse} message PlaceForwardOrderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlaceForwardOrderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this PlaceForwardOrderResponse to JSON.
     * @function toJSON
     * @memberof PlaceForwardOrderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlaceForwardOrderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlaceForwardOrderResponse;
})();

$root.PlacePendingOrderRequest = (function() {

    /**
     * Properties of a PlacePendingOrderRequest.
     * @exports IPlacePendingOrderRequest
     * @interface IPlacePendingOrderRequest
     * @property {PendingType|null} [Type] PlacePendingOrderRequest Type
     * @property {string|null} [Symbol] PlacePendingOrderRequest Symbol
     * @property {TradeSide|null} [Side] PlacePendingOrderRequest Side
     * @property {number|null} [Price] PlacePendingOrderRequest Price
     * @property {string|null} [BaseCurrency] PlacePendingOrderRequest BaseCurrency
     * @property {number|null} [Quantity] PlacePendingOrderRequest Quantity
     * @property {number|null} [ClientId] PlacePendingOrderRequest ClientId
     * @property {ExpirationType|null} [Expiry] PlacePendingOrderRequest Expiry
     * @property {google.protobuf.IStringValue|null} [ExpiryDate] PlacePendingOrderRequest ExpiryDate
     * @property {PriceType|null} [PriceType] PlacePendingOrderRequest PriceType
     * @property {PriceType|null} [PriceTypeSecondLeg] PlacePendingOrderRequest PriceTypeSecondLeg
     * @property {TradeSide|null} [SideSecondLeg] PlacePendingOrderRequest SideSecondLeg
     * @property {number|null} [PriceSecondLeg] PlacePendingOrderRequest PriceSecondLeg
     * @property {number|null} [QuantitySecondLeg] PlacePendingOrderRequest QuantitySecondLeg
     */

    /**
     * Constructs a new PlacePendingOrderRequest.
     * @exports PlacePendingOrderRequest
     * @classdesc Represents a PlacePendingOrderRequest.
     * @implements IPlacePendingOrderRequest
     * @constructor
     * @param {IPlacePendingOrderRequest=} [properties] Properties to set
     */
    function PlacePendingOrderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlacePendingOrderRequest Type.
     * @member {PendingType} Type
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Type = 0;

    /**
     * PlacePendingOrderRequest Symbol.
     * @member {string} Symbol
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Symbol = "";

    /**
     * PlacePendingOrderRequest Side.
     * @member {TradeSide} Side
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Side = 0;

    /**
     * PlacePendingOrderRequest Price.
     * @member {number} Price
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Price = 0;

    /**
     * PlacePendingOrderRequest BaseCurrency.
     * @member {string} BaseCurrency
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.BaseCurrency = "";

    /**
     * PlacePendingOrderRequest Quantity.
     * @member {number} Quantity
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Quantity = 0;

    /**
     * PlacePendingOrderRequest ClientId.
     * @member {number} ClientId
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.ClientId = 0;

    /**
     * PlacePendingOrderRequest Expiry.
     * @member {ExpirationType} Expiry
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.Expiry = 0;

    /**
     * PlacePendingOrderRequest ExpiryDate.
     * @member {google.protobuf.IStringValue|null|undefined} ExpiryDate
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.ExpiryDate = null;

    /**
     * PlacePendingOrderRequest PriceType.
     * @member {PriceType} PriceType
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.PriceType = 0;

    /**
     * PlacePendingOrderRequest PriceTypeSecondLeg.
     * @member {PriceType} PriceTypeSecondLeg
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.PriceTypeSecondLeg = 0;

    /**
     * PlacePendingOrderRequest SideSecondLeg.
     * @member {TradeSide} SideSecondLeg
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.SideSecondLeg = 0;

    /**
     * PlacePendingOrderRequest PriceSecondLeg.
     * @member {number} PriceSecondLeg
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.PriceSecondLeg = 0;

    /**
     * PlacePendingOrderRequest QuantitySecondLeg.
     * @member {number} QuantitySecondLeg
     * @memberof PlacePendingOrderRequest
     * @instance
     */
    PlacePendingOrderRequest.prototype.QuantitySecondLeg = 0;

    /**
     * Creates a new PlacePendingOrderRequest instance using the specified properties.
     * @function create
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {IPlacePendingOrderRequest=} [properties] Properties to set
     * @returns {PlacePendingOrderRequest} PlacePendingOrderRequest instance
     */
    PlacePendingOrderRequest.create = function create(properties) {
        return new PlacePendingOrderRequest(properties);
    };

    /**
     * Encodes the specified PlacePendingOrderRequest message. Does not implicitly {@link PlacePendingOrderRequest.verify|verify} messages.
     * @function encode
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {IPlacePendingOrderRequest} message PlacePendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlacePendingOrderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
        if (message.Symbol != null && Object.hasOwnProperty.call(message, "Symbol"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Symbol);
        if (message.Side != null && Object.hasOwnProperty.call(message, "Side"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Side);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.Price);
        if (message.BaseCurrency != null && Object.hasOwnProperty.call(message, "BaseCurrency"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.BaseCurrency);
        if (message.Quantity != null && Object.hasOwnProperty.call(message, "Quantity"))
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.Quantity);
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ClientId);
        if (message.Expiry != null && Object.hasOwnProperty.call(message, "Expiry"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Expiry);
        if (message.ExpiryDate != null && Object.hasOwnProperty.call(message, "ExpiryDate"))
            $root.google.protobuf.StringValue.encode(message.ExpiryDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.PriceType != null && Object.hasOwnProperty.call(message, "PriceType"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.PriceType);
        if (message.PriceTypeSecondLeg != null && Object.hasOwnProperty.call(message, "PriceTypeSecondLeg"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.PriceTypeSecondLeg);
        if (message.SideSecondLeg != null && Object.hasOwnProperty.call(message, "SideSecondLeg"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.SideSecondLeg);
        if (message.PriceSecondLeg != null && Object.hasOwnProperty.call(message, "PriceSecondLeg"))
            writer.uint32(/* id 13, wireType 1 =*/105).double(message.PriceSecondLeg);
        if (message.QuantitySecondLeg != null && Object.hasOwnProperty.call(message, "QuantitySecondLeg"))
            writer.uint32(/* id 14, wireType 1 =*/113).double(message.QuantitySecondLeg);
        return writer;
    };

    /**
     * Encodes the specified PlacePendingOrderRequest message, length delimited. Does not implicitly {@link PlacePendingOrderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {IPlacePendingOrderRequest} message PlacePendingOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlacePendingOrderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlacePendingOrderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlacePendingOrderRequest} PlacePendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlacePendingOrderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlacePendingOrderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Type = reader.int32();
                break;
            case 2:
                message.Symbol = reader.string();
                break;
            case 3:
                message.Side = reader.int32();
                break;
            case 4:
                message.Price = reader.double();
                break;
            case 5:
                message.BaseCurrency = reader.string();
                break;
            case 6:
                message.Quantity = reader.double();
                break;
            case 7:
                message.ClientId = reader.int32();
                break;
            case 8:
                message.Expiry = reader.int32();
                break;
            case 9:
                message.ExpiryDate = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                break;
            case 10:
                message.PriceType = reader.int32();
                break;
            case 11:
                message.PriceTypeSecondLeg = reader.int32();
                break;
            case 12:
                message.SideSecondLeg = reader.int32();
                break;
            case 13:
                message.PriceSecondLeg = reader.double();
                break;
            case 14:
                message.QuantitySecondLeg = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlacePendingOrderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlacePendingOrderRequest} PlacePendingOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlacePendingOrderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlacePendingOrderRequest message.
     * @function verify
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlacePendingOrderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            if (!$util.isString(message.Symbol))
                return "Symbol: string expected";
        if (message.Side != null && message.hasOwnProperty("Side"))
            switch (message.Side) {
            default:
                return "Side: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Price != null && message.hasOwnProperty("Price"))
            if (typeof message.Price !== "number")
                return "Price: number expected";
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            if (!$util.isString(message.BaseCurrency))
                return "BaseCurrency: string expected";
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            if (typeof message.Quantity !== "number")
                return "Quantity: number expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            switch (message.Expiry) {
            default:
                return "Expiry: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate")) {
            var error = $root.google.protobuf.StringValue.verify(message.ExpiryDate);
            if (error)
                return "ExpiryDate." + error;
        }
        if (message.PriceType != null && message.hasOwnProperty("PriceType"))
            switch (message.PriceType) {
            default:
                return "PriceType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.PriceTypeSecondLeg != null && message.hasOwnProperty("PriceTypeSecondLeg"))
            switch (message.PriceTypeSecondLeg) {
            default:
                return "PriceTypeSecondLeg: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.SideSecondLeg != null && message.hasOwnProperty("SideSecondLeg"))
            switch (message.SideSecondLeg) {
            default:
                return "SideSecondLeg: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.PriceSecondLeg != null && message.hasOwnProperty("PriceSecondLeg"))
            if (typeof message.PriceSecondLeg !== "number")
                return "PriceSecondLeg: number expected";
        if (message.QuantitySecondLeg != null && message.hasOwnProperty("QuantitySecondLeg"))
            if (typeof message.QuantitySecondLeg !== "number")
                return "QuantitySecondLeg: number expected";
        return null;
    };

    /**
     * Creates a PlacePendingOrderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlacePendingOrderRequest} PlacePendingOrderRequest
     */
    PlacePendingOrderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PlacePendingOrderRequest)
            return object;
        var message = new $root.PlacePendingOrderRequest();
        switch (object.Type) {
        case "PENDINGTYPE_LIMIT":
        case 0:
            message.Type = 0;
            break;
        case "PENDINGTYPE_STOP":
        case 1:
            message.Type = 1;
            break;
        case "PENDINGTYPE_IF_DONE":
        case 2:
            message.Type = 2;
            break;
        case "PENDINGTYPE_OCO":
        case 3:
            message.Type = 3;
            break;
        }
        if (object.Symbol != null)
            message.Symbol = String(object.Symbol);
        switch (object.Side) {
        case "TRADESIDE_SELL":
        case 0:
            message.Side = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.Side = 1;
            break;
        }
        if (object.Price != null)
            message.Price = Number(object.Price);
        if (object.BaseCurrency != null)
            message.BaseCurrency = String(object.BaseCurrency);
        if (object.Quantity != null)
            message.Quantity = Number(object.Quantity);
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        switch (object.Expiry) {
        case "EXPIRATIONTYPE_UNKNOWN":
        case 0:
            message.Expiry = 0;
            break;
        case "EXPIRATIONTYPE_GTC":
        case 1:
            message.Expiry = 1;
            break;
        case "EXPIRATIONTYPE_GTD":
        case 2:
            message.Expiry = 2;
            break;
        case "EXPIRATIONTYPE_GTS":
        case 3:
            message.Expiry = 3;
            break;
        case "EXPIRATIONTYPE_FOK":
        case 4:
            message.Expiry = 4;
            break;
        case "EXPIRATIONTYPE_IOC":
        case 5:
            message.Expiry = 5;
            break;
        }
        if (object.ExpiryDate != null) {
            if (typeof object.ExpiryDate !== "object")
                throw TypeError(".PlacePendingOrderRequest.ExpiryDate: object expected");
            message.ExpiryDate = $root.google.protobuf.StringValue.fromObject(object.ExpiryDate);
        }
        switch (object.PriceType) {
        case "PRICETYPE_LIMIT":
        case 0:
            message.PriceType = 0;
            break;
        case "PRICETYPE_STOP":
        case 1:
            message.PriceType = 1;
            break;
        }
        switch (object.PriceTypeSecondLeg) {
        case "PRICETYPE_LIMIT":
        case 0:
            message.PriceTypeSecondLeg = 0;
            break;
        case "PRICETYPE_STOP":
        case 1:
            message.PriceTypeSecondLeg = 1;
            break;
        }
        switch (object.SideSecondLeg) {
        case "TRADESIDE_SELL":
        case 0:
            message.SideSecondLeg = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.SideSecondLeg = 1;
            break;
        }
        if (object.PriceSecondLeg != null)
            message.PriceSecondLeg = Number(object.PriceSecondLeg);
        if (object.QuantitySecondLeg != null)
            message.QuantitySecondLeg = Number(object.QuantitySecondLeg);
        return message;
    };

    /**
     * Creates a plain object from a PlacePendingOrderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlacePendingOrderRequest
     * @static
     * @param {PlacePendingOrderRequest} message PlacePendingOrderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlacePendingOrderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Type = options.enums === String ? "PENDINGTYPE_LIMIT" : 0;
            object.Symbol = "";
            object.Side = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.Price = 0;
            object.BaseCurrency = "";
            object.Quantity = 0;
            object.ClientId = 0;
            object.Expiry = options.enums === String ? "EXPIRATIONTYPE_UNKNOWN" : 0;
            object.ExpiryDate = null;
            object.PriceType = options.enums === String ? "PRICETYPE_LIMIT" : 0;
            object.PriceTypeSecondLeg = options.enums === String ? "PRICETYPE_LIMIT" : 0;
            object.SideSecondLeg = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.PriceSecondLeg = 0;
            object.QuantitySecondLeg = 0;
        }
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.PendingType[message.Type] : message.Type;
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            object.Symbol = message.Symbol;
        if (message.Side != null && message.hasOwnProperty("Side"))
            object.Side = options.enums === String ? $root.TradeSide[message.Side] : message.Side;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = options.json && !isFinite(message.Price) ? String(message.Price) : message.Price;
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            object.BaseCurrency = message.BaseCurrency;
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            object.Quantity = options.json && !isFinite(message.Quantity) ? String(message.Quantity) : message.Quantity;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.Expiry != null && message.hasOwnProperty("Expiry"))
            object.Expiry = options.enums === String ? $root.ExpirationType[message.Expiry] : message.Expiry;
        if (message.ExpiryDate != null && message.hasOwnProperty("ExpiryDate"))
            object.ExpiryDate = $root.google.protobuf.StringValue.toObject(message.ExpiryDate, options);
        if (message.PriceType != null && message.hasOwnProperty("PriceType"))
            object.PriceType = options.enums === String ? $root.PriceType[message.PriceType] : message.PriceType;
        if (message.PriceTypeSecondLeg != null && message.hasOwnProperty("PriceTypeSecondLeg"))
            object.PriceTypeSecondLeg = options.enums === String ? $root.PriceType[message.PriceTypeSecondLeg] : message.PriceTypeSecondLeg;
        if (message.SideSecondLeg != null && message.hasOwnProperty("SideSecondLeg"))
            object.SideSecondLeg = options.enums === String ? $root.TradeSide[message.SideSecondLeg] : message.SideSecondLeg;
        if (message.PriceSecondLeg != null && message.hasOwnProperty("PriceSecondLeg"))
            object.PriceSecondLeg = options.json && !isFinite(message.PriceSecondLeg) ? String(message.PriceSecondLeg) : message.PriceSecondLeg;
        if (message.QuantitySecondLeg != null && message.hasOwnProperty("QuantitySecondLeg"))
            object.QuantitySecondLeg = options.json && !isFinite(message.QuantitySecondLeg) ? String(message.QuantitySecondLeg) : message.QuantitySecondLeg;
        return object;
    };

    /**
     * Converts this PlacePendingOrderRequest to JSON.
     * @function toJSON
     * @memberof PlacePendingOrderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlacePendingOrderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlacePendingOrderRequest;
})();

$root.PlacePendingOrderResponse = (function() {

    /**
     * Properties of a PlacePendingOrderResponse.
     * @exports IPlacePendingOrderResponse
     * @interface IPlacePendingOrderResponse
     * @property {boolean|null} [Accepted] PlacePendingOrderResponse Accepted
     * @property {string|null} [Reason] PlacePendingOrderResponse Reason
     */

    /**
     * Constructs a new PlacePendingOrderResponse.
     * @exports PlacePendingOrderResponse
     * @classdesc Represents a PlacePendingOrderResponse.
     * @implements IPlacePendingOrderResponse
     * @constructor
     * @param {IPlacePendingOrderResponse=} [properties] Properties to set
     */
    function PlacePendingOrderResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlacePendingOrderResponse Accepted.
     * @member {boolean} Accepted
     * @memberof PlacePendingOrderResponse
     * @instance
     */
    PlacePendingOrderResponse.prototype.Accepted = false;

    /**
     * PlacePendingOrderResponse Reason.
     * @member {string} Reason
     * @memberof PlacePendingOrderResponse
     * @instance
     */
    PlacePendingOrderResponse.prototype.Reason = "";

    /**
     * Creates a new PlacePendingOrderResponse instance using the specified properties.
     * @function create
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {IPlacePendingOrderResponse=} [properties] Properties to set
     * @returns {PlacePendingOrderResponse} PlacePendingOrderResponse instance
     */
    PlacePendingOrderResponse.create = function create(properties) {
        return new PlacePendingOrderResponse(properties);
    };

    /**
     * Encodes the specified PlacePendingOrderResponse message. Does not implicitly {@link PlacePendingOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {IPlacePendingOrderResponse} message PlacePendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlacePendingOrderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified PlacePendingOrderResponse message, length delimited. Does not implicitly {@link PlacePendingOrderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {IPlacePendingOrderResponse} message PlacePendingOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlacePendingOrderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlacePendingOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlacePendingOrderResponse} PlacePendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlacePendingOrderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlacePendingOrderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlacePendingOrderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlacePendingOrderResponse} PlacePendingOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlacePendingOrderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlacePendingOrderResponse message.
     * @function verify
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlacePendingOrderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a PlacePendingOrderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlacePendingOrderResponse} PlacePendingOrderResponse
     */
    PlacePendingOrderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.PlacePendingOrderResponse)
            return object;
        var message = new $root.PlacePendingOrderResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a PlacePendingOrderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlacePendingOrderResponse
     * @static
     * @param {PlacePendingOrderResponse} message PlacePendingOrderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlacePendingOrderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this PlacePendingOrderResponse to JSON.
     * @function toJSON
     * @memberof PlacePendingOrderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlacePendingOrderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlacePendingOrderResponse;
})();

$root.PlaceSpotOrderRequest = (function() {

    /**
     * Properties of a PlaceSpotOrderRequest.
     * @exports IPlaceSpotOrderRequest
     * @interface IPlaceSpotOrderRequest
     * @property {string|null} [Symbol] PlaceSpotOrderRequest Symbol
     * @property {TradeSide|null} [Side] PlaceSpotOrderRequest Side
     * @property {SpotType|null} [Type] PlaceSpotOrderRequest Type
     * @property {string|null} [BaseCurrency] PlaceSpotOrderRequest BaseCurrency
     * @property {number|null} [Price] PlaceSpotOrderRequest Price
     * @property {number|null} [Quantity] PlaceSpotOrderRequest Quantity
     * @property {number|null} [ClientId] PlaceSpotOrderRequest ClientId
     * @property {number|Long|null} [Timestamp] PlaceSpotOrderRequest Timestamp
     */

    /**
     * Constructs a new PlaceSpotOrderRequest.
     * @exports PlaceSpotOrderRequest
     * @classdesc Represents a PlaceSpotOrderRequest.
     * @implements IPlaceSpotOrderRequest
     * @constructor
     * @param {IPlaceSpotOrderRequest=} [properties] Properties to set
     */
    function PlaceSpotOrderRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlaceSpotOrderRequest Symbol.
     * @member {string} Symbol
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Symbol = "";

    /**
     * PlaceSpotOrderRequest Side.
     * @member {TradeSide} Side
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Side = 0;

    /**
     * PlaceSpotOrderRequest Type.
     * @member {SpotType} Type
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Type = 0;

    /**
     * PlaceSpotOrderRequest BaseCurrency.
     * @member {string} BaseCurrency
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.BaseCurrency = "";

    /**
     * PlaceSpotOrderRequest Price.
     * @member {number} Price
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Price = 0;

    /**
     * PlaceSpotOrderRequest Quantity.
     * @member {number} Quantity
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Quantity = 0;

    /**
     * PlaceSpotOrderRequest ClientId.
     * @member {number} ClientId
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.ClientId = 0;

    /**
     * PlaceSpotOrderRequest Timestamp.
     * @member {number|Long} Timestamp
     * @memberof PlaceSpotOrderRequest
     * @instance
     */
    PlaceSpotOrderRequest.prototype.Timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new PlaceSpotOrderRequest instance using the specified properties.
     * @function create
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {IPlaceSpotOrderRequest=} [properties] Properties to set
     * @returns {PlaceSpotOrderRequest} PlaceSpotOrderRequest instance
     */
    PlaceSpotOrderRequest.create = function create(properties) {
        return new PlaceSpotOrderRequest(properties);
    };

    /**
     * Encodes the specified PlaceSpotOrderRequest message. Does not implicitly {@link PlaceSpotOrderRequest.verify|verify} messages.
     * @function encode
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {IPlaceSpotOrderRequest} message PlaceSpotOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceSpotOrderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Symbol != null && Object.hasOwnProperty.call(message, "Symbol"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Symbol);
        if (message.Side != null && Object.hasOwnProperty.call(message, "Side"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Side);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Type);
        if (message.BaseCurrency != null && Object.hasOwnProperty.call(message, "BaseCurrency"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BaseCurrency);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.Price);
        if (message.Quantity != null && Object.hasOwnProperty.call(message, "Quantity"))
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.Quantity);
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ClientId);
        if (message.Timestamp != null && Object.hasOwnProperty.call(message, "Timestamp"))
            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Timestamp);
        return writer;
    };

    /**
     * Encodes the specified PlaceSpotOrderRequest message, length delimited. Does not implicitly {@link PlaceSpotOrderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {IPlaceSpotOrderRequest} message PlaceSpotOrderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceSpotOrderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlaceSpotOrderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlaceSpotOrderRequest} PlaceSpotOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceSpotOrderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlaceSpotOrderRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Symbol = reader.string();
                break;
            case 2:
                message.Side = reader.int32();
                break;
            case 3:
                message.Type = reader.int32();
                break;
            case 4:
                message.BaseCurrency = reader.string();
                break;
            case 5:
                message.Price = reader.double();
                break;
            case 6:
                message.Quantity = reader.double();
                break;
            case 7:
                message.ClientId = reader.int32();
                break;
            case 8:
                message.Timestamp = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlaceSpotOrderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlaceSpotOrderRequest} PlaceSpotOrderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceSpotOrderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlaceSpotOrderRequest message.
     * @function verify
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlaceSpotOrderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            if (!$util.isString(message.Symbol))
                return "Symbol: string expected";
        if (message.Side != null && message.hasOwnProperty("Side"))
            switch (message.Side) {
            default:
                return "Side: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            if (!$util.isString(message.BaseCurrency))
                return "BaseCurrency: string expected";
        if (message.Price != null && message.hasOwnProperty("Price"))
            if (typeof message.Price !== "number")
                return "Price: number expected";
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            if (typeof message.Quantity !== "number")
                return "Quantity: number expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (!$util.isInteger(message.Timestamp) && !(message.Timestamp && $util.isInteger(message.Timestamp.low) && $util.isInteger(message.Timestamp.high)))
                return "Timestamp: integer|Long expected";
        return null;
    };

    /**
     * Creates a PlaceSpotOrderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlaceSpotOrderRequest} PlaceSpotOrderRequest
     */
    PlaceSpotOrderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PlaceSpotOrderRequest)
            return object;
        var message = new $root.PlaceSpotOrderRequest();
        if (object.Symbol != null)
            message.Symbol = String(object.Symbol);
        switch (object.Side) {
        case "TRADESIDE_SELL":
        case 0:
            message.Side = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.Side = 1;
            break;
        }
        switch (object.Type) {
        case "SPOTTYPE_MARKET":
        case 0:
            message.Type = 0;
            break;
        case "SPOTTYPE_FULL":
        case 1:
            message.Type = 1;
            break;
        case "SPOTTYPE_IOC":
        case 2:
            message.Type = 2;
            break;
        }
        if (object.BaseCurrency != null)
            message.BaseCurrency = String(object.BaseCurrency);
        if (object.Price != null)
            message.Price = Number(object.Price);
        if (object.Quantity != null)
            message.Quantity = Number(object.Quantity);
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        if (object.Timestamp != null)
            if ($util.Long)
                (message.Timestamp = $util.Long.fromValue(object.Timestamp)).unsigned = false;
            else if (typeof object.Timestamp === "string")
                message.Timestamp = parseInt(object.Timestamp, 10);
            else if (typeof object.Timestamp === "number")
                message.Timestamp = object.Timestamp;
            else if (typeof object.Timestamp === "object")
                message.Timestamp = new $util.LongBits(object.Timestamp.low >>> 0, object.Timestamp.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a PlaceSpotOrderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlaceSpotOrderRequest
     * @static
     * @param {PlaceSpotOrderRequest} message PlaceSpotOrderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlaceSpotOrderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Symbol = "";
            object.Side = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.Type = options.enums === String ? "SPOTTYPE_MARKET" : 0;
            object.BaseCurrency = "";
            object.Price = 0;
            object.Quantity = 0;
            object.ClientId = 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Timestamp = options.longs === String ? "0" : 0;
        }
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            object.Symbol = message.Symbol;
        if (message.Side != null && message.hasOwnProperty("Side"))
            object.Side = options.enums === String ? $root.TradeSide[message.Side] : message.Side;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.SpotType[message.Type] : message.Type;
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            object.BaseCurrency = message.BaseCurrency;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = options.json && !isFinite(message.Price) ? String(message.Price) : message.Price;
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            object.Quantity = options.json && !isFinite(message.Quantity) ? String(message.Quantity) : message.Quantity;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (typeof message.Timestamp === "number")
                object.Timestamp = options.longs === String ? String(message.Timestamp) : message.Timestamp;
            else
                object.Timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.Timestamp) : options.longs === Number ? new $util.LongBits(message.Timestamp.low >>> 0, message.Timestamp.high >>> 0).toNumber() : message.Timestamp;
        return object;
    };

    /**
     * Converts this PlaceSpotOrderRequest to JSON.
     * @function toJSON
     * @memberof PlaceSpotOrderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlaceSpotOrderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlaceSpotOrderRequest;
})();

$root.PlaceSpotOrderResponse = (function() {

    /**
     * Properties of a PlaceSpotOrderResponse.
     * @exports IPlaceSpotOrderResponse
     * @interface IPlaceSpotOrderResponse
     * @property {boolean|null} [Accepted] PlaceSpotOrderResponse Accepted
     * @property {string|null} [Reason] PlaceSpotOrderResponse Reason
     */

    /**
     * Constructs a new PlaceSpotOrderResponse.
     * @exports PlaceSpotOrderResponse
     * @classdesc Represents a PlaceSpotOrderResponse.
     * @implements IPlaceSpotOrderResponse
     * @constructor
     * @param {IPlaceSpotOrderResponse=} [properties] Properties to set
     */
    function PlaceSpotOrderResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PlaceSpotOrderResponse Accepted.
     * @member {boolean} Accepted
     * @memberof PlaceSpotOrderResponse
     * @instance
     */
    PlaceSpotOrderResponse.prototype.Accepted = false;

    /**
     * PlaceSpotOrderResponse Reason.
     * @member {string} Reason
     * @memberof PlaceSpotOrderResponse
     * @instance
     */
    PlaceSpotOrderResponse.prototype.Reason = "";

    /**
     * Creates a new PlaceSpotOrderResponse instance using the specified properties.
     * @function create
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {IPlaceSpotOrderResponse=} [properties] Properties to set
     * @returns {PlaceSpotOrderResponse} PlaceSpotOrderResponse instance
     */
    PlaceSpotOrderResponse.create = function create(properties) {
        return new PlaceSpotOrderResponse(properties);
    };

    /**
     * Encodes the specified PlaceSpotOrderResponse message. Does not implicitly {@link PlaceSpotOrderResponse.verify|verify} messages.
     * @function encode
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {IPlaceSpotOrderResponse} message PlaceSpotOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceSpotOrderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified PlaceSpotOrderResponse message, length delimited. Does not implicitly {@link PlaceSpotOrderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {IPlaceSpotOrderResponse} message PlaceSpotOrderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PlaceSpotOrderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PlaceSpotOrderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PlaceSpotOrderResponse} PlaceSpotOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceSpotOrderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PlaceSpotOrderResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PlaceSpotOrderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PlaceSpotOrderResponse} PlaceSpotOrderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PlaceSpotOrderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PlaceSpotOrderResponse message.
     * @function verify
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PlaceSpotOrderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a PlaceSpotOrderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PlaceSpotOrderResponse} PlaceSpotOrderResponse
     */
    PlaceSpotOrderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.PlaceSpotOrderResponse)
            return object;
        var message = new $root.PlaceSpotOrderResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a PlaceSpotOrderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PlaceSpotOrderResponse
     * @static
     * @param {PlaceSpotOrderResponse} message PlaceSpotOrderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PlaceSpotOrderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this PlaceSpotOrderResponse to JSON.
     * @function toJSON
     * @memberof PlaceSpotOrderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PlaceSpotOrderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PlaceSpotOrderResponse;
})();

$root.SessionRequest = (function() {

    /**
     * Properties of a SessionRequest.
     * @exports ISessionRequest
     * @interface ISessionRequest
     */

    /**
     * Constructs a new SessionRequest.
     * @exports SessionRequest
     * @classdesc Represents a SessionRequest.
     * @implements ISessionRequest
     * @constructor
     * @param {ISessionRequest=} [properties] Properties to set
     */
    function SessionRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SessionRequest instance using the specified properties.
     * @function create
     * @memberof SessionRequest
     * @static
     * @param {ISessionRequest=} [properties] Properties to set
     * @returns {SessionRequest} SessionRequest instance
     */
    SessionRequest.create = function create(properties) {
        return new SessionRequest(properties);
    };

    /**
     * Encodes the specified SessionRequest message. Does not implicitly {@link SessionRequest.verify|verify} messages.
     * @function encode
     * @memberof SessionRequest
     * @static
     * @param {ISessionRequest} message SessionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SessionRequest message, length delimited. Does not implicitly {@link SessionRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SessionRequest
     * @static
     * @param {ISessionRequest} message SessionRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SessionRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SessionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionRequest} SessionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SessionRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SessionRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SessionRequest} SessionRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SessionRequest message.
     * @function verify
     * @memberof SessionRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SessionRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SessionRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionRequest} SessionRequest
     */
    SessionRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionRequest)
            return object;
        return new $root.SessionRequest();
    };

    /**
     * Creates a plain object from a SessionRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionRequest
     * @static
     * @param {SessionRequest} message SessionRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SessionRequest to JSON.
     * @function toJSON
     * @memberof SessionRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SessionRequest;
})();

$root.SessionResponse = (function() {

    /**
     * Properties of a SessionResponse.
     * @exports ISessionResponse
     * @interface ISessionResponse
     * @property {SessionState|null} [State] SessionResponse State
     */

    /**
     * Constructs a new SessionResponse.
     * @exports SessionResponse
     * @classdesc Represents a SessionResponse.
     * @implements ISessionResponse
     * @constructor
     * @param {ISessionResponse=} [properties] Properties to set
     */
    function SessionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SessionResponse State.
     * @member {SessionState} State
     * @memberof SessionResponse
     * @instance
     */
    SessionResponse.prototype.State = 0;

    /**
     * Creates a new SessionResponse instance using the specified properties.
     * @function create
     * @memberof SessionResponse
     * @static
     * @param {ISessionResponse=} [properties] Properties to set
     * @returns {SessionResponse} SessionResponse instance
     */
    SessionResponse.create = function create(properties) {
        return new SessionResponse(properties);
    };

    /**
     * Encodes the specified SessionResponse message. Does not implicitly {@link SessionResponse.verify|verify} messages.
     * @function encode
     * @memberof SessionResponse
     * @static
     * @param {ISessionResponse} message SessionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.State != null && Object.hasOwnProperty.call(message, "State"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.State);
        return writer;
    };

    /**
     * Encodes the specified SessionResponse message, length delimited. Does not implicitly {@link SessionResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SessionResponse
     * @static
     * @param {ISessionResponse} message SessionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SessionResponse message from the specified reader or buffer.
     * @function decode
     * @memberof SessionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionResponse} SessionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.State = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SessionResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SessionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SessionResponse} SessionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SessionResponse message.
     * @function verify
     * @memberof SessionResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SessionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
                break;
            }
        return null;
    };

    /**
     * Creates a SessionResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionResponse} SessionResponse
     */
    SessionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionResponse)
            return object;
        var message = new $root.SessionResponse();
        switch (object.State) {
        case "SESSIONSTATE_UNKNOWN":
        case 0:
            message.State = 0;
            break;
        case "SESSIONSTATE_END":
        case 1:
            message.State = 1;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a SessionResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionResponse
     * @static
     * @param {SessionResponse} message SessionResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.State = options.enums === String ? "SESSIONSTATE_UNKNOWN" : 0;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.SessionState[message.State] : message.State;
        return object;
    };

    /**
     * Converts this SessionResponse to JSON.
     * @function toJSON
     * @memberof SessionResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SessionResponse;
})();



$root.SetCurrentFirmRequest = (function() {

    /**
     * Properties of a SetCurrentFirmRequest.
     * @exports ISetCurrentFirmRequest
     * @interface ISetCurrentFirmRequest
     * @property {number|null} [FirmId] SetCurrentFirmRequest FirmId
     */

    /**
     * Constructs a new SetCurrentFirmRequest.
     * @exports SetCurrentFirmRequest
     * @classdesc Represents a SetCurrentFirmRequest.
     * @implements ISetCurrentFirmRequest
     * @constructor
     * @param {ISetCurrentFirmRequest=} [properties] Properties to set
     */
    function SetCurrentFirmRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SetCurrentFirmRequest FirmId.
     * @member {number} FirmId
     * @memberof SetCurrentFirmRequest
     * @instance
     */
    SetCurrentFirmRequest.prototype.FirmId = 0;

    /**
     * Creates a new SetCurrentFirmRequest instance using the specified properties.
     * @function create
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {ISetCurrentFirmRequest=} [properties] Properties to set
     * @returns {SetCurrentFirmRequest} SetCurrentFirmRequest instance
     */
    SetCurrentFirmRequest.create = function create(properties) {
        return new SetCurrentFirmRequest(properties);
    };

    /**
     * Encodes the specified SetCurrentFirmRequest message. Does not implicitly {@link SetCurrentFirmRequest.verify|verify} messages.
     * @function encode
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {ISetCurrentFirmRequest} message SetCurrentFirmRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetCurrentFirmRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.FirmId != null && Object.hasOwnProperty.call(message, "FirmId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.FirmId);
        return writer;
    };

    /**
     * Encodes the specified SetCurrentFirmRequest message, length delimited. Does not implicitly {@link SetCurrentFirmRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {ISetCurrentFirmRequest} message SetCurrentFirmRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetCurrentFirmRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetCurrentFirmRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetCurrentFirmRequest} SetCurrentFirmRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetCurrentFirmRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetCurrentFirmRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.FirmId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetCurrentFirmRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetCurrentFirmRequest} SetCurrentFirmRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetCurrentFirmRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetCurrentFirmRequest message.
     * @function verify
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetCurrentFirmRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.FirmId != null && message.hasOwnProperty("FirmId"))
            if (!$util.isInteger(message.FirmId))
                return "FirmId: integer expected";
        return null;
    };

    /**
     * Creates a SetCurrentFirmRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetCurrentFirmRequest} SetCurrentFirmRequest
     */
    SetCurrentFirmRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SetCurrentFirmRequest)
            return object;
        var message = new $root.SetCurrentFirmRequest();
        if (object.FirmId != null)
            message.FirmId = object.FirmId | 0;
        return message;
    };

    /**
     * Creates a plain object from a SetCurrentFirmRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetCurrentFirmRequest
     * @static
     * @param {SetCurrentFirmRequest} message SetCurrentFirmRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetCurrentFirmRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.FirmId = 0;
        if (message.FirmId != null && message.hasOwnProperty("FirmId"))
            object.FirmId = message.FirmId;
        return object;
    };

    /**
     * Converts this SetCurrentFirmRequest to JSON.
     * @function toJSON
     * @memberof SetCurrentFirmRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetCurrentFirmRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetCurrentFirmRequest;
})();

$root.SetCurrentFirmResponse = (function() {

    /**
     * Properties of a SetCurrentFirmResponse.
     * @exports ISetCurrentFirmResponse
     * @interface ISetCurrentFirmResponse
     */

    /**
     * Constructs a new SetCurrentFirmResponse.
     * @exports SetCurrentFirmResponse
     * @classdesc Represents a SetCurrentFirmResponse.
     * @implements ISetCurrentFirmResponse
     * @constructor
     * @param {ISetCurrentFirmResponse=} [properties] Properties to set
     */
    function SetCurrentFirmResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SetCurrentFirmResponse instance using the specified properties.
     * @function create
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {ISetCurrentFirmResponse=} [properties] Properties to set
     * @returns {SetCurrentFirmResponse} SetCurrentFirmResponse instance
     */
    SetCurrentFirmResponse.create = function create(properties) {
        return new SetCurrentFirmResponse(properties);
    };

    /**
     * Encodes the specified SetCurrentFirmResponse message. Does not implicitly {@link SetCurrentFirmResponse.verify|verify} messages.
     * @function encode
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {ISetCurrentFirmResponse} message SetCurrentFirmResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetCurrentFirmResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SetCurrentFirmResponse message, length delimited. Does not implicitly {@link SetCurrentFirmResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {ISetCurrentFirmResponse} message SetCurrentFirmResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SetCurrentFirmResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SetCurrentFirmResponse message from the specified reader or buffer.
     * @function decode
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SetCurrentFirmResponse} SetCurrentFirmResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetCurrentFirmResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SetCurrentFirmResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SetCurrentFirmResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SetCurrentFirmResponse} SetCurrentFirmResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SetCurrentFirmResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SetCurrentFirmResponse message.
     * @function verify
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SetCurrentFirmResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SetCurrentFirmResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SetCurrentFirmResponse} SetCurrentFirmResponse
     */
    SetCurrentFirmResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SetCurrentFirmResponse)
            return object;
        return new $root.SetCurrentFirmResponse();
    };

    /**
     * Creates a plain object from a SetCurrentFirmResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SetCurrentFirmResponse
     * @static
     * @param {SetCurrentFirmResponse} message SetCurrentFirmResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SetCurrentFirmResponse.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SetCurrentFirmResponse to JSON.
     * @function toJSON
     * @memberof SetCurrentFirmResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SetCurrentFirmResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SetCurrentFirmResponse;
})();

$root.SoundNotificationsRequest = (function() {

    /**
     * Properties of a SoundNotificationsRequest.
     * @exports ISoundNotificationsRequest
     * @interface ISoundNotificationsRequest
     */

    /**
     * Constructs a new SoundNotificationsRequest.
     * @exports SoundNotificationsRequest
     * @classdesc Represents a SoundNotificationsRequest.
     * @implements ISoundNotificationsRequest
     * @constructor
     * @param {ISoundNotificationsRequest=} [properties] Properties to set
     */
    function SoundNotificationsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new SoundNotificationsRequest instance using the specified properties.
     * @function create
     * @memberof SoundNotificationsRequest
     * @static
     * @param {ISoundNotificationsRequest=} [properties] Properties to set
     * @returns {SoundNotificationsRequest} SoundNotificationsRequest instance
     */
    SoundNotificationsRequest.create = function create(properties) {
        return new SoundNotificationsRequest(properties);
    };

    /**
     * Encodes the specified SoundNotificationsRequest message. Does not implicitly {@link SoundNotificationsRequest.verify|verify} messages.
     * @function encode
     * @memberof SoundNotificationsRequest
     * @static
     * @param {ISoundNotificationsRequest} message SoundNotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotificationsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified SoundNotificationsRequest message, length delimited. Does not implicitly {@link SoundNotificationsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SoundNotificationsRequest
     * @static
     * @param {ISoundNotificationsRequest} message SoundNotificationsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SoundNotificationsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SoundNotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SoundNotificationsRequest} SoundNotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotificationsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SoundNotificationsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SoundNotificationsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SoundNotificationsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SoundNotificationsRequest} SoundNotificationsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SoundNotificationsRequest message.
     * @function verify
     * @memberof SoundNotificationsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SoundNotificationsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a SoundNotificationsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SoundNotificationsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SoundNotificationsRequest} SoundNotificationsRequest
     */
    SoundNotificationsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SoundNotificationsRequest)
            return object;
        return new $root.SoundNotificationsRequest();
    };

    /**
     * Creates a plain object from a SoundNotificationsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SoundNotificationsRequest
     * @static
     * @param {SoundNotificationsRequest} message SoundNotificationsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SoundNotificationsRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this SoundNotificationsRequest to JSON.
     * @function toJSON
     * @memberof SoundNotificationsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SoundNotificationsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SoundNotificationsRequest;
})();

$root.SoundNotificationsResponse = (function() {

    /**
     * Properties of a SoundNotificationsResponse.
     * @exports ISoundNotificationsResponse
     * @interface ISoundNotificationsResponse
     * @property {Array.<ISoundNotification>|null} [Notifications] SoundNotificationsResponse Notifications
     */

    /**
     * Constructs a new SoundNotificationsResponse.
     * @exports SoundNotificationsResponse
     * @classdesc Represents a SoundNotificationsResponse.
     * @implements ISoundNotificationsResponse
     * @constructor
     * @param {ISoundNotificationsResponse=} [properties] Properties to set
     */
    function SoundNotificationsResponse(properties) {
        this.Notifications = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SoundNotificationsResponse Notifications.
     * @member {Array.<ISoundNotification>} Notifications
     * @memberof SoundNotificationsResponse
     * @instance
     */
    SoundNotificationsResponse.prototype.Notifications = $util.emptyArray;

    /**
     * Creates a new SoundNotificationsResponse instance using the specified properties.
     * @function create
     * @memberof SoundNotificationsResponse
     * @static
     * @param {ISoundNotificationsResponse=} [properties] Properties to set
     * @returns {SoundNotificationsResponse} SoundNotificationsResponse instance
     */
    SoundNotificationsResponse.create = function create(properties) {
        return new SoundNotificationsResponse(properties);
    };

    /**
     * Encodes the specified SoundNotificationsResponse message. Does not implicitly {@link SoundNotificationsResponse.verify|verify} messages.
     * @function encode
     * @memberof SoundNotificationsResponse
     * @static
     * @param {ISoundNotificationsResponse} message SoundNotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotificationsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Notifications != null && message.Notifications.length)
            for (var i = 0; i < message.Notifications.length; ++i)
                $root.SoundNotification.encode(message.Notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SoundNotificationsResponse message, length delimited. Does not implicitly {@link SoundNotificationsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SoundNotificationsResponse
     * @static
     * @param {ISoundNotificationsResponse} message SoundNotificationsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SoundNotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SoundNotificationsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof SoundNotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SoundNotificationsResponse} SoundNotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotificationsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SoundNotificationsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Notifications && message.Notifications.length))
                    message.Notifications = [];
                message.Notifications.push($root.SoundNotification.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SoundNotificationsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SoundNotificationsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SoundNotificationsResponse} SoundNotificationsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SoundNotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SoundNotificationsResponse message.
     * @function verify
     * @memberof SoundNotificationsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SoundNotificationsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Notifications != null && message.hasOwnProperty("Notifications")) {
            if (!Array.isArray(message.Notifications))
                return "Notifications: array expected";
            for (var i = 0; i < message.Notifications.length; ++i) {
                var error = $root.SoundNotification.verify(message.Notifications[i]);
                if (error)
                    return "Notifications." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SoundNotificationsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SoundNotificationsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SoundNotificationsResponse} SoundNotificationsResponse
     */
    SoundNotificationsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SoundNotificationsResponse)
            return object;
        var message = new $root.SoundNotificationsResponse();
        if (object.Notifications) {
            if (!Array.isArray(object.Notifications))
                throw TypeError(".SoundNotificationsResponse.Notifications: array expected");
            message.Notifications = [];
            for (var i = 0; i < object.Notifications.length; ++i) {
                if (typeof object.Notifications[i] !== "object")
                    throw TypeError(".SoundNotificationsResponse.Notifications: object expected");
                message.Notifications[i] = $root.SoundNotification.fromObject(object.Notifications[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SoundNotificationsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SoundNotificationsResponse
     * @static
     * @param {SoundNotificationsResponse} message SoundNotificationsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SoundNotificationsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Notifications = [];
        if (message.Notifications && message.Notifications.length) {
            object.Notifications = [];
            for (var j = 0; j < message.Notifications.length; ++j)
                object.Notifications[j] = $root.SoundNotification.toObject(message.Notifications[j], options);
        }
        return object;
    };

    /**
     * Converts this SoundNotificationsResponse to JSON.
     * @function toJSON
     * @memberof SoundNotificationsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SoundNotificationsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SoundNotificationsResponse;
})();

$root.SpotQuoteRequest = (function() {

    /**
     * Properties of a SpotQuoteRequest.
     * @exports ISpotQuoteRequest
     * @interface ISpotQuoteRequest
     * @property {number|null} [ClientId] SpotQuoteRequest ClientId
     * @property {number|null} [Quantity] SpotQuoteRequest Quantity
     * @property {string|null} [Instrument] SpotQuoteRequest Instrument
     * @property {string|null} [BaseCurrency] SpotQuoteRequest BaseCurrency
     * @property {OrderType|null} [SpotType] SpotQuoteRequest SpotType
     * @property {google.protobuf.IDoubleValue|null} [QuantitySecondLeg] SpotQuoteRequest QuantitySecondLeg
     * @property {TradeSide|null} [Side] SpotQuoteRequest Side
     * @property {google.protobuf.IDoubleValue|null} [Price] SpotQuoteRequest Price
     */

    /**
     * Constructs a new SpotQuoteRequest.
     * @exports SpotQuoteRequest
     * @classdesc Represents a SpotQuoteRequest.
     * @implements ISpotQuoteRequest
     * @constructor
     * @param {ISpotQuoteRequest=} [properties] Properties to set
     */
    function SpotQuoteRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpotQuoteRequest ClientId.
     * @member {number} ClientId
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.ClientId = 0;

    /**
     * SpotQuoteRequest Quantity.
     * @member {number} Quantity
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.Quantity = 0;

    /**
     * SpotQuoteRequest Instrument.
     * @member {string} Instrument
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.Instrument = "";

    /**
     * SpotQuoteRequest BaseCurrency.
     * @member {string} BaseCurrency
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.BaseCurrency = "";

    /**
     * SpotQuoteRequest SpotType.
     * @member {OrderType} SpotType
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.SpotType = 0;

    /**
     * SpotQuoteRequest QuantitySecondLeg.
     * @member {google.protobuf.IDoubleValue|null|undefined} QuantitySecondLeg
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.QuantitySecondLeg = null;

    /**
     * SpotQuoteRequest Side.
     * @member {TradeSide} Side
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.Side = 0;

    /**
     * SpotQuoteRequest Price.
     * @member {google.protobuf.IDoubleValue|null|undefined} Price
     * @memberof SpotQuoteRequest
     * @instance
     */
    SpotQuoteRequest.prototype.Price = null;

    /**
     * Creates a new SpotQuoteRequest instance using the specified properties.
     * @function create
     * @memberof SpotQuoteRequest
     * @static
     * @param {ISpotQuoteRequest=} [properties] Properties to set
     * @returns {SpotQuoteRequest} SpotQuoteRequest instance
     */
    SpotQuoteRequest.create = function create(properties) {
        return new SpotQuoteRequest(properties);
    };

    /**
     * Encodes the specified SpotQuoteRequest message. Does not implicitly {@link SpotQuoteRequest.verify|verify} messages.
     * @function encode
     * @memberof SpotQuoteRequest
     * @static
     * @param {ISpotQuoteRequest} message SpotQuoteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuoteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClientId);
        if (message.Quantity != null && Object.hasOwnProperty.call(message, "Quantity"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Quantity);
        if (message.Instrument != null && Object.hasOwnProperty.call(message, "Instrument"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Instrument);
        if (message.BaseCurrency != null && Object.hasOwnProperty.call(message, "BaseCurrency"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BaseCurrency);
        if (message.SpotType != null && Object.hasOwnProperty.call(message, "SpotType"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.SpotType);
        if (message.QuantitySecondLeg != null && Object.hasOwnProperty.call(message, "QuantitySecondLeg"))
            $root.google.protobuf.DoubleValue.encode(message.QuantitySecondLeg, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.Side != null && Object.hasOwnProperty.call(message, "Side"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.Side);
        if (message.Price != null && Object.hasOwnProperty.call(message, "Price"))
            $root.google.protobuf.DoubleValue.encode(message.Price, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SpotQuoteRequest message, length delimited. Does not implicitly {@link SpotQuoteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SpotQuoteRequest
     * @static
     * @param {ISpotQuoteRequest} message SpotQuoteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuoteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpotQuoteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SpotQuoteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpotQuoteRequest} SpotQuoteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuoteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpotQuoteRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClientId = reader.int32();
                break;
            case 2:
                message.Quantity = reader.double();
                break;
            case 3:
                message.Instrument = reader.string();
                break;
            case 4:
                message.BaseCurrency = reader.string();
                break;
            case 5:
                message.SpotType = reader.int32();
                break;
            case 6:
                message.QuantitySecondLeg = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            case 7:
                message.Side = reader.int32();
                break;
            case 8:
                message.Price = $root.google.protobuf.DoubleValue.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SpotQuoteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SpotQuoteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SpotQuoteRequest} SpotQuoteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuoteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpotQuoteRequest message.
     * @function verify
     * @memberof SpotQuoteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpotQuoteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            if (typeof message.Quantity !== "number")
                return "Quantity: number expected";
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            if (!$util.isString(message.Instrument))
                return "Instrument: string expected";
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            if (!$util.isString(message.BaseCurrency))
                return "BaseCurrency: string expected";
        if (message.SpotType != null && message.hasOwnProperty("SpotType"))
            switch (message.SpotType) {
            default:
                return "SpotType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
                break;
            }
        if (message.QuantitySecondLeg != null && message.hasOwnProperty("QuantitySecondLeg")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.QuantitySecondLeg);
            if (error)
                return "QuantitySecondLeg." + error;
        }
        if (message.Side != null && message.hasOwnProperty("Side"))
            switch (message.Side) {
            default:
                return "Side: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Price != null && message.hasOwnProperty("Price")) {
            var error = $root.google.protobuf.DoubleValue.verify(message.Price);
            if (error)
                return "Price." + error;
        }
        return null;
    };

    /**
     * Creates a SpotQuoteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpotQuoteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpotQuoteRequest} SpotQuoteRequest
     */
    SpotQuoteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SpotQuoteRequest)
            return object;
        var message = new $root.SpotQuoteRequest();
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        if (object.Quantity != null)
            message.Quantity = Number(object.Quantity);
        if (object.Instrument != null)
            message.Instrument = String(object.Instrument);
        if (object.BaseCurrency != null)
            message.BaseCurrency = String(object.BaseCurrency);
        switch (object.SpotType) {
        case "ORDERTYPE_MARKET":
        case 0:
            message.SpotType = 0;
            break;
        case "ORDERTYPE_FULL":
        case 1:
            message.SpotType = 1;
            break;
        case "ORDERTYPE_IOC":
        case 2:
            message.SpotType = 2;
            break;
        case "ORDERTYPE_LIMIT":
        case 3:
            message.SpotType = 3;
            break;
        case "ORDERTYPE_STOP":
        case 4:
            message.SpotType = 4;
            break;
        case "ORDERTYPE_IF_DONE":
        case 5:
            message.SpotType = 5;
            break;
        case "ORDERTYPE_OCO":
        case 6:
            message.SpotType = 6;
            break;
        }
        if (object.QuantitySecondLeg != null) {
            if (typeof object.QuantitySecondLeg !== "object")
                throw TypeError(".SpotQuoteRequest.QuantitySecondLeg: object expected");
            message.QuantitySecondLeg = $root.google.protobuf.DoubleValue.fromObject(object.QuantitySecondLeg);
        }
        switch (object.Side) {
        case "TRADESIDE_SELL":
        case 0:
            message.Side = 0;
            break;
        case "TRADESIDE_BUY":
        case 1:
            message.Side = 1;
            break;
        }
        if (object.Price != null) {
            if (typeof object.Price !== "object")
                throw TypeError(".SpotQuoteRequest.Price: object expected");
            message.Price = $root.google.protobuf.DoubleValue.fromObject(object.Price);
        }
        return message;
    };

    /**
     * Creates a plain object from a SpotQuoteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpotQuoteRequest
     * @static
     * @param {SpotQuoteRequest} message SpotQuoteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpotQuoteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ClientId = 0;
            object.Quantity = 0;
            object.Instrument = "";
            object.BaseCurrency = "";
            object.SpotType = options.enums === String ? "ORDERTYPE_MARKET" : 0;
            object.QuantitySecondLeg = null;
            object.Side = options.enums === String ? "TRADESIDE_SELL" : 0;
            object.Price = null;
        }
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        if (message.Quantity != null && message.hasOwnProperty("Quantity"))
            object.Quantity = options.json && !isFinite(message.Quantity) ? String(message.Quantity) : message.Quantity;
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            object.Instrument = message.Instrument;
        if (message.BaseCurrency != null && message.hasOwnProperty("BaseCurrency"))
            object.BaseCurrency = message.BaseCurrency;
        if (message.SpotType != null && message.hasOwnProperty("SpotType"))
            object.SpotType = options.enums === String ? $root.OrderType[message.SpotType] : message.SpotType;
        if (message.QuantitySecondLeg != null && message.hasOwnProperty("QuantitySecondLeg"))
            object.QuantitySecondLeg = $root.google.protobuf.DoubleValue.toObject(message.QuantitySecondLeg, options);
        if (message.Side != null && message.hasOwnProperty("Side"))
            object.Side = options.enums === String ? $root.TradeSide[message.Side] : message.Side;
        if (message.Price != null && message.hasOwnProperty("Price"))
            object.Price = $root.google.protobuf.DoubleValue.toObject(message.Price, options);
        return object;
    };

    /**
     * Converts this SpotQuoteRequest to JSON.
     * @function toJSON
     * @memberof SpotQuoteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpotQuoteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpotQuoteRequest;
})();

$root.SpotQuote = (function() {

    /**
     * Properties of a SpotQuote.
     * @exports ISpotQuote
     * @interface ISpotQuote
     * @property {IPrice|null} [AskPrice] SpotQuote AskPrice
     * @property {IPrice|null} [BidPrice] SpotQuote BidPrice
     * @property {IPoint|null} [Spread] SpotQuote Spread
     * @property {number|Long|null} [BidTimeStamp] BID Creation time of quote.
     * @property {number|Long|null} [OfferTimeStamp] OFFER Creation time of quote.
     */

    /**
     * Constructs a new SpotQuote.
     * @exports SpotQuote
     * @classdesc Represents a SpotQuote.
     * @implements ISpotQuote
     * @constructor
     * @param {ISpotQuote=} [properties] Properties to set
     */
    function SpotQuote(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpotQuote AskPrice.
     * @member {IPrice|null|undefined} AskPrice
     * @memberof SpotQuote
     * @instance
     */
    SpotQuote.prototype.AskPrice = null;

    /**
     * SpotQuote BidPrice.
     * @member {IPrice|null|undefined} BidPrice
     * @memberof SpotQuote
     * @instance
     */
    SpotQuote.prototype.BidPrice = null;

    /**
     * SpotQuote Spread.
     * @member {IPoint|null|undefined} Spread
     * @memberof SpotQuote
     * @instance
     */
    SpotQuote.prototype.Spread = null;

    /**
     * BID Creation time of quote.
     * @member {number|Long} BidTimeStamp
     * @memberof SpotQuote
     * @instance
     */
    SpotQuote.prototype.BidTimeStamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * OFFER Creation time of quote.
     * @member {number|Long} OfferTimeStamp
     * @memberof SpotQuote
     * @instance
     */
    SpotQuote.prototype.OfferTimeStamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new SpotQuote instance using the specified properties.
     * @function create
     * @memberof SpotQuote
     * @static
     * @param {ISpotQuote=} [properties] Properties to set
     * @returns {SpotQuote} SpotQuote instance
     */
    SpotQuote.create = function create(properties) {
        return new SpotQuote(properties);
    };

    /**
     * Encodes the specified SpotQuote message. Does not implicitly {@link SpotQuote.verify|verify} messages.
     * @function encode
     * @memberof SpotQuote
     * @static
     * @param {ISpotQuote} message SpotQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuote.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.AskPrice != null && Object.hasOwnProperty.call(message, "AskPrice"))
            $root.Price.encode(message.AskPrice, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.BidPrice != null && Object.hasOwnProperty.call(message, "BidPrice"))
            $root.Price.encode(message.BidPrice, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Spread != null && Object.hasOwnProperty.call(message, "Spread"))
            $root.Point.encode(message.Spread, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.BidTimeStamp != null && Object.hasOwnProperty.call(message, "BidTimeStamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.BidTimeStamp);
        if (message.OfferTimeStamp != null && Object.hasOwnProperty.call(message, "OfferTimeStamp"))
            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.OfferTimeStamp);
        return writer;
    };

    /**
     * Encodes the specified SpotQuote message, length delimited. Does not implicitly {@link SpotQuote.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SpotQuote
     * @static
     * @param {ISpotQuote} message SpotQuote message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuote.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpotQuote message from the specified reader or buffer.
     * @function decode
     * @memberof SpotQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpotQuote} SpotQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuote.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpotQuote();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.AskPrice = $root.Price.decode(reader, reader.uint32());
                break;
            case 2:
                message.BidPrice = $root.Price.decode(reader, reader.uint32());
                break;
            case 3:
                message.Spread = $root.Point.decode(reader, reader.uint32());
                break;
            case 4:
                message.BidTimeStamp = reader.int64();
                break;
            case 5:
                message.OfferTimeStamp = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SpotQuote message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SpotQuote
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SpotQuote} SpotQuote
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuote.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpotQuote message.
     * @function verify
     * @memberof SpotQuote
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpotQuote.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.AskPrice != null && message.hasOwnProperty("AskPrice")) {
            var error = $root.Price.verify(message.AskPrice);
            if (error)
                return "AskPrice." + error;
        }
        if (message.BidPrice != null && message.hasOwnProperty("BidPrice")) {
            var error = $root.Price.verify(message.BidPrice);
            if (error)
                return "BidPrice." + error;
        }
        if (message.Spread != null && message.hasOwnProperty("Spread")) {
            var error = $root.Point.verify(message.Spread);
            if (error)
                return "Spread." + error;
        }
        if (message.BidTimeStamp != null && message.hasOwnProperty("BidTimeStamp"))
            if (!$util.isInteger(message.BidTimeStamp) && !(message.BidTimeStamp && $util.isInteger(message.BidTimeStamp.low) && $util.isInteger(message.BidTimeStamp.high)))
                return "BidTimeStamp: integer|Long expected";
        if (message.OfferTimeStamp != null && message.hasOwnProperty("OfferTimeStamp"))
            if (!$util.isInteger(message.OfferTimeStamp) && !(message.OfferTimeStamp && $util.isInteger(message.OfferTimeStamp.low) && $util.isInteger(message.OfferTimeStamp.high)))
                return "OfferTimeStamp: integer|Long expected";
        return null;
    };

    /**
     * Creates a SpotQuote message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpotQuote
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpotQuote} SpotQuote
     */
    SpotQuote.fromObject = function fromObject(object) {
        if (object instanceof $root.SpotQuote)
            return object;
        var message = new $root.SpotQuote();
        if (object.AskPrice != null) {
            if (typeof object.AskPrice !== "object")
                throw TypeError(".SpotQuote.AskPrice: object expected");
            message.AskPrice = $root.Price.fromObject(object.AskPrice);
        }
        if (object.BidPrice != null) {
            if (typeof object.BidPrice !== "object")
                throw TypeError(".SpotQuote.BidPrice: object expected");
            message.BidPrice = $root.Price.fromObject(object.BidPrice);
        }
        if (object.Spread != null) {
            if (typeof object.Spread !== "object")
                throw TypeError(".SpotQuote.Spread: object expected");
            message.Spread = $root.Point.fromObject(object.Spread);
        }
        if (object.BidTimeStamp != null)
            if ($util.Long)
                (message.BidTimeStamp = $util.Long.fromValue(object.BidTimeStamp)).unsigned = false;
            else if (typeof object.BidTimeStamp === "string")
                message.BidTimeStamp = parseInt(object.BidTimeStamp, 10);
            else if (typeof object.BidTimeStamp === "number")
                message.BidTimeStamp = object.BidTimeStamp;
            else if (typeof object.BidTimeStamp === "object")
                message.BidTimeStamp = new $util.LongBits(object.BidTimeStamp.low >>> 0, object.BidTimeStamp.high >>> 0).toNumber();
        if (object.OfferTimeStamp != null)
            if ($util.Long)
                (message.OfferTimeStamp = $util.Long.fromValue(object.OfferTimeStamp)).unsigned = false;
            else if (typeof object.OfferTimeStamp === "string")
                message.OfferTimeStamp = parseInt(object.OfferTimeStamp, 10);
            else if (typeof object.OfferTimeStamp === "number")
                message.OfferTimeStamp = object.OfferTimeStamp;
            else if (typeof object.OfferTimeStamp === "object")
                message.OfferTimeStamp = new $util.LongBits(object.OfferTimeStamp.low >>> 0, object.OfferTimeStamp.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a SpotQuote message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpotQuote
     * @static
     * @param {SpotQuote} message SpotQuote
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpotQuote.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.AskPrice = null;
            object.BidPrice = null;
            object.Spread = null;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.BidTimeStamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.BidTimeStamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.OfferTimeStamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.OfferTimeStamp = options.longs === String ? "0" : 0;
        }
        if (message.AskPrice != null && message.hasOwnProperty("AskPrice"))
            object.AskPrice = $root.Price.toObject(message.AskPrice, options);
        if (message.BidPrice != null && message.hasOwnProperty("BidPrice"))
            object.BidPrice = $root.Price.toObject(message.BidPrice, options);
        if (message.Spread != null && message.hasOwnProperty("Spread"))
            object.Spread = $root.Point.toObject(message.Spread, options);
        if (message.BidTimeStamp != null && message.hasOwnProperty("BidTimeStamp"))
            if (typeof message.BidTimeStamp === "number")
                object.BidTimeStamp = options.longs === String ? String(message.BidTimeStamp) : message.BidTimeStamp;
            else
                object.BidTimeStamp = options.longs === String ? $util.Long.prototype.toString.call(message.BidTimeStamp) : options.longs === Number ? new $util.LongBits(message.BidTimeStamp.low >>> 0, message.BidTimeStamp.high >>> 0).toNumber() : message.BidTimeStamp;
        if (message.OfferTimeStamp != null && message.hasOwnProperty("OfferTimeStamp"))
            if (typeof message.OfferTimeStamp === "number")
                object.OfferTimeStamp = options.longs === String ? String(message.OfferTimeStamp) : message.OfferTimeStamp;
            else
                object.OfferTimeStamp = options.longs === String ? $util.Long.prototype.toString.call(message.OfferTimeStamp) : options.longs === Number ? new $util.LongBits(message.OfferTimeStamp.low >>> 0, message.OfferTimeStamp.high >>> 0).toNumber() : message.OfferTimeStamp;
        return object;
    };

    /**
     * Converts this SpotQuote to JSON.
     * @function toJSON
     * @memberof SpotQuote
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpotQuote.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpotQuote;
})();

$root.SpotQuoteResponse = (function() {

    /**
     * Properties of a SpotQuoteResponse.
     * @exports ISpotQuoteResponse
     * @interface ISpotQuoteResponse
     * @property {Array.<ISpotQuote>|null} [SpotQuotes] SpotQuoteResponse SpotQuotes
     */

    /**
     * Constructs a new SpotQuoteResponse.
     * @exports SpotQuoteResponse
     * @classdesc Represents a SpotQuoteResponse.
     * @implements ISpotQuoteResponse
     * @constructor
     * @param {ISpotQuoteResponse=} [properties] Properties to set
     */
    function SpotQuoteResponse(properties) {
        this.SpotQuotes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SpotQuoteResponse SpotQuotes.
     * @member {Array.<ISpotQuote>} SpotQuotes
     * @memberof SpotQuoteResponse
     * @instance
     */
    SpotQuoteResponse.prototype.SpotQuotes = $util.emptyArray;

    /**
     * Creates a new SpotQuoteResponse instance using the specified properties.
     * @function create
     * @memberof SpotQuoteResponse
     * @static
     * @param {ISpotQuoteResponse=} [properties] Properties to set
     * @returns {SpotQuoteResponse} SpotQuoteResponse instance
     */
    SpotQuoteResponse.create = function create(properties) {
        return new SpotQuoteResponse(properties);
    };

    /**
     * Encodes the specified SpotQuoteResponse message. Does not implicitly {@link SpotQuoteResponse.verify|verify} messages.
     * @function encode
     * @memberof SpotQuoteResponse
     * @static
     * @param {ISpotQuoteResponse} message SpotQuoteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuoteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SpotQuotes != null && message.SpotQuotes.length)
            for (var i = 0; i < message.SpotQuotes.length; ++i)
                $root.SpotQuote.encode(message.SpotQuotes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SpotQuoteResponse message, length delimited. Does not implicitly {@link SpotQuoteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SpotQuoteResponse
     * @static
     * @param {ISpotQuoteResponse} message SpotQuoteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SpotQuoteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SpotQuoteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof SpotQuoteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SpotQuoteResponse} SpotQuoteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuoteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SpotQuoteResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.SpotQuotes && message.SpotQuotes.length))
                    message.SpotQuotes = [];
                message.SpotQuotes.push($root.SpotQuote.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SpotQuoteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SpotQuoteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SpotQuoteResponse} SpotQuoteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SpotQuoteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SpotQuoteResponse message.
     * @function verify
     * @memberof SpotQuoteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SpotQuoteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SpotQuotes != null && message.hasOwnProperty("SpotQuotes")) {
            if (!Array.isArray(message.SpotQuotes))
                return "SpotQuotes: array expected";
            for (var i = 0; i < message.SpotQuotes.length; ++i) {
                var error = $root.SpotQuote.verify(message.SpotQuotes[i]);
                if (error)
                    return "SpotQuotes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SpotQuoteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SpotQuoteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SpotQuoteResponse} SpotQuoteResponse
     */
    SpotQuoteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SpotQuoteResponse)
            return object;
        var message = new $root.SpotQuoteResponse();
        if (object.SpotQuotes) {
            if (!Array.isArray(object.SpotQuotes))
                throw TypeError(".SpotQuoteResponse.SpotQuotes: array expected");
            message.SpotQuotes = [];
            for (var i = 0; i < object.SpotQuotes.length; ++i) {
                if (typeof object.SpotQuotes[i] !== "object")
                    throw TypeError(".SpotQuoteResponse.SpotQuotes: object expected");
                message.SpotQuotes[i] = $root.SpotQuote.fromObject(object.SpotQuotes[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SpotQuoteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SpotQuoteResponse
     * @static
     * @param {SpotQuoteResponse} message SpotQuoteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SpotQuoteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.SpotQuotes = [];
        if (message.SpotQuotes && message.SpotQuotes.length) {
            object.SpotQuotes = [];
            for (var j = 0; j < message.SpotQuotes.length; ++j)
                object.SpotQuotes[j] = $root.SpotQuote.toObject(message.SpotQuotes[j], options);
        }
        return object;
    };

    /**
     * Converts this SpotQuoteResponse to JSON.
     * @function toJSON
     * @memberof SpotQuoteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SpotQuoteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SpotQuoteResponse;
})();

$root.TenorResolveRequest = (function() {

    /**
     * Properties of a TenorResolveRequest.
     * @exports ITenorResolveRequest
     * @interface ITenorResolveRequest
     * @property {Array.<ITenor>|null} [Tenors] TenorResolveRequest Tenors
     */

    /**
     * Constructs a new TenorResolveRequest.
     * @exports TenorResolveRequest
     * @classdesc Represents a TenorResolveRequest.
     * @implements ITenorResolveRequest
     * @constructor
     * @param {ITenorResolveRequest=} [properties] Properties to set
     */
    function TenorResolveRequest(properties) {
        this.Tenors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TenorResolveRequest Tenors.
     * @member {Array.<ITenor>} Tenors
     * @memberof TenorResolveRequest
     * @instance
     */
    TenorResolveRequest.prototype.Tenors = $util.emptyArray;

    /**
     * Creates a new TenorResolveRequest instance using the specified properties.
     * @function create
     * @memberof TenorResolveRequest
     * @static
     * @param {ITenorResolveRequest=} [properties] Properties to set
     * @returns {TenorResolveRequest} TenorResolveRequest instance
     */
    TenorResolveRequest.create = function create(properties) {
        return new TenorResolveRequest(properties);
    };

    /**
     * Encodes the specified TenorResolveRequest message. Does not implicitly {@link TenorResolveRequest.verify|verify} messages.
     * @function encode
     * @memberof TenorResolveRequest
     * @static
     * @param {ITenorResolveRequest} message TenorResolveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TenorResolveRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Tenors != null && message.Tenors.length)
            for (var i = 0; i < message.Tenors.length; ++i)
                $root.Tenor.encode(message.Tenors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TenorResolveRequest message, length delimited. Does not implicitly {@link TenorResolveRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TenorResolveRequest
     * @static
     * @param {ITenorResolveRequest} message TenorResolveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TenorResolveRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TenorResolveRequest message from the specified reader or buffer.
     * @function decode
     * @memberof TenorResolveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TenorResolveRequest} TenorResolveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TenorResolveRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TenorResolveRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Tenors && message.Tenors.length))
                    message.Tenors = [];
                message.Tenors.push($root.Tenor.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TenorResolveRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TenorResolveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TenorResolveRequest} TenorResolveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TenorResolveRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TenorResolveRequest message.
     * @function verify
     * @memberof TenorResolveRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TenorResolveRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Tenors != null && message.hasOwnProperty("Tenors")) {
            if (!Array.isArray(message.Tenors))
                return "Tenors: array expected";
            for (var i = 0; i < message.Tenors.length; ++i) {
                var error = $root.Tenor.verify(message.Tenors[i]);
                if (error)
                    return "Tenors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TenorResolveRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TenorResolveRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TenorResolveRequest} TenorResolveRequest
     */
    TenorResolveRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TenorResolveRequest)
            return object;
        var message = new $root.TenorResolveRequest();
        if (object.Tenors) {
            if (!Array.isArray(object.Tenors))
                throw TypeError(".TenorResolveRequest.Tenors: array expected");
            message.Tenors = [];
            for (var i = 0; i < object.Tenors.length; ++i) {
                if (typeof object.Tenors[i] !== "object")
                    throw TypeError(".TenorResolveRequest.Tenors: object expected");
                message.Tenors[i] = $root.Tenor.fromObject(object.Tenors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TenorResolveRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TenorResolveRequest
     * @static
     * @param {TenorResolveRequest} message TenorResolveRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TenorResolveRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Tenors = [];
        if (message.Tenors && message.Tenors.length) {
            object.Tenors = [];
            for (var j = 0; j < message.Tenors.length; ++j)
                object.Tenors[j] = $root.Tenor.toObject(message.Tenors[j], options);
        }
        return object;
    };

    /**
     * Converts this TenorResolveRequest to JSON.
     * @function toJSON
     * @memberof TenorResolveRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TenorResolveRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TenorResolveRequest;
})();

$root.TenorResolveResponse = (function() {

    /**
     * Properties of a TenorResolveResponse.
     * @exports ITenorResolveResponse
     * @interface ITenorResolveResponse
     * @property {Array.<ITenor>|null} [Tenors] TenorResolveResponse Tenors
     */

    /**
     * Constructs a new TenorResolveResponse.
     * @exports TenorResolveResponse
     * @classdesc Represents a TenorResolveResponse.
     * @implements ITenorResolveResponse
     * @constructor
     * @param {ITenorResolveResponse=} [properties] Properties to set
     */
    function TenorResolveResponse(properties) {
        this.Tenors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TenorResolveResponse Tenors.
     * @member {Array.<ITenor>} Tenors
     * @memberof TenorResolveResponse
     * @instance
     */
    TenorResolveResponse.prototype.Tenors = $util.emptyArray;

    /**
     * Creates a new TenorResolveResponse instance using the specified properties.
     * @function create
     * @memberof TenorResolveResponse
     * @static
     * @param {ITenorResolveResponse=} [properties] Properties to set
     * @returns {TenorResolveResponse} TenorResolveResponse instance
     */
    TenorResolveResponse.create = function create(properties) {
        return new TenorResolveResponse(properties);
    };

    /**
     * Encodes the specified TenorResolveResponse message. Does not implicitly {@link TenorResolveResponse.verify|verify} messages.
     * @function encode
     * @memberof TenorResolveResponse
     * @static
     * @param {ITenorResolveResponse} message TenorResolveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TenorResolveResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Tenors != null && message.Tenors.length)
            for (var i = 0; i < message.Tenors.length; ++i)
                $root.Tenor.encode(message.Tenors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TenorResolveResponse message, length delimited. Does not implicitly {@link TenorResolveResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TenorResolveResponse
     * @static
     * @param {ITenorResolveResponse} message TenorResolveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TenorResolveResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TenorResolveResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TenorResolveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TenorResolveResponse} TenorResolveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TenorResolveResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TenorResolveResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Tenors && message.Tenors.length))
                    message.Tenors = [];
                message.Tenors.push($root.Tenor.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TenorResolveResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TenorResolveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TenorResolveResponse} TenorResolveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TenorResolveResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TenorResolveResponse message.
     * @function verify
     * @memberof TenorResolveResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TenorResolveResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Tenors != null && message.hasOwnProperty("Tenors")) {
            if (!Array.isArray(message.Tenors))
                return "Tenors: array expected";
            for (var i = 0; i < message.Tenors.length; ++i) {
                var error = $root.Tenor.verify(message.Tenors[i]);
                if (error)
                    return "Tenors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TenorResolveResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TenorResolveResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TenorResolveResponse} TenorResolveResponse
     */
    TenorResolveResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TenorResolveResponse)
            return object;
        var message = new $root.TenorResolveResponse();
        if (object.Tenors) {
            if (!Array.isArray(object.Tenors))
                throw TypeError(".TenorResolveResponse.Tenors: array expected");
            message.Tenors = [];
            for (var i = 0; i < object.Tenors.length; ++i) {
                if (typeof object.Tenors[i] !== "object")
                    throw TypeError(".TenorResolveResponse.Tenors: object expected");
                message.Tenors[i] = $root.Tenor.fromObject(object.Tenors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TenorResolveResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TenorResolveResponse
     * @static
     * @param {TenorResolveResponse} message TenorResolveResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TenorResolveResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Tenors = [];
        if (message.Tenors && message.Tenors.length) {
            object.Tenors = [];
            for (var j = 0; j < message.Tenors.length; ++j)
                object.Tenors[j] = $root.Tenor.toObject(message.Tenors[j], options);
        }
        return object;
    };

    /**
     * Converts this TenorResolveResponse to JSON.
     * @function toJSON
     * @memberof TenorResolveResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TenorResolveResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TenorResolveResponse;
})();

$root.Tenor = (function() {

    /**
     * Properties of a Tenor.
     * @exports ITenor
     * @interface ITenor
     * @property {string|null} [Instrument] Tenor Instrument
     * @property {string|null} [Tenor] Tenor Tenor
     * @property {string|null} [Date] Tenor Date
     */

    /**
     * Constructs a new Tenor.
     * @exports Tenor
     * @classdesc Represents a Tenor.
     * @implements ITenor
     * @constructor
     * @param {ITenor=} [properties] Properties to set
     */
    function Tenor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Tenor Instrument.
     * @member {string} Instrument
     * @memberof Tenor
     * @instance
     */
    Tenor.prototype.Instrument = "";

    /**
     * Tenor Tenor.
     * @member {string} Tenor
     * @memberof Tenor
     * @instance
     */
    Tenor.prototype.Tenor = "";

    /**
     * Tenor Date.
     * @member {string} Date
     * @memberof Tenor
     * @instance
     */
    Tenor.prototype.Date = "";

    /**
     * Creates a new Tenor instance using the specified properties.
     * @function create
     * @memberof Tenor
     * @static
     * @param {ITenor=} [properties] Properties to set
     * @returns {Tenor} Tenor instance
     */
    Tenor.create = function create(properties) {
        return new Tenor(properties);
    };

    /**
     * Encodes the specified Tenor message. Does not implicitly {@link Tenor.verify|verify} messages.
     * @function encode
     * @memberof Tenor
     * @static
     * @param {ITenor} message Tenor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tenor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Instrument != null && Object.hasOwnProperty.call(message, "Instrument"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Instrument);
        if (message.Tenor != null && Object.hasOwnProperty.call(message, "Tenor"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Tenor);
        if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Date);
        return writer;
    };

    /**
     * Encodes the specified Tenor message, length delimited. Does not implicitly {@link Tenor.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Tenor
     * @static
     * @param {ITenor} message Tenor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tenor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Tenor message from the specified reader or buffer.
     * @function decode
     * @memberof Tenor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Tenor} Tenor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tenor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Tenor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Instrument = reader.string();
                break;
            case 2:
                message.Tenor = reader.string();
                break;
            case 3:
                message.Date = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Tenor message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Tenor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Tenor} Tenor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tenor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Tenor message.
     * @function verify
     * @memberof Tenor
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Tenor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            if (!$util.isString(message.Instrument))
                return "Instrument: string expected";
        if (message.Tenor != null && message.hasOwnProperty("Tenor"))
            if (!$util.isString(message.Tenor))
                return "Tenor: string expected";
        if (message.Date != null && message.hasOwnProperty("Date"))
            if (!$util.isString(message.Date))
                return "Date: string expected";
        return null;
    };

    /**
     * Creates a Tenor message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Tenor
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Tenor} Tenor
     */
    Tenor.fromObject = function fromObject(object) {
        if (object instanceof $root.Tenor)
            return object;
        var message = new $root.Tenor();
        if (object.Instrument != null)
            message.Instrument = String(object.Instrument);
        if (object.Tenor != null)
            message.Tenor = String(object.Tenor);
        if (object.Date != null)
            message.Date = String(object.Date);
        return message;
    };

    /**
     * Creates a plain object from a Tenor message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Tenor
     * @static
     * @param {Tenor} message Tenor
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Tenor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Instrument = "";
            object.Tenor = "";
            object.Date = "";
        }
        if (message.Instrument != null && message.hasOwnProperty("Instrument"))
            object.Instrument = message.Instrument;
        if (message.Tenor != null && message.hasOwnProperty("Tenor"))
            object.Tenor = message.Tenor;
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = message.Date;
        return object;
    };

    /**
     * Converts this Tenor to JSON.
     * @function toJSON
     * @memberof Tenor
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Tenor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Tenor;
})();

$root.TradingSettingsRequest = (function() {

    /**
     * Properties of a TradingSettingsRequest.
     * @exports ITradingSettingsRequest
     * @interface ITradingSettingsRequest
     * @property {number|null} [ClientId] TradingSettingsRequest ClientId
     */

    /**
     * Constructs a new TradingSettingsRequest.
     * @exports TradingSettingsRequest
     * @classdesc Represents a TradingSettingsRequest.
     * @implements ITradingSettingsRequest
     * @constructor
     * @param {ITradingSettingsRequest=} [properties] Properties to set
     */
    function TradingSettingsRequest(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TradingSettingsRequest ClientId.
     * @member {number} ClientId
     * @memberof TradingSettingsRequest
     * @instance
     */
    TradingSettingsRequest.prototype.ClientId = 0;

    /**
     * Creates a new TradingSettingsRequest instance using the specified properties.
     * @function create
     * @memberof TradingSettingsRequest
     * @static
     * @param {ITradingSettingsRequest=} [properties] Properties to set
     * @returns {TradingSettingsRequest} TradingSettingsRequest instance
     */
    TradingSettingsRequest.create = function create(properties) {
        return new TradingSettingsRequest(properties);
    };

    /**
     * Encodes the specified TradingSettingsRequest message. Does not implicitly {@link TradingSettingsRequest.verify|verify} messages.
     * @function encode
     * @memberof TradingSettingsRequest
     * @static
     * @param {ITradingSettingsRequest} message TradingSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradingSettingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClientId != null && Object.hasOwnProperty.call(message, "ClientId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClientId);
        return writer;
    };

    /**
     * Encodes the specified TradingSettingsRequest message, length delimited. Does not implicitly {@link TradingSettingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TradingSettingsRequest
     * @static
     * @param {ITradingSettingsRequest} message TradingSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradingSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TradingSettingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof TradingSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TradingSettingsRequest} TradingSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradingSettingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TradingSettingsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClientId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TradingSettingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TradingSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TradingSettingsRequest} TradingSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradingSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TradingSettingsRequest message.
     * @function verify
     * @memberof TradingSettingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TradingSettingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            if (!$util.isInteger(message.ClientId))
                return "ClientId: integer expected";
        return null;
    };

    /**
     * Creates a TradingSettingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TradingSettingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TradingSettingsRequest} TradingSettingsRequest
     */
    TradingSettingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.TradingSettingsRequest)
            return object;
        var message = new $root.TradingSettingsRequest();
        if (object.ClientId != null)
            message.ClientId = object.ClientId | 0;
        return message;
    };

    /**
     * Creates a plain object from a TradingSettingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TradingSettingsRequest
     * @static
     * @param {TradingSettingsRequest} message TradingSettingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TradingSettingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.ClientId = 0;
        if (message.ClientId != null && message.hasOwnProperty("ClientId"))
            object.ClientId = message.ClientId;
        return object;
    };

    /**
     * Converts this TradingSettingsRequest to JSON.
     * @function toJSON
     * @memberof TradingSettingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TradingSettingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TradingSettingsRequest;
})();

$root.TradingSettingsResponse = (function() {

    /**
     * Properties of a TradingSettingsResponse.
     * @exports ITradingSettingsResponse
     * @interface ITradingSettingsResponse
     * @property {ClickMode|null} [ClickMode] TradingSettingsResponse ClickMode
     * @property {boolean|null} [TradingEnabled] TradingSettingsResponse TradingEnabled
     * @property {Array.<OrderType>|null} [AvailableOrderTypes] TradingSettingsResponse AvailableOrderTypes
     * @property {boolean|null} [HasInHouseAttached] TradingSettingsResponse HasInHouseAttached
     */

    /**
     * Constructs a new TradingSettingsResponse.
     * @exports TradingSettingsResponse
     * @classdesc Represents a TradingSettingsResponse.
     * @implements ITradingSettingsResponse
     * @constructor
     * @param {ITradingSettingsResponse=} [properties] Properties to set
     */
    function TradingSettingsResponse(properties) {
        this.AvailableOrderTypes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TradingSettingsResponse ClickMode.
     * @member {ClickMode} ClickMode
     * @memberof TradingSettingsResponse
     * @instance
     */
    TradingSettingsResponse.prototype.ClickMode = 0;

    /**
     * TradingSettingsResponse TradingEnabled.
     * @member {boolean} TradingEnabled
     * @memberof TradingSettingsResponse
     * @instance
     */
    TradingSettingsResponse.prototype.TradingEnabled = false;

    /**
     * TradingSettingsResponse AvailableOrderTypes.
     * @member {Array.<OrderType>} AvailableOrderTypes
     * @memberof TradingSettingsResponse
     * @instance
     */
    TradingSettingsResponse.prototype.AvailableOrderTypes = $util.emptyArray;

    /**
     * TradingSettingsResponse HasInHouseAttached.
     * @member {boolean} HasInHouseAttached
     * @memberof TradingSettingsResponse
     * @instance
     */
    TradingSettingsResponse.prototype.HasInHouseAttached = false;

    /**
     * Creates a new TradingSettingsResponse instance using the specified properties.
     * @function create
     * @memberof TradingSettingsResponse
     * @static
     * @param {ITradingSettingsResponse=} [properties] Properties to set
     * @returns {TradingSettingsResponse} TradingSettingsResponse instance
     */
    TradingSettingsResponse.create = function create(properties) {
        return new TradingSettingsResponse(properties);
    };

    /**
     * Encodes the specified TradingSettingsResponse message. Does not implicitly {@link TradingSettingsResponse.verify|verify} messages.
     * @function encode
     * @memberof TradingSettingsResponse
     * @static
     * @param {ITradingSettingsResponse} message TradingSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradingSettingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ClickMode != null && Object.hasOwnProperty.call(message, "ClickMode"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ClickMode);
        if (message.TradingEnabled != null && Object.hasOwnProperty.call(message, "TradingEnabled"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.TradingEnabled);
        if (message.AvailableOrderTypes != null && message.AvailableOrderTypes.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (var i = 0; i < message.AvailableOrderTypes.length; ++i)
                writer.int32(message.AvailableOrderTypes[i]);
            writer.ldelim();
        }
        if (message.HasInHouseAttached != null && Object.hasOwnProperty.call(message, "HasInHouseAttached"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.HasInHouseAttached);
        return writer;
    };

    /**
     * Encodes the specified TradingSettingsResponse message, length delimited. Does not implicitly {@link TradingSettingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TradingSettingsResponse
     * @static
     * @param {ITradingSettingsResponse} message TradingSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TradingSettingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TradingSettingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TradingSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TradingSettingsResponse} TradingSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradingSettingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TradingSettingsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ClickMode = reader.int32();
                break;
            case 2:
                message.TradingEnabled = reader.bool();
                break;
            case 3:
                if (!(message.AvailableOrderTypes && message.AvailableOrderTypes.length))
                    message.AvailableOrderTypes = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.AvailableOrderTypes.push(reader.int32());
                } else
                    message.AvailableOrderTypes.push(reader.int32());
                break;
            case 4:
                message.HasInHouseAttached = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TradingSettingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TradingSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TradingSettingsResponse} TradingSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TradingSettingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TradingSettingsResponse message.
     * @function verify
     * @memberof TradingSettingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TradingSettingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ClickMode != null && message.hasOwnProperty("ClickMode"))
            switch (message.ClickMode) {
            default:
                return "ClickMode: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.TradingEnabled != null && message.hasOwnProperty("TradingEnabled"))
            if (typeof message.TradingEnabled !== "boolean")
                return "TradingEnabled: boolean expected";
        if (message.AvailableOrderTypes != null && message.hasOwnProperty("AvailableOrderTypes")) {
            if (!Array.isArray(message.AvailableOrderTypes))
                return "AvailableOrderTypes: array expected";
            for (var i = 0; i < message.AvailableOrderTypes.length; ++i)
                switch (message.AvailableOrderTypes[i]) {
                default:
                    return "AvailableOrderTypes: enum value[] expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
        }
        if (message.HasInHouseAttached != null && message.hasOwnProperty("HasInHouseAttached"))
            if (typeof message.HasInHouseAttached !== "boolean")
                return "HasInHouseAttached: boolean expected";
        return null;
    };

    /**
     * Creates a TradingSettingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TradingSettingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TradingSettingsResponse} TradingSettingsResponse
     */
    TradingSettingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TradingSettingsResponse)
            return object;
        var message = new $root.TradingSettingsResponse();
        switch (object.ClickMode) {
        case "CLICKMODE_FREE":
        case 0:
            message.ClickMode = 0;
            break;
        case "CLICKMODE_SINGLE":
        case 1:
            message.ClickMode = 1;
            break;
        case "CLICKMODE_CONFIRM":
        case 2:
            message.ClickMode = 2;
            break;
        }
        if (object.TradingEnabled != null)
            message.TradingEnabled = Boolean(object.TradingEnabled);
        if (object.AvailableOrderTypes) {
            if (!Array.isArray(object.AvailableOrderTypes))
                throw TypeError(".TradingSettingsResponse.AvailableOrderTypes: array expected");
            message.AvailableOrderTypes = [];
            for (var i = 0; i < object.AvailableOrderTypes.length; ++i)
                switch (object.AvailableOrderTypes[i]) {
                default:
                case "ORDERTYPE_MARKET":
                case 0:
                    message.AvailableOrderTypes[i] = 0;
                    break;
                case "ORDERTYPE_FULL":
                case 1:
                    message.AvailableOrderTypes[i] = 1;
                    break;
                case "ORDERTYPE_IOC":
                case 2:
                    message.AvailableOrderTypes[i] = 2;
                    break;
                case "ORDERTYPE_LIMIT":
                case 3:
                    message.AvailableOrderTypes[i] = 3;
                    break;
                case "ORDERTYPE_STOP":
                case 4:
                    message.AvailableOrderTypes[i] = 4;
                    break;
                case "ORDERTYPE_IF_DONE":
                case 5:
                    message.AvailableOrderTypes[i] = 5;
                    break;
                case "ORDERTYPE_OCO":
                case 6:
                    message.AvailableOrderTypes[i] = 6;
                    break;
                }
        }
        if (object.HasInHouseAttached != null)
            message.HasInHouseAttached = Boolean(object.HasInHouseAttached);
        return message;
    };

    /**
     * Creates a plain object from a TradingSettingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TradingSettingsResponse
     * @static
     * @param {TradingSettingsResponse} message TradingSettingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TradingSettingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.AvailableOrderTypes = [];
        if (options.defaults) {
            object.ClickMode = options.enums === String ? "CLICKMODE_FREE" : 0;
            object.TradingEnabled = false;
            object.HasInHouseAttached = false;
        }
        if (message.ClickMode != null && message.hasOwnProperty("ClickMode"))
            object.ClickMode = options.enums === String ? $root.ClickMode[message.ClickMode] : message.ClickMode;
        if (message.TradingEnabled != null && message.hasOwnProperty("TradingEnabled"))
            object.TradingEnabled = message.TradingEnabled;
        if (message.AvailableOrderTypes && message.AvailableOrderTypes.length) {
            object.AvailableOrderTypes = [];
            for (var j = 0; j < message.AvailableOrderTypes.length; ++j)
                object.AvailableOrderTypes[j] = options.enums === String ? $root.OrderType[message.AvailableOrderTypes[j]] : message.AvailableOrderTypes[j];
        }
        if (message.HasInHouseAttached != null && message.hasOwnProperty("HasInHouseAttached"))
            object.HasInHouseAttached = message.HasInHouseAttached;
        return object;
    };

    /**
     * Converts this TradingSettingsResponse to JSON.
     * @function toJSON
     * @memberof TradingSettingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TradingSettingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TradingSettingsResponse;
})();

$root.UserSettingsRequest = (function() {

    /**
     * Properties of a UserSettingsRequest.
     * @exports IUserSettingsRequest
     * @interface IUserSettingsRequest
     * @property {Array.<string>|null} [Keys] UserSettingsRequest Keys
     */

    /**
     * Constructs a new UserSettingsRequest.
     * @exports UserSettingsRequest
     * @classdesc Represents a UserSettingsRequest.
     * @implements IUserSettingsRequest
     * @constructor
     * @param {IUserSettingsRequest=} [properties] Properties to set
     */
    function UserSettingsRequest(properties) {
        this.Keys = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserSettingsRequest Keys.
     * @member {Array.<string>} Keys
     * @memberof UserSettingsRequest
     * @instance
     */
    UserSettingsRequest.prototype.Keys = $util.emptyArray;

    /**
     * Creates a new UserSettingsRequest instance using the specified properties.
     * @function create
     * @memberof UserSettingsRequest
     * @static
     * @param {IUserSettingsRequest=} [properties] Properties to set
     * @returns {UserSettingsRequest} UserSettingsRequest instance
     */
    UserSettingsRequest.create = function create(properties) {
        return new UserSettingsRequest(properties);
    };

    /**
     * Encodes the specified UserSettingsRequest message. Does not implicitly {@link UserSettingsRequest.verify|verify} messages.
     * @function encode
     * @memberof UserSettingsRequest
     * @static
     * @param {IUserSettingsRequest} message UserSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Keys != null && message.Keys.length)
            for (var i = 0; i < message.Keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Keys[i]);
        return writer;
    };

    /**
     * Encodes the specified UserSettingsRequest message, length delimited. Does not implicitly {@link UserSettingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserSettingsRequest
     * @static
     * @param {IUserSettingsRequest} message UserSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserSettingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UserSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserSettingsRequest} UserSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserSettingsRequest();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Keys && message.Keys.length))
                    message.Keys = [];
                message.Keys.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserSettingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserSettingsRequest} UserSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserSettingsRequest message.
     * @function verify
     * @memberof UserSettingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserSettingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Keys != null && message.hasOwnProperty("Keys")) {
            if (!Array.isArray(message.Keys))
                return "Keys: array expected";
            for (var i = 0; i < message.Keys.length; ++i)
                if (!$util.isString(message.Keys[i]))
                    return "Keys: string[] expected";
        }
        return null;
    };

    /**
     * Creates a UserSettingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserSettingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserSettingsRequest} UserSettingsRequest
     */
    UserSettingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UserSettingsRequest)
            return object;
        var message = new $root.UserSettingsRequest();
        if (object.Keys) {
            if (!Array.isArray(object.Keys))
                throw TypeError(".UserSettingsRequest.Keys: array expected");
            message.Keys = [];
            for (var i = 0; i < object.Keys.length; ++i)
                message.Keys[i] = String(object.Keys[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a UserSettingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserSettingsRequest
     * @static
     * @param {UserSettingsRequest} message UserSettingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserSettingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Keys = [];
        if (message.Keys && message.Keys.length) {
            object.Keys = [];
            for (var j = 0; j < message.Keys.length; ++j)
                object.Keys[j] = message.Keys[j];
        }
        return object;
    };

    /**
     * Converts this UserSettingsRequest to JSON.
     * @function toJSON
     * @memberof UserSettingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserSettingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserSettingsRequest;
})();

$root.UserSettingsResponse = (function() {

    /**
     * Properties of a UserSettingsResponse.
     * @exports IUserSettingsResponse
     * @interface IUserSettingsResponse
     * @property {Object.<string,string>|null} [Items] UserSettingsResponse Items
     */

    /**
     * Constructs a new UserSettingsResponse.
     * @exports UserSettingsResponse
     * @classdesc Represents a UserSettingsResponse.
     * @implements IUserSettingsResponse
     * @constructor
     * @param {IUserSettingsResponse=} [properties] Properties to set
     */
    function UserSettingsResponse(properties) {
        this.Items = {};
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserSettingsResponse Items.
     * @member {Object.<string,string>} Items
     * @memberof UserSettingsResponse
     * @instance
     */
    UserSettingsResponse.prototype.Items = $util.emptyObject;

    /**
     * Creates a new UserSettingsResponse instance using the specified properties.
     * @function create
     * @memberof UserSettingsResponse
     * @static
     * @param {IUserSettingsResponse=} [properties] Properties to set
     * @returns {UserSettingsResponse} UserSettingsResponse instance
     */
    UserSettingsResponse.create = function create(properties) {
        return new UserSettingsResponse(properties);
    };

    /**
     * Encodes the specified UserSettingsResponse message. Does not implicitly {@link UserSettingsResponse.verify|verify} messages.
     * @function encode
     * @memberof UserSettingsResponse
     * @static
     * @param {IUserSettingsResponse} message UserSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && Object.hasOwnProperty.call(message, "Items"))
            for (var keys = Object.keys(message.Items), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Items[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UserSettingsResponse message, length delimited. Does not implicitly {@link UserSettingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserSettingsResponse
     * @static
     * @param {IUserSettingsResponse} message UserSettingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserSettingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UserSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserSettingsResponse} UserSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserSettingsResponse(), key, value;
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (message.Items === $util.emptyObject)
                    message.Items = {};
                var end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                    var tag2 = reader.uint32();
                    switch (tag2 >>> 3) {
                    case 1:
                        key = reader.string();
                        break;
                    case 2:
                        value = reader.string();
                        break;
                    default:
                        reader.skipType(tag2 & 7);
                        break;
                    }
                }
                message.Items[key] = value;
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserSettingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserSettingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserSettingsResponse} UserSettingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserSettingsResponse message.
     * @function verify
     * @memberof UserSettingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserSettingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!$util.isObject(message.Items))
                return "Items: object expected";
            var key = Object.keys(message.Items);
            for (var i = 0; i < key.length; ++i)
                if (!$util.isString(message.Items[key[i]]))
                    return "Items: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a UserSettingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserSettingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserSettingsResponse} UserSettingsResponse
     */
    UserSettingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UserSettingsResponse)
            return object;
        var message = new $root.UserSettingsResponse();
        if (object.Items) {
            if (typeof object.Items !== "object")
                throw TypeError(".UserSettingsResponse.Items: object expected");
            message.Items = {};
            for (var keys = Object.keys(object.Items), i = 0; i < keys.length; ++i)
                message.Items[keys[i]] = String(object.Items[keys[i]]);
        }
        return message;
    };

    /**
     * Creates a plain object from a UserSettingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserSettingsResponse
     * @static
     * @param {UserSettingsResponse} message UserSettingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserSettingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.objects || options.defaults)
            object.Items = {};
        var keys2;
        if (message.Items && (keys2 = Object.keys(message.Items)).length) {
            object.Items = {};
            for (var j = 0; j < keys2.length; ++j)
                object.Items[keys2[j]] = message.Items[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this UserSettingsResponse to JSON.
     * @function toJSON
     * @memberof UserSettingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserSettingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserSettingsResponse;
})();

$root.UserSettingsSaveRequest = (function() {

    /**
     * Properties of a UserSettingsSaveRequest.
     * @exports IUserSettingsSaveRequest
     * @interface IUserSettingsSaveRequest
     * @property {Object.<string,string>|null} [Items] UserSettingsSaveRequest Items
     */

    /**
     * Constructs a new UserSettingsSaveRequest.
     * @exports UserSettingsSaveRequest
     * @classdesc Represents a UserSettingsSaveRequest.
     * @implements IUserSettingsSaveRequest
     * @constructor
     * @param {IUserSettingsSaveRequest=} [properties] Properties to set
     */
    function UserSettingsSaveRequest(properties) {
        this.Items = {};
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserSettingsSaveRequest Items.
     * @member {Object.<string,string>} Items
     * @memberof UserSettingsSaveRequest
     * @instance
     */
    UserSettingsSaveRequest.prototype.Items = $util.emptyObject;

    /**
     * Creates a new UserSettingsSaveRequest instance using the specified properties.
     * @function create
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {IUserSettingsSaveRequest=} [properties] Properties to set
     * @returns {UserSettingsSaveRequest} UserSettingsSaveRequest instance
     */
    UserSettingsSaveRequest.create = function create(properties) {
        return new UserSettingsSaveRequest(properties);
    };

    /**
     * Encodes the specified UserSettingsSaveRequest message. Does not implicitly {@link UserSettingsSaveRequest.verify|verify} messages.
     * @function encode
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {IUserSettingsSaveRequest} message UserSettingsSaveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsSaveRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && Object.hasOwnProperty.call(message, "Items"))
            for (var keys = Object.keys(message.Items), i = 0; i < keys.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Items[keys[i]]).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UserSettingsSaveRequest message, length delimited. Does not implicitly {@link UserSettingsSaveRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {IUserSettingsSaveRequest} message UserSettingsSaveRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsSaveRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserSettingsSaveRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserSettingsSaveRequest} UserSettingsSaveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsSaveRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserSettingsSaveRequest(), key, value;
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (message.Items === $util.emptyObject)
                    message.Items = {};
                var end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                    var tag2 = reader.uint32();
                    switch (tag2 >>> 3) {
                    case 1:
                        key = reader.string();
                        break;
                    case 2:
                        value = reader.string();
                        break;
                    default:
                        reader.skipType(tag2 & 7);
                        break;
                    }
                }
                message.Items[key] = value;
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserSettingsSaveRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserSettingsSaveRequest} UserSettingsSaveRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsSaveRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserSettingsSaveRequest message.
     * @function verify
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserSettingsSaveRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!$util.isObject(message.Items))
                return "Items: object expected";
            var key = Object.keys(message.Items);
            for (var i = 0; i < key.length; ++i)
                if (!$util.isString(message.Items[key[i]]))
                    return "Items: string{k:string} expected";
        }
        return null;
    };

    /**
     * Creates a UserSettingsSaveRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserSettingsSaveRequest} UserSettingsSaveRequest
     */
    UserSettingsSaveRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UserSettingsSaveRequest)
            return object;
        var message = new $root.UserSettingsSaveRequest();
        if (object.Items) {
            if (typeof object.Items !== "object")
                throw TypeError(".UserSettingsSaveRequest.Items: object expected");
            message.Items = {};
            for (var keys = Object.keys(object.Items), i = 0; i < keys.length; ++i)
                message.Items[keys[i]] = String(object.Items[keys[i]]);
        }
        return message;
    };

    /**
     * Creates a plain object from a UserSettingsSaveRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserSettingsSaveRequest
     * @static
     * @param {UserSettingsSaveRequest} message UserSettingsSaveRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserSettingsSaveRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.objects || options.defaults)
            object.Items = {};
        var keys2;
        if (message.Items && (keys2 = Object.keys(message.Items)).length) {
            object.Items = {};
            for (var j = 0; j < keys2.length; ++j)
                object.Items[keys2[j]] = message.Items[keys2[j]];
        }
        return object;
    };

    /**
     * Converts this UserSettingsSaveRequest to JSON.
     * @function toJSON
     * @memberof UserSettingsSaveRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserSettingsSaveRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserSettingsSaveRequest;
})();

$root.UserSettingsSaveResponse = (function() {

    /**
     * Properties of a UserSettingsSaveResponse.
     * @exports IUserSettingsSaveResponse
     * @interface IUserSettingsSaveResponse
     * @property {boolean|null} [Accepted] UserSettingsSaveResponse Accepted
     * @property {string|null} [Reason] UserSettingsSaveResponse Reason
     */

    /**
     * Constructs a new UserSettingsSaveResponse.
     * @exports UserSettingsSaveResponse
     * @classdesc Represents a UserSettingsSaveResponse.
     * @implements IUserSettingsSaveResponse
     * @constructor
     * @param {IUserSettingsSaveResponse=} [properties] Properties to set
     */
    function UserSettingsSaveResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UserSettingsSaveResponse Accepted.
     * @member {boolean} Accepted
     * @memberof UserSettingsSaveResponse
     * @instance
     */
    UserSettingsSaveResponse.prototype.Accepted = false;

    /**
     * UserSettingsSaveResponse Reason.
     * @member {string} Reason
     * @memberof UserSettingsSaveResponse
     * @instance
     */
    UserSettingsSaveResponse.prototype.Reason = "";

    /**
     * Creates a new UserSettingsSaveResponse instance using the specified properties.
     * @function create
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {IUserSettingsSaveResponse=} [properties] Properties to set
     * @returns {UserSettingsSaveResponse} UserSettingsSaveResponse instance
     */
    UserSettingsSaveResponse.create = function create(properties) {
        return new UserSettingsSaveResponse(properties);
    };

    /**
     * Encodes the specified UserSettingsSaveResponse message. Does not implicitly {@link UserSettingsSaveResponse.verify|verify} messages.
     * @function encode
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {IUserSettingsSaveResponse} message UserSettingsSaveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsSaveResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Accepted != null && Object.hasOwnProperty.call(message, "Accepted"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Accepted);
        if (message.Reason != null && Object.hasOwnProperty.call(message, "Reason"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Reason);
        return writer;
    };

    /**
     * Encodes the specified UserSettingsSaveResponse message, length delimited. Does not implicitly {@link UserSettingsSaveResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {IUserSettingsSaveResponse} message UserSettingsSaveResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UserSettingsSaveResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a UserSettingsSaveResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UserSettingsSaveResponse} UserSettingsSaveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsSaveResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserSettingsSaveResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Accepted = reader.bool();
                break;
            case 2:
                message.Reason = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a UserSettingsSaveResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UserSettingsSaveResponse} UserSettingsSaveResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UserSettingsSaveResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a UserSettingsSaveResponse message.
     * @function verify
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UserSettingsSaveResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            if (typeof message.Accepted !== "boolean")
                return "Accepted: boolean expected";
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            if (!$util.isString(message.Reason))
                return "Reason: string expected";
        return null;
    };

    /**
     * Creates a UserSettingsSaveResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UserSettingsSaveResponse} UserSettingsSaveResponse
     */
    UserSettingsSaveResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UserSettingsSaveResponse)
            return object;
        var message = new $root.UserSettingsSaveResponse();
        if (object.Accepted != null)
            message.Accepted = Boolean(object.Accepted);
        if (object.Reason != null)
            message.Reason = String(object.Reason);
        return message;
    };

    /**
     * Creates a plain object from a UserSettingsSaveResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UserSettingsSaveResponse
     * @static
     * @param {UserSettingsSaveResponse} message UserSettingsSaveResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UserSettingsSaveResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Accepted = false;
            object.Reason = "";
        }
        if (message.Accepted != null && message.hasOwnProperty("Accepted"))
            object.Accepted = message.Accepted;
        if (message.Reason != null && message.hasOwnProperty("Reason"))
            object.Reason = message.Reason;
        return object;
    };

    /**
     * Converts this UserSettingsSaveResponse to JSON.
     * @function toJSON
     * @memberof UserSettingsSaveResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UserSettingsSaveResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return UserSettingsSaveResponse;
})();



$root.FormatItem = (function() {

    /**
     * Properties of a FormatItem.
     * @exports IFormatItem
     * @interface IFormatItem
     * @property {string|null} [Key] FormatItem Key
     * @property {ValueType|null} [Type] FormatItem Type
     * @property {string|null} [Value] FormatItem Value
     */

    /**
     * Constructs a new FormatItem.
     * @exports FormatItem
     * @classdesc Represents a FormatItem.
     * @implements IFormatItem
     * @constructor
     * @param {IFormatItem=} [properties] Properties to set
     */
    function FormatItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FormatItem Key.
     * @member {string} Key
     * @memberof FormatItem
     * @instance
     */
    FormatItem.prototype.Key = "";

    /**
     * FormatItem Type.
     * @member {ValueType} Type
     * @memberof FormatItem
     * @instance
     */
    FormatItem.prototype.Type = 0;

    /**
     * FormatItem Value.
     * @member {string} Value
     * @memberof FormatItem
     * @instance
     */
    FormatItem.prototype.Value = "";

    /**
     * Creates a new FormatItem instance using the specified properties.
     * @function create
     * @memberof FormatItem
     * @static
     * @param {IFormatItem=} [properties] Properties to set
     * @returns {FormatItem} FormatItem instance
     */
    FormatItem.create = function create(properties) {
        return new FormatItem(properties);
    };

    /**
     * Encodes the specified FormatItem message. Does not implicitly {@link FormatItem.verify|verify} messages.
     * @function encode
     * @memberof FormatItem
     * @static
     * @param {IFormatItem} message FormatItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FormatItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Key != null && Object.hasOwnProperty.call(message, "Key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Key);
        if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Type);
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Value);
        return writer;
    };

    /**
     * Encodes the specified FormatItem message, length delimited. Does not implicitly {@link FormatItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FormatItem
     * @static
     * @param {IFormatItem} message FormatItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FormatItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FormatItem message from the specified reader or buffer.
     * @function decode
     * @memberof FormatItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FormatItem} FormatItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FormatItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FormatItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Key = reader.string();
                break;
            case 2:
                message.Type = reader.int32();
                break;
            case 3:
                message.Value = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FormatItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FormatItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FormatItem} FormatItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FormatItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FormatItem message.
     * @function verify
     * @memberof FormatItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FormatItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Key != null && message.hasOwnProperty("Key"))
            if (!$util.isString(message.Key))
                return "Key: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (!$util.isString(message.Value))
                return "Value: string expected";
        return null;
    };

    /**
     * Creates a FormatItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FormatItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FormatItem} FormatItem
     */
    FormatItem.fromObject = function fromObject(object) {
        if (object instanceof $root.FormatItem)
            return object;
        var message = new $root.FormatItem();
        if (object.Key != null)
            message.Key = String(object.Key);
        switch (object.Type) {
        case "VALUETYPE_DATE":
        case 0:
            message.Type = 0;
            break;
        case "VALUETYPE_PRICE":
        case 1:
            message.Type = 1;
            break;
        case "VALUETYPE_QUANTITY":
        case 2:
            message.Type = 2;
            break;
        }
        if (object.Value != null)
            message.Value = String(object.Value);
        return message;
    };

    /**
     * Creates a plain object from a FormatItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FormatItem
     * @static
     * @param {FormatItem} message FormatItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FormatItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Key = "";
            object.Type = options.enums === String ? "VALUETYPE_DATE" : 0;
            object.Value = "";
        }
        if (message.Key != null && message.hasOwnProperty("Key"))
            object.Key = message.Key;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.ValueType[message.Type] : message.Type;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = message.Value;
        return object;
    };

    /**
     * Converts this FormatItem to JSON.
     * @function toJSON
     * @memberof FormatItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FormatItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FormatItem;
})();

$root.FormattedText = (function() {

    /**
     * Properties of a FormattedText.
     * @exports IFormattedText
     * @interface IFormattedText
     * @property {string|null} [Template] FormattedText Template
     * @property {Array.<IFormatItem>|null} [Items] FormattedText Items
     */

    /**
     * Constructs a new FormattedText.
     * @exports FormattedText
     * @classdesc Represents a FormattedText.
     * @implements IFormattedText
     * @constructor
     * @param {IFormattedText=} [properties] Properties to set
     */
    function FormattedText(properties) {
        this.Items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FormattedText Template.
     * @member {string} Template
     * @memberof FormattedText
     * @instance
     */
    FormattedText.prototype.Template = "";

    /**
     * FormattedText Items.
     * @member {Array.<IFormatItem>} Items
     * @memberof FormattedText
     * @instance
     */
    FormattedText.prototype.Items = $util.emptyArray;

    /**
     * Creates a new FormattedText instance using the specified properties.
     * @function create
     * @memberof FormattedText
     * @static
     * @param {IFormattedText=} [properties] Properties to set
     * @returns {FormattedText} FormattedText instance
     */
    FormattedText.create = function create(properties) {
        return new FormattedText(properties);
    };

    /**
     * Encodes the specified FormattedText message. Does not implicitly {@link FormattedText.verify|verify} messages.
     * @function encode
     * @memberof FormattedText
     * @static
     * @param {IFormattedText} message FormattedText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FormattedText.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Template != null && Object.hasOwnProperty.call(message, "Template"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Template);
        if (message.Items != null && message.Items.length)
            for (var i = 0; i < message.Items.length; ++i)
                $root.FormatItem.encode(message.Items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FormattedText message, length delimited. Does not implicitly {@link FormattedText.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FormattedText
     * @static
     * @param {IFormattedText} message FormattedText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FormattedText.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FormattedText message from the specified reader or buffer.
     * @function decode
     * @memberof FormattedText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FormattedText} FormattedText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FormattedText.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FormattedText();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Template = reader.string();
                break;
            case 2:
                if (!(message.Items && message.Items.length))
                    message.Items = [];
                message.Items.push($root.FormatItem.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FormattedText message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FormattedText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FormattedText} FormattedText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FormattedText.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FormattedText message.
     * @function verify
     * @memberof FormattedText
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FormattedText.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Template != null && message.hasOwnProperty("Template"))
            if (!$util.isString(message.Template))
                return "Template: string expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!Array.isArray(message.Items))
                return "Items: array expected";
            for (var i = 0; i < message.Items.length; ++i) {
                var error = $root.FormatItem.verify(message.Items[i]);
                if (error)
                    return "Items." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FormattedText message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FormattedText
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FormattedText} FormattedText
     */
    FormattedText.fromObject = function fromObject(object) {
        if (object instanceof $root.FormattedText)
            return object;
        var message = new $root.FormattedText();
        if (object.Template != null)
            message.Template = String(object.Template);
        if (object.Items) {
            if (!Array.isArray(object.Items))
                throw TypeError(".FormattedText.Items: array expected");
            message.Items = [];
            for (var i = 0; i < object.Items.length; ++i) {
                if (typeof object.Items[i] !== "object")
                    throw TypeError(".FormattedText.Items: object expected");
                message.Items[i] = $root.FormatItem.fromObject(object.Items[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FormattedText message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FormattedText
     * @static
     * @param {FormattedText} message FormattedText
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FormattedText.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Items = [];
        if (options.defaults)
            object.Template = "";
        if (message.Template != null && message.hasOwnProperty("Template"))
            object.Template = message.Template;
        if (message.Items && message.Items.length) {
            object.Items = [];
            for (var j = 0; j < message.Items.length; ++j)
                object.Items[j] = $root.FormatItem.toObject(message.Items[j], options);
        }
        return object;
    };

    /**
     * Converts this FormattedText to JSON.
     * @function toJSON
     * @memberof FormattedText
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FormattedText.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FormattedText;
})();

$root.PersistanceItem = (function() {

    /**
     * Properties of a PersistanceItem.
     * @exports IPersistanceItem
     * @interface IPersistanceItem
     * @property {string|null} [Key] PersistanceItem Key
     * @property {string|null} [Value] PersistanceItem Value
     */

    /**
     * Constructs a new PersistanceItem.
     * @exports PersistanceItem
     * @classdesc Represents a PersistanceItem.
     * @implements IPersistanceItem
     * @constructor
     * @param {IPersistanceItem=} [properties] Properties to set
     */
    function PersistanceItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PersistanceItem Key.
     * @member {string} Key
     * @memberof PersistanceItem
     * @instance
     */
    PersistanceItem.prototype.Key = "";

    /**
     * PersistanceItem Value.
     * @member {string} Value
     * @memberof PersistanceItem
     * @instance
     */
    PersistanceItem.prototype.Value = "";

    /**
     * Creates a new PersistanceItem instance using the specified properties.
     * @function create
     * @memberof PersistanceItem
     * @static
     * @param {IPersistanceItem=} [properties] Properties to set
     * @returns {PersistanceItem} PersistanceItem instance
     */
    PersistanceItem.create = function create(properties) {
        return new PersistanceItem(properties);
    };

    /**
     * Encodes the specified PersistanceItem message. Does not implicitly {@link PersistanceItem.verify|verify} messages.
     * @function encode
     * @memberof PersistanceItem
     * @static
     * @param {IPersistanceItem} message PersistanceItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PersistanceItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Key != null && Object.hasOwnProperty.call(message, "Key"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Key);
        if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Value);
        return writer;
    };

    /**
     * Encodes the specified PersistanceItem message, length delimited. Does not implicitly {@link PersistanceItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PersistanceItem
     * @static
     * @param {IPersistanceItem} message PersistanceItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PersistanceItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PersistanceItem message from the specified reader or buffer.
     * @function decode
     * @memberof PersistanceItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PersistanceItem} PersistanceItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PersistanceItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PersistanceItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Key = reader.string();
                break;
            case 2:
                message.Value = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PersistanceItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PersistanceItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PersistanceItem} PersistanceItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PersistanceItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PersistanceItem message.
     * @function verify
     * @memberof PersistanceItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PersistanceItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Key != null && message.hasOwnProperty("Key"))
            if (!$util.isString(message.Key))
                return "Key: string expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (!$util.isString(message.Value))
                return "Value: string expected";
        return null;
    };

    /**
     * Creates a PersistanceItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PersistanceItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PersistanceItem} PersistanceItem
     */
    PersistanceItem.fromObject = function fromObject(object) {
        if (object instanceof $root.PersistanceItem)
            return object;
        var message = new $root.PersistanceItem();
        if (object.Key != null)
            message.Key = String(object.Key);
        if (object.Value != null)
            message.Value = String(object.Value);
        return message;
    };

    /**
     * Creates a plain object from a PersistanceItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PersistanceItem
     * @static
     * @param {PersistanceItem} message PersistanceItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PersistanceItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Key = "";
            object.Value = "";
        }
        if (message.Key != null && message.hasOwnProperty("Key"))
            object.Key = message.Key;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = message.Value;
        return object;
    };

    /**
     * Converts this PersistanceItem to JSON.
     * @function toJSON
     * @memberof PersistanceItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PersistanceItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PersistanceItem;
})();

/**
 * TradeSide enum.
 * @exports TradeSide
 * @enum {number}
 * @property {number} TRADESIDE_SELL=0 TRADESIDE_SELL value
 * @property {number} TRADESIDE_BUY=1 TRADESIDE_BUY value
 */
$root.TradeSide = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "TRADESIDE_SELL"] = 0;
    values[valuesById[1] = "TRADESIDE_BUY"] = 1;
    return values;
})();

/**
 * QuoteSide enum.
 * @exports QuoteSide
 * @enum {number}
 * @property {number} QUOTESIDE_BID=0 QUOTESIDE_BID value
 * @property {number} QUOTESIDE_OFFER=1 QUOTESIDE_OFFER value
 */
$root.QuoteSide = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "QUOTESIDE_BID"] = 0;
    values[valuesById[1] = "QUOTESIDE_OFFER"] = 1;
    return values;
})();

/**
 * SpotType enum.
 * @exports SpotType
 * @enum {number}
 * @property {number} SPOTTYPE_MARKET=0 SPOTTYPE_MARKET value
 * @property {number} SPOTTYPE_FULL=1 SPOTTYPE_FULL value
 * @property {number} SPOTTYPE_IOC=2 SPOTTYPE_IOC value
 */
$root.SpotType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SPOTTYPE_MARKET"] = 0;
    values[valuesById[1] = "SPOTTYPE_FULL"] = 1;
    values[valuesById[2] = "SPOTTYPE_IOC"] = 2;
    return values;
})();

/**
 * OrderType enum.
 * @exports OrderType
 * @enum {number}
 * @property {number} ORDERTYPE_MARKET=0 ORDERTYPE_MARKET value
 * @property {number} ORDERTYPE_FULL=1 ORDERTYPE_FULL value
 * @property {number} ORDERTYPE_IOC=2 ORDERTYPE_IOC value
 * @property {number} ORDERTYPE_LIMIT=3 ORDERTYPE_LIMIT value
 * @property {number} ORDERTYPE_STOP=4 ORDERTYPE_STOP value
 * @property {number} ORDERTYPE_IF_DONE=5 ORDERTYPE_IF_DONE value
 * @property {number} ORDERTYPE_OCO=6 ORDERTYPE_OCO value
 */
$root.OrderType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDERTYPE_MARKET"] = 0;
    values[valuesById[1] = "ORDERTYPE_FULL"] = 1;
    values[valuesById[2] = "ORDERTYPE_IOC"] = 2;
    values[valuesById[3] = "ORDERTYPE_LIMIT"] = 3;
    values[valuesById[4] = "ORDERTYPE_STOP"] = 4;
    values[valuesById[5] = "ORDERTYPE_IF_DONE"] = 5;
    values[valuesById[6] = "ORDERTYPE_OCO"] = 6;
    return values;
})();

/**
 * OrderState enum.
 * @exports OrderState
 * @enum {number}
 * @property {number} ORDERSTATE_UNKNOWN=0 ORDERSTATE_UNKNOWN value
 * @property {number} ORDERSTATE_EXECUTING=1 ORDERSTATE_EXECUTING value
 * @property {number} ORDERSTATE_ACTIVE=2 ORDERSTATE_ACTIVE value
 * @property {number} ORDERSTATE_FILLED=3 ORDERSTATE_FILLED value
 * @property {number} ORDERSTATE_PARTIALLY_CANCELLED=4 ORDERSTATE_PARTIALLY_CANCELLED value
 * @property {number} ORDERSTATE_CANCELLED=5 ORDERSTATE_CANCELLED value
 * @property {number} ORDERSTATE_REJECTED=6 ORDERSTATE_REJECTED value
 * @property {number} ORDERSTATE_INACTIVE=7 ORDERSTATE_INACTIVE value
 * @property {number} ORDERSTATE_PARTIALLY_FILLED=8 ORDERSTATE_PARTIALLY_FILLED value
 * @property {number} ORDERSTATE_SUSPENDED=9 ORDERSTATE_SUSPENDED value
 */
$root.OrderState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDERSTATE_UNKNOWN"] = 0;
    values[valuesById[1] = "ORDERSTATE_EXECUTING"] = 1;
    values[valuesById[2] = "ORDERSTATE_ACTIVE"] = 2;
    values[valuesById[3] = "ORDERSTATE_FILLED"] = 3;
    values[valuesById[4] = "ORDERSTATE_PARTIALLY_CANCELLED"] = 4;
    values[valuesById[5] = "ORDERSTATE_CANCELLED"] = 5;
    values[valuesById[6] = "ORDERSTATE_REJECTED"] = 6;
    values[valuesById[7] = "ORDERSTATE_INACTIVE"] = 7;
    values[valuesById[8] = "ORDERSTATE_PARTIALLY_FILLED"] = 8;
    values[valuesById[9] = "ORDERSTATE_SUSPENDED"] = 9;
    return values;
})();

/**
 * UpdateType enum.
 * @exports UpdateType
 * @enum {number}
 * @property {number} UPDATETYPE_INCREMENT=0 UPDATETYPE_INCREMENT value
 * @property {number} UPDATETYPE_SNAPSHOT=1 UPDATETYPE_SNAPSHOT value
 */
$root.UpdateType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UPDATETYPE_INCREMENT"] = 0;
    values[valuesById[1] = "UPDATETYPE_SNAPSHOT"] = 1;
    return values;
})();

/**
 * NotificationItemType enum.
 * @exports NotificationItemType
 * @enum {number}
 * @property {number} NOTIFICATIONITEMTYPE_SENT=0 NOTIFICATIONITEMTYPE_SENT value
 * @property {number} NOTIFICATIONITEMTYPE_FILLED=1 NOTIFICATIONITEMTYPE_FILLED value
 * @property {number} NOTIFICATIONITEMTYPE_REJECTED=2 NOTIFICATIONITEMTYPE_REJECTED value
 * @property {number} NOTIFICATIONITEMTYPE_SUSPENDED=3 NOTIFICATIONITEMTYPE_SUSPENDED value
 * @property {number} NOTIFICATIONITEMTYPE_TRADINGDISABLED=4 NOTIFICATIONITEMTYPE_TRADINGDISABLED value
 * @property {number} NOTIFICATIONITEMTYPE_CANCELLED=5 NOTIFICATIONITEMTYPE_CANCELLED value
 * @property {number} NOTIFICATIONITEMTYPE_EXPIRED=6 NOTIFICATIONITEMTYPE_EXPIRED value
 * @property {number} NOTIFICATIONITEMTYPE_ORDERCHANGED=7 NOTIFICATIONITEMTYPE_ORDERCHANGED value
 * @property {number} NOTIFICATIONITEMTYPE_BACKTOACTIVE=8 NOTIFICATIONITEMTYPE_BACKTOACTIVE value
 * @property {number} NOTIFICATIONITEMTYPE_UNKNOWN=9 NOTIFICATIONITEMTYPE_UNKNOWN value
 */
$root.NotificationItemType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "NOTIFICATIONITEMTYPE_SENT"] = 0;
    values[valuesById[1] = "NOTIFICATIONITEMTYPE_FILLED"] = 1;
    values[valuesById[2] = "NOTIFICATIONITEMTYPE_REJECTED"] = 2;
    values[valuesById[3] = "NOTIFICATIONITEMTYPE_SUSPENDED"] = 3;
    values[valuesById[4] = "NOTIFICATIONITEMTYPE_TRADINGDISABLED"] = 4;
    values[valuesById[5] = "NOTIFICATIONITEMTYPE_CANCELLED"] = 5;
    values[valuesById[6] = "NOTIFICATIONITEMTYPE_EXPIRED"] = 6;
    values[valuesById[7] = "NOTIFICATIONITEMTYPE_ORDERCHANGED"] = 7;
    values[valuesById[8] = "NOTIFICATIONITEMTYPE_BACKTOACTIVE"] = 8;
    values[valuesById[9] = "NOTIFICATIONITEMTYPE_UNKNOWN"] = 9;
    return values;
})();

/**
 * ValueType enum.
 * @exports ValueType
 * @enum {number}
 * @property {number} VALUETYPE_DATE=0 VALUETYPE_DATE value
 * @property {number} VALUETYPE_PRICE=1 VALUETYPE_PRICE value
 * @property {number} VALUETYPE_QUANTITY=2 VALUETYPE_QUANTITY value
 */
$root.ValueType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "VALUETYPE_DATE"] = 0;
    values[valuesById[1] = "VALUETYPE_PRICE"] = 1;
    values[valuesById[2] = "VALUETYPE_QUANTITY"] = 2;
    return values;
})();

/**
 * RequestType enum.
 * @exports RequestType
 * @enum {number}
 * @property {number} REQUESTTYPE_UNKNOWN=0 REQUESTTYPE_UNKNOWN value
 * @property {number} REQUESTTYPE_SUBSCRIBE=1 REQUESTTYPE_SUBSCRIBE value
 * @property {number} REQUESTTYPE_UNSUBSCRIBE=2 REQUESTTYPE_UNSUBSCRIBE value
 * @property {number} REQUESTTYPE_REQUEST=3 REQUESTTYPE_REQUEST value
 * @property {number} REQUESTTYPE_SEND=4 REQUESTTYPE_SEND value
 */
$root.RequestType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "REQUESTTYPE_UNKNOWN"] = 0;
    values[valuesById[1] = "REQUESTTYPE_SUBSCRIBE"] = 1;
    values[valuesById[2] = "REQUESTTYPE_UNSUBSCRIBE"] = 2;
    values[valuesById[3] = "REQUESTTYPE_REQUEST"] = 3;
    values[valuesById[4] = "REQUESTTYPE_SEND"] = 4;
    return values;
})();

/**
 * InstrumentType enum.
 * @exports InstrumentType
 * @enum {number}
 * @property {number} INSTRUMENTTYPE_SPOT=0 INSTRUMENTTYPE_SPOT value
 * @property {number} INSTRUMENTTYPE_FORWARD=1 INSTRUMENTTYPE_FORWARD value
 */
$root.InstrumentType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "INSTRUMENTTYPE_SPOT"] = 0;
    values[valuesById[1] = "INSTRUMENTTYPE_FORWARD"] = 1;
    return values;
})();

/**
 * OrderInstrument enum.
 * @exports OrderInstrument
 * @enum {number}
 * @property {number} ORDERINSTRUMENT_SPOT=0 ORDERINSTRUMENT_SPOT value
 * @property {number} ORDERINSTRUMENT_FORWARD=1 ORDERINSTRUMENT_FORWARD value
 * @property {number} ORDERINSTRUMENT_SWAP=2 ORDERINSTRUMENT_SWAP value
 */
$root.OrderInstrument = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "ORDERINSTRUMENT_SPOT"] = 0;
    values[valuesById[1] = "ORDERINSTRUMENT_FORWARD"] = 1;
    values[valuesById[2] = "ORDERINSTRUMENT_SWAP"] = 2;
    return values;
})();

/**
 * ForwardProduct enum.
 * @exports ForwardProduct
 * @enum {number}
 * @property {number} FORWARDPRODUCT_FORWARD=0 FORWARDPRODUCT_FORWARD value
 * @property {number} FORWARDPRODUCT_SWAP=1 FORWARDPRODUCT_SWAP value
 */
$root.ForwardProduct = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FORWARDPRODUCT_FORWARD"] = 0;
    values[valuesById[1] = "FORWARDPRODUCT_SWAP"] = 1;
    return values;
})();

/**
 * ExpirationType enum.
 * @exports ExpirationType
 * @enum {number}
 * @property {number} EXPIRATIONTYPE_UNKNOWN=0 EXPIRATIONTYPE_UNKNOWN value
 * @property {number} EXPIRATIONTYPE_GTC=1 EXPIRATIONTYPE_GTC value
 * @property {number} EXPIRATIONTYPE_GTD=2 EXPIRATIONTYPE_GTD value
 * @property {number} EXPIRATIONTYPE_GTS=3 EXPIRATIONTYPE_GTS value
 * @property {number} EXPIRATIONTYPE_FOK=4 EXPIRATIONTYPE_FOK value
 * @property {number} EXPIRATIONTYPE_IOC=5 EXPIRATIONTYPE_IOC value
 */
$root.ExpirationType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "EXPIRATIONTYPE_UNKNOWN"] = 0;
    values[valuesById[1] = "EXPIRATIONTYPE_GTC"] = 1;
    values[valuesById[2] = "EXPIRATIONTYPE_GTD"] = 2;
    values[valuesById[3] = "EXPIRATIONTYPE_GTS"] = 3;
    values[valuesById[4] = "EXPIRATIONTYPE_FOK"] = 4;
    values[valuesById[5] = "EXPIRATIONTYPE_IOC"] = 5;
    return values;
})();

/**
 * PendingType enum.
 * @exports PendingType
 * @enum {number}
 * @property {number} PENDINGTYPE_LIMIT=0 PENDINGTYPE_LIMIT value
 * @property {number} PENDINGTYPE_STOP=1 PENDINGTYPE_STOP value
 * @property {number} PENDINGTYPE_IF_DONE=2 PENDINGTYPE_IF_DONE value
 * @property {number} PENDINGTYPE_OCO=3 PENDINGTYPE_OCO value
 */
$root.PendingType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PENDINGTYPE_LIMIT"] = 0;
    values[valuesById[1] = "PENDINGTYPE_STOP"] = 1;
    values[valuesById[2] = "PENDINGTYPE_IF_DONE"] = 2;
    values[valuesById[3] = "PENDINGTYPE_OCO"] = 3;
    return values;
})();

/**
 * PriceType enum.
 * @exports PriceType
 * @enum {number}
 * @property {number} PRICETYPE_LIMIT=0 PRICETYPE_LIMIT value
 * @property {number} PRICETYPE_STOP=1 PRICETYPE_STOP value
 */
$root.PriceType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PRICETYPE_LIMIT"] = 0;
    values[valuesById[1] = "PRICETYPE_STOP"] = 1;
    return values;
})();

/**
 * PendingStrategy enum.
 * @exports PendingStrategy
 * @enum {number}
 * @property {number} PENDINGSTRATEGY_SINGLE_ORDER=0 PENDINGSTRATEGY_SINGLE_ORDER value
 * @property {number} PENDINGSTRATEGY_OCO=1 PENDINGSTRATEGY_OCO value
 * @property {number} PENDINGSTRATEGY_IF_DONE=2 PENDINGSTRATEGY_IF_DONE value
 */
$root.PendingStrategy = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PENDINGSTRATEGY_SINGLE_ORDER"] = 0;
    values[valuesById[1] = "PENDINGSTRATEGY_OCO"] = 1;
    values[valuesById[2] = "PENDINGSTRATEGY_IF_DONE"] = 2;
    return values;
})();

/**
 * MarketApproximation enum.
 * @exports MarketApproximation
 * @enum {number}
 * @property {number} MARKETAPPROXIMATION_CLOSE=0 MARKETAPPROXIMATION_CLOSE value
 * @property {number} MARKETAPPROXIMATION_NEAR=1 MARKETAPPROXIMATION_NEAR value
 * @property {number} MARKETAPPROXIMATION_FAR=2 MARKETAPPROXIMATION_FAR value
 * @property {number} MARKETAPPROXIMATION_VERY_FAR=3 MARKETAPPROXIMATION_VERY_FAR value
 */
$root.MarketApproximation = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "MARKETAPPROXIMATION_CLOSE"] = 0;
    values[valuesById[1] = "MARKETAPPROXIMATION_NEAR"] = 1;
    values[valuesById[2] = "MARKETAPPROXIMATION_FAR"] = 2;
    values[valuesById[3] = "MARKETAPPROXIMATION_VERY_FAR"] = 3;
    return values;
})();

/**
 * ForwardDisplayMode enum.
 * @exports ForwardDisplayMode
 * @enum {number}
 * @property {number} FORWARDDISPLAYMODE_POINTS=0 FORWARDDISPLAYMODE_POINTS value
 * @property {number} FORWARDDISPLAYMODE_SPOTPRICE=1 FORWARDDISPLAYMODE_SPOTPRICE value
 * @property {number} FORWARDDISPLAYMODE_SIMPLIFIED=2 FORWARDDISPLAYMODE_SIMPLIFIED value
 */
$root.ForwardDisplayMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FORWARDDISPLAYMODE_POINTS"] = 0;
    values[valuesById[1] = "FORWARDDISPLAYMODE_SPOTPRICE"] = 1;
    values[valuesById[2] = "FORWARDDISPLAYMODE_SIMPLIFIED"] = 2;
    return values;
})();

/**
 * PadType enum.
 * @exports PadType
 * @enum {number}
 * @property {number} PADTYPE_SPOT=0 PADTYPE_SPOT value
 * @property {number} PADTYPE_FORWARD=1 PADTYPE_FORWARD value
 * @property {number} PADTYPE_SWAP=2 PADTYPE_SWAP value
 * @property {number} PADTYPE_PENDING=3 PADTYPE_PENDING value
 */
$root.PadType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "PADTYPE_SPOT"] = 0;
    values[valuesById[1] = "PADTYPE_FORWARD"] = 1;
    values[valuesById[2] = "PADTYPE_SWAP"] = 2;
    values[valuesById[3] = "PADTYPE_PENDING"] = 3;
    return values;
})();

/**
 * ClickMode enum.
 * @exports ClickMode
 * @enum {number}
 * @property {number} CLICKMODE_FREE=0 CLICKMODE_FREE value
 * @property {number} CLICKMODE_SINGLE=1 CLICKMODE_SINGLE value
 * @property {number} CLICKMODE_CONFIRM=2 CLICKMODE_CONFIRM value
 */
$root.ClickMode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "CLICKMODE_FREE"] = 0;
    values[valuesById[1] = "CLICKMODE_SINGLE"] = 1;
    values[valuesById[2] = "CLICKMODE_CONFIRM"] = 2;
    return values;
})();

/**
 * SeverityCode enum.
 * @exports SeverityCode
 * @enum {number}
 * @property {number} SEVERITYCODE_ERROR=0 SEVERITYCODE_ERROR value
 * @property {number} SEVERITYCODE_WARNING=1 SEVERITYCODE_WARNING value
 * @property {number} SEVERITYCODE_INFO=2 SEVERITYCODE_INFO value
 */
$root.SeverityCode = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SEVERITYCODE_ERROR"] = 0;
    values[valuesById[1] = "SEVERITYCODE_WARNING"] = 1;
    values[valuesById[2] = "SEVERITYCODE_INFO"] = 2;
    return values;
})();

/**
 * CounterType enum.
 * @exports CounterType
 * @enum {number}
 * @property {number} COUNTERTYPE_UNKNOWN_TYPE=0 COUNTERTYPE_UNKNOWN_TYPE value
 * @property {number} COUNTERTYPE_CLIENT_WS_INPUT_LATENCY=1 COUNTERTYPE_CLIENT_WS_INPUT_LATENCY value
 * @property {number} COUNTERTYPE_CLIENT_ELEMENT_CLICK_COUNT=2 COUNTERTYPE_CLIENT_ELEMENT_CLICK_COUNT value
 * @property {number} COUNTERTYPE_CLIENT_OPENED_PADS_COUNT=3 COUNTERTYPE_CLIENT_OPENED_PADS_COUNT value
 */
$root.CounterType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "COUNTERTYPE_UNKNOWN_TYPE"] = 0;
    values[valuesById[1] = "COUNTERTYPE_CLIENT_WS_INPUT_LATENCY"] = 1;
    values[valuesById[2] = "COUNTERTYPE_CLIENT_ELEMENT_CLICK_COUNT"] = 2;
    values[valuesById[3] = "COUNTERTYPE_CLIENT_OPENED_PADS_COUNT"] = 3;
    return values;
})();

/**
 * CounterAction enum.
 * @exports CounterAction
 * @enum {number}
 * @property {number} COUNTERACTION_UNKNOWN_ACION=0 COUNTERACTION_UNKNOWN_ACION value
 * @property {number} COUNTERACTION_INCREMENT=1 COUNTERACTION_INCREMENT value
 * @property {number} COUNTERACTION_DECREMENT=2 COUNTERACTION_DECREMENT value
 * @property {number} COUNTERACTION_OBSERVE=3 COUNTERACTION_OBSERVE value
 */
$root.CounterAction = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "COUNTERACTION_UNKNOWN_ACION"] = 0;
    values[valuesById[1] = "COUNTERACTION_INCREMENT"] = 1;
    values[valuesById[2] = "COUNTERACTION_DECREMENT"] = 2;
    values[valuesById[3] = "COUNTERACTION_OBSERVE"] = 3;
    return values;
})();

/**
 * SessionState enum.
 * @exports SessionState
 * @enum {number}
 * @property {number} SESSIONSTATE_UNKNOWN=0 SESSIONSTATE_UNKNOWN value
 * @property {number} SESSIONSTATE_END=1 SESSIONSTATE_END value
 */
$root.SessionState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "SESSIONSTATE_UNKNOWN"] = 0;
    values[valuesById[1] = "SESSIONSTATE_END"] = 1;
    return values;
})();

/**
 * MessageTypes enum.
 * @exports MessageTypes
 * @enum {number}
 * @property {number} FirmsInstruments=0 FirmsInstruments value
 * @property {number} SpotQuote=1 SpotQuote value
 * @property {number} PlaceSpotOrder=2 PlaceSpotOrder value
 * @property {number} Limits=3 Limits value
 * @property {number} Notifications=4 Notifications value
 * @property {number} Orders=5 Orders value
 * @property {number} UserSettings=6 UserSettings value
 * @property {number} UserSettingsSave=7 UserSettingsSave value
 * @property {number} ForwardQuote=8 ForwardQuote value
 * @property {number} TenorResolve=9 TenorResolve value
 * @property {number} PlaceForwardOrder=10 PlaceForwardOrder value
 * @property {number} HistoricalNotifications=11 HistoricalNotifications value
 * @property {number} NotificationResolve=12 NotificationResolve value
 * @property {number} Log=13 Log value
 * @property {number} PlacePendingOrder=14 PlacePendingOrder value
 * @property {number} AmendPendingOrder=15 AmendPendingOrder value
 * @property {number} CancelAllOrders=16 CancelAllOrders value
 * @property {number} CancelPendingOrder=17 CancelPendingOrder value
 * @property {number} Configuration=18 Configuration value
 * @property {number} TradingSettings=19 TradingSettings value
 * @property {number} Metric=20 Metric value
 * @property {number} Feedback=21 Feedback value
 * @property {number} Session=22 Session value
 * @property {number} SetCurrentFirm=23 SetCurrentFirm value
 * @property {number} Authentication=24 Authentication value
 * @property {number} Disclaimer=25 Disclaimer value
 * @property {number} DisclaimerApprovalSave=26 DisclaimerApprovalSave value
 * @property {number} SoundNotifications=27 SoundNotifications value
 */
$root.MessageTypes = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "FirmsInstruments"] = 0;
    values[valuesById[1] = "SpotQuote"] = 1;
    values[valuesById[2] = "PlaceSpotOrder"] = 2;
    values[valuesById[3] = "Limits"] = 3;
    values[valuesById[4] = "Notifications"] = 4;
    values[valuesById[5] = "Orders"] = 5;
    values[valuesById[6] = "UserSettings"] = 6;
    values[valuesById[7] = "UserSettingsSave"] = 7;
    values[valuesById[8] = "ForwardQuote"] = 8;
    values[valuesById[9] = "TenorResolve"] = 9;
    values[valuesById[10] = "PlaceForwardOrder"] = 10;
    values[valuesById[11] = "HistoricalNotifications"] = 11;
    values[valuesById[12] = "NotificationResolve"] = 12;
    values[valuesById[13] = "Log"] = 13;
    values[valuesById[14] = "PlacePendingOrder"] = 14;
    values[valuesById[15] = "AmendPendingOrder"] = 15;
    values[valuesById[16] = "CancelAllOrders"] = 16;
    values[valuesById[17] = "CancelPendingOrder"] = 17;
    values[valuesById[18] = "Configuration"] = 18;
    values[valuesById[19] = "TradingSettings"] = 19;
    values[valuesById[20] = "Metric"] = 20;
    values[valuesById[21] = "Feedback"] = 21;
    values[valuesById[22] = "Session"] = 22;
    values[valuesById[23] = "SetCurrentFirm"] = 23;
    values[valuesById[24] = "Authentication"] = 24;
    values[valuesById[25] = "Disclaimer"] = 25;
    values[valuesById[26] = "DisclaimerApprovalSave"] = 26;
    values[valuesById[27] = "SoundNotifications"] = 27;
    return values;
})();

module.exports = $root;
